function getSiteName() {
  return 'ss-unbxd-ganz-prod-blue-illusion-anz23461767337513';
}
function getApiKey() {
  return 'f0fbd430892f8712a86e026003eb807a';
}
((t, e) => {
  'object' == typeof module && 'object' == typeof module.exports
    ? (module.exports = t.document
        ? e(t, !0)
        : function (t) {
            if (t.document) return e(t);
            throw new Error('jQuery requires a window with a document');
          })
    : e(t);
})('undefined' != typeof window ? window : this, function (w, U) {
  function v(t) {
    return 'function' == typeof t && 'number' != typeof t.nodeType && 'function' != typeof t.item;
  }
  function M(t) {
    return null != t && t === t.window;
  }
  var e = [],
    H = Object.getPrototypeOf,
    a = e.slice,
    j = e.flat
      ? function (t) {
          return e.flat.call(t);
        }
      : function (t) {
          return e.concat.apply([], t);
        },
    F = e.push,
    x = e.indexOf,
    q = {},
    B = q.toString,
    $ = q.hasOwnProperty,
    W = $.toString,
    G = W.call(Object),
    g = {},
    _ = w.document,
    Q = {type: !0, src: !0, nonce: !0, noModule: !0};
  function K(t, e, n) {
    var r,
      o,
      i = (n = n || _).createElement('script');
    if (((i.text = t), e)) for (r in Q) (o = e[r] || (e.getAttribute && e.getAttribute(r))) && i.setAttribute(r, o);
    n.head.appendChild(i).parentNode.removeChild(i);
  }
  function z(t) {
    return null == t ? t + '' : 'object' == typeof t || 'function' == typeof t ? q[B.call(t)] || 'object' : typeof t;
  }
  var t = '3.7.1',
    V = /HTML$/i,
    P = function (t, e) {
      return new P.fn.init(t, e);
    };
  function Y(t) {
    var e = !!t && 'length' in t && t.length,
      n = z(t);
    return !v(t) && !M(t) && ('array' === n || 0 === e || ('number' == typeof e && 0 < e && e - 1 in t));
  }
  function b(t, e) {
    return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
  }
  (P.fn = P.prototype =
    {
      jquery: t,
      constructor: P,
      length: 0,
      toArray: function () {
        return a.call(this);
      },
      get: function (t) {
        return null == t ? a.call(this) : t < 0 ? this[t + this.length] : this[t];
      },
      pushStack: function (t) {
        t = P.merge(this.constructor(), t);
        return (t.prevObject = this), t;
      },
      each: function (t) {
        return P.each(this, t);
      },
      map: function (n) {
        return this.pushStack(
          P.map(this, function (t, e) {
            return n.call(t, e, t);
          })
        );
      },
      slice: function () {
        return this.pushStack(a.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      even: function () {
        return this.pushStack(
          P.grep(this, function (t, e) {
            return (e + 1) % 2;
          })
        );
      },
      odd: function () {
        return this.pushStack(
          P.grep(this, function (t, e) {
            return e % 2;
          })
        );
      },
      eq: function (t) {
        var e = this.length,
          t = +t + (t < 0 ? e : 0);
        return this.pushStack(0 <= t && t < e ? [this[t]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: F,
      sort: e.sort,
      splice: e.splice,
    }),
    (P.extend = P.fn.extend =
      function () {
        var t,
          e,
          n,
          r,
          o,
          i = arguments[0] || {},
          s = 1,
          a = arguments.length,
          u = !1;
        for (
          'boolean' == typeof i && ((u = i), (i = arguments[s] || {}), s++),
            'object' == typeof i || v(i) || (i = {}),
            s === a && ((i = this), s--);
          s < a;
          s++
        )
          if (null != (t = arguments[s]))
            for (e in t)
              (n = t[e]),
                '__proto__' !== e &&
                  i !== n &&
                  (u && n && (P.isPlainObject(n) || (r = Array.isArray(n)))
                    ? ((o = i[e]),
                      (o = r && !Array.isArray(o) ? [] : r || P.isPlainObject(o) ? o : {}),
                      (r = !1),
                      (i[e] = P.extend(u, o, n)))
                    : void 0 !== n && (i[e] = n));
        return i;
      }),
    P.extend({
      expando: 'jQuery' + (t + Math.random()).replace(/\D/g, ''),
      isReady: !0,
      error: function (t) {
        throw new Error(t);
      },
      noop: function () {},
      isPlainObject: function (t) {
        return !(
          !t ||
          '[object Object]' !== B.call(t) ||
          ((t = H(t)) && ('function' != typeof (t = $.call(t, 'constructor') && t.constructor) || W.call(t) !== G))
        );
      },
      isEmptyObject: function (t) {
        for (var e in t) return !1;
        return !0;
      },
      globalEval: function (t, e, n) {
        K(t, {nonce: e && e.nonce}, n);
      },
      each: function (t, e) {
        var n,
          r = 0;
        if (Y(t)) for (n = t.length; r < n && !1 !== e.call(t[r], r, t[r]); r++);
        else for (r in t) if (!1 === e.call(t[r], r, t[r])) break;
        return t;
      },
      text: function (t) {
        var e,
          n = '',
          r = 0,
          o = t.nodeType;
        if (!o) for (; (e = t[r++]); ) n += P.text(e);
        return 1 === o || 11 === o
          ? t.textContent
          : 9 === o
            ? t.documentElement.textContent
            : 3 === o || 4 === o
              ? t.nodeValue
              : n;
      },
      makeArray: function (t, e) {
        e = e || [];
        return null != t && (Y(Object(t)) ? P.merge(e, 'string' == typeof t ? [t] : t) : F.call(e, t)), e;
      },
      inArray: function (t, e, n) {
        return null == e ? -1 : x.call(e, t, n);
      },
      isXMLDoc: function (t) {
        var e = t && t.namespaceURI,
          t = t && (t.ownerDocument || t).documentElement;
        return !V.test(e || (t && t.nodeName) || 'HTML');
      },
      merge: function (t, e) {
        for (var n = +e.length, r = 0, o = t.length; r < n; r++) t[o++] = e[r];
        return (t.length = o), t;
      },
      grep: function (t, e, n) {
        for (var r = [], o = 0, i = t.length, s = !n; o < i; o++) !e(t[o], o) != s && r.push(t[o]);
        return r;
      },
      map: function (t, e, n) {
        var r,
          o,
          i = 0,
          s = [];
        if (Y(t)) for (r = t.length; i < r; i++) null != (o = e(t[i], i, n)) && s.push(o);
        else for (i in t) null != (o = e(t[i], i, n)) && s.push(o);
        return j(s);
      },
      guid: 1,
      support: g,
    }),
    'function' == typeof Symbol && (P.fn[Symbol.iterator] = e[Symbol.iterator]),
    P.each('Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '), function (t, e) {
      q['[object ' + e + ']'] = e.toLowerCase();
    });
  var X = e.pop,
    J = e.sort,
    Z = e.splice,
    n = '[\\x20\\t\\r\\n\\f]',
    tt = new RegExp('^' + n + '+|((?:^|[^\\\\])(?:\\\\.)*)' + n + '+$', 'g'),
    et =
      ((P.contains = function (t, e) {
        e = e && e.parentNode;
        return (
          t === e ||
          !(
            !e ||
            1 !== e.nodeType ||
            !(t.contains ? t.contains(e) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(e))
          )
        );
      }),
      /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g);
  function nt(t, e) {
    return e ? ('\0' === t ? '�' : t.slice(0, -1) + '\\' + t.charCodeAt(t.length - 1).toString(16) + ' ') : '\\' + t;
  }
  P.escapeSelector = function (t) {
    return (t + '').replace(et, nt);
  };
  var rt,
    S,
    ot,
    it,
    st,
    k,
    r,
    E,
    d,
    at,
    o = _,
    ut = F,
    C = ut,
    T = P.expando,
    A = 0,
    lt = 0,
    ct = At(),
    pt = At(),
    dt = At(),
    ht = At(),
    ft = function (t, e) {
      return t === e && (st = !0), 0;
    },
    gt =
      'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
    t = '(?:\\\\[\\da-fA-F]{1,6}' + n + '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
    i =
      '\\[' +
      n +
      '*(' +
      t +
      ')(?:' +
      n +
      '*([*^$|!~]?=)' +
      n +
      '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
      t +
      '))|)' +
      n +
      '*\\]',
    s =
      ':(' +
      t +
      ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
      i +
      ')*)|.*)\\)|)',
    mt = new RegExp(n + '+', 'g'),
    yt = new RegExp('^' + n + '*,' + n + '*'),
    vt = new RegExp('^' + n + '*([>+~]|' + n + ')' + n + '*'),
    bt = new RegExp(n + '|>'),
    xt = new RegExp(s),
    St = new RegExp('^' + t + '$'),
    wt = {
      ID: new RegExp('^#(' + t + ')'),
      CLASS: new RegExp('^\\.(' + t + ')'),
      TAG: new RegExp('^(' + t + '|[*])'),
      ATTR: new RegExp('^' + i),
      PSEUDO: new RegExp('^' + s),
      CHILD: new RegExp(
        '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
          n +
          '*(even|odd|(([+-]|)(\\d*)n|)' +
          n +
          '*(?:([+-]|)' +
          n +
          '*(\\d+)|))' +
          n +
          '*\\)|)',
        'i'
      ),
      bool: new RegExp('^(?:' + gt + ')$', 'i'),
      needsContext: new RegExp(
        '^' + n + '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' + n + '*((?:-\\d)?\\d*)' + n + '*\\)|)(?=[^-]|$)',
        'i'
      ),
    },
    _t = /^(?:input|select|textarea|button)$/i,
    Pt = /^h\d$/i,
    kt = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
    Et = /[+~]/,
    p = new RegExp('\\\\[\\da-fA-F]{1,6}' + n + '?|\\\\([^\\r\\n\\f])', 'g'),
    h = function (t, e) {
      t = '0x' + t.slice(1) - 65536;
      return e || (t < 0 ? String.fromCharCode(65536 + t) : String.fromCharCode((t >> 10) | 55296, (1023 & t) | 56320));
    },
    Ct = function () {
      Nt();
    },
    Tt = Ht(
      function (t) {
        return !0 === t.disabled && b(t, 'fieldset');
      },
      {dir: 'parentNode', next: 'legend'}
    );
  try {
    C.apply((e = a.call(o.childNodes)), o.childNodes), e[o.childNodes.length].nodeType;
  } catch (rt) {
    C = {
      apply: function (t, e) {
        ut.apply(t, a.call(e));
      },
      call: function (t) {
        ut.apply(t, a.call(arguments, 1));
      },
    };
  }
  function O(t, e, n, r) {
    var o,
      i,
      s,
      a,
      u,
      l,
      c = e && e.ownerDocument,
      p = e ? e.nodeType : 9;
    if (((n = n || []), 'string' != typeof t || !t || (1 !== p && 9 !== p && 11 !== p))) return n;
    if (!r && (Nt(e), (e = e || k), E)) {
      if (11 !== p && (a = kt.exec(t)))
        if ((o = a[1])) {
          if (9 === p) {
            if (!(l = e.getElementById(o))) return n;
            if (l.id === o) return C.call(n, l), n;
          } else if (c && (l = c.getElementById(o)) && O.contains(e, l) && l.id === o) return C.call(n, l), n;
        } else {
          if (a[2]) return C.apply(n, e.getElementsByTagName(t)), n;
          if ((o = a[3]) && e.getElementsByClassName) return C.apply(n, e.getElementsByClassName(o)), n;
        }
      if (!(ht[t + ' '] || (d && d.test(t)))) {
        if (((l = t), (c = e), 1 === p && (bt.test(t) || vt.test(t)))) {
          for (
            ((c = (Et.test(t) && Dt(e.parentNode)) || e) == e && g.scope) ||
              ((s = e.getAttribute('id')) ? (s = P.escapeSelector(s)) : e.setAttribute('id', (s = T))),
              i = (u = Ut(t)).length;
            i--;

          )
            u[i] = (s ? '#' + s : ':scope') + ' ' + Mt(u[i]);
          l = u.join(',');
        }
        try {
          return C.apply(n, c.querySelectorAll(l)), n;
        } catch (e) {
          ht(t, !0);
        } finally {
          s === T && e.removeAttribute('id');
        }
      }
    }
    return $t(t.replace(tt, '$1'), e, n, r);
  }
  function At() {
    var r = [];
    return function t(e, n) {
      return r.push(e + ' ') > S.cacheLength && delete t[r.shift()], (t[e + ' '] = n);
    };
  }
  function u(t) {
    return (t[T] = !0), t;
  }
  function Ot(t) {
    var e = k.createElement('fieldset');
    try {
      return !!t(e);
    } catch (t) {
      return !1;
    } finally {
      e.parentNode && e.parentNode.removeChild(e);
    }
  }
  function Rt(e) {
    return function (t) {
      return 'form' in t
        ? t.parentNode && !1 === t.disabled
          ? 'label' in t
            ? 'label' in t.parentNode
              ? t.parentNode.disabled === e
              : t.disabled === e
            : t.isDisabled === e || (t.isDisabled !== !e && Tt(t) === e)
          : t.disabled === e
        : 'label' in t && t.disabled === e;
    };
  }
  function It(s) {
    return u(function (i) {
      return (
        (i = +i),
        u(function (t, e) {
          for (var n, r = s([], t.length, i), o = r.length; o--; ) t[(n = r[o])] && (t[n] = !(e[n] = t[n]));
        })
      );
    });
  }
  function Dt(t) {
    return t && void 0 !== t.getElementsByTagName && t;
  }
  function Nt(t) {
    var t = t ? t.ownerDocument || t : o;
    return (
      t != k &&
        9 === t.nodeType &&
        t.documentElement &&
        ((r = (k = t).documentElement),
        (E = !P.isXMLDoc(k)),
        (at = r.matches || r.webkitMatchesSelector || r.msMatchesSelector),
        r.msMatchesSelector && o != k && (t = k.defaultView) && t.top !== t && t.addEventListener('unload', Ct),
        (g.getById = Ot(function (t) {
          return (r.appendChild(t).id = P.expando), !k.getElementsByName || !k.getElementsByName(P.expando).length;
        })),
        (g.disconnectedMatch = Ot(function (t) {
          return at.call(t, '*');
        })),
        (g.scope = Ot(function () {
          return k.querySelectorAll(':scope');
        })),
        (g.cssHas = Ot(function () {
          try {
            return k.querySelector(':has(*,:jqfake)'), 0;
          } catch (t) {
            return 1;
          }
        })),
        g.getById
          ? ((S.filter.ID = function (t) {
              var e = t.replace(p, h);
              return function (t) {
                return t.getAttribute('id') === e;
              };
            }),
            (S.find.ID = function (t, e) {
              if (void 0 !== e.getElementById && E) return (e = e.getElementById(t)) ? [e] : [];
            }))
          : ((S.filter.ID = function (t) {
              var e = t.replace(p, h);
              return function (t) {
                t = void 0 !== t.getAttributeNode && t.getAttributeNode('id');
                return t && t.value === e;
              };
            }),
            (S.find.ID = function (t, e) {
              if (void 0 !== e.getElementById && E) {
                var n,
                  r,
                  o,
                  i = e.getElementById(t);
                if (i) {
                  if ((n = i.getAttributeNode('id')) && n.value === t) return [i];
                  for (o = e.getElementsByName(t), r = 0; (i = o[r++]); )
                    if ((n = i.getAttributeNode('id')) && n.value === t) return [i];
                }
                return [];
              }
            })),
        (S.find.TAG = function (t, e) {
          return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : e.querySelectorAll(t);
        }),
        (S.find.CLASS = function (t, e) {
          if (void 0 !== e.getElementsByClassName && E) return e.getElementsByClassName(t);
        }),
        (d = []),
        Ot(function (t) {
          var e;
          (r.appendChild(t).innerHTML =
            "<a id='" +
            T +
            "' href='' disabled='disabled'></a><select id='" +
            T +
            "-\r\\' disabled='disabled'><option selected=''></option></select>"),
            t.querySelectorAll('[selected]').length || d.push('\\[' + n + '*(?:value|' + gt + ')'),
            t.querySelectorAll('[id~=' + T + '-]').length || d.push('~='),
            t.querySelectorAll('a#' + T + '+*').length || d.push('.#.+[+~]'),
            t.querySelectorAll(':checked').length || d.push(':checked'),
            (e = k.createElement('input')).setAttribute('type', 'hidden'),
            t.appendChild(e).setAttribute('name', 'D'),
            (r.appendChild(t).disabled = !0),
            2 !== t.querySelectorAll(':disabled').length && d.push(':enabled', ':disabled'),
            (e = k.createElement('input')).setAttribute('name', ''),
            t.appendChild(e),
            t.querySelectorAll("[name='']").length || d.push('\\[' + n + '*name' + n + '*=' + n + '*(?:\'\'|"")');
        }),
        g.cssHas || d.push(':has'),
        (d = d.length && new RegExp(d.join('|'))),
        (ft = function (t, e) {
          var n;
          return t === e
            ? ((st = !0), 0)
            : !t.compareDocumentPosition - !e.compareDocumentPosition ||
                (1 & (n = (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) ||
                (!g.sortDetached && e.compareDocumentPosition(t) === n)
                  ? t === k || (t.ownerDocument == o && O.contains(o, t))
                    ? -1
                    : e === k || (e.ownerDocument == o && O.contains(o, e))
                      ? 1
                      : it
                        ? x.call(it, t) - x.call(it, e)
                        : 0
                  : 4 & n
                    ? -1
                    : 1);
        })),
      k
    );
  }
  for (rt in ((O.matches = function (t, e) {
    return O(t, null, null, e);
  }),
  (O.matchesSelector = function (t, e) {
    if ((Nt(t), E && !ht[e + ' '] && (!d || !d.test(e))))
      try {
        var n = at.call(t, e);
        if (n || g.disconnectedMatch || (t.document && 11 !== t.document.nodeType)) return n;
      } catch (t) {
        ht(e, !0);
      }
    return 0 < O(e, k, null, [t]).length;
  }),
  (O.contains = function (t, e) {
    return (t.ownerDocument || t) != k && Nt(t), P.contains(t, e);
  }),
  (O.attr = function (t, e) {
    (t.ownerDocument || t) != k && Nt(t);
    var n = S.attrHandle[e.toLowerCase()],
      n = n && $.call(S.attrHandle, e.toLowerCase()) ? n(t, e, !E) : void 0;
    return void 0 !== n ? n : t.getAttribute(e);
  }),
  (O.error = function (t) {
    throw new Error('Syntax error, unrecognized expression: ' + t);
  }),
  (P.uniqueSort = function (t) {
    var e,
      n = [],
      r = 0,
      o = 0;
    if (((st = !g.sortStable), (it = !g.sortStable && a.call(t, 0)), J.call(t, ft), st)) {
      for (; (e = t[o++]); ) e === t[o] && (r = n.push(o));
      for (; r--; ) Z.call(t, n[r], 1);
    }
    return (it = null), t;
  }),
  (P.fn.uniqueSort = function () {
    return this.pushStack(P.uniqueSort(a.apply(this)));
  }),
  ((S = P.expr =
    {
      cacheLength: 50,
      createPseudo: u,
      match: wt,
      attrHandle: {},
      find: {},
      relative: {
        '>': {dir: 'parentNode', first: !0},
        ' ': {dir: 'parentNode'},
        '+': {dir: 'previousSibling', first: !0},
        '~': {dir: 'previousSibling'},
      },
      preFilter: {
        ATTR: function (t) {
          return (
            (t[1] = t[1].replace(p, h)),
            (t[3] = (t[3] || t[4] || t[5] || '').replace(p, h)),
            '~=' === t[2] && (t[3] = ' ' + t[3] + ' '),
            t.slice(0, 4)
          );
        },
        CHILD: function (t) {
          return (
            (t[1] = t[1].toLowerCase()),
            'nth' === t[1].slice(0, 3)
              ? (t[3] || O.error(t[0]),
                (t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ('even' === t[3] || 'odd' === t[3]))),
                (t[5] = +(t[7] + t[8] || 'odd' === t[3])))
              : t[3] && O.error(t[0]),
            t
          );
        },
        PSEUDO: function (t) {
          var e,
            n = !t[6] && t[2];
          return wt.CHILD.test(t[0])
            ? null
            : (t[3]
                ? (t[2] = t[4] || t[5] || '')
                : n &&
                  xt.test(n) &&
                  (e = (e = Ut(n, !0)) && n.indexOf(')', n.length - e) - n.length) &&
                  ((t[0] = t[0].slice(0, e)), (t[2] = n.slice(0, e))),
              t.slice(0, 3));
        },
      },
      filter: {
        TAG: function (t) {
          var e = t.replace(p, h).toLowerCase();
          return '*' === t
            ? function () {
                return !0;
              }
            : function (t) {
                return b(t, e);
              };
        },
        CLASS: function (t) {
          var e = ct[t + ' '];
          return (
            e ||
            ((e = new RegExp('(^|' + n + ')' + t + '(' + n + '|$)')) &&
              ct(t, function (t) {
                return e.test(
                  ('string' == typeof t.className && t.className) ||
                    (void 0 !== t.getAttribute && t.getAttribute('class')) ||
                    ''
                );
              }))
          );
        },
        ATTR: function (e, n, r) {
          return function (t) {
            t = O.attr(t, e);
            return null == t
              ? '!=' === n
              : !n ||
                  ((t += ''),
                  '=' === n
                    ? t === r
                    : '!=' === n
                      ? t !== r
                      : '^=' === n
                        ? r && 0 === t.indexOf(r)
                        : '*=' === n
                          ? r && -1 < t.indexOf(r)
                          : '$=' === n
                            ? r && t.slice(-r.length) === r
                            : '~=' === n
                              ? -1 < (' ' + t.replace(mt, ' ') + ' ').indexOf(r)
                              : '|=' === n && (t === r || t.slice(0, r.length + 1) === r + '-'));
          };
        },
        CHILD: function (h, t, e, f, g) {
          var m = 'nth' !== h.slice(0, 3),
            y = 'last' !== h.slice(-4),
            v = 'of-type' === t;
          return 1 === f && 0 === g
            ? function (t) {
                return !!t.parentNode;
              }
            : function (t, e, n) {
                var r,
                  o,
                  i,
                  s,
                  a,
                  u = m != y ? 'nextSibling' : 'previousSibling',
                  l = t.parentNode,
                  c = v && t.nodeName.toLowerCase(),
                  p = !n && !v,
                  d = !1;
                if (l) {
                  if (m) {
                    for (; u; ) {
                      for (i = t; (i = i[u]); ) if (v ? b(i, c) : 1 === i.nodeType) return !1;
                      a = u = 'only' === h && !a && 'nextSibling';
                    }
                    return !0;
                  }
                  if (((a = [y ? l.firstChild : l.lastChild]), y && p)) {
                    for (
                      d = (s = (r = (o = l[T] || (l[T] = {}))[h] || [])[0] === A && r[1]) && r[2],
                        i = s && l.childNodes[s];
                      (i = (++s && i && i[u]) || ((d = s = 0), a.pop()));

                    )
                      if (1 === i.nodeType && ++d && i === t) {
                        o[h] = [A, s, d];
                        break;
                      }
                  } else if (!1 === (d = p ? (s = (r = (o = t[T] || (t[T] = {}))[h] || [])[0] === A && r[1]) : d))
                    for (
                      ;
                      (i = (++s && i && i[u]) || ((d = s = 0), a.pop())) &&
                      ((v ? !b(i, c) : 1 !== i.nodeType) ||
                        !++d ||
                        (p && ((o = i[T] || (i[T] = {}))[h] = [A, d]), i !== t));

                    );
                  return (d -= g) === f || (d % f == 0 && 0 <= d / f);
                }
              };
        },
        PSEUDO: function (t, i) {
          var e,
            s = S.pseudos[t] || S.setFilters[t.toLowerCase()] || O.error('unsupported pseudo: ' + t);
          return s[T]
            ? s(i)
            : 1 < s.length
              ? ((e = [t, t, '', i]),
                S.setFilters.hasOwnProperty(t.toLowerCase())
                  ? u(function (t, e) {
                      for (var n, r = s(t, i), o = r.length; o--; ) t[(n = x.call(t, r[o]))] = !(e[n] = r[o]);
                    })
                  : function (t) {
                      return s(t, 0, e);
                    })
              : s;
        },
      },
      pseudos: {
        not: u(function (t) {
          var r = [],
            o = [],
            a = Bt(t.replace(tt, '$1'));
          return a[T]
            ? u(function (t, e, n, r) {
                for (var o, i = a(t, null, r, []), s = t.length; s--; ) (o = i[s]) && (t[s] = !(e[s] = o));
              })
            : function (t, e, n) {
                return (r[0] = t), a(r, null, n, o), (r[0] = null), !o.pop();
              };
        }),
        has: u(function (e) {
          return function (t) {
            return 0 < O(e, t).length;
          };
        }),
        contains: u(function (e) {
          return (
            (e = e.replace(p, h)),
            function (t) {
              return -1 < (t.textContent || P.text(t)).indexOf(e);
            }
          );
        }),
        lang: u(function (n) {
          return (
            St.test(n || '') || O.error('unsupported lang: ' + n),
            (n = n.replace(p, h).toLowerCase()),
            function (t) {
              var e;
              do {
                if ((e = E ? t.lang : t.getAttribute('xml:lang') || t.getAttribute('lang')))
                  return (e = e.toLowerCase()) === n || 0 === e.indexOf(n + '-');
              } while ((t = t.parentNode) && 1 === t.nodeType);
              return !1;
            }
          );
        }),
        target: function (t) {
          var e = w.location && w.location.hash;
          return e && e.slice(1) === t.id;
        },
        root: function (t) {
          return t === r;
        },
        focus: function (t) {
          return (
            t ===
              (() => {
                try {
                  return k.activeElement;
                } catch (t) {}
              })() &&
            k.hasFocus() &&
            !!(t.type || t.href || ~t.tabIndex)
          );
        },
        enabled: Rt(!1),
        disabled: Rt(!0),
        checked: function (t) {
          return (b(t, 'input') && !!t.checked) || (b(t, 'option') && !!t.selected);
        },
        selected: function (t) {
          return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected;
        },
        empty: function (t) {
          for (t = t.firstChild; t; t = t.nextSibling) if (t.nodeType < 6) return !1;
          return !0;
        },
        parent: function (t) {
          return !S.pseudos.empty(t);
        },
        header: function (t) {
          return Pt.test(t.nodeName);
        },
        input: function (t) {
          return _t.test(t.nodeName);
        },
        button: function (t) {
          return (b(t, 'input') && 'button' === t.type) || b(t, 'button');
        },
        text: function (t) {
          return (
            b(t, 'input') && 'text' === t.type && (null == (t = t.getAttribute('type')) || 'text' === t.toLowerCase())
          );
        },
        first: It(function () {
          return [0];
        }),
        last: It(function (t, e) {
          return [e - 1];
        }),
        eq: It(function (t, e, n) {
          return [n < 0 ? n + e : n];
        }),
        even: It(function (t, e) {
          for (var n = 0; n < e; n += 2) t.push(n);
          return t;
        }),
        odd: It(function (t, e) {
          for (var n = 1; n < e; n += 2) t.push(n);
          return t;
        }),
        lt: It(function (t, e, n) {
          for (var r = n < 0 ? n + e : e < n ? e : n; 0 <= --r; ) t.push(r);
          return t;
        }),
        gt: It(function (t, e, n) {
          for (var r = n < 0 ? n + e : n; ++r < e; ) t.push(r);
          return t;
        }),
      },
    }).pseudos.nth = S.pseudos.eq),
  {radio: !0, checkbox: !0, file: !0, password: !0, image: !0}))
    S.pseudos[rt] = ((e) =>
      function (t) {
        return b(t, 'input') && t.type === e;
      })(rt);
  for (rt in {submit: !0, reset: !0})
    S.pseudos[rt] = ((e) =>
      function (t) {
        return (b(t, 'input') || b(t, 'button')) && t.type === e;
      })(rt);
  function Lt() {}
  function Ut(t, e) {
    var n,
      r,
      o,
      i,
      s,
      a,
      u,
      l = pt[t + ' '];
    if (l) return e ? 0 : l.slice(0);
    for (s = t, a = [], u = S.preFilter; s; ) {
      for (i in ((n && !(r = yt.exec(s))) || (r && (s = s.slice(r[0].length) || s), a.push((o = []))),
      (n = !1),
      (r = vt.exec(s)) && ((n = r.shift()), o.push({value: n, type: r[0].replace(tt, ' ')}), (s = s.slice(n.length))),
      S.filter))
        !(r = wt[i].exec(s)) ||
          (u[i] && !(r = u[i](r))) ||
          ((n = r.shift()), o.push({value: n, type: i, matches: r}), (s = s.slice(n.length)));
      if (!n) break;
    }
    return e ? s.length : s ? O.error(t) : pt(t, a).slice(0);
  }
  function Mt(t) {
    for (var e = 0, n = t.length, r = ''; e < n; e++) r += t[e].value;
    return r;
  }
  function Ht(s, t, e) {
    var a = t.dir,
      u = t.next,
      l = u || a,
      c = e && 'parentNode' === l,
      p = lt++;
    return t.first
      ? function (t, e, n) {
          for (; (t = t[a]); ) if (1 === t.nodeType || c) return s(t, e, n);
          return !1;
        }
      : function (t, e, n) {
          var r,
            o,
            i = [A, p];
          if (n) {
            for (; (t = t[a]); ) if ((1 === t.nodeType || c) && s(t, e, n)) return !0;
          } else
            for (; (t = t[a]); )
              if (1 === t.nodeType || c)
                if (((o = t[T] || (t[T] = {})), u && b(t, u))) t = t[a] || t;
                else {
                  if ((r = o[l]) && r[0] === A && r[1] === p) return (i[2] = r[2]);
                  if (((o[l] = i)[2] = s(t, e, n))) return !0;
                }
          return !1;
        };
  }
  function jt(o) {
    return 1 < o.length
      ? function (t, e, n) {
          for (var r = o.length; r--; ) if (!o[r](t, e, n)) return !1;
          return !0;
        }
      : o[0];
  }
  function Ft(t, e, n, r, o) {
    for (var i, s = [], a = 0, u = t.length, l = null != e; a < u; a++)
      !(i = t[a]) || (n && !n(i, r, o)) || (s.push(i), l && e.push(a));
    return s;
  }
  function qt(h, f, g, m, y, t) {
    return (
      m && !m[T] && (m = qt(m)),
      y && !y[T] && (y = qt(y, t)),
      u(function (t, e, n, r) {
        var o,
          i,
          s,
          a,
          u = [],
          l = [],
          c = e.length,
          p =
            t ||
            ((t, e, n) => {
              for (var r = 0, o = e.length; r < o; r++) O(t, e[r], n);
              return n;
            })(f || '*', n.nodeType ? [n] : n, []),
          d = !h || (!t && f) ? p : Ft(p, u, h, n, r);
        if ((g ? g(d, (a = y || (t ? h : c || m) ? [] : e), n, r) : (a = d), m))
          for (o = Ft(a, l), m(o, [], n, r), i = o.length; i--; ) (s = o[i]) && (a[l[i]] = !(d[l[i]] = s));
        if (t) {
          if (y || h) {
            if (y) {
              for (o = [], i = a.length; i--; ) (s = a[i]) && o.push((d[i] = s));
              y(null, (a = []), o, r);
            }
            for (i = a.length; i--; ) (s = a[i]) && -1 < (o = y ? x.call(t, s) : u[i]) && (t[o] = !(e[o] = s));
          }
        } else (a = Ft(a === e ? a.splice(c, a.length) : a)), y ? y(null, e, a, r) : C.apply(e, a);
      })
    );
  }
  function Bt(t, e) {
    var n,
      m,
      y,
      v,
      b,
      r,
      o = [],
      i = [],
      s = dt[t + ' '];
    if (!s) {
      for (n = (e = e || Ut(t)).length; n--; )
        ((s = (function t(e) {
          for (
            var r,
              n,
              o,
              i = e.length,
              s = S.relative[e[0].type],
              a = s || S.relative[' '],
              u = s ? 1 : 0,
              l = Ht(
                function (t) {
                  return t === r;
                },
                a,
                !0
              ),
              c = Ht(
                function (t) {
                  return -1 < x.call(r, t);
                },
                a,
                !0
              ),
              p = [
                function (t, e, n) {
                  return (t = (!s && (n || e != ot)) || ((r = e).nodeType ? l : c)(t, e, n)), (r = null), t;
                },
              ];
            u < i;
            u++
          )
            if ((n = S.relative[e[u].type])) p = [Ht(jt(p), n)];
            else {
              if ((n = S.filter[e[u].type].apply(null, e[u].matches))[T]) {
                for (o = ++u; o < i && !S.relative[e[o].type]; o++);
                return qt(
                  1 < u && jt(p),
                  1 < u && Mt(e.slice(0, u - 1).concat({value: ' ' === e[u - 2].type ? '*' : ''})).replace(tt, '$1'),
                  n,
                  u < o && t(e.slice(u, o)),
                  o < i && t((e = e.slice(o))),
                  o < i && Mt(e)
                );
              }
              p.push(n);
            }
          return jt(p);
        })(e[n]))[T]
          ? o
          : i
        ).push(s);
      (s = dt(
        t,
        ((v = 0 < (y = o).length),
        (b = 0 < (m = i).length),
        (r = function (t, e, n, r, o) {
          var i,
            s,
            a,
            u = 0,
            l = '0',
            c = t && [],
            p = [],
            d = ot,
            h = t || (b && S.find.TAG('*', o)),
            f = (A += null == d ? 1 : Math.random() || 0.1),
            g = h.length;
          for (o && (ot = e == k || e || o); l !== g && null != (i = h[l]); l++) {
            if (b && i) {
              for (s = 0, e || i.ownerDocument == k || (Nt(i), (n = !E)); (a = m[s++]); )
                if (a(i, e || k, n)) {
                  C.call(r, i);
                  break;
                }
              o && (A = f);
            }
            v && ((i = !a && i) && u--, t) && c.push(i);
          }
          if (((u += l), v && l !== u)) {
            for (s = 0; (a = y[s++]); ) a(c, p, e, n);
            if (t) {
              if (0 < u) for (; l--; ) c[l] || p[l] || (p[l] = X.call(r));
              p = Ft(p);
            }
            C.apply(r, p), o && !t && 0 < p.length && 1 < u + y.length && P.uniqueSort(r);
          }
          return o && ((A = f), (ot = d)), c;
        }),
        v ? u(r) : r)
      )).selector = t;
    }
    return s;
  }
  function $t(t, e, n, r) {
    var o,
      i,
      s,
      a,
      u,
      l = 'function' == typeof t && t,
      c = !r && Ut((t = l.selector || t));
    if (((n = n || []), 1 === c.length)) {
      if (
        2 < (i = c[0] = c[0].slice(0)).length &&
        'ID' === (s = i[0]).type &&
        9 === e.nodeType &&
        E &&
        S.relative[i[1].type]
      ) {
        if (!(e = (S.find.ID(s.matches[0].replace(p, h), e) || [])[0])) return n;
        l && (e = e.parentNode), (t = t.slice(i.shift().value.length));
      }
      for (o = wt.needsContext.test(t) ? 0 : i.length; o-- && ((s = i[o]), !S.relative[(a = s.type)]); )
        if ((u = S.find[a]) && (r = u(s.matches[0].replace(p, h), (Et.test(i[0].type) && Dt(e.parentNode)) || e))) {
          if ((i.splice(o, 1), (t = r.length && Mt(i)))) break;
          return C.apply(n, r), n;
        }
    }
    return (l || Bt(t, c))(r, e, !E, n, !e || (Et.test(t) && Dt(e.parentNode)) || e), n;
  }
  (Lt.prototype = S.filters = S.pseudos),
    (S.setFilters = new Lt()),
    (g.sortStable = T.split('').sort(ft).join('') === T),
    Nt(),
    (g.sortDetached = Ot(function (t) {
      return 1 & t.compareDocumentPosition(k.createElement('fieldset'));
    })),
    (P.find = O),
    (P.expr[':'] = P.expr.pseudos),
    (P.unique = P.uniqueSort),
    (O.compile = Bt),
    (O.select = $t),
    (O.setDocument = Nt),
    (O.tokenize = Ut),
    (O.escape = P.escapeSelector),
    (O.getText = P.text),
    (O.isXML = P.isXMLDoc),
    (O.selectors = P.expr),
    (O.support = P.support),
    (O.uniqueSort = P.uniqueSort);
  function Wt(t, e, n) {
    for (var r = [], o = void 0 !== n; (t = t[e]) && 9 !== t.nodeType; )
      if (1 === t.nodeType) {
        if (o && P(t).is(n)) break;
        r.push(t);
      }
    return r;
  }
  function Gt(t, e) {
    for (var n = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && n.push(t);
    return n;
  }
  var Qt = P.expr.match.needsContext,
    Kt = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function zt(t, n, r) {
    return v(n)
      ? P.grep(t, function (t, e) {
          return !!n.call(t, e, t) !== r;
        })
      : n.nodeType
        ? P.grep(t, function (t) {
            return (t === n) !== r;
          })
        : 'string' != typeof n
          ? P.grep(t, function (t) {
              return -1 < x.call(n, t) !== r;
            })
          : P.filter(n, t, r);
  }
  (P.filter = function (t, e, n) {
    var r = e[0];
    return (
      n && (t = ':not(' + t + ')'),
      1 === e.length && 1 === r.nodeType
        ? P.find.matchesSelector(r, t)
          ? [r]
          : []
        : P.find.matches(
            t,
            P.grep(e, function (t) {
              return 1 === t.nodeType;
            })
          )
    );
  }),
    P.fn.extend({
      find: function (t) {
        var e,
          n,
          r = this.length,
          o = this;
        if ('string' != typeof t)
          return this.pushStack(
            P(t).filter(function () {
              for (e = 0; e < r; e++) if (P.contains(o[e], this)) return !0;
            })
          );
        for (n = this.pushStack([]), e = 0; e < r; e++) P.find(t, o[e], n);
        return 1 < r ? P.uniqueSort(n) : n;
      },
      filter: function (t) {
        return this.pushStack(zt(this, t || [], !1));
      },
      not: function (t) {
        return this.pushStack(zt(this, t || [], !0));
      },
      is: function (t) {
        return !!zt(this, 'string' == typeof t && Qt.test(t) ? P(t) : t || [], !1).length;
      },
    });
  var Vt,
    Yt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
    Xt =
      (((P.fn.init = function (t, e, n) {
        if (t) {
          if (((n = n || Vt), 'string' != typeof t))
            return t.nodeType
              ? ((this[0] = t), (this.length = 1), this)
              : v(t)
                ? void 0 !== n.ready
                  ? n.ready(t)
                  : t(P)
                : P.makeArray(t, this);
          if (
            !(r = '<' === t[0] && '>' === t[t.length - 1] && 3 <= t.length ? [null, t, null] : Yt.exec(t)) ||
            (!r[1] && e)
          )
            return (!e || e.jquery ? e || n : this.constructor(e)).find(t);
          if (r[1]) {
            if (
              ((e = e instanceof P ? e[0] : e),
              P.merge(this, P.parseHTML(r[1], e && e.nodeType ? e.ownerDocument || e : _, !0)),
              Kt.test(r[1]) && P.isPlainObject(e))
            )
              for (var r in e) v(this[r]) ? this[r](e[r]) : this.attr(r, e[r]);
          } else (n = _.getElementById(r[2])) && ((this[0] = n), (this.length = 1));
        }
        return this;
      }).prototype = P.fn),
      (Vt = P(_)),
      /^(?:parents|prev(?:Until|All))/),
    Jt = {children: !0, contents: !0, next: !0, prev: !0};
  function Zt(t, e) {
    for (; (t = t[e]) && 1 !== t.nodeType; );
    return t;
  }
  P.fn.extend({
    has: function (t) {
      var e = P(t, this),
        n = e.length;
      return this.filter(function () {
        for (var t = 0; t < n; t++) if (P.contains(this, e[t])) return !0;
      });
    },
    closest: function (t, e) {
      var n,
        r = 0,
        o = this.length,
        i = [],
        s = 'string' != typeof t && P(t);
      if (!Qt.test(t))
        for (; r < o; r++)
          for (n = this[r]; n && n !== e; n = n.parentNode)
            if (n.nodeType < 11 && (s ? -1 < s.index(n) : 1 === n.nodeType && P.find.matchesSelector(n, t))) {
              i.push(n);
              break;
            }
      return this.pushStack(1 < i.length ? P.uniqueSort(i) : i);
    },
    index: function (t) {
      return t
        ? 'string' == typeof t
          ? x.call(P(t), this[0])
          : x.call(this, t.jquery ? t[0] : t)
        : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
    },
    add: function (t, e) {
      return this.pushStack(P.uniqueSort(P.merge(this.get(), P(t, e))));
    },
    addBack: function (t) {
      return this.add(null == t ? this.prevObject : this.prevObject.filter(t));
    },
  }),
    P.each(
      {
        parent: function (t) {
          t = t.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function (t) {
          return Wt(t, 'parentNode');
        },
        parentsUntil: function (t, e, n) {
          return Wt(t, 'parentNode', n);
        },
        next: function (t) {
          return Zt(t, 'nextSibling');
        },
        prev: function (t) {
          return Zt(t, 'previousSibling');
        },
        nextAll: function (t) {
          return Wt(t, 'nextSibling');
        },
        prevAll: function (t) {
          return Wt(t, 'previousSibling');
        },
        nextUntil: function (t, e, n) {
          return Wt(t, 'nextSibling', n);
        },
        prevUntil: function (t, e, n) {
          return Wt(t, 'previousSibling', n);
        },
        siblings: function (t) {
          return Gt((t.parentNode || {}).firstChild, t);
        },
        children: function (t) {
          return Gt(t.firstChild);
        },
        contents: function (t) {
          return null != t.contentDocument && H(t.contentDocument)
            ? t.contentDocument
            : (b(t, 'template') && (t = t.content || t), P.merge([], t.childNodes));
        },
      },
      function (r, o) {
        P.fn[r] = function (t, e) {
          var n = P.map(this, o, t);
          return (
            (e = 'Until' !== r.slice(-5) ? t : e) && 'string' == typeof e && (n = P.filter(e, n)),
            1 < this.length && (Jt[r] || P.uniqueSort(n), Xt.test(r)) && n.reverse(),
            this.pushStack(n)
          );
        };
      }
    );
  var R = /[^\x20\t\r\n\f]+/g;
  function te(t) {
    return t;
  }
  function ee(t) {
    throw t;
  }
  function ne(t, e, n, r) {
    var o;
    try {
      t && v((o = t.promise))
        ? o.call(t).done(e).fail(n)
        : t && v((o = t.then))
          ? o.call(t, e, n)
          : e.apply(void 0, [t].slice(r));
    } catch (t) {
      n.apply(void 0, [t]);
    }
  }
  (P.Callbacks = function (r) {
    var t, n;
    r =
      'string' == typeof r
        ? ((t = r),
          (n = {}),
          P.each(t.match(R) || [], function (t, e) {
            n[e] = !0;
          }),
          n)
        : P.extend({}, r);
    function o() {
      for (a = a || r.once, s = i = !0; l.length; c = -1)
        for (e = l.shift(); ++c < u.length; )
          !1 === u[c].apply(e[0], e[1]) && r.stopOnFalse && ((c = u.length), (e = !1));
      r.memory || (e = !1), (i = !1), a && (u = e ? [] : '');
    }
    var i,
      e,
      s,
      a,
      u = [],
      l = [],
      c = -1,
      p = {
        add: function () {
          return (
            u &&
              (e && !i && ((c = u.length - 1), l.push(e)),
              (function n(t) {
                P.each(t, function (t, e) {
                  v(e) ? (r.unique && p.has(e)) || u.push(e) : e && e.length && 'string' !== z(e) && n(e);
                });
              })(arguments),
              e) &&
              !i &&
              o(),
            this
          );
        },
        remove: function () {
          return (
            P.each(arguments, function (t, e) {
              for (var n; -1 < (n = P.inArray(e, u, n)); ) u.splice(n, 1), n <= c && c--;
            }),
            this
          );
        },
        has: function (t) {
          return t ? -1 < P.inArray(t, u) : 0 < u.length;
        },
        empty: function () {
          return (u = u && []), this;
        },
        disable: function () {
          return (a = l = []), (u = e = ''), this;
        },
        disabled: function () {
          return !u;
        },
        lock: function () {
          return (a = l = []), e || i || (u = e = ''), this;
        },
        locked: function () {
          return !!a;
        },
        fireWith: function (t, e) {
          return a || ((e = [t, (e = e || []).slice ? e.slice() : e]), l.push(e), i) || o(), this;
        },
        fire: function () {
          return p.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!s;
        },
      };
    return p;
  }),
    P.extend({
      Deferred: function (t) {
        var i = [
            ['notify', 'progress', P.Callbacks('memory'), P.Callbacks('memory'), 2],
            ['resolve', 'done', P.Callbacks('once memory'), P.Callbacks('once memory'), 0, 'resolved'],
            ['reject', 'fail', P.Callbacks('once memory'), P.Callbacks('once memory'), 1, 'rejected'],
          ],
          o = 'pending',
          s = {
            state: function () {
              return o;
            },
            always: function () {
              return a.done(arguments).fail(arguments), this;
            },
            catch: function (t) {
              return s.then(null, t);
            },
            pipe: function () {
              var o = arguments;
              return P.Deferred(function (r) {
                P.each(i, function (t, e) {
                  var n = v(o[e[4]]) && o[e[4]];
                  a[e[1]](function () {
                    var t = n && n.apply(this, arguments);
                    t && v(t.promise)
                      ? t.promise().progress(r.notify).done(r.resolve).fail(r.reject)
                      : r[e[0] + 'With'](this, n ? [t] : arguments);
                  });
                }),
                  (o = null);
              }).promise();
            },
            then: function (e, n, r) {
              var u = 0;
              function l(o, i, s, a) {
                return function () {
                  function t() {
                    var t, e;
                    if (!(o < u)) {
                      if ((t = s.apply(n, r)) === i.promise()) throw new TypeError('Thenable self-resolution');
                      (e = t && ('object' == typeof t || 'function' == typeof t) && t.then),
                        v(e)
                          ? a
                            ? e.call(t, l(u, i, te, a), l(u, i, ee, a))
                            : (u++, e.call(t, l(u, i, te, a), l(u, i, ee, a), l(u, i, te, i.notifyWith)))
                          : (s !== te && ((n = void 0), (r = [t])), (a || i.resolveWith)(n, r));
                    }
                  }
                  var n = this,
                    r = arguments,
                    e = a
                      ? t
                      : function () {
                          try {
                            t();
                          } catch (t) {
                            P.Deferred.exceptionHook && P.Deferred.exceptionHook(t, e.error),
                              u <= o + 1 && (s !== ee && ((n = void 0), (r = [t])), i.rejectWith(n, r));
                          }
                        };
                  o
                    ? e()
                    : (P.Deferred.getErrorHook
                        ? (e.error = P.Deferred.getErrorHook())
                        : P.Deferred.getStackHook && (e.error = P.Deferred.getStackHook()),
                      w.setTimeout(e));
                };
              }
              return P.Deferred(function (t) {
                i[0][3].add(l(0, t, v(r) ? r : te, t.notifyWith)),
                  i[1][3].add(l(0, t, v(e) ? e : te)),
                  i[2][3].add(l(0, t, v(n) ? n : ee));
              }).promise();
            },
            promise: function (t) {
              return null != t ? P.extend(t, s) : s;
            },
          },
          a = {};
        return (
          P.each(i, function (t, e) {
            var n = e[2],
              r = e[5];
            (s[e[1]] = n.add),
              r &&
                n.add(
                  function () {
                    o = r;
                  },
                  i[3 - t][2].disable,
                  i[3 - t][3].disable,
                  i[0][2].lock,
                  i[0][3].lock
                ),
              n.add(e[3].fire),
              (a[e[0]] = function () {
                return a[e[0] + 'With'](this === a ? void 0 : this, arguments), this;
              }),
              (a[e[0] + 'With'] = n.fireWith);
          }),
          s.promise(a),
          t && t.call(a, a),
          a
        );
      },
      when: function (t) {
        function e(e) {
          return function (t) {
            (o[e] = this), (i[e] = 1 < arguments.length ? a.call(arguments) : t), --n || s.resolveWith(o, i);
          };
        }
        var n = arguments.length,
          r = n,
          o = Array(r),
          i = a.call(arguments),
          s = P.Deferred();
        if (n <= 1 && (ne(t, s.done(e(r)).resolve, s.reject, !n), 'pending' === s.state() || v(i[r] && i[r].then)))
          return s.then();
        for (; r--; ) ne(i[r], e(r), s.reject);
        return s.promise();
      },
    });
  var re = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/,
    oe =
      ((P.Deferred.exceptionHook = function (t, e) {
        w.console &&
          w.console.warn &&
          t &&
          re.test(t.name) &&
          w.console.warn('jQuery.Deferred exception: ' + t.message, t.stack, e);
      }),
      (P.readyException = function (t) {
        w.setTimeout(function () {
          throw t;
        });
      }),
      P.Deferred());
  function ie() {
    _.removeEventListener('DOMContentLoaded', ie), w.removeEventListener('load', ie), P.ready();
  }
  (P.fn.ready = function (t) {
    return (
      oe.then(t).catch(function (t) {
        P.readyException(t);
      }),
      this
    );
  }),
    P.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (t) {
        (!0 === t ? --P.readyWait : P.isReady) ||
          ((P.isReady = !0) !== t && 0 < --P.readyWait) ||
          oe.resolveWith(_, [P]);
      },
    }),
    (P.ready.then = oe.then),
    'complete' === _.readyState || ('loading' !== _.readyState && !_.documentElement.doScroll)
      ? w.setTimeout(P.ready)
      : (_.addEventListener('DOMContentLoaded', ie), w.addEventListener('load', ie));
  function c(t, e, n, r, o, i, s) {
    var a = 0,
      u = t.length,
      l = null == n;
    if ('object' === z(n)) for (a in ((o = !0), n)) c(t, e, a, n[a], !0, i, s);
    else if (
      void 0 !== r &&
      ((o = !0),
      v(r) || (s = !0),
      (e = l
        ? s
          ? (e.call(t, r), null)
          : ((l = e),
            function (t, e, n) {
              return l.call(P(t), n);
            })
        : e))
    )
      for (; a < u; a++) e(t[a], n, s ? r : r.call(t[a], a, e(t[a], n)));
    return o ? t : l ? e.call(t) : u ? e(t[0], n) : i;
  }
  var se = /^-ms-/,
    ae = /-([a-z])/g;
  function ue(t, e) {
    return e.toUpperCase();
  }
  function I(t) {
    return t.replace(se, 'ms-').replace(ae, ue);
  }
  function le(t) {
    return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
  }
  function ce() {
    this.expando = P.expando + ce.uid++;
  }
  (ce.uid = 1),
    (ce.prototype = {
      cache: function (t) {
        var e = t[this.expando];
        return (
          e ||
            ((e = {}),
            le(t) &&
              (t.nodeType
                ? (t[this.expando] = e)
                : Object.defineProperty(t, this.expando, {value: e, configurable: !0}))),
          e
        );
      },
      set: function (t, e, n) {
        var r,
          o = this.cache(t);
        if ('string' == typeof e) o[I(e)] = n;
        else for (r in e) o[I(r)] = e[r];
        return o;
      },
      get: function (t, e) {
        return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][I(e)];
      },
      access: function (t, e, n) {
        return void 0 === e || (e && 'string' == typeof e && void 0 === n)
          ? this.get(t, e)
          : (this.set(t, e, n), void 0 !== n ? n : e);
      },
      remove: function (t, e) {
        var n,
          r = t[this.expando];
        if (void 0 !== r) {
          if (void 0 !== e) {
            n = (e = Array.isArray(e) ? e.map(I) : (e = I(e)) in r ? [e] : e.match(R) || []).length;
            for (; n--; ) delete r[e[n]];
          }
          (void 0 !== e && !P.isEmptyObject(r)) || (t.nodeType ? (t[this.expando] = void 0) : delete t[this.expando]);
        }
      },
      hasData: function (t) {
        t = t[this.expando];
        return void 0 !== t && !P.isEmptyObject(t);
      },
    });
  var y = new ce(),
    l = new ce(),
    pe = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    de = /[A-Z]/g;
  function he(t, e, n) {
    var r, o;
    if (void 0 === n && 1 === t.nodeType)
      if (((r = 'data-' + e.replace(de, '-$&').toLowerCase()), 'string' == typeof (n = t.getAttribute(r)))) {
        try {
          n =
            'true' === (o = n) ||
            ('false' !== o && ('null' === o ? null : o === +o + '' ? +o : pe.test(o) ? JSON.parse(o) : o));
        } catch (t) {}
        l.set(t, e, n);
      } else n = void 0;
    return n;
  }
  P.extend({
    hasData: function (t) {
      return l.hasData(t) || y.hasData(t);
    },
    data: function (t, e, n) {
      return l.access(t, e, n);
    },
    removeData: function (t, e) {
      l.remove(t, e);
    },
    _data: function (t, e, n) {
      return y.access(t, e, n);
    },
    _removeData: function (t, e) {
      y.remove(t, e);
    },
  }),
    P.fn.extend({
      data: function (n, t) {
        var e,
          r,
          o,
          i = this[0],
          s = i && i.attributes;
        if (void 0 !== n)
          return 'object' == typeof n
            ? this.each(function () {
                l.set(this, n);
              })
            : c(
                this,
                function (t) {
                  var e;
                  if (i && void 0 === t) return void 0 !== (e = l.get(i, n)) || void 0 !== (e = he(i, n)) ? e : void 0;
                  this.each(function () {
                    l.set(this, n, t);
                  });
                },
                null,
                t,
                1 < arguments.length,
                null,
                !0
              );
        if (this.length && ((o = l.get(i)), 1 === i.nodeType) && !y.get(i, 'hasDataAttrs')) {
          for (e = s.length; e--; )
            s[e] && 0 === (r = s[e].name).indexOf('data-') && ((r = I(r.slice(5))), he(i, r, o[r]));
          y.set(i, 'hasDataAttrs', !0);
        }
        return o;
      },
      removeData: function (t) {
        return this.each(function () {
          l.remove(this, t);
        });
      },
    }),
    P.extend({
      queue: function (t, e, n) {
        var r;
        if (t)
          return (
            (r = y.get(t, (e = (e || 'fx') + 'queue'))),
            n && (!r || Array.isArray(n) ? (r = y.access(t, e, P.makeArray(n))) : r.push(n)),
            r || []
          );
      },
      dequeue: function (t, e) {
        e = e || 'fx';
        var n = P.queue(t, e),
          r = n.length,
          o = n.shift(),
          i = P._queueHooks(t, e);
        'inprogress' === o && ((o = n.shift()), r--),
          o &&
            ('fx' === e && n.unshift('inprogress'),
            delete i.stop,
            o.call(
              t,
              function () {
                P.dequeue(t, e);
              },
              i
            )),
          !r && i && i.empty.fire();
      },
      _queueHooks: function (t, e) {
        var n = e + 'queueHooks';
        return (
          y.get(t, n) ||
          y.access(t, n, {
            empty: P.Callbacks('once memory').add(function () {
              y.remove(t, [e + 'queue', n]);
            }),
          })
        );
      },
    }),
    P.fn.extend({
      queue: function (e, n) {
        var t = 2;
        return (
          'string' != typeof e && ((n = e), (e = 'fx'), t--),
          arguments.length < t
            ? P.queue(this[0], e)
            : void 0 === n
              ? this
              : this.each(function () {
                  var t = P.queue(this, e, n);
                  P._queueHooks(this, e), 'fx' === e && 'inprogress' !== t[0] && P.dequeue(this, e);
                })
        );
      },
      dequeue: function (t) {
        return this.each(function () {
          P.dequeue(this, t);
        });
      },
      clearQueue: function (t) {
        return this.queue(t || 'fx', []);
      },
      promise: function (t, e) {
        function n() {
          --o || i.resolveWith(s, [s]);
        }
        var r,
          o = 1,
          i = P.Deferred(),
          s = this,
          a = this.length;
        for ('string' != typeof t && ((e = t), (t = void 0)), t = t || 'fx'; a--; )
          (r = y.get(s[a], t + 'queueHooks')) && r.empty && (o++, r.empty.add(n));
        return n(), i.promise(e);
      },
    });
  function fe(t, e) {
    return 'none' === (t = e || t).style.display || ('' === t.style.display && ve(t) && 'none' === P.css(t, 'display'));
  }
  var t = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    ge = new RegExp('^(?:([+-])=|)(' + t + ')([a-z%]*)$', 'i'),
    me = ['Top', 'Right', 'Bottom', 'Left'],
    ye = _.documentElement,
    ve = function (t) {
      return P.contains(t.ownerDocument, t);
    },
    be = {composed: !0};
  ye.getRootNode &&
    (ve = function (t) {
      return P.contains(t.ownerDocument, t) || t.getRootNode(be) === t.ownerDocument;
    });
  function xe(t, e, n, r) {
    var o,
      i,
      s = 20,
      a = r
        ? function () {
            return r.cur();
          }
        : function () {
            return P.css(t, e, '');
          },
      u = a(),
      l = (n && n[3]) || (P.cssNumber[e] ? '' : 'px'),
      c = t.nodeType && (P.cssNumber[e] || ('px' !== l && +u)) && ge.exec(P.css(t, e));
    if (c && c[3] !== l) {
      for (l = l || c[3], c = +(u /= 2) || 1; s--; )
        P.style(t, e, c + l), (1 - i) * (1 - (i = a() / u || 0.5)) <= 0 && (s = 0), (c /= i);
      P.style(t, e, (c *= 2) + l), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +u || 0), (o = n[1] ? c + (n[1] + 1) * n[2] : +n[2]), r) &&
        ((r.unit = l), (r.start = c), (r.end = o)),
      o
    );
  }
  var Se = {};
  function we(t, e) {
    for (var n, r, o, i, s, a, u = [], l = 0, c = t.length; l < c; l++)
      (r = t[l]).style &&
        ((n = r.style.display),
        e
          ? ('none' === n && ((u[l] = y.get(r, 'display') || null), u[l] || (r.style.display = '')),
            '' === r.style.display &&
              fe(r) &&
              (u[l] =
                ((a = i = o = void 0),
                (i = r.ownerDocument),
                (a = Se[(s = r.nodeName)]) ||
                  ((o = i.body.appendChild(i.createElement(s))),
                  (a = P.css(o, 'display')),
                  o.parentNode.removeChild(o),
                  (Se[s] = a = 'none' === a ? 'block' : a)))))
          : 'none' !== n && ((u[l] = 'none'), y.set(r, 'display', n)));
    for (l = 0; l < c; l++) null != u[l] && (t[l].style.display = u[l]);
    return t;
  }
  P.fn.extend({
    show: function () {
      return we(this, !0);
    },
    hide: function () {
      return we(this);
    },
    toggle: function (t) {
      return 'boolean' == typeof t
        ? t
          ? this.show()
          : this.hide()
        : this.each(function () {
            fe(this) ? P(this).show() : P(this).hide();
          });
    },
  });
  var _e = /^(?:checkbox|radio)$/i,
    Pe = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
    ke = /^$|^module$|\/(?:java|ecma)script/i,
    i = _.createDocumentFragment().appendChild(_.createElement('div')),
    f =
      ((s = _.createElement('input')).setAttribute('type', 'radio'),
      s.setAttribute('checked', 'checked'),
      s.setAttribute('name', 't'),
      i.appendChild(s),
      (g.checkClone = i.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (i.innerHTML = '<textarea>x</textarea>'),
      (g.noCloneChecked = !!i.cloneNode(!0).lastChild.defaultValue),
      (i.innerHTML = '<option></option>'),
      (g.option = !!i.lastChild),
      {
        thead: [1, '<table>', '</table>'],
        col: [2, '<table><colgroup>', '</colgroup></table>'],
        tr: [2, '<table><tbody>', '</tbody></table>'],
        td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
        _default: [0, '', ''],
      });
  function m(t, e) {
    var n =
      void 0 !== t.getElementsByTagName
        ? t.getElementsByTagName(e || '*')
        : void 0 !== t.querySelectorAll
          ? t.querySelectorAll(e || '*')
          : [];
    return void 0 === e || (e && b(t, e)) ? P.merge([t], n) : n;
  }
  function Ee(t, e) {
    for (var n = 0, r = t.length; n < r; n++) y.set(t[n], 'globalEval', !e || y.get(e[n], 'globalEval'));
  }
  (f.tbody = f.tfoot = f.colgroup = f.caption = f.thead),
    (f.th = f.td),
    g.option || (f.optgroup = f.option = [1, "<select multiple='multiple'>", '</select>']);
  var Ce = /<|&#?\w+;/;
  function Te(t, e, n, r, o) {
    for (var i, s, a, u, l, c = e.createDocumentFragment(), p = [], d = 0, h = t.length; d < h; d++)
      if ((i = t[d]) || 0 === i)
        if ('object' === z(i)) P.merge(p, i.nodeType ? [i] : i);
        else if (Ce.test(i)) {
          for (
            s = s || c.appendChild(e.createElement('div')),
              a = (Pe.exec(i) || ['', ''])[1].toLowerCase(),
              a = f[a] || f._default,
              s.innerHTML = a[1] + P.htmlPrefilter(i) + a[2],
              l = a[0];
            l--;

          )
            s = s.lastChild;
          P.merge(p, s.childNodes), ((s = c.firstChild).textContent = '');
        } else p.push(e.createTextNode(i));
    for (c.textContent = '', d = 0; (i = p[d++]); )
      if (r && -1 < P.inArray(i, r)) o && o.push(i);
      else if (((u = ve(i)), (s = m(c.appendChild(i), 'script')), u && Ee(s), n))
        for (l = 0; (i = s[l++]); ) ke.test(i.type || '') && n.push(i);
    return c;
  }
  var Ae = /^([^.]*)(?:\.(.+)|)/;
  function Oe() {
    return !0;
  }
  function Re() {
    return !1;
  }
  function Ie(t, e, n, r, o, i) {
    var s, a;
    if ('object' == typeof e) {
      for (a in ('string' != typeof n && ((r = r || n), (n = void 0)), e)) Ie(t, a, n, r, e[a], i);
      return t;
    }
    if (
      (null == r && null == o
        ? ((o = n), (r = n = void 0))
        : null == o && ('string' == typeof n ? ((o = r), (r = void 0)) : ((o = r), (r = n), (n = void 0))),
      !1 === o)
    )
      o = Re;
    else if (!o) return t;
    return (
      1 === i &&
        ((s = o),
        ((o = function (t) {
          return P().off(t), s.apply(this, arguments);
        }).guid = s.guid || (s.guid = P.guid++))),
      t.each(function () {
        P.event.add(this, e, o, r, n);
      })
    );
  }
  function De(t, r, e) {
    e
      ? (y.set(t, r, !1),
        P.event.add(t, r, {
          namespace: !1,
          handler: function (t) {
            var e,
              n = y.get(this, r);
            if (1 & t.isTrigger && this[r]) {
              if (n) (P.event.special[r] || {}).delegateType && t.stopPropagation();
              else if (
                ((n = a.call(arguments)),
                y.set(this, r, n),
                this[r](),
                (e = y.get(this, r)),
                y.set(this, r, !1),
                n !== e)
              )
                return t.stopImmediatePropagation(), t.preventDefault(), e;
            } else
              n &&
                (y.set(this, r, P.event.trigger(n[0], n.slice(1), this)),
                t.stopPropagation(),
                (t.isImmediatePropagationStopped = Oe));
          },
        }))
      : void 0 === y.get(t, r) && P.event.add(t, r, Oe);
  }
  (P.event = {
    global: {},
    add: function (e, t, n, r, o) {
      var i,
        s,
        a,
        u,
        l,
        c,
        p,
        d,
        h,
        f = y.get(e);
      if (le(e))
        for (
          n.handler && ((n = (i = n).handler), (o = i.selector)),
            o && P.find.matchesSelector(ye, o),
            n.guid || (n.guid = P.guid++),
            a = (a = f.events) || (f.events = Object.create(null)),
            s =
              (s = f.handle) ||
              (f.handle = function (t) {
                return void 0 !== P && P.event.triggered !== t.type ? P.event.dispatch.apply(e, arguments) : void 0;
              }),
            u = (t = (t || '').match(R) || ['']).length;
          u--;

        )
          (p = h = (d = Ae.exec(t[u]) || [])[1]),
            (d = (d[2] || '').split('.').sort()),
            p &&
              ((l = P.event.special[p] || {}),
              (p = (o ? l.delegateType : l.bindType) || p),
              (l = P.event.special[p] || {}),
              (h = P.extend(
                {
                  type: p,
                  origType: h,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: o,
                  needsContext: o && P.expr.match.needsContext.test(o),
                  namespace: d.join('.'),
                },
                i
              )),
              (c = a[p]) ||
                (((c = a[p] = []).delegateCount = 0), l.setup && !1 !== l.setup.call(e, r, d, s)) ||
                (e.addEventListener && e.addEventListener(p, s)),
              l.add && (l.add.call(e, h), h.handler.guid || (h.handler.guid = n.guid)),
              o ? c.splice(c.delegateCount++, 0, h) : c.push(h),
              (P.event.global[p] = !0));
    },
    remove: function (t, e, n, r, o) {
      var i,
        s,
        a,
        u,
        l,
        c,
        p,
        d,
        h,
        f,
        g,
        m = y.hasData(t) && y.get(t);
      if (m && (u = m.events)) {
        for (l = (e = (e || '').match(R) || ['']).length; l--; )
          if (((h = g = (a = Ae.exec(e[l]) || [])[1]), (f = (a[2] || '').split('.').sort()), h)) {
            for (
              p = P.event.special[h] || {},
                d = u[(h = (r ? p.delegateType : p.bindType) || h)] || [],
                a = a[2] && new RegExp('(^|\\.)' + f.join('\\.(?:.*\\.|)') + '(\\.|$)'),
                s = i = d.length;
              i--;

            )
              (c = d[i]),
                (!o && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (a && !a.test(c.namespace)) ||
                  (r && r !== c.selector && ('**' !== r || !c.selector)) ||
                  (d.splice(i, 1), c.selector && d.delegateCount--, p.remove && p.remove.call(t, c));
            s &&
              !d.length &&
              ((p.teardown && !1 !== p.teardown.call(t, f, m.handle)) || P.removeEvent(t, h, m.handle), delete u[h]);
          } else for (h in u) P.event.remove(t, h + e[l], n, r, !0);
        P.isEmptyObject(u) && y.remove(t, 'handle events');
      }
    },
    dispatch: function (t) {
      var e,
        n,
        r,
        o,
        i,
        s = new Array(arguments.length),
        a = P.event.fix(t),
        t = (y.get(this, 'events') || Object.create(null))[a.type] || [],
        u = P.event.special[a.type] || {};
      for (s[0] = a, e = 1; e < arguments.length; e++) s[e] = arguments[e];
      if (((a.delegateTarget = this), !u.preDispatch || !1 !== u.preDispatch.call(this, a))) {
        for (i = P.event.handlers.call(this, a, t), e = 0; (r = i[e++]) && !a.isPropagationStopped(); )
          for (a.currentTarget = r.elem, n = 0; (o = r.handlers[n++]) && !a.isImmediatePropagationStopped(); )
            (a.rnamespace && !1 !== o.namespace && !a.rnamespace.test(o.namespace)) ||
              ((a.handleObj = o),
              (a.data = o.data),
              void 0 !== (o = ((P.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, s)) &&
                !1 === (a.result = o) &&
                (a.preventDefault(), a.stopPropagation()));
        return u.postDispatch && u.postDispatch.call(this, a), a.result;
      }
    },
    handlers: function (t, e) {
      var n,
        r,
        o,
        i,
        s,
        a = [],
        u = e.delegateCount,
        l = t.target;
      if (u && l.nodeType && !('click' === t.type && 1 <= t.button))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ('click' !== t.type || !0 !== l.disabled)) {
            for (i = [], s = {}, n = 0; n < u; n++)
              void 0 === s[(o = (r = e[n]).selector + ' ')] &&
                (s[o] = r.needsContext ? -1 < P(o, this).index(l) : P.find(o, this, null, [l]).length),
                s[o] && i.push(r);
            i.length && a.push({elem: l, handlers: i});
          }
      return (l = this), u < e.length && a.push({elem: l, handlers: e.slice(u)}), a;
    },
    addProp: function (e, t) {
      Object.defineProperty(P.Event.prototype, e, {
        enumerable: !0,
        configurable: !0,
        get: v(t)
          ? function () {
              if (this.originalEvent) return t(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[e];
            },
        set: function (t) {
          Object.defineProperty(this, e, {enumerable: !0, configurable: !0, writable: !0, value: t});
        },
      });
    },
    fix: function (t) {
      return t[P.expando] ? t : new P.Event(t);
    },
    special: {
      load: {noBubble: !0},
      click: {
        setup: function (t) {
          t = this || t;
          return _e.test(t.type) && t.click && b(t, 'input') && De(t, 'click', !0), !1;
        },
        trigger: function (t) {
          t = this || t;
          return _e.test(t.type) && t.click && b(t, 'input') && De(t, 'click'), !0;
        },
        _default: function (t) {
          t = t.target;
          return (_e.test(t.type) && t.click && b(t, 'input') && y.get(t, 'click')) || b(t, 'a');
        },
      },
      beforeunload: {
        postDispatch: function (t) {
          void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result);
        },
      },
    },
  }),
    (P.removeEvent = function (t, e, n) {
      t.removeEventListener && t.removeEventListener(e, n);
    }),
    (P.Event = function (t, e) {
      if (!(this instanceof P.Event)) return new P.Event(t, e);
      t && t.type
        ? ((this.originalEvent = t),
          (this.type = t.type),
          (this.isDefaultPrevented =
            t.defaultPrevented || (void 0 === t.defaultPrevented && !1 === t.returnValue) ? Oe : Re),
          (this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target),
          (this.currentTarget = t.currentTarget),
          (this.relatedTarget = t.relatedTarget))
        : (this.type = t),
        e && P.extend(this, e),
        (this.timeStamp = (t && t.timeStamp) || Date.now()),
        (this[P.expando] = !0);
    }),
    (P.Event.prototype = {
      constructor: P.Event,
      isDefaultPrevented: Re,
      isPropagationStopped: Re,
      isImmediatePropagationStopped: Re,
      isSimulated: !1,
      preventDefault: function () {
        var t = this.originalEvent;
        (this.isDefaultPrevented = Oe), t && !this.isSimulated && t.preventDefault();
      },
      stopPropagation: function () {
        var t = this.originalEvent;
        (this.isPropagationStopped = Oe), t && !this.isSimulated && t.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var t = this.originalEvent;
        (this.isImmediatePropagationStopped = Oe),
          t && !this.isSimulated && t.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    P.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: !0,
      },
      P.event.addProp
    ),
    P.each({focus: 'focusin', blur: 'focusout'}, function (r, o) {
      function i(t) {
        var e, n;
        _.documentMode
          ? ((e = y.get(this, 'handle')),
            ((n = P.event.fix(t)).type = 'focusin' === t.type ? 'focus' : 'blur'),
            (n.isSimulated = !0),
            e(t),
            n.target === n.currentTarget && e(n))
          : P.event.simulate(o, t.target, P.event.fix(t));
      }
      (P.event.special[r] = {
        setup: function () {
          var t;
          if ((De(this, r, !0), !_.documentMode)) return !1;
          (t = y.get(this, o)) || this.addEventListener(o, i), y.set(this, o, (t || 0) + 1);
        },
        trigger: function () {
          return De(this, r), !0;
        },
        teardown: function () {
          var t;
          if (!_.documentMode) return !1;
          (t = y.get(this, o) - 1) ? y.set(this, o, t) : (this.removeEventListener(o, i), y.remove(this, o));
        },
        _default: function (t) {
          return y.get(t.target, r);
        },
        delegateType: o,
      }),
        (P.event.special[o] = {
          setup: function () {
            var t = this.ownerDocument || this.document || this,
              e = _.documentMode ? this : t,
              n = y.get(e, o);
            n || (_.documentMode ? this.addEventListener(o, i) : t.addEventListener(r, i, !0)),
              y.set(e, o, (n || 0) + 1);
          },
          teardown: function () {
            var t = this.ownerDocument || this.document || this,
              e = _.documentMode ? this : t,
              n = y.get(e, o) - 1;
            n
              ? y.set(e, o, n)
              : (_.documentMode ? this.removeEventListener(o, i) : t.removeEventListener(r, i, !0), y.remove(e, o));
          },
        });
    }),
    P.each(
      {mouseenter: 'mouseover', mouseleave: 'mouseout', pointerenter: 'pointerover', pointerleave: 'pointerout'},
      function (t, o) {
        P.event.special[t] = {
          delegateType: o,
          bindType: o,
          handle: function (t) {
            var e,
              n = t.relatedTarget,
              r = t.handleObj;
            return (
              (n && (n === this || P.contains(this, n))) ||
                ((t.type = r.origType), (e = r.handler.apply(this, arguments)), (t.type = o)),
              e
            );
          },
        };
      }
    ),
    P.fn.extend({
      on: function (t, e, n, r) {
        return Ie(this, t, e, n, r);
      },
      one: function (t, e, n, r) {
        return Ie(this, t, e, n, r, 1);
      },
      off: function (t, e, n) {
        var r, o;
        if (t && t.preventDefault && t.handleObj)
          (r = t.handleObj),
            P(t.delegateTarget).off(r.namespace ? r.origType + '.' + r.namespace : r.origType, r.selector, r.handler);
        else {
          if ('object' != typeof t)
            return (
              (!1 !== e && 'function' != typeof e) || ((n = e), (e = void 0)),
              !1 === n && (n = Re),
              this.each(function () {
                P.event.remove(this, t, n, e);
              })
            );
          for (o in t) this.off(o, e, t[o]);
        }
        return this;
      },
    });
  var Ne = /<script|<style|<link/i,
    Le = /checked\s*(?:[^=]|=\s*.checked.)/i,
    Ue = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
  function Me(t, e) {
    return (b(t, 'table') && b(11 !== e.nodeType ? e : e.firstChild, 'tr') && P(t).children('tbody')[0]) || t;
  }
  function He(t) {
    return (t.type = (null !== t.getAttribute('type')) + '/' + t.type), t;
  }
  function je(t) {
    return 'true/' === (t.type || '').slice(0, 5) ? (t.type = t.type.slice(5)) : t.removeAttribute('type'), t;
  }
  function Fe(t, e) {
    var n, r, o, i;
    if (1 === e.nodeType) {
      if (y.hasData(t) && (i = y.get(t).events))
        for (o in (y.remove(e, 'handle events'), i))
          for (n = 0, r = i[o].length; n < r; n++) P.event.add(e, o, i[o][n]);
      l.hasData(t) && ((t = l.access(t)), (t = P.extend({}, t)), l.set(e, t));
    }
  }
  function qe(n, r, o, i) {
    r = j(r);
    var t,
      e,
      s,
      a,
      u,
      l,
      c = 0,
      p = n.length,
      d = p - 1,
      h = r[0],
      f = v(h);
    if (f || (1 < p && 'string' == typeof h && !g.checkClone && Le.test(h)))
      return n.each(function (t) {
        var e = n.eq(t);
        f && (r[0] = h.call(this, t, e.html())), qe(e, r, o, i);
      });
    if (
      p &&
      ((e = (t = Te(r, n[0].ownerDocument, !1, n, i)).firstChild), 1 === t.childNodes.length && (t = e), e || i)
    ) {
      for (a = (s = P.map(m(t, 'script'), He)).length; c < p; c++)
        (u = t), c !== d && ((u = P.clone(u, !0, !0)), a) && P.merge(s, m(u, 'script')), o.call(n[c], u, c);
      if (a)
        for (l = s[s.length - 1].ownerDocument, P.map(s, je), c = 0; c < a; c++)
          (u = s[c]),
            ke.test(u.type || '') &&
              !y.access(u, 'globalEval') &&
              P.contains(l, u) &&
              (u.src && 'module' !== (u.type || '').toLowerCase()
                ? P._evalUrl && !u.noModule && P._evalUrl(u.src, {nonce: u.nonce || u.getAttribute('nonce')}, l)
                : K(u.textContent.replace(Ue, ''), u, l));
    }
    return n;
  }
  function Be(t, e, n) {
    for (var r, o = e ? P.filter(e, t) : t, i = 0; null != (r = o[i]); i++)
      n || 1 !== r.nodeType || P.cleanData(m(r)),
        r.parentNode && (n && ve(r) && Ee(m(r, 'script')), r.parentNode.removeChild(r));
    return t;
  }
  P.extend({
    htmlPrefilter: function (t) {
      return t;
    },
    clone: function (t, e, n) {
      var r,
        o,
        i,
        s,
        a,
        u,
        l,
        c = t.cloneNode(!0),
        p = ve(t);
      if (!(g.noCloneChecked || (1 !== t.nodeType && 11 !== t.nodeType) || P.isXMLDoc(t)))
        for (s = m(c), r = 0, o = (i = m(t)).length; r < o; r++)
          (a = i[r]),
            'input' === (l = (u = s[r]).nodeName.toLowerCase()) && _e.test(a.type)
              ? (u.checked = a.checked)
              : ('input' !== l && 'textarea' !== l) || (u.defaultValue = a.defaultValue);
      if (e)
        if (n) for (i = i || m(t), s = s || m(c), r = 0, o = i.length; r < o; r++) Fe(i[r], s[r]);
        else Fe(t, c);
      return 0 < (s = m(c, 'script')).length && Ee(s, !p && m(t, 'script')), c;
    },
    cleanData: function (t) {
      for (var e, n, r, o = P.event.special, i = 0; void 0 !== (n = t[i]); i++)
        if (le(n)) {
          if ((e = n[y.expando])) {
            if (e.events) for (r in e.events) o[r] ? P.event.remove(n, r) : P.removeEvent(n, r, e.handle);
            n[y.expando] = void 0;
          }
          n[l.expando] && (n[l.expando] = void 0);
        }
    },
  }),
    P.fn.extend({
      detach: function (t) {
        return Be(this, t, !0);
      },
      remove: function (t) {
        return Be(this, t);
      },
      text: function (t) {
        return c(
          this,
          function (t) {
            return void 0 === t
              ? P.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = t);
                });
          },
          null,
          t,
          arguments.length
        );
      },
      append: function () {
        return qe(this, arguments, function (t) {
          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Me(this, t).appendChild(t);
        });
      },
      prepend: function () {
        return qe(this, arguments, function (t) {
          var e;
          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
            (e = Me(this, t)).insertBefore(t, e.firstChild);
        });
      },
      before: function () {
        return qe(this, arguments, function (t) {
          this.parentNode && this.parentNode.insertBefore(t, this);
        });
      },
      after: function () {
        return qe(this, arguments, function (t) {
          this.parentNode && this.parentNode.insertBefore(t, this.nextSibling);
        });
      },
      empty: function () {
        for (var t, e = 0; null != (t = this[e]); e++)
          1 === t.nodeType && (P.cleanData(m(t, !1)), (t.textContent = ''));
        return this;
      },
      clone: function (t, e) {
        return (
          (t = null != t && t),
          (e = null == e ? t : e),
          this.map(function () {
            return P.clone(this, t, e);
          })
        );
      },
      html: function (t) {
        return c(
          this,
          function (t) {
            var e = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
            if ('string' == typeof t && !Ne.test(t) && !f[(Pe.exec(t) || ['', ''])[1].toLowerCase()]) {
              t = P.htmlPrefilter(t);
              try {
                for (; n < r; n++) 1 === (e = this[n] || {}).nodeType && (P.cleanData(m(e, !1)), (e.innerHTML = t));
                e = 0;
              } catch (t) {}
            }
            e && this.empty().append(t);
          },
          null,
          t,
          arguments.length
        );
      },
      replaceWith: function () {
        var n = [];
        return qe(
          this,
          arguments,
          function (t) {
            var e = this.parentNode;
            P.inArray(this, n) < 0 && (P.cleanData(m(this)), e) && e.replaceChild(t, this);
          },
          n
        );
      },
    }),
    P.each(
      {
        appendTo: 'append',
        prependTo: 'prepend',
        insertBefore: 'before',
        insertAfter: 'after',
        replaceAll: 'replaceWith',
      },
      function (t, s) {
        P.fn[t] = function (t) {
          for (var e, n = [], r = P(t), o = r.length - 1, i = 0; i <= o; i++)
            (e = i === o ? this : this.clone(!0)), P(r[i])[s](e), F.apply(n, e.get());
          return this.pushStack(n);
        };
      }
    );
  function $e(t) {
    var e = t.ownerDocument.defaultView;
    return (e = e && e.opener ? e : w).getComputedStyle(t);
  }
  function We(t, e, n) {
    var r,
      o = {};
    for (r in e) (o[r] = t.style[r]), (t.style[r] = e[r]);
    for (r in ((n = n.call(t)), e)) t.style[r] = o[r];
    return n;
  }
  var Ge,
    Qe,
    Ke,
    ze,
    Ve,
    Ye,
    Xe,
    D,
    Je = new RegExp('^(' + t + ')(?!px)[a-z%]+$', 'i'),
    Ze = /^--/,
    tn = new RegExp(me.join('|'), 'i');
  function en(t, e, n) {
    var r,
      o = Ze.test(e),
      i = t.style;
    return (
      (n = n || $e(t)) &&
        ((r = n.getPropertyValue(e) || n[e]),
        '' !== (r = o ? r && (r.replace(tt, '$1') || void 0) : r) || ve(t) || (r = P.style(t, e)),
        !g.pixelBoxStyles()) &&
        Je.test(r) &&
        tn.test(e) &&
        ((o = i.width),
        (t = i.minWidth),
        (e = i.maxWidth),
        (i.minWidth = i.maxWidth = i.width = r),
        (r = n.width),
        (i.width = o),
        (i.minWidth = t),
        (i.maxWidth = e)),
      void 0 !== r ? r + '' : r
    );
  }
  function nn(t, e) {
    return {
      get: function () {
        if (!t()) return (this.get = e).apply(this, arguments);
        delete this.get;
      },
    };
  }
  function rn() {
    var t;
    D &&
      ((Xe.style.cssText = 'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
      (D.style.cssText =
        'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
      ye.appendChild(Xe).appendChild(D),
      (t = w.getComputedStyle(D)),
      (Ge = '1%' !== t.top),
      (Ye = 12 === on(t.marginLeft)),
      (D.style.right = '60%'),
      (ze = 36 === on(t.right)),
      (Qe = 36 === on(t.width)),
      (D.style.position = 'absolute'),
      (Ke = 12 === on(D.offsetWidth / 3)),
      ye.removeChild(Xe),
      (D = null));
  }
  function on(t) {
    return Math.round(parseFloat(t));
  }
  (Xe = _.createElement('div')),
    (D = _.createElement('div')).style &&
      ((D.style.backgroundClip = 'content-box'),
      (D.cloneNode(!0).style.backgroundClip = ''),
      (g.clearCloneStyle = 'content-box' === D.style.backgroundClip),
      P.extend(g, {
        boxSizingReliable: function () {
          return rn(), Qe;
        },
        pixelBoxStyles: function () {
          return rn(), ze;
        },
        pixelPosition: function () {
          return rn(), Ge;
        },
        reliableMarginLeft: function () {
          return rn(), Ye;
        },
        scrollboxSize: function () {
          return rn(), Ke;
        },
        reliableTrDimensions: function () {
          var t, e, n;
          return (
            null == Ve &&
              ((t = _.createElement('table')),
              (e = _.createElement('tr')),
              (n = _.createElement('div')),
              (t.style.cssText = 'position:absolute;left:-11111px;border-collapse:separate'),
              (e.style.cssText = 'box-sizing:content-box;border:1px solid'),
              (e.style.height = '1px'),
              (n.style.height = '9px'),
              (n.style.display = 'block'),
              ye.appendChild(t).appendChild(e).appendChild(n),
              (n = w.getComputedStyle(e)),
              (Ve =
                parseInt(n.height, 10) + parseInt(n.borderTopWidth, 10) + parseInt(n.borderBottomWidth, 10) ===
                e.offsetHeight),
              ye.removeChild(t)),
            Ve
          );
        },
      }));
  var sn = ['Webkit', 'Moz', 'ms'],
    an = _.createElement('div').style,
    un = {};
  function ln(t) {
    return (
      P.cssProps[t] ||
      un[t] ||
      (t in an
        ? t
        : (un[t] =
            ((t) => {
              for (var e = t[0].toUpperCase() + t.slice(1), n = sn.length; n--; ) if ((t = sn[n] + e) in an) return t;
            })(t) || t))
    );
  }
  var cn = /^(none|table(?!-c[ea]).+)/,
    pn = {position: 'absolute', visibility: 'hidden', display: 'block'},
    dn = {letterSpacing: '0', fontWeight: '400'};
  function hn(t, e, n) {
    var r = ge.exec(e);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || 'px') : e;
  }
  function fn(t, e, n, r, o, i) {
    var s = 'width' === e ? 1 : 0,
      a = 0,
      u = 0,
      l = 0;
    if (n === (r ? 'border' : 'content')) return 0;
    for (; s < 4; s += 2)
      'margin' === n && (l += P.css(t, n + me[s], !0, o)),
        r
          ? ('content' === n && (u -= P.css(t, 'padding' + me[s], !0, o)),
            'margin' !== n && (u -= P.css(t, 'border' + me[s] + 'Width', !0, o)))
          : ((u += P.css(t, 'padding' + me[s], !0, o)),
            'padding' !== n
              ? (u += P.css(t, 'border' + me[s] + 'Width', !0, o))
              : (a += P.css(t, 'border' + me[s] + 'Width', !0, o)));
    return (
      !r &&
        0 <= i &&
        (u += Math.max(0, Math.ceil(t['offset' + e[0].toUpperCase() + e.slice(1)] - i - u - a - 0.5)) || 0),
      u + l
    );
  }
  function gn(t, e, n) {
    var r = $e(t),
      o = (!g.boxSizingReliable() || n) && 'border-box' === P.css(t, 'boxSizing', !1, r),
      i = o,
      s = en(t, e, r),
      a = 'offset' + e[0].toUpperCase() + e.slice(1);
    if (Je.test(s)) {
      if (!n) return s;
      s = 'auto';
    }
    return (
      ((!g.boxSizingReliable() && o) ||
        (!g.reliableTrDimensions() && b(t, 'tr')) ||
        'auto' === s ||
        (!parseFloat(s) && 'inline' === P.css(t, 'display', !1, r))) &&
        t.getClientRects().length &&
        ((o = 'border-box' === P.css(t, 'boxSizing', !1, r)), (i = a in t)) &&
        (s = t[a]),
      (s = parseFloat(s) || 0) + fn(t, e, n || (o ? 'border' : 'content'), i, r, s) + 'px'
    );
  }
  function N(t, e, n, r, o) {
    return new N.prototype.init(t, e, n, r, o);
  }
  P.extend({
    cssHooks: {
      opacity: {
        get: function (t, e) {
          if (e) return '' === (e = en(t, 'opacity')) ? '1' : e;
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageSlice: !0,
      columnCount: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      scale: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
    },
    cssProps: {},
    style: function (t, e, n, r) {
      if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
        var o,
          i,
          s,
          a = I(e),
          u = Ze.test(e),
          l = t.style;
        if ((u || (e = ln(a)), (s = P.cssHooks[e] || P.cssHooks[a]), void 0 === n))
          return s && 'get' in s && void 0 !== (o = s.get(t, !1, r)) ? o : l[e];
        'string' == (i = typeof n) && (o = ge.exec(n)) && o[1] && ((n = xe(t, e, o)), (i = 'number')),
          null != n &&
            n == n &&
            ('number' !== i || u || (n += (o && o[3]) || (P.cssNumber[a] ? '' : 'px')),
            g.clearCloneStyle || '' !== n || 0 !== e.indexOf('background') || (l[e] = 'inherit'),
            (s && 'set' in s && void 0 === (n = s.set(t, n, r))) || (u ? l.setProperty(e, n) : (l[e] = n)));
      }
    },
    css: function (t, e, n, r) {
      var o,
        i = I(e);
      return (
        Ze.test(e) || (e = ln(i)),
        'normal' ===
          (o =
            void 0 === (o = (i = P.cssHooks[e] || P.cssHooks[i]) && 'get' in i ? i.get(t, !0, n) : o)
              ? en(t, e, r)
              : o) &&
          e in dn &&
          (o = dn[e]),
        ('' === n || n) && ((i = parseFloat(o)), !0 === n || isFinite(i)) ? i || 0 : o
      );
    },
  }),
    P.each(['height', 'width'], function (t, s) {
      P.cssHooks[s] = {
        get: function (t, e, n) {
          if (e)
            return !cn.test(P.css(t, 'display')) || (t.getClientRects().length && t.getBoundingClientRect().width)
              ? gn(t, s, n)
              : We(t, pn, function () {
                  return gn(t, s, n);
                });
        },
        set: function (t, e, n) {
          var r = $e(t),
            o = !g.scrollboxSize() && 'absolute' === r.position,
            i = (o || n) && 'border-box' === P.css(t, 'boxSizing', !1, r),
            n = n ? fn(t, s, n, i, r) : 0;
          return (
            i &&
              o &&
              (n -= Math.ceil(
                t['offset' + s[0].toUpperCase() + s.slice(1)] - parseFloat(r[s]) - fn(t, s, 'border', !1, r) - 0.5
              )),
            n && (i = ge.exec(e)) && 'px' !== (i[3] || 'px') && ((t.style[s] = e), (e = P.css(t, s))),
            hn(0, e, n)
          );
        },
      };
    }),
    (P.cssHooks.marginLeft = nn(g.reliableMarginLeft, function (t, e) {
      if (e)
        return (
          (parseFloat(en(t, 'marginLeft')) ||
            t.getBoundingClientRect().left -
              We(t, {marginLeft: 0}, function () {
                return t.getBoundingClientRect().left;
              })) + 'px'
        );
    })),
    P.each({margin: '', padding: '', border: 'Width'}, function (o, i) {
      (P.cssHooks[o + i] = {
        expand: function (t) {
          for (var e = 0, n = {}, r = 'string' == typeof t ? t.split(' ') : [t]; e < 4; e++)
            n[o + me[e] + i] = r[e] || r[e - 2] || r[0];
          return n;
        },
      }),
        'margin' !== o && (P.cssHooks[o + i].set = hn);
    }),
    P.fn.extend({
      css: function (t, e) {
        return c(
          this,
          function (t, e, n) {
            var r,
              o,
              i = {},
              s = 0;
            if (Array.isArray(e)) {
              for (r = $e(t), o = e.length; s < o; s++) i[e[s]] = P.css(t, e[s], !1, r);
              return i;
            }
            return void 0 !== n ? P.style(t, e, n) : P.css(t, e);
          },
          t,
          e,
          1 < arguments.length
        );
      },
    }),
    (((P.Tween = N).prototype = {
      constructor: N,
      init: function (t, e, n, r, o, i) {
        (this.elem = t),
          (this.prop = n),
          (this.easing = o || P.easing._default),
          (this.options = e),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = i || (P.cssNumber[n] ? '' : 'px'));
      },
      cur: function () {
        var t = N.propHooks[this.prop];
        return (t && t.get ? t : N.propHooks._default).get(this);
      },
      run: function (t) {
        var e,
          n = N.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = e = P.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration))
            : (this.pos = e = t),
          (this.now = (this.end - this.start) * e + this.start),
          this.options.step && this.options.step.call(this.elem, this.now, this),
          (n && n.set ? n : N.propHooks._default).set(this),
          this
        );
      },
    }).init.prototype = N.prototype),
    ((N.propHooks = {
      _default: {
        get: function (t) {
          return 1 !== t.elem.nodeType || (null != t.elem[t.prop] && null == t.elem.style[t.prop])
            ? t.elem[t.prop]
            : (t = P.css(t.elem, t.prop, '')) && 'auto' !== t
              ? t
              : 0;
        },
        set: function (t) {
          P.fx.step[t.prop]
            ? P.fx.step[t.prop](t)
            : 1 !== t.elem.nodeType || (!P.cssHooks[t.prop] && null == t.elem.style[ln(t.prop)])
              ? (t.elem[t.prop] = t.now)
              : P.style(t.elem, t.prop, t.now + t.unit);
        },
      },
    }).scrollTop = N.propHooks.scrollLeft =
      {
        set: function (t) {
          t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
        },
      }),
    (P.easing = {
      linear: function (t) {
        return t;
      },
      swing: function (t) {
        return 0.5 - Math.cos(t * Math.PI) / 2;
      },
      _default: 'swing',
    }),
    (P.fx = N.prototype.init),
    (P.fx.step = {});
  var mn,
    yn,
    vn = /^(?:toggle|show|hide)$/,
    bn = /queueHooks$/;
  function xn() {
    yn &&
      (!1 === _.hidden && w.requestAnimationFrame ? w.requestAnimationFrame(xn) : w.setTimeout(xn, P.fx.interval),
      P.fx.tick());
  }
  function Sn() {
    return (
      w.setTimeout(function () {
        mn = void 0;
      }),
      (mn = Date.now())
    );
  }
  function wn(t, e) {
    var n,
      r = 0,
      o = {height: t};
    for (e = e ? 1 : 0; r < 4; r += 2 - e) o['margin' + (n = me[r])] = o['padding' + n] = t;
    return e && (o.opacity = o.width = t), o;
  }
  function _n(t, e, n) {
    for (var r, o = (L.tweeners[e] || []).concat(L.tweeners['*']), i = 0, s = o.length; i < s; i++)
      if ((r = o[i].call(n, e, t))) return r;
  }
  function L(o, t, e) {
    var n,
      i,
      r,
      s,
      a,
      u,
      l,
      c = 0,
      p = L.prefilters.length,
      d = P.Deferred().always(function () {
        delete h.elem;
      }),
      h = function () {
        if (i) return !1;
        for (
          var t = mn || Sn(),
            t = Math.max(0, f.startTime + f.duration - t),
            e = 1 - (t / f.duration || 0),
            n = 0,
            r = f.tweens.length;
          n < r;
          n++
        )
          f.tweens[n].run(e);
        return (
          d.notifyWith(o, [f, e, t]), e < 1 && r ? t : (r || d.notifyWith(o, [f, 1, 0]), d.resolveWith(o, [f]), !1)
        );
      },
      f = d.promise({
        elem: o,
        props: P.extend({}, t),
        opts: P.extend(!0, {specialEasing: {}, easing: P.easing._default}, e),
        originalProperties: t,
        originalOptions: e,
        startTime: mn || Sn(),
        duration: e.duration,
        tweens: [],
        createTween: function (t, e) {
          e = P.Tween(o, f.opts, t, e, f.opts.specialEasing[t] || f.opts.easing);
          return f.tweens.push(e), e;
        },
        stop: function (t) {
          var e = 0,
            n = t ? f.tweens.length : 0;
          if (!i) {
            for (i = !0; e < n; e++) f.tweens[e].run(1);
            t ? (d.notifyWith(o, [f, 1, 0]), d.resolveWith(o, [f, t])) : d.rejectWith(o, [f, t]);
          }
          return this;
        },
      }),
      g = f.props,
      m = g,
      y = f.opts.specialEasing;
    for (r in m)
      if (
        ((a = y[(s = I(r))]),
        (u = m[r]),
        Array.isArray(u) && ((a = u[1]), (u = m[r] = u[0])),
        r !== s && ((m[s] = u), delete m[r]),
        (l = P.cssHooks[s]) && 'expand' in l)
      )
        for (r in ((u = l.expand(u)), delete m[s], u)) r in m || ((m[r] = u[r]), (y[r] = a));
      else y[s] = a;
    for (; c < p; c++)
      if ((n = L.prefilters[c].call(f, o, g, f.opts)))
        return v(n.stop) && (P._queueHooks(f.elem, f.opts.queue).stop = n.stop.bind(n)), n;
    return (
      P.map(g, _n, f),
      v(f.opts.start) && f.opts.start.call(o, f),
      f.progress(f.opts.progress).done(f.opts.done, f.opts.complete).fail(f.opts.fail).always(f.opts.always),
      P.fx.timer(P.extend(h, {elem: o, anim: f, queue: f.opts.queue})),
      f
    );
  }
  (P.Animation = P.extend(L, {
    tweeners: {
      '*': [
        function (t, e) {
          var n = this.createTween(t, e);
          return xe(n.elem, t, ge.exec(e), n), n;
        },
      ],
    },
    tweener: function (t, e) {
      for (var n, r = 0, o = (t = v(t) ? ((e = t), ['*']) : t.match(R)).length; r < o; r++)
        (n = t[r]), (L.tweeners[n] = L.tweeners[n] || []), L.tweeners[n].unshift(e);
    },
    prefilters: [
      function (t, e, n) {
        var r,
          o,
          i,
          s,
          a,
          u,
          l,
          c = 'width' in e || 'height' in e,
          p = this,
          d = {},
          h = t.style,
          f = t.nodeType && fe(t),
          g = y.get(t, 'fxshow');
        for (r in (n.queue ||
          (null == (s = P._queueHooks(t, 'fx')).unqueued &&
            ((s.unqueued = 0),
            (a = s.empty.fire),
            (s.empty.fire = function () {
              s.unqueued || a();
            })),
          s.unqueued++,
          p.always(function () {
            p.always(function () {
              s.unqueued--, P.queue(t, 'fx').length || s.empty.fire();
            });
          })),
        e))
          if (((o = e[r]), vn.test(o))) {
            if ((delete e[r], (i = i || 'toggle' === o), o === (f ? 'hide' : 'show'))) {
              if ('show' !== o || !g || void 0 === g[r]) continue;
              f = !0;
            }
            d[r] = (g && g[r]) || P.style(t, r);
          }
        if ((u = !P.isEmptyObject(e)) || !P.isEmptyObject(d))
          for (r in (c &&
            1 === t.nodeType &&
            ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
            null == (l = g && g.display) && (l = y.get(t, 'display')),
            'none' === (c = P.css(t, 'display')) &&
              (l ? (c = l) : (we([t], !0), (l = t.style.display || l), (c = P.css(t, 'display')), we([t]))),
            'inline' === c || ('inline-block' === c && null != l)) &&
            'none' === P.css(t, 'float') &&
            (u ||
              (p.done(function () {
                h.display = l;
              }),
              null == l && ((c = h.display), (l = 'none' === c ? '' : c))),
            (h.display = 'inline-block')),
          n.overflow &&
            ((h.overflow = 'hidden'),
            p.always(function () {
              (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
            })),
          (u = !1),
          d))
            u ||
              (g ? 'hidden' in g && (f = g.hidden) : (g = y.access(t, 'fxshow', {display: l})),
              i && (g.hidden = !f),
              f && we([t], !0),
              p.done(function () {
                for (r in (f || we([t]), y.remove(t, 'fxshow'), d)) P.style(t, r, d[r]);
              })),
              (u = _n(f ? g[r] : 0, r, p)),
              r in g || ((g[r] = u.start), f && ((u.end = u.start), (u.start = 0)));
      },
    ],
    prefilter: function (t, e) {
      e ? L.prefilters.unshift(t) : L.prefilters.push(t);
    },
  })),
    (P.speed = function (t, e, n) {
      var r =
        t && 'object' == typeof t
          ? P.extend({}, t)
          : {complete: n || (!n && e) || (v(t) && t), duration: t, easing: (n && e) || (e && !v(e) && e)};
      return (
        P.fx.off
          ? (r.duration = 0)
          : 'number' != typeof r.duration &&
            (r.duration in P.fx.speeds ? (r.duration = P.fx.speeds[r.duration]) : (r.duration = P.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = 'fx'),
        (r.old = r.complete),
        (r.complete = function () {
          v(r.old) && r.old.call(this), r.queue && P.dequeue(this, r.queue);
        }),
        r
      );
    }),
    P.fn.extend({
      fadeTo: function (t, e, n, r) {
        return this.filter(fe).css('opacity', 0).show().end().animate({opacity: e}, t, n, r);
      },
      animate: function (e, t, n, r) {
        function o() {
          var t = L(this, P.extend({}, e), s);
          (i || y.get(this, 'finish')) && t.stop(!0);
        }
        var i = P.isEmptyObject(e),
          s = P.speed(t, n, r);
        return (o.finish = o), i || !1 === s.queue ? this.each(o) : this.queue(s.queue, o);
      },
      stop: function (o, t, i) {
        function s(t) {
          var e = t.stop;
          delete t.stop, e(i);
        }
        return (
          'string' != typeof o && ((i = t), (t = o), (o = void 0)),
          t && this.queue(o || 'fx', []),
          this.each(function () {
            var t = !0,
              e = null != o && o + 'queueHooks',
              n = P.timers,
              r = y.get(this);
            if (e) r[e] && r[e].stop && s(r[e]);
            else for (e in r) r[e] && r[e].stop && bn.test(e) && s(r[e]);
            for (e = n.length; e--; )
              n[e].elem !== this || (null != o && n[e].queue !== o) || (n[e].anim.stop(i), (t = !1), n.splice(e, 1));
            (!t && i) || P.dequeue(this, o);
          })
        );
      },
      finish: function (s) {
        return (
          !1 !== s && (s = s || 'fx'),
          this.each(function () {
            var t,
              e = y.get(this),
              n = e[s + 'queue'],
              r = e[s + 'queueHooks'],
              o = P.timers,
              i = n ? n.length : 0;
            for (e.finish = !0, P.queue(this, s, []), r && r.stop && r.stop.call(this, !0), t = o.length; t--; )
              o[t].elem === this && o[t].queue === s && (o[t].anim.stop(!0), o.splice(t, 1));
            for (t = 0; t < i; t++) n[t] && n[t].finish && n[t].finish.call(this);
            delete e.finish;
          })
        );
      },
    }),
    P.each(['toggle', 'show', 'hide'], function (t, r) {
      var o = P.fn[r];
      P.fn[r] = function (t, e, n) {
        return null == t || 'boolean' == typeof t ? o.apply(this, arguments) : this.animate(wn(r, !0), t, e, n);
      };
    }),
    P.each(
      {
        slideDown: wn('show'),
        slideUp: wn('hide'),
        slideToggle: wn('toggle'),
        fadeIn: {opacity: 'show'},
        fadeOut: {opacity: 'hide'},
        fadeToggle: {opacity: 'toggle'},
      },
      function (t, r) {
        P.fn[t] = function (t, e, n) {
          return this.animate(r, t, e, n);
        };
      }
    ),
    (P.timers = []),
    (P.fx.tick = function () {
      var t,
        e = 0,
        n = P.timers;
      for (mn = Date.now(); e < n.length; e++) (t = n[e])() || n[e] !== t || n.splice(e--, 1);
      n.length || P.fx.stop(), (mn = void 0);
    }),
    (P.fx.timer = function (t) {
      P.timers.push(t), P.fx.start();
    }),
    (P.fx.interval = 13),
    (P.fx.start = function () {
      yn || ((yn = !0), xn());
    }),
    (P.fx.stop = function () {
      yn = null;
    }),
    (P.fx.speeds = {slow: 600, fast: 200, _default: 400}),
    (P.fn.delay = function (r, t) {
      return (
        (r = (P.fx && P.fx.speeds[r]) || r),
        this.queue((t = t || 'fx'), function (t, e) {
          var n = w.setTimeout(t, r);
          e.stop = function () {
            w.clearTimeout(n);
          };
        })
      );
    }),
    (s = _.createElement('input')),
    (i = _.createElement('select').appendChild(_.createElement('option'))),
    (s.type = 'checkbox'),
    (g.checkOn = '' !== s.value),
    (g.optSelected = i.selected),
    ((s = _.createElement('input')).value = 't'),
    (s.type = 'radio'),
    (g.radioValue = 't' === s.value);
  var Pn,
    kn = P.expr.attrHandle,
    En =
      (P.fn.extend({
        attr: function (t, e) {
          return c(this, P.attr, t, e, 1 < arguments.length);
        },
        removeAttr: function (t) {
          return this.each(function () {
            P.removeAttr(this, t);
          });
        },
      }),
      P.extend({
        attr: function (t, e, n) {
          var r,
            o,
            i = t.nodeType;
          if (3 !== i && 8 !== i && 2 !== i)
            return void 0 === t.getAttribute
              ? P.prop(t, e, n)
              : ((1 === i && P.isXMLDoc(t)) ||
                  (o = P.attrHooks[e.toLowerCase()] || (P.expr.match.bool.test(e) ? Pn : void 0)),
                void 0 !== n
                  ? null === n
                    ? void P.removeAttr(t, e)
                    : o && 'set' in o && void 0 !== (r = o.set(t, n, e))
                      ? r
                      : (t.setAttribute(e, n + ''), n)
                  : !(o && 'get' in o && null !== (r = o.get(t, e))) && null == (r = P.find.attr(t, e))
                    ? void 0
                    : r);
        },
        attrHooks: {
          type: {
            set: function (t, e) {
              var n;
              if (!g.radioValue && 'radio' === e && b(t, 'input'))
                return (n = t.value), t.setAttribute('type', e), n && (t.value = n), e;
            },
          },
        },
        removeAttr: function (t, e) {
          var n,
            r = 0,
            o = e && e.match(R);
          if (o && 1 === t.nodeType) for (; (n = o[r++]); ) t.removeAttribute(n);
        },
      }),
      (Pn = {
        set: function (t, e, n) {
          return !1 === e ? P.removeAttr(t, n) : t.setAttribute(n, n), n;
        },
      }),
      P.each(P.expr.match.bool.source.match(/\w+/g), function (t, e) {
        var s = kn[e] || P.find.attr;
        kn[e] = function (t, e, n) {
          var r,
            o,
            i = e.toLowerCase();
          return n || ((o = kn[i]), (kn[i] = r), (r = null != s(t, e, n) ? i : null), (kn[i] = o)), r;
        };
      }),
      /^(?:input|select|textarea|button)$/i),
    Cn = /^(?:a|area)$/i;
  function Tn(t) {
    return (t.match(R) || []).join(' ');
  }
  function An(t) {
    return (t.getAttribute && t.getAttribute('class')) || '';
  }
  function On(t) {
    return Array.isArray(t) ? t : ('string' == typeof t && t.match(R)) || [];
  }
  P.fn.extend({
    prop: function (t, e) {
      return c(this, P.prop, t, e, 1 < arguments.length);
    },
    removeProp: function (t) {
      return this.each(function () {
        delete this[P.propFix[t] || t];
      });
    },
  }),
    P.extend({
      prop: function (t, e, n) {
        var r,
          o,
          i = t.nodeType;
        if (3 !== i && 8 !== i && 2 !== i)
          return (
            (1 === i && P.isXMLDoc(t)) || ((e = P.propFix[e] || e), (o = P.propHooks[e])),
            void 0 !== n
              ? o && 'set' in o && void 0 !== (r = o.set(t, n, e))
                ? r
                : (t[e] = n)
              : o && 'get' in o && null !== (r = o.get(t, e))
                ? r
                : t[e]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (t) {
            var e = P.find.attr(t, 'tabindex');
            return e ? parseInt(e, 10) : En.test(t.nodeName) || (Cn.test(t.nodeName) && t.href) ? 0 : -1;
          },
        },
      },
      propFix: {for: 'htmlFor', class: 'className'},
    }),
    g.optSelected ||
      (P.propHooks.selected = {
        get: function (t) {
          t = t.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (t) {
          t = t.parentNode;
          t && (t.selectedIndex, t.parentNode) && t.parentNode.selectedIndex;
        },
      }),
    P.each(
      [
        'tabIndex',
        'readOnly',
        'maxLength',
        'cellSpacing',
        'cellPadding',
        'rowSpan',
        'colSpan',
        'useMap',
        'frameBorder',
        'contentEditable',
      ],
      function () {
        P.propFix[this.toLowerCase()] = this;
      }
    ),
    P.fn.extend({
      addClass: function (e) {
        var t, n, r, o, i, s;
        return v(e)
          ? this.each(function (t) {
              P(this).addClass(e.call(this, t, An(this)));
            })
          : (t = On(e)).length
            ? this.each(function () {
                if (((r = An(this)), (n = 1 === this.nodeType && ' ' + Tn(r) + ' '))) {
                  for (i = 0; i < t.length; i++) (o = t[i]), n.indexOf(' ' + o + ' ') < 0 && (n += o + ' ');
                  (s = Tn(n)), r !== s && this.setAttribute('class', s);
                }
              })
            : this;
      },
      removeClass: function (e) {
        var t, n, r, o, i, s;
        return v(e)
          ? this.each(function (t) {
              P(this).removeClass(e.call(this, t, An(this)));
            })
          : arguments.length
            ? (t = On(e)).length
              ? this.each(function () {
                  if (((r = An(this)), (n = 1 === this.nodeType && ' ' + Tn(r) + ' '))) {
                    for (i = 0; i < t.length; i++)
                      for (o = t[i]; -1 < n.indexOf(' ' + o + ' '); ) n = n.replace(' ' + o + ' ', ' ');
                    (s = Tn(n)), r !== s && this.setAttribute('class', s);
                  }
                })
              : this
            : this.attr('class', '');
      },
      toggleClass: function (e, n) {
        var t,
          r,
          o,
          i,
          s = typeof e,
          a = 'string' == s || Array.isArray(e);
        return v(e)
          ? this.each(function (t) {
              P(this).toggleClass(e.call(this, t, An(this), n), n);
            })
          : 'boolean' == typeof n && a
            ? n
              ? this.addClass(e)
              : this.removeClass(e)
            : ((t = On(e)),
              this.each(function () {
                if (a)
                  for (i = P(this), o = 0; o < t.length; o++)
                    (r = t[o]), i.hasClass(r) ? i.removeClass(r) : i.addClass(r);
                else
                  (void 0 !== e && 'boolean' != s) ||
                    ((r = An(this)) && y.set(this, '__className__', r),
                    this.setAttribute &&
                      this.setAttribute('class', (!r && !1 !== e && y.get(this, '__className__')) || ''));
              }));
      },
      hasClass: function (t) {
        for (var e, n = 0, r = ' ' + t + ' '; (e = this[n++]); )
          if (1 === e.nodeType && -1 < (' ' + Tn(An(e)) + ' ').indexOf(r)) return !0;
        return !1;
      },
    });
  function Rn(t) {
    t.stopPropagation();
  }
  var In = /\r/g,
    Dn =
      (P.fn.extend({
        val: function (e) {
          var n,
            t,
            r,
            o = this[0];
          return arguments.length
            ? ((r = v(e)),
              this.each(function (t) {
                1 === this.nodeType &&
                  (null == (t = r ? e.call(this, t, P(this).val()) : e)
                    ? (t = '')
                    : 'number' == typeof t
                      ? (t += '')
                      : Array.isArray(t) &&
                        (t = P.map(t, function (t) {
                          return null == t ? '' : t + '';
                        })),
                  ((n = P.valHooks[this.type] || P.valHooks[this.nodeName.toLowerCase()]) &&
                    'set' in n &&
                    void 0 !== n.set(this, t, 'value')) ||
                    (this.value = t));
              }))
            : o
              ? (n = P.valHooks[o.type] || P.valHooks[o.nodeName.toLowerCase()]) &&
                'get' in n &&
                void 0 !== (t = n.get(o, 'value'))
                ? t
                : 'string' == typeof (t = o.value)
                  ? t.replace(In, '')
                  : null == t
                    ? ''
                    : t
              : void 0;
        },
      }),
      P.extend({
        valHooks: {
          option: {
            get: function (t) {
              var e = P.find.attr(t, 'value');
              return null != e ? e : Tn(P.text(t));
            },
          },
          select: {
            get: function (t) {
              for (
                var e,
                  n = t.options,
                  r = t.selectedIndex,
                  o = 'select-one' === t.type,
                  i = o ? null : [],
                  s = o ? r + 1 : n.length,
                  a = r < 0 ? s : o ? r : 0;
                a < s;
                a++
              )
                if (
                  ((e = n[a]).selected || a === r) &&
                  !e.disabled &&
                  (!e.parentNode.disabled || !b(e.parentNode, 'optgroup'))
                ) {
                  if (((e = P(e).val()), o)) return e;
                  i.push(e);
                }
              return i;
            },
            set: function (t, e) {
              for (var n, r, o = t.options, i = P.makeArray(e), s = o.length; s--; )
                ((r = o[s]).selected = -1 < P.inArray(P.valHooks.option.get(r), i)) && (n = !0);
              return n || (t.selectedIndex = -1), i;
            },
          },
        },
      }),
      P.each(['radio', 'checkbox'], function () {
        (P.valHooks[this] = {
          set: function (t, e) {
            if (Array.isArray(e)) return (t.checked = -1 < P.inArray(P(t).val(), e));
          },
        }),
          g.checkOn ||
            (P.valHooks[this].get = function (t) {
              return null === t.getAttribute('value') ? 'on' : t.value;
            });
      }),
      w.location),
    Nn = {guid: Date.now()},
    Ln = /\?/,
    Un =
      ((P.parseXML = function (t) {
        var e, n;
        if (!t || 'string' != typeof t) return null;
        try {
          e = new w.DOMParser().parseFromString(t, 'text/xml');
        } catch (t) {}
        return (
          (n = e && e.getElementsByTagName('parsererror')[0]),
          (e && !n) ||
            P.error(
              'Invalid XML: ' +
                (n
                  ? P.map(n.childNodes, function (t) {
                      return t.textContent;
                    }).join('\n')
                  : t)
            ),
          e
        );
      }),
      /^(?:focusinfocus|focusoutblur)$/),
    Mn =
      (P.extend(P.event, {
        trigger: function (t, e, n, r) {
          var o,
            i,
            s,
            a,
            u,
            l,
            c,
            p = [n || _],
            d = $.call(t, 'type') ? t.type : t,
            h = $.call(t, 'namespace') ? t.namespace.split('.') : [],
            f = (c = i = n = n || _);
          if (
            3 !== n.nodeType &&
            8 !== n.nodeType &&
            !Un.test(d + P.event.triggered) &&
            (-1 < d.indexOf('.') && ((d = (h = d.split('.')).shift()), h.sort()),
            (a = d.indexOf(':') < 0 && 'on' + d),
            ((t = t[P.expando] ? t : new P.Event(d, 'object' == typeof t && t)).isTrigger = r ? 2 : 3),
            (t.namespace = h.join('.')),
            (t.rnamespace = t.namespace ? new RegExp('(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)') : null),
            (t.result = void 0),
            t.target || (t.target = n),
            (e = null == e ? [t] : P.makeArray(e, [t])),
            (l = P.event.special[d] || {}),
            r || !l.trigger || !1 !== l.trigger.apply(n, e))
          ) {
            if (!r && !l.noBubble && !M(n)) {
              for (s = l.delegateType || d, Un.test(s + d) || (f = f.parentNode); f; f = f.parentNode)
                p.push(f), (i = f);
              i === (n.ownerDocument || _) && p.push(i.defaultView || i.parentWindow || w);
            }
            for (o = 0; (f = p[o++]) && !t.isPropagationStopped(); )
              (c = f),
                (t.type = 1 < o ? s : l.bindType || d),
                (u = (y.get(f, 'events') || Object.create(null))[t.type] && y.get(f, 'handle')) && u.apply(f, e),
                (u = a && f[a]) &&
                  u.apply &&
                  le(f) &&
                  ((t.result = u.apply(f, e)), !1 === t.result) &&
                  t.preventDefault();
            return (
              (t.type = d),
              r ||
                t.isDefaultPrevented() ||
                (l._default && !1 !== l._default.apply(p.pop(), e)) ||
                !le(n) ||
                (a &&
                  v(n[d]) &&
                  !M(n) &&
                  ((i = n[a]) && (n[a] = null),
                  (P.event.triggered = d),
                  t.isPropagationStopped() && c.addEventListener(d, Rn),
                  n[d](),
                  t.isPropagationStopped() && c.removeEventListener(d, Rn),
                  (P.event.triggered = void 0),
                  i) &&
                  (n[a] = i)),
              t.result
            );
          }
        },
        simulate: function (t, e, n) {
          n = P.extend(new P.Event(), n, {type: t, isSimulated: !0});
          P.event.trigger(n, null, e);
        },
      }),
      P.fn.extend({
        trigger: function (t, e) {
          return this.each(function () {
            P.event.trigger(t, e, this);
          });
        },
        triggerHandler: function (t, e) {
          var n = this[0];
          if (n) return P.event.trigger(t, e, n, !0);
        },
      }),
      /\[\]$/),
    Hn = /\r?\n/g,
    jn = /^(?:submit|button|image|reset|file)$/i,
    Fn = /^(?:input|select|textarea|keygen)/i;
  (P.param = function (t, e) {
    function n(t, e) {
      (e = v(e) ? e() : e), (o[o.length] = encodeURIComponent(t) + '=' + encodeURIComponent(null == e ? '' : e));
    }
    var r,
      o = [];
    if (null == t) return '';
    if (Array.isArray(t) || (t.jquery && !P.isPlainObject(t)))
      P.each(t, function () {
        n(this.name, this.value);
      });
    else
      for (r in t)
        !(function n(r, t, o, i) {
          if (Array.isArray(t))
            P.each(t, function (t, e) {
              o || Mn.test(r) ? i(r, e) : n(r + '[' + ('object' == typeof e && null != e ? t : '') + ']', e, o, i);
            });
          else if (o || 'object' !== z(t)) i(r, t);
          else for (var e in t) n(r + '[' + e + ']', t[e], o, i);
        })(r, t[r], e, n);
    return o.join('&');
  }),
    P.fn.extend({
      serialize: function () {
        return P.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var t = P.prop(this, 'elements');
          return t ? P.makeArray(t) : this;
        })
          .filter(function () {
            var t = this.type;
            return (
              this.name &&
              !P(this).is(':disabled') &&
              Fn.test(this.nodeName) &&
              !jn.test(t) &&
              (this.checked || !_e.test(t))
            );
          })
          .map(function (t, e) {
            var n = P(this).val();
            return null == n
              ? null
              : Array.isArray(n)
                ? P.map(n, function (t) {
                    return {name: e.name, value: t.replace(Hn, '\r\n')};
                  })
                : {name: e.name, value: n.replace(Hn, '\r\n')};
          })
          .get();
      },
    });
  var qn = /%20/g,
    Bn = /#.*$/,
    $n = /([?&])_=[^&]*/,
    Wn = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Gn = /^(?:GET|HEAD)$/,
    Qn = /^\/\//,
    Kn = {},
    zn = {},
    Vn = '*/'.concat('*'),
    Yn = _.createElement('a');
  function Xn(i) {
    return function (t, e) {
      'string' != typeof t && ((e = t), (t = '*'));
      var n,
        r = 0,
        o = t.toLowerCase().match(R) || [];
      if (v(e))
        for (; (n = o[r++]); )
          '+' === n[0] ? ((n = n.slice(1) || '*'), (i[n] = i[n] || []).unshift(e)) : (i[n] = i[n] || []).push(e);
    };
  }
  function Jn(e, r, o, i) {
    var s = {},
      a = e === zn;
    function u(t) {
      var n;
      return (
        (s[t] = !0),
        P.each(e[t] || [], function (t, e) {
          e = e(r, o, i);
          return 'string' != typeof e || a || s[e] ? (a ? !(n = e) : void 0) : (r.dataTypes.unshift(e), u(e), !1);
        }),
        n
      );
    }
    return u(r.dataTypes[0]) || (!s['*'] && u('*'));
  }
  function Zn(t, e) {
    var n,
      r,
      o = P.ajaxSettings.flatOptions || {};
    for (n in e) void 0 !== e[n] && ((o[n] ? t : (r = r || {}))[n] = e[n]);
    return r && P.extend(!0, t, r), t;
  }
  (Yn.href = Dn.href),
    P.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Dn.href,
        type: 'GET',
        isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Dn.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        accepts: {
          '*': Vn,
          text: 'text/plain',
          html: 'text/html',
          xml: 'application/xml, text/xml',
          json: 'application/json, text/javascript',
        },
        contents: {xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/},
        responseFields: {xml: 'responseXML', text: 'responseText', json: 'responseJSON'},
        converters: {'* text': String, 'text html': !0, 'text json': JSON.parse, 'text xml': P.parseXML},
        flatOptions: {url: !0, context: !0},
      },
      ajaxSetup: function (t, e) {
        return e ? Zn(Zn(t, P.ajaxSettings), e) : Zn(P.ajaxSettings, t);
      },
      ajaxPrefilter: Xn(Kn),
      ajaxTransport: Xn(zn),
      ajax: function (t, e) {
        'object' == typeof t && ((e = t), (t = void 0));
        var u,
          l,
          c,
          n,
          p,
          d,
          h,
          r,
          o,
          f = P.ajaxSetup({}, (e = e || {})),
          g = f.context || f,
          m = f.context && (g.nodeType || g.jquery) ? P(g) : P.event,
          y = P.Deferred(),
          v = P.Callbacks('once memory'),
          b = f.statusCode || {},
          i = {},
          s = {},
          a = 'canceled',
          x = {
            readyState: 0,
            getResponseHeader: function (t) {
              var e;
              if (d) {
                if (!n)
                  for (n = {}; (e = Wn.exec(c)); )
                    n[e[1].toLowerCase() + ' '] = (n[e[1].toLowerCase() + ' '] || []).concat(e[2]);
                e = n[t.toLowerCase() + ' '];
              }
              return null == e ? null : e.join(', ');
            },
            getAllResponseHeaders: function () {
              return d ? c : null;
            },
            setRequestHeader: function (t, e) {
              return null == d && ((t = s[t.toLowerCase()] = s[t.toLowerCase()] || t), (i[t] = e)), this;
            },
            overrideMimeType: function (t) {
              return null == d && (f.mimeType = t), this;
            },
            statusCode: function (t) {
              if (t)
                if (d) x.always(t[x.status]);
                else for (var e in t) b[e] = [b[e], t[e]];
              return this;
            },
            abort: function (t) {
              t = t || a;
              return u && u.abort(t), S(0, t), this;
            },
          };
        if (
          (y.promise(x),
          (f.url = ((t || f.url || Dn.href) + '').replace(Qn, Dn.protocol + '//')),
          (f.type = e.method || e.type || f.method || f.type),
          (f.dataTypes = (f.dataType || '*').toLowerCase().match(R) || ['']),
          null == f.crossDomain)
        ) {
          o = _.createElement('a');
          try {
            (o.href = f.url),
              (o.href = o.href),
              (f.crossDomain = Yn.protocol + '//' + Yn.host != o.protocol + '//' + o.host);
          } catch (t) {
            f.crossDomain = !0;
          }
        }
        if (
          (f.data && f.processData && 'string' != typeof f.data && (f.data = P.param(f.data, f.traditional)),
          Jn(Kn, f, e, x),
          !d)
        ) {
          for (r in ((h = P.event && f.global) && 0 == P.active++ && P.event.trigger('ajaxStart'),
          (f.type = f.type.toUpperCase()),
          (f.hasContent = !Gn.test(f.type)),
          (l = f.url.replace(Bn, '')),
          f.hasContent
            ? f.data &&
              f.processData &&
              0 === (f.contentType || '').indexOf('application/x-www-form-urlencoded') &&
              (f.data = f.data.replace(qn, '+'))
            : ((o = f.url.slice(l.length)),
              f.data &&
                (f.processData || 'string' == typeof f.data) &&
                ((l += (Ln.test(l) ? '&' : '?') + f.data), delete f.data),
              !1 === f.cache && ((l = l.replace($n, '$1')), (o = (Ln.test(l) ? '&' : '?') + '_=' + Nn.guid++ + o)),
              (f.url = l + o)),
          f.ifModified &&
            (P.lastModified[l] && x.setRequestHeader('If-Modified-Since', P.lastModified[l]), P.etag[l]) &&
            x.setRequestHeader('If-None-Match', P.etag[l]),
          ((f.data && f.hasContent && !1 !== f.contentType) || e.contentType) &&
            x.setRequestHeader('Content-Type', f.contentType),
          x.setRequestHeader(
            'Accept',
            f.dataTypes[0] && f.accepts[f.dataTypes[0]]
              ? f.accepts[f.dataTypes[0]] + ('*' !== f.dataTypes[0] ? ', ' + Vn + '; q=0.01' : '')
              : f.accepts['*']
          ),
          f.headers))
            x.setRequestHeader(r, f.headers[r]);
          if (f.beforeSend && (!1 === f.beforeSend.call(g, x, f) || d)) return x.abort();
          if (((a = 'abort'), v.add(f.complete), x.done(f.success), x.fail(f.error), (u = Jn(zn, f, e, x)))) {
            if (((x.readyState = 1), h && m.trigger('ajaxSend', [x, f]), d)) return x;
            f.async &&
              0 < f.timeout &&
              (p = w.setTimeout(function () {
                x.abort('timeout');
              }, f.timeout));
            try {
              (d = !1), u.send(i, S);
            } catch (t) {
              if (d) throw t;
              S(-1, t);
            }
          } else S(-1, 'No Transport');
        }
        return x;
        function S(t, e, n, r) {
          var o,
            i,
            s,
            a = e;
          d ||
            ((d = !0),
            p && w.clearTimeout(p),
            (u = void 0),
            (c = r || ''),
            (x.readyState = 0 < t ? 4 : 0),
            (r = (200 <= t && t < 300) || 304 === t),
            n &&
              (s = ((t, e, n) => {
                for (var r, o, i, s, a = t.contents, u = t.dataTypes; '*' === u[0]; )
                  u.shift(), void 0 === r && (r = t.mimeType || e.getResponseHeader('Content-Type'));
                if (r)
                  for (o in a)
                    if (a[o] && a[o].test(r)) {
                      u.unshift(o);
                      break;
                    }
                if (u[0] in n) i = u[0];
                else {
                  for (o in n) {
                    if (!u[0] || t.converters[o + ' ' + u[0]]) {
                      i = o;
                      break;
                    }
                    s = s || o;
                  }
                  i = i || s;
                }
                if (i) return i !== u[0] && u.unshift(i), n[i];
              })(f, x, n)),
            !r &&
              -1 < P.inArray('script', f.dataTypes) &&
              P.inArray('json', f.dataTypes) < 0 &&
              (f.converters['text script'] = function () {}),
            (s = ((t, e, n, r) => {
              var o,
                i,
                s,
                a,
                u,
                l = {},
                c = t.dataTypes.slice();
              if (c[1]) for (s in t.converters) l[s.toLowerCase()] = t.converters[s];
              for (i = c.shift(); i; )
                if (
                  (t.responseFields[i] && (n[t.responseFields[i]] = e),
                  !u && r && t.dataFilter && (e = t.dataFilter(e, t.dataType)),
                  (u = i),
                  (i = c.shift()))
                )
                  if ('*' === i) i = u;
                  else if ('*' !== u && u !== i) {
                    if (!(s = l[u + ' ' + i] || l['* ' + i]))
                      for (o in l)
                        if ((a = o.split(' '))[1] === i && (s = l[u + ' ' + a[0]] || l['* ' + a[0]])) {
                          !0 === s ? (s = l[o]) : !0 !== l[o] && ((i = a[0]), c.unshift(a[1]));
                          break;
                        }
                    if (!0 !== s)
                      if (s && t.throws) e = s(e);
                      else
                        try {
                          e = s(e);
                        } catch (t) {
                          return {state: 'parsererror', error: s ? t : 'No conversion from ' + u + ' to ' + i};
                        }
                  }
              return {state: 'success', data: e};
            })(f, s, x, r)),
            r
              ? (f.ifModified &&
                  ((n = x.getResponseHeader('Last-Modified')) && (P.lastModified[l] = n),
                  (n = x.getResponseHeader('etag'))) &&
                  (P.etag[l] = n),
                204 === t || 'HEAD' === f.type
                  ? (a = 'nocontent')
                  : 304 === t
                    ? (a = 'notmodified')
                    : ((a = s.state), (o = s.data), (r = !(i = s.error))))
              : ((i = a), (!t && a) || ((a = 'error'), t < 0 && (t = 0))),
            (x.status = t),
            (x.statusText = (e || a) + ''),
            r ? y.resolveWith(g, [o, a, x]) : y.rejectWith(g, [x, a, i]),
            x.statusCode(b),
            (b = void 0),
            h && m.trigger(r ? 'ajaxSuccess' : 'ajaxError', [x, f, r ? o : i]),
            v.fireWith(g, [x, a]),
            h && (m.trigger('ajaxComplete', [x, f]), --P.active || P.event.trigger('ajaxStop')));
        }
      },
      getJSON: function (t, e, n) {
        return P.get(t, e, n, 'json');
      },
      getScript: function (t, e) {
        return P.get(t, void 0, e, 'script');
      },
    }),
    P.each(['get', 'post'], function (t, o) {
      P[o] = function (t, e, n, r) {
        return (
          v(e) && ((r = r || n), (n = e), (e = void 0)),
          P.ajax(P.extend({url: t, type: o, dataType: r, data: e, success: n}, P.isPlainObject(t) && t))
        );
      };
    }),
    P.ajaxPrefilter(function (t) {
      for (var e in t.headers) 'content-type' === e.toLowerCase() && (t.contentType = t.headers[e] || '');
    }),
    (P._evalUrl = function (t, e, n) {
      return P.ajax({
        url: t,
        type: 'GET',
        dataType: 'script',
        cache: !0,
        async: !1,
        global: !1,
        converters: {'text script': function () {}},
        dataFilter: function (t) {
          P.globalEval(t, e, n);
        },
      });
    }),
    P.fn.extend({
      wrapAll: function (t) {
        return (
          this[0] &&
            (v(t) && (t = t.call(this[0])),
            (t = P(t, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                for (var t = this; t.firstElementChild; ) t = t.firstElementChild;
                return t;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (n) {
        return v(n)
          ? this.each(function (t) {
              P(this).wrapInner(n.call(this, t));
            })
          : this.each(function () {
              var t = P(this),
                e = t.contents();
              e.length ? e.wrapAll(n) : t.append(n);
            });
      },
      wrap: function (e) {
        var n = v(e);
        return this.each(function (t) {
          P(this).wrapAll(n ? e.call(this, t) : e);
        });
      },
      unwrap: function (t) {
        return (
          this.parent(t)
            .not('body')
            .each(function () {
              P(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (P.expr.pseudos.hidden = function (t) {
      return !P.expr.pseudos.visible(t);
    }),
    (P.expr.pseudos.visible = function (t) {
      return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
    }),
    (P.ajaxSettings.xhr = function () {
      try {
        return new w.XMLHttpRequest();
      } catch (t) {}
    });
  var tr = {0: 200, 1223: 204},
    er = P.ajaxSettings.xhr();
  (g.cors = !!er && 'withCredentials' in er),
    (g.ajax = er = !!er),
    P.ajaxTransport(function (o) {
      var i, s;
      if (g.cors || (er && !o.crossDomain))
        return {
          send: function (t, e) {
            var n,
              r = o.xhr();
            if ((r.open(o.type, o.url, o.async, o.username, o.password), o.xhrFields))
              for (n in o.xhrFields) r[n] = o.xhrFields[n];
            for (n in (o.mimeType && r.overrideMimeType && r.overrideMimeType(o.mimeType),
            o.crossDomain || t['X-Requested-With'] || (t['X-Requested-With'] = 'XMLHttpRequest'),
            t))
              r.setRequestHeader(n, t[n]);
            (i = function (t) {
              return function () {
                i &&
                  ((i = s = r.onload = r.onerror = r.onabort = r.ontimeout = r.onreadystatechange = null),
                  'abort' === t
                    ? r.abort()
                    : 'error' === t
                      ? 'number' != typeof r.status
                        ? e(0, 'error')
                        : e(r.status, r.statusText)
                      : e(
                          tr[r.status] || r.status,
                          r.statusText,
                          'text' !== (r.responseType || 'text') || 'string' != typeof r.responseText
                            ? {binary: r.response}
                            : {text: r.responseText},
                          r.getAllResponseHeaders()
                        ));
              };
            }),
              (r.onload = i()),
              (s = r.onerror = r.ontimeout = i('error')),
              void 0 !== r.onabort
                ? (r.onabort = s)
                : (r.onreadystatechange = function () {
                    4 === r.readyState &&
                      w.setTimeout(function () {
                        i && s();
                      });
                  }),
              (i = i('abort'));
            try {
              r.send((o.hasContent && o.data) || null);
            } catch (t) {
              if (i) throw t;
            }
          },
          abort: function () {
            i && i();
          },
        };
    }),
    P.ajaxPrefilter(function (t) {
      t.crossDomain && (t.contents.script = !1);
    }),
    P.ajaxSetup({
      accepts: {script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript'},
      contents: {script: /\b(?:java|ecma)script\b/},
      converters: {
        'text script': function (t) {
          return P.globalEval(t), t;
        },
      },
    }),
    P.ajaxPrefilter('script', function (t) {
      void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = 'GET');
    }),
    P.ajaxTransport('script', function (n) {
      var r, o;
      if (n.crossDomain || n.scriptAttrs)
        return {
          send: function (t, e) {
            (r = P('<script>')
              .attr(n.scriptAttrs || {})
              .prop({charset: n.scriptCharset, src: n.url})
              .on(
                'load error',
                (o = function (t) {
                  r.remove(), (o = null), t && e('error' === t.type ? 404 : 200, t.type);
                })
              )),
              _.head.appendChild(r[0]);
          },
          abort: function () {
            o && o();
          },
        };
    });
  var nr = [],
    rr = /(=)\?(?=&|$)|\?\?/,
    or =
      (P.ajaxSetup({
        jsonp: 'callback',
        jsonpCallback: function () {
          var t = nr.pop() || P.expando + '_' + Nn.guid++;
          return (this[t] = !0), t;
        },
      }),
      P.ajaxPrefilter('json jsonp', function (t, e, n) {
        var r,
          o,
          i,
          s =
            !1 !== t.jsonp &&
            (rr.test(t.url)
              ? 'url'
              : 'string' == typeof t.data &&
                0 === (t.contentType || '').indexOf('application/x-www-form-urlencoded') &&
                rr.test(t.data) &&
                'data');
        if (s || 'jsonp' === t.dataTypes[0])
          return (
            (r = t.jsonpCallback = v(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
            s
              ? (t[s] = t[s].replace(rr, '$1' + r))
              : !1 !== t.jsonp && (t.url += (Ln.test(t.url) ? '&' : '?') + t.jsonp + '=' + r),
            (t.converters['script json'] = function () {
              return i || P.error(r + ' was not called'), i[0];
            }),
            (t.dataTypes[0] = 'json'),
            (o = w[r]),
            (w[r] = function () {
              i = arguments;
            }),
            n.always(function () {
              void 0 === o ? P(w).removeProp(r) : (w[r] = o),
                t[r] && ((t.jsonpCallback = e.jsonpCallback), nr.push(r)),
                i && v(o) && o(i[0]),
                (i = o = void 0);
            }),
            'script'
          );
      }),
      (g.createHTMLDocument =
        (((t = _.implementation.createHTMLDocument('').body).innerHTML = '<form></form><form></form>'),
        2 === t.childNodes.length)),
      (P.parseHTML = function (t, e, n) {
        return 'string' != typeof t
          ? []
          : ('boolean' == typeof e && ((n = e), (e = !1)),
            e ||
              (g.createHTMLDocument
                ? (((r = (e = _.implementation.createHTMLDocument('')).createElement('base')).href = _.location.href),
                  e.head.appendChild(r))
                : (e = _)),
            (r = !n && []),
            (n = Kt.exec(t))
              ? [e.createElement(n[1])]
              : ((n = Te([t], e, r)), r && r.length && P(r).remove(), P.merge([], n.childNodes)));
        var r;
      }),
      (P.fn.load = function (t, e, n) {
        var r,
          o,
          i,
          s = this,
          a = t.indexOf(' ');
        return (
          -1 < a && ((r = Tn(t.slice(a))), (t = t.slice(0, a))),
          v(e) ? ((n = e), (e = void 0)) : e && 'object' == typeof e && (o = 'POST'),
          0 < s.length &&
            P.ajax({url: t, type: o || 'GET', dataType: 'html', data: e})
              .done(function (t) {
                (i = arguments), s.html(r ? P('<div>').append(P.parseHTML(t)).find(r) : t);
              })
              .always(
                n &&
                  function (t, e) {
                    s.each(function () {
                      n.apply(this, i || [t.responseText, e, t]);
                    });
                  }
              ),
          this
        );
      }),
      (P.expr.pseudos.animated = function (e) {
        return P.grep(P.timers, function (t) {
          return e === t.elem;
        }).length;
      }),
      (P.offset = {
        setOffset: function (t, e, n) {
          var r,
            o,
            i,
            s,
            a = P.css(t, 'position'),
            u = P(t),
            l = {};
          'static' === a && (t.style.position = 'relative'),
            (i = u.offset()),
            (r = P.css(t, 'top')),
            (s = P.css(t, 'left')),
            (a =
              ('absolute' === a || 'fixed' === a) && -1 < (r + s).indexOf('auto')
                ? ((o = (a = u.position()).top), a.left)
                : ((o = parseFloat(r) || 0), parseFloat(s) || 0)),
            null != (e = v(e) ? e.call(t, n, P.extend({}, i)) : e).top && (l.top = e.top - i.top + o),
            null != e.left && (l.left = e.left - i.left + a),
            'using' in e ? e.using.call(t, l) : u.css(l);
        },
      }),
      P.fn.extend({
        offset: function (e) {
          var t, n;
          return arguments.length
            ? void 0 === e
              ? this
              : this.each(function (t) {
                  P.offset.setOffset(this, e, t);
                })
            : (n = this[0])
              ? n.getClientRects().length
                ? ((t = n.getBoundingClientRect()),
                  (n = n.ownerDocument.defaultView),
                  {top: t.top + n.pageYOffset, left: t.left + n.pageXOffset})
                : {top: 0, left: 0}
              : void 0;
        },
        position: function () {
          if (this[0]) {
            var t,
              e,
              n,
              r = this[0],
              o = {top: 0, left: 0};
            if ('fixed' === P.css(r, 'position')) e = r.getBoundingClientRect();
            else {
              for (
                e = this.offset(), n = r.ownerDocument, t = r.offsetParent || n.documentElement;
                t && (t === n.body || t === n.documentElement) && 'static' === P.css(t, 'position');

              )
                t = t.parentNode;
              t &&
                t !== r &&
                1 === t.nodeType &&
                (((o = P(t).offset()).top += P.css(t, 'borderTopWidth', !0)),
                (o.left += P.css(t, 'borderLeftWidth', !0)));
            }
            return {top: e.top - o.top - P.css(r, 'marginTop', !0), left: e.left - o.left - P.css(r, 'marginLeft', !0)};
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (var t = this.offsetParent; t && 'static' === P.css(t, 'position'); ) t = t.offsetParent;
            return t || ye;
          });
        },
      }),
      P.each({scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset'}, function (e, o) {
        var i = 'pageYOffset' === o;
        P.fn[e] = function (t) {
          return c(
            this,
            function (t, e, n) {
              var r;
              if ((M(t) ? (r = t) : 9 === t.nodeType && (r = t.defaultView), void 0 === n)) return r ? r[o] : t[e];
              r ? r.scrollTo(i ? r.pageXOffset : n, i ? n : r.pageYOffset) : (t[e] = n);
            },
            e,
            t,
            arguments.length
          );
        };
      }),
      P.each(['top', 'left'], function (t, n) {
        P.cssHooks[n] = nn(g.pixelPosition, function (t, e) {
          if (e) return (e = en(t, n)), Je.test(e) ? P(t).position()[n] + 'px' : e;
        });
      }),
      P.each({Height: 'height', Width: 'width'}, function (s, a) {
        P.each({padding: 'inner' + s, content: a, '': 'outer' + s}, function (r, i) {
          P.fn[i] = function (t, e) {
            var n = arguments.length && (r || 'boolean' != typeof t),
              o = r || (!0 === t || !0 === e ? 'margin' : 'border');
            return c(
              this,
              function (t, e, n) {
                var r;
                return M(t)
                  ? 0 === i.indexOf('outer')
                    ? t['inner' + s]
                    : t.document.documentElement['client' + s]
                  : 9 === t.nodeType
                    ? ((r = t.documentElement),
                      Math.max(
                        t.body['scroll' + s],
                        r['scroll' + s],
                        t.body['offset' + s],
                        r['offset' + s],
                        r['client' + s]
                      ))
                    : void 0 === n
                      ? P.css(t, e, o)
                      : P.style(t, e, n, o);
              },
              a,
              n ? t : void 0,
              n
            );
          };
        });
      }),
      P.each(['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'], function (t, e) {
        P.fn[e] = function (t) {
          return this.on(e, t);
        };
      }),
      P.fn.extend({
        bind: function (t, e, n) {
          return this.on(t, null, e, n);
        },
        unbind: function (t, e) {
          return this.off(t, null, e);
        },
        delegate: function (t, e, n, r) {
          return this.on(e, t, n, r);
        },
        undelegate: function (t, e, n) {
          return 1 === arguments.length ? this.off(t, '**') : this.off(e, t || '**', n);
        },
        hover: function (t, e) {
          return this.on('mouseenter', t).on('mouseleave', e || t);
        },
      }),
      P.each(
        'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
          ' '
        ),
        function (t, n) {
          P.fn[n] = function (t, e) {
            return 0 < arguments.length ? this.on(n, null, t, e) : this.trigger(n);
          };
        }
      ),
      /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g),
    ir =
      ((P.proxy = function (t, e) {
        var n, r;
        if (('string' == typeof e && ((r = t[e]), (e = t), (t = r)), v(t)))
          return (
            (n = a.call(arguments, 2)),
            ((r = function () {
              return t.apply(e || this, n.concat(a.call(arguments)));
            }).guid = t.guid =
              t.guid || P.guid++),
            r
          );
      }),
      (P.holdReady = function (t) {
        t ? P.readyWait++ : P.ready(!0);
      }),
      (P.isArray = Array.isArray),
      (P.parseJSON = JSON.parse),
      (P.nodeName = b),
      (P.isFunction = v),
      (P.isWindow = M),
      (P.camelCase = I),
      (P.type = z),
      (P.now = Date.now),
      (P.isNumeric = function (t) {
        var e = P.type(t);
        return ('number' === e || 'string' === e) && !isNaN(t - parseFloat(t));
      }),
      (P.trim = function (t) {
        return null == t ? '' : (t + '').replace(or, '$1');
      }),
      'function' == typeof define &&
        define.amd &&
        define('jquery', [], function () {
          return P;
        }),
      w.jQuery),
    sr = w.$;
  return (
    (P.noConflict = function (t) {
      return w.$ === P && (w.$ = sr), t && w.jQuery === P && (w.jQuery = ir), P;
    }),
    void 0 === U && (w.jQuery = w.$ = P),
    P
  );
}),
  ((t, e) => {
    'object' == typeof exports && 'object' == typeof module
      ? (module.exports = e())
      : 'function' == typeof define && define.amd
        ? define([], e)
        : 'object' == typeof exports
          ? (exports.Handlebars = e())
          : (t.Handlebars = e());
  })(this, function () {
    return (
      (r = [
        function (t, e, n) {
          function r() {
            var n = p();
            return (
              (n.compile = function (t, e) {
                return u.compile(t, e, n);
              }),
              (n.precompile = function (t, e) {
                return u.precompile(t, e, n);
              }),
              (n.AST = s.default),
              (n.Compiler = u.Compiler),
              (n.JavaScriptCompiler = l.default),
              (n.Parser = a.parser),
              (n.parse = a.parse),
              (n.parseWithoutProcessing = a.parseWithoutProcessing),
              n
            );
          }
          var o = n(1).default;
          e.__esModule = !0;
          var i = o(n(2)),
            s = o(n(84)),
            a = n(85),
            u = n(90),
            l = o(n(91)),
            c = o(n(88)),
            o = o(n(83)),
            p = i.default.create,
            n = r();
          (n.create = r),
            o.default(n),
            (n.Visitor = c.default),
            (n.default = n),
            (e.default = n),
            (t.exports = e.default);
        },
        function (t, e) {
          (e.default = function (t) {
            return t && t.__esModule ? t : {default: t};
          }),
            (e.__esModule = !0);
        },
        function (t, e, n) {
          function r() {
            var e = new s.HandlebarsEnvironment();
            return (
              l.extend(e, s),
              (e.SafeString = a.default),
              (e.Exception = u.default),
              (e.Utils = l),
              (e.escapeExpression = l.escapeExpression),
              (e.VM = c),
              (e.template = function (t) {
                return c.template(t, e);
              }),
              e
            );
          }
          var o = n(3).default,
            i = n(1).default;
          e.__esModule = !0;
          var s = o(n(4)),
            a = i(n(77)),
            u = i(n(6)),
            l = o(n(5)),
            c = o(n(78)),
            o = i(n(83)),
            i = r();
          (i.create = r), o.default(i), (i.default = i), (e.default = i), (t.exports = e.default);
        },
        function (t, e) {
          (e.default = function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return (e.default = t), e;
          }),
            (e.__esModule = !0);
        },
        function (t, e, n) {
          function r(t, e, n) {
            (this.helpers = t || {}),
              (this.partials = e || {}),
              (this.decorators = n || {}),
              a.registerDefaultHelpers(this),
              u.registerDefaultDecorators(this);
          }
          var o = n(1).default,
            i = ((e.__esModule = !0), (e.HandlebarsEnvironment = r), n(5)),
            s = o(n(6)),
            a = n(10),
            u = n(70),
            o = o(n(72)),
            l = n(73),
            c =
              ((e.VERSION = '4.7.8'),
              (e.COMPILER_REVISION = 8),
              (e.LAST_COMPATIBLE_COMPILER_REVISION = 7),
              (e.REVISION_CHANGES = {
                1: '<= 1.0.rc.2',
                2: '== 1.0.0-rc.3',
                3: '== 1.0.0-rc.4',
                4: '== 1.x.x',
                5: '== 2.0.0-alpha.x',
                6: '>= 2.0.0-beta.1',
                7: '>= 4.0.0 <4.3.0',
                8: '>= 4.3.0',
              }),
              '[object Object]'),
            n =
              ((r.prototype = {
                constructor: r,
                logger: o.default,
                log: o.default.log,
                registerHelper: function (t, e) {
                  if (i.toString.call(t) === c) {
                    if (e) throw new s.default('Arg not supported with multiple helpers');
                    i.extend(this.helpers, t);
                  } else this.helpers[t] = e;
                },
                unregisterHelper: function (t) {
                  delete this.helpers[t];
                },
                registerPartial: function (t, e) {
                  if (i.toString.call(t) === c) i.extend(this.partials, t);
                  else {
                    if (void 0 === e)
                      throw new s.default('Attempting to register a partial called "' + t + '" as undefined');
                    this.partials[t] = e;
                  }
                },
                unregisterPartial: function (t) {
                  delete this.partials[t];
                },
                registerDecorator: function (t, e) {
                  if (i.toString.call(t) === c) {
                    if (e) throw new s.default('Arg not supported with multiple decorators');
                    i.extend(this.decorators, t);
                  } else this.decorators[t] = e;
                },
                unregisterDecorator: function (t) {
                  delete this.decorators[t];
                },
                resetLoggedPropertyAccesses: function () {
                  l.resetLoggedProperties();
                },
              }),
              o.default.log);
          (e.log = n), (e.createFrame = i.createFrame), (e.logger = o.default);
        },
        function (t, e) {
          function n(t) {
            return o[t];
          }
          function r(t) {
            for (var e = 1; e < arguments.length; e++)
              for (var n in arguments[e])
                Object.prototype.hasOwnProperty.call(arguments[e], n) && (t[n] = arguments[e][n]);
            return t;
          }
          (e.__esModule = !0),
            (e.extend = r),
            (e.indexOf = function (t, e) {
              for (var n = 0, r = t.length; n < r; n++) if (t[n] === e) return n;
              return -1;
            }),
            (e.escapeExpression = function (t) {
              if ('string' != typeof t) {
                if (t && t.toHTML) return t.toHTML();
                if (null == t) return '';
                if (!t) return t + '';
                t = '' + t;
              }
              return s.test(t) ? t.replace(i, n) : t;
            }),
            (e.isEmpty = function (t) {
              return (!t && 0 !== t) || !(!l(t) || 0 !== t.length);
            }),
            (e.createFrame = function (t) {
              var e = r({}, t);
              return (e._parent = t), e;
            }),
            (e.blockParams = function (t, e) {
              return (t.path = e), t;
            }),
            (e.appendContextPath = function (t, e) {
              return (t ? t + '.' : '') + e;
            });
          var o = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;', '`': '&#x60;', '=': '&#x3D;'},
            i = /[&<>"'`=]/g,
            s = /[&<>"'`=]/,
            a = Object.prototype.toString,
            u =
              ((e.toString = a),
              function (t) {
                return 'function' == typeof t;
              }),
            l =
              (u(/x/) &&
                (e.isFunction = u =
                  function (t) {
                    return 'function' == typeof t && '[object Function]' === a.call(t);
                  }),
              (e.isFunction = u),
              Array.isArray ||
                function (t) {
                  return !(!t || 'object' != typeof t) && '[object Array]' === a.call(t);
                });
          e.isArray = l;
        },
        function (t, e, n) {
          function u(t, e) {
            var e = e && e.loc,
              n = void 0,
              r = void 0,
              o = void 0,
              i = void 0;
            e &&
              ((n = e.start.line),
              (r = e.end.line),
              (o = e.start.column),
              (i = e.end.column),
              (t += ' - ' + n + ':' + o));
            for (var s = Error.prototype.constructor.call(this, t), a = 0; a < c.length; a++) this[c[a]] = s[c[a]];
            Error.captureStackTrace && Error.captureStackTrace(this, u);
            try {
              e &&
                ((this.lineNumber = n),
                (this.endLineNumber = r),
                l
                  ? (Object.defineProperty(this, 'column', {value: o, enumerable: !0}),
                    Object.defineProperty(this, 'endColumn', {value: i, enumerable: !0}))
                  : ((this.column = o), (this.endColumn = i)));
            } catch (t) {}
          }
          var l = n(7).default,
            c =
              ((e.__esModule = !0),
              ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack']);
          (u.prototype = new Error()), (e.default = u), (t.exports = e.default);
        },
        function (t, e, n) {
          t.exports = {default: n(8), __esModule: !0};
        },
        function (t, e, n) {
          var r = n(9);
          t.exports = function (t, e, n) {
            return r.setDesc(t, e, n);
          };
        },
        function (t, e) {
          var n = Object;
          t.exports = {
            create: n.create,
            getProto: n.getPrototypeOf,
            isEnum: {}.propertyIsEnumerable,
            getDesc: n.getOwnPropertyDescriptor,
            setDesc: n.defineProperty,
            setDescs: n.defineProperties,
            getKeys: n.keys,
            getNames: n.getOwnPropertyNames,
            getSymbols: n.getOwnPropertySymbols,
            each: [].forEach,
          };
        },
        function (t, e, n) {
          var r = n(1).default;
          (e.__esModule = !0),
            (e.registerDefaultHelpers = function (t) {
              o.default(t), i.default(t), s.default(t), a.default(t), u.default(t), l.default(t), c.default(t);
            }),
            (e.moveHelperToHooks = function (t, e, n) {
              t.helpers[e] && ((t.hooks[e] = t.helpers[e]), n || delete t.helpers[e]);
            });
          var o = r(n(11)),
            i = r(n(12)),
            s = r(n(65)),
            a = r(n(66)),
            u = r(n(67)),
            l = r(n(68)),
            c = r(n(69));
        },
        function (t, e, n) {
          e.__esModule = !0;
          var i = n(5);
          (e.default = function (o) {
            o.registerHelper('blockHelperMissing', function (t, e) {
              var n = e.inverse,
                r = e.fn;
              return !0 === t
                ? r(this)
                : !1 === t || null == t
                  ? n(this)
                  : i.isArray(t)
                    ? 0 < t.length
                      ? (e.ids && (e.ids = [e.name]), o.helpers.each(t, e))
                      : n(this)
                    : (e.data &&
                        e.ids &&
                        (((n = i.createFrame(e.data)).contextPath = i.appendContextPath(e.data.contextPath, e.name)),
                        (e = {data: n})),
                      r(t, e));
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, n) {
          var f = n(13).default,
            g = n(43).default,
            m = n(55).default,
            y = n(60).default,
            r = n(1).default,
            v = ((e.__esModule = !0), n(5)),
            b = r(n(6));
          (e.default = function (t) {
            t.registerHelper('each', function (r, t) {
              function e(t, e, n) {
                u && ((u.key = t), (u.index = e), (u.first = 0 === e), (u.last = !!n), l) && (u.contextPath = l + t),
                  (a += o(r[t], {data: u, blockParams: v.blockParams([r[t], t], [l + t, null])}));
              }
              if (!t) throw new b.default('Must pass iterator to #each');
              var n,
                o = t.fn,
                i = t.inverse,
                s = 0,
                a = '',
                u = void 0,
                l = void 0;
              if (
                (t.data && t.ids && (l = v.appendContextPath(t.data.contextPath, t.ids[0]) + '.'),
                v.isFunction(r) && (r = r.call(this)),
                t.data && (u = v.createFrame(t.data)),
                r && 'object' == typeof r)
              )
                if (v.isArray(r)) for (var c = r.length; s < c; s++) s in r && e(s, s, s === r.length - 1);
                else if ('function' == typeof f && r[g]) {
                  for (var p = [], d = m(r), h = d.next(); !h.done; h = d.next()) p.push(h.value);
                  for (c = (r = p).length; s < c; s++) e(s, s, s === r.length - 1);
                } else
                  (n = void 0),
                    y(r).forEach(function (t) {
                      void 0 !== n && e(n, s - 1), (n = t), s++;
                    }),
                    void 0 !== n && e(n, s - 1, !0);
              return (a = 0 === s ? i(this) : a);
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, n) {
          t.exports = {default: n(14), __esModule: !0};
        },
        function (t, e, n) {
          n(15), n(42), (t.exports = n(21).Symbol);
        },
        function (U, M, t) {
          function n(e) {
            var t = (O[e] = _(P.prototype));
            return (
              (t._k = e),
              p &&
                C &&
                D(I, e, {
                  configurable: !0,
                  set: function (t) {
                    c(this, T) && c(this[T], e) && (this[T][e] = !1), D(this, e, x(1, t));
                  },
                }),
              t
            );
          }
          function r(t, e) {
            B(t);
            for (var n, r = F((e = b(e))), o = 0, i = r.length; o < i; ) L(t, (n = r[o++]), e[n]);
            return t;
          }
          function e(t, e) {
            return void 0 === e ? _(t) : r(_(t), e);
          }
          function o(t) {
            var e = W.call(this, t);
            return !(e || !c(this, t) || !c(O, t) || (c(this, T) && this[T][t])) || e;
          }
          function i(t, e) {
            var n = S((t = b(t)), e);
            return !n || !c(O, e) || (c(t, T) && t[T][e]) || (n.enumerable = !0), n;
          }
          function s(t) {
            for (var e, n = $(b(t)), r = [], o = 0; n.length > o; ) c(O, (e = n[o++])) || e == T || r.push(e);
            return r;
          }
          function a(t) {
            for (var e, n = $(b(t)), r = [], o = 0; n.length > o; ) c(O, (e = n[o++])) && r.push(O[e]);
            return r;
          }
          var u = t(9),
            l = t(16),
            c = t(17),
            p = t(18),
            d = t(20),
            h = t(24),
            f = t(19),
            g = t(27),
            m = t(28),
            H = t(30),
            y = t(29),
            j = t(31),
            v = t(36),
            F = t(37),
            q = t(38),
            B = t(39),
            b = t(32),
            x = t(26),
            S = u.getDesc,
            w = u.setDesc,
            _ = u.create,
            $ = v.get,
            P = l.Symbol,
            k = l.JSON,
            E = k && k.stringify,
            C = !1,
            T = y('_hidden'),
            W = u.isEnum,
            A = g('symbol-registry'),
            O = g('symbols'),
            R = 'function' == typeof P,
            I = Object.prototype,
            D =
              p &&
              f(function () {
                return (
                  7 !=
                  _(
                    w({}, 'a', {
                      get: function () {
                        return w(this, 'a', {value: 7}).a;
                      },
                    })
                  ).a
                );
              })
                ? function (t, e, n) {
                    var r = S(I, e);
                    r && delete I[e], w(t, e, n), r && t !== I && w(I, e, r);
                  }
                : w,
            N = function (t) {
              return 'symbol' == typeof t;
            },
            L = function (t, e, n) {
              return (
                n && c(O, e)
                  ? (n.enumerable
                      ? (c(t, T) && t[T][e] && (t[T][e] = !1), (n = _(n, {enumerable: x(0, !1)})))
                      : (c(t, T) || w(t, T, x(1, {})), (t[T][e] = !0)),
                    D)
                  : w
              )(t, e, n);
            },
            g = f(function () {
              var t = P();
              return '[null]' != E([t]) || '{}' != E({a: t}) || '{}' != E(Object(t));
            }),
            G =
              (R ||
                (h(
                  (P = function () {
                    if (N(this)) throw TypeError('Symbol is not a constructor');
                    return n(H(0 < arguments.length ? arguments[0] : void 0));
                  }).prototype,
                  'toString',
                  function () {
                    return this._k;
                  }
                ),
                (N = function (t) {
                  return t instanceof P;
                }),
                (u.create = e),
                (u.isEnum = o),
                (u.getDesc = i),
                (u.setDesc = L),
                (u.setDescs = r),
                (u.getNames = v.get = s),
                (u.getSymbols = a),
                p && !t(41) && h(I, 'propertyIsEnumerable', o, !0)),
              {
                for: function (t) {
                  return c(A, (t += '')) ? A[t] : (A[t] = P(t));
                },
                keyFor: function (t) {
                  return j(A, t);
                },
                useSetter: function () {
                  C = !0;
                },
                useSimple: function () {
                  C = !1;
                },
              });
          u.each.call(
            'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(
              ','
            ),
            function (t) {
              var e = y(t);
              G[t] = R ? e : n(e);
            }
          ),
            (C = !0),
            d(d.G + d.W, {Symbol: P}),
            d(d.S, 'Symbol', G),
            d(d.S + d.F * !R, 'Object', {
              create: e,
              defineProperty: L,
              defineProperties: r,
              getOwnPropertyDescriptor: i,
              getOwnPropertyNames: s,
              getOwnPropertySymbols: a,
            }),
            k &&
              d(d.S + d.F * (!R || g), 'JSON', {
                stringify: function (t) {
                  if (void 0 !== t && !N(t)) {
                    for (var n, e = [t], r = 1, o = arguments; r < o.length; ) e.push(o[r++]);
                    return (
                      (!(n = 'function' == typeof (t = e[1]) ? t : n) && q(t)) ||
                        (t = function (t, e) {
                          if ((n && (e = n.call(this, t, e)), !N(e))) return e;
                        }),
                      (e[1] = t),
                      E.apply(k, e)
                    );
                  }
                },
              }),
            m(P, 'Symbol'),
            m(Math, 'Math', !0),
            m(l.JSON, 'JSON', !0);
        },
        function (t, e) {
          t = t.exports =
            'undefined' != typeof window && window.Math == Math
              ? window
              : 'undefined' != typeof self && self.Math == Math
                ? self
                : Function('return this')();
          'number' == typeof __g && (__g = t);
        },
        function (t, e) {
          var n = {}.hasOwnProperty;
          t.exports = function (t, e) {
            return n.call(t, e);
          };
        },
        function (t, e, n) {
          t.exports = !n(19)(function () {
            return (
              7 !=
              Object.defineProperty({}, 'a', {
                get: function () {
                  return 7;
                },
              }).a
            );
          });
        },
        function (t, e) {
          t.exports = function (t) {
            try {
              return !!t();
            } catch (t) {
              return !0;
            }
          };
        },
        function (t, e, n) {
          function f(t, e, n) {
            var r,
              o,
              i,
              s = t & f.F,
              a = t & f.G,
              u = t & f.S,
              l = t & f.P,
              c = t & f.B,
              p = t & f.W,
              d = a ? m : m[e] || (m[e] = {}),
              h = a ? g : u ? g[e] : (g[e] || {})[v];
            for (r in (n = a ? e : n))
              (o = !s && h && r in h),
                (o && r in d) ||
                  ((i = (o ? h : n)[r]),
                  (d[r] =
                    a && 'function' != typeof h[r]
                      ? n[r]
                      : c && o
                        ? y(i, g)
                        : p && h[r] == i
                          ? ((e) => {
                              function t(t) {
                                return this instanceof e ? new e(t) : e(t);
                              }
                              return (t[v] = e[v]), t;
                            })(i)
                          : l && 'function' == typeof i
                            ? y(Function.call, i)
                            : i),
                  l && ((d[v] || (d[v] = {}))[r] = i));
          }
          var g = n(16),
            m = n(21),
            y = n(22),
            v = 'prototype';
          (f.F = 1), (f.G = 2), (f.S = 4), (f.P = 8), (f.B = 16), (f.W = 32), (t.exports = f);
        },
        function (t, e) {
          t = t.exports = {version: '1.2.6'};
          'number' == typeof __e && (__e = t);
        },
        function (t, e, n) {
          var i = n(23);
          t.exports = function (r, o, t) {
            if ((i(r), void 0 === o)) return r;
            switch (t) {
              case 1:
                return function (t) {
                  return r.call(o, t);
                };
              case 2:
                return function (t, e) {
                  return r.call(o, t, e);
                };
              case 3:
                return function (t, e, n) {
                  return r.call(o, t, e, n);
                };
            }
            return function () {
              return r.apply(o, arguments);
            };
          };
        },
        function (t, e) {
          t.exports = function (t) {
            if ('function' != typeof t) throw TypeError(t + ' is not a function!');
            return t;
          };
        },
        function (t, e, n) {
          t.exports = n(25);
        },
        function (t, e, n) {
          var r = n(9),
            o = n(26);
          t.exports = n(18)
            ? function (t, e, n) {
                return r.setDesc(t, e, o(1, n));
              }
            : function (t, e, n) {
                return (t[e] = n), t;
              };
        },
        function (t, e) {
          t.exports = function (t, e) {
            return {enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e};
          };
        },
        function (t, e, n) {
          var n = n(16),
            r = '__core-js_shared__',
            o = n[r] || (n[r] = {});
          t.exports = function (t) {
            return o[t] || (o[t] = {});
          };
        },
        function (t, e, n) {
          var r = n(9).setDesc,
            o = n(17),
            i = n(29)('toStringTag');
          t.exports = function (t, e, n) {
            t && !o((t = n ? t : t.prototype), i) && r(t, i, {configurable: !0, value: e});
          };
        },
        function (t, e, n) {
          var r = n(27)('wks'),
            o = n(30),
            i = n(16).Symbol;
          t.exports = function (t) {
            return r[t] || (r[t] = (i && i[t]) || (i || o)('Symbol.' + t));
          };
        },
        function (t, e) {
          var n = 0,
            r = Math.random();
          t.exports = function (t) {
            return 'Symbol('.concat(void 0 === t ? '' : t, ')_', (++n + r).toString(36));
          };
        },
        function (t, e, n) {
          var a = n(9),
            u = n(32);
          t.exports = function (t, e) {
            for (var n, r = u(t), o = a.getKeys(r), i = o.length, s = 0; s < i; ) if (r[(n = o[s++])] === e) return n;
          };
        },
        function (t, e, n) {
          var r = n(33),
            o = n(35);
          t.exports = function (t) {
            return r(o(t));
          };
        },
        function (t, e, n) {
          var r = n(34);
          t.exports = Object('z').propertyIsEnumerable(0)
            ? Object
            : function (t) {
                return 'String' == r(t) ? t.split('') : Object(t);
              };
        },
        function (t, e) {
          var n = {}.toString;
          t.exports = function (t) {
            return n.call(t).slice(8, -1);
          };
        },
        function (t, e) {
          t.exports = function (t) {
            if (null == t) throw TypeError("Can't call method on  " + t);
            return t;
          };
        },
        function (t, e, n) {
          var r = n(32),
            o = n(9).getNames,
            i = {}.toString,
            s = 'object' == typeof window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
          t.exports.get = function (t) {
            if (!s || '[object Window]' != i.call(t)) return o(r(t));
            try {
              return o(t);
            } catch (t) {
              return s.slice();
            }
          };
        },
        function (t, e, n) {
          var a = n(9);
          t.exports = function (t) {
            var e = a.getKeys(t),
              n = a.getSymbols;
            if (n) for (var r, o = n(t), i = a.isEnum, s = 0; o.length > s; ) i.call(t, (r = o[s++])) && e.push(r);
            return e;
          };
        },
        function (t, e, n) {
          var r = n(34);
          t.exports =
            Array.isArray ||
            function (t) {
              return 'Array' == r(t);
            };
        },
        function (t, e, n) {
          var r = n(40);
          t.exports = function (t) {
            if (r(t)) return t;
            throw TypeError(t + ' is not an object!');
          };
        },
        function (t, e) {
          t.exports = function (t) {
            return 'object' == typeof t ? null !== t : 'function' == typeof t;
          };
        },
        function (t, e) {
          t.exports = !0;
        },
        function (t, e) {},
        function (t, e, n) {
          t.exports = {default: n(44), __esModule: !0};
        },
        function (t, e, n) {
          n(45), n(51), (t.exports = n(29)('iterator'));
        },
        function (t, e, n) {
          var r = n(46)(!0);
          n(48)(
            String,
            'String',
            function (t) {
              (this._t = String(t)), (this._i = 0);
            },
            function () {
              var t = this._t,
                e = this._i;
              return e >= t.length
                ? {value: void 0, done: !0}
                : ((t = r(t, e)), (this._i += t.length), {value: t, done: !1});
            }
          );
        },
        function (t, e, n) {
          var i = n(47),
            s = n(35);
          t.exports = function (o) {
            return function (t, e) {
              var n,
                t = String(s(t)),
                e = i(e),
                r = t.length;
              return e < 0 || r <= e
                ? o
                  ? ''
                  : void 0
                : (n = t.charCodeAt(e)) < 55296 ||
                    56319 < n ||
                    e + 1 === r ||
                    (r = t.charCodeAt(e + 1)) < 56320 ||
                    57343 < r
                  ? o
                    ? t.charAt(e)
                    : n
                  : o
                    ? t.slice(e, e + 2)
                    : r - 56320 + ((n - 55296) << 10) + 65536;
            };
          };
        },
        function (t, e) {
          var n = Math.ceil,
            r = Math.floor;
          t.exports = function (t) {
            return isNaN((t = +t)) ? 0 : (0 < t ? r : n)(t);
          };
        },
        function (t, e, n) {
          function g() {
            return this;
          }
          var m = n(41),
            y = n(20),
            v = n(24),
            b = n(25),
            x = n(17),
            S = n(49),
            w = n(50),
            _ = n(28),
            P = n(9).getProto,
            k = n(29)('iterator'),
            E = !([].keys && 'next' in [].keys()),
            C = '@@iterator',
            T = 'values';
          t.exports = function (t, e, n, r, o, i, s) {
            w(n, e, r);
            function a(t) {
              if (!E && t in d) return d[t];
              switch (t) {
                case 'keys':
                case T:
                  return function () {
                    return new n(this, t);
                  };
              }
              return function () {
                return new n(this, t);
              };
            }
            var u,
              l,
              r = e + ' Iterator',
              c = o == T,
              p = !1,
              d = t.prototype,
              h = d[k] || d[C] || (o && d[o]),
              f = h || a(o);
            if (
              (h &&
                ((t = P(f.call(new t()))), _(t, r, !0), !m && x(d, C) && b(t, k, g), c) &&
                h.name !== T &&
                ((p = !0),
                (f = function () {
                  return h.call(this);
                })),
              (m && !s) || (!E && !p && d[k]) || b(d, k, f),
              (S[e] = f),
              (S[r] = g),
              o)
            )
              if (((u = {values: c ? f : a(T), keys: i ? f : a('keys'), entries: c ? a('entries') : f}), s))
                for (l in u) l in d || v(d, l, u[l]);
              else y(y.P + y.F * (E || p), e, u);
            return u;
          };
        },
        function (t, e) {
          t.exports = {};
        },
        function (t, e, n) {
          var r = n(9),
            o = n(26),
            i = n(28),
            s = {};
          n(25)(s, n(29)('iterator'), function () {
            return this;
          }),
            (t.exports = function (t, e, n) {
              (t.prototype = r.create(s, {next: o(1, n)})), i(t, e + ' Iterator');
            });
        },
        function (t, e, n) {
          n(52);
          n = n(49);
          n.NodeList = n.HTMLCollection = n.Array;
        },
        function (t, e, n) {
          var r = n(53),
            o = n(54),
            i = n(49),
            s = n(32);
          (t.exports = n(48)(
            Array,
            'Array',
            function (t, e) {
              (this._t = s(t)), (this._i = 0), (this._k = e);
            },
            function () {
              var t = this._t,
                e = this._k,
                n = this._i++;
              return !t || n >= t.length
                ? ((this._t = void 0), o(1))
                : o(0, 'keys' == e ? n : 'values' == e ? t[n] : [n, t[n]]);
            },
            'values'
          )),
            (i.Arguments = i.Array),
            r('keys'),
            r('values'),
            r('entries');
        },
        function (t, e) {
          t.exports = function () {};
        },
        function (t, e) {
          t.exports = function (t, e) {
            return {value: e, done: !!t};
          };
        },
        function (t, e, n) {
          t.exports = {default: n(56), __esModule: !0};
        },
        function (t, e, n) {
          n(51), n(45), (t.exports = n(57));
        },
        function (t, e, n) {
          var r = n(39),
            o = n(58);
          t.exports = n(21).getIterator = function (t) {
            var e = o(t);
            if ('function' != typeof e) throw TypeError(t + ' is not iterable!');
            return r(e.call(t));
          };
        },
        function (t, e, n) {
          var r = n(59),
            o = n(29)('iterator'),
            i = n(49);
          t.exports = n(21).getIteratorMethod = function (t) {
            if (null != t) return t[o] || t['@@iterator'] || i[r(t)];
          };
        },
        function (t, e, n) {
          var r = n(34),
            o = n(29)('toStringTag'),
            i =
              'Arguments' ==
              r(
                (function () {
                  return arguments;
                })()
              );
          t.exports = function (t) {
            var e;
            return void 0 === t
              ? 'Undefined'
              : null === t
                ? 'Null'
                : 'string' == typeof (e = (t = Object(t))[o])
                  ? e
                  : i
                    ? r(t)
                    : 'Object' == (e = r(t)) && 'function' == typeof t.callee
                      ? 'Arguments'
                      : e;
          };
        },
        function (t, e, n) {
          t.exports = {default: n(61), __esModule: !0};
        },
        function (t, e, n) {
          n(62), (t.exports = n(21).Object.keys);
        },
        function (t, e, n) {
          var r = n(63);
          n(64)('keys', function (e) {
            return function (t) {
              return e(r(t));
            };
          });
        },
        function (t, e, n) {
          var r = n(35);
          t.exports = function (t) {
            return Object(r(t));
          };
        },
        function (t, e, n) {
          var o = n(20),
            i = n(21),
            s = n(19);
          t.exports = function (t, e) {
            var n = (i.Object || {})[t] || Object[t],
              r = {};
            (r[t] = e(n)),
              o(
                o.S +
                  o.F *
                    s(function () {
                      n(1);
                    }),
                'Object',
                r
              );
          };
        },
        function (t, e, n) {
          var r = n(1).default;
          e.__esModule = !0;
          var o = r(n(6));
          (e.default = function (t) {
            t.registerHelper('helperMissing', function () {
              if (1 !== arguments.length)
                throw new o.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, n) {
          var r = n(1).default,
            o = ((e.__esModule = !0), n(5)),
            i = r(n(6));
          (e.default = function (n) {
            n.registerHelper('if', function (t, e) {
              if (2 != arguments.length) throw new i.default('#if requires exactly one argument');
              return (
                o.isFunction(t) && (t = t.call(this)),
                (!e.hash.includeZero && !t) || o.isEmpty(t) ? e.inverse(this) : e.fn(this)
              );
            }),
              n.registerHelper('unless', function (t, e) {
                if (2 != arguments.length) throw new i.default('#unless requires exactly one argument');
                return n.helpers.if.call(this, t, {fn: e.inverse, inverse: e.fn, hash: e.hash});
              });
          }),
            (t.exports = e.default);
        },
        function (t, e) {
          (e.__esModule = !0),
            (e.default = function (o) {
              o.registerHelper('log', function () {
                for (var t = [void 0], e = arguments[arguments.length - 1], n = 0; n < arguments.length - 1; n++)
                  t.push(arguments[n]);
                var r = 1;
                null != e.hash.level ? (r = e.hash.level) : e.data && null != e.data.level && (r = e.data.level),
                  (t[0] = r),
                  o.log.apply(o, t);
              });
            }),
            (t.exports = e.default);
        },
        function (t, e) {
          (e.__esModule = !0),
            (e.default = function (t) {
              t.registerHelper('lookup', function (t, e, n) {
                return t && n.lookupProperty(t, e);
              });
            }),
            (t.exports = e.default);
        },
        function (t, e, n) {
          var r = n(1).default,
            o = ((e.__esModule = !0), n(5)),
            i = r(n(6));
          (e.default = function (t) {
            t.registerHelper('with', function (t, e) {
              if (2 != arguments.length) throw new i.default('#with requires exactly one argument');
              o.isFunction(t) && (t = t.call(this));
              var n,
                r = e.fn;
              return o.isEmpty(t)
                ? e.inverse(this)
                : ((n = e.data),
                  e.data &&
                    e.ids &&
                    ((n = o.createFrame(e.data)).contextPath = o.appendContextPath(e.data.contextPath, e.ids[0])),
                  r(t, {data: n, blockParams: o.blockParams([t], [n && n.contextPath])}));
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, n) {
          var r = n(1).default;
          (e.__esModule = !0),
            (e.registerDefaultDecorators = function (t) {
              o.default(t);
            });
          var o = r(n(71));
        },
        function (t, e, n) {
          e.__esModule = !0;
          var s = n(5);
          (e.default = function (t) {
            t.registerDecorator('inline', function (r, o, i, t) {
              var e = r;
              return (
                o.partials ||
                  ((o.partials = {}),
                  (e = function (t, e) {
                    var n = i.partials,
                      t = ((i.partials = s.extend({}, n, o.partials)), r(t, e));
                    return (i.partials = n), t;
                  })),
                (o.partials[t.args[0]] = t.fn),
                e
              );
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, n) {
          e.__esModule = !0;
          var r = n(5),
            o = {
              methodMap: ['debug', 'info', 'warn', 'error'],
              level: 'info',
              lookupLevel: function (t) {
                var e;
                return (t =
                  'string' == typeof t
                    ? 0 <= (e = r.indexOf(o.methodMap, t.toLowerCase()))
                      ? e
                      : parseInt(t, 10)
                    : t);
              },
              log: function (t) {
                if (((t = o.lookupLevel(t)), 'undefined' != typeof console && o.lookupLevel(o.level) <= t)) {
                  t = o.methodMap[t];
                  console[t] || (t = 'log');
                  for (var e = arguments.length, n = Array(1 < e ? e - 1 : 0), r = 1; r < e; r++)
                    n[r - 1] = arguments[r];
                  console[t].apply(console, n);
                }
              },
            };
          (e.default = o), (t.exports = e.default);
        },
        function (t, e, n) {
          function r(t, e) {
            return void 0 !== t.whitelist[e]
              ? !0 === t.whitelist[e]
              : void 0 !== t.defaultValue
                ? t.defaultValue
                : (!0 !== l[(t = e)] &&
                    ((l[t] = !0),
                    u.default.log(
                      'error',
                      'Handlebars: Access has been denied to resolve the property "' +
                        t +
                        '" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'
                    )),
                  !1);
          }
          var o = n(74).default,
            i = n(60).default,
            s = n(1).default,
            a =
              ((e.__esModule = !0),
              (e.createProtoAccessControl = function (t) {
                var e = o(null),
                  n =
                    ((e.constructor = !1),
                    (e.__defineGetter__ = !1),
                    (e.__defineSetter__ = !1),
                    (e.__lookupGetter__ = !1),
                    o(null));
                return (
                  (n.__proto__ = !1),
                  {
                    properties: {
                      whitelist: a.createNewLookupObject(n, t.allowedProtoProperties),
                      defaultValue: t.allowProtoPropertiesByDefault,
                    },
                    methods: {
                      whitelist: a.createNewLookupObject(e, t.allowedProtoMethods),
                      defaultValue: t.allowProtoMethodsByDefault,
                    },
                  }
                );
              }),
              (e.resultIsAllowed = function (t, e, n) {
                return r('function' == typeof t ? e.methods : e.properties, n);
              }),
              (e.resetLoggedProperties = function () {
                i(l).forEach(function (t) {
                  delete l[t];
                });
              }),
              n(76)),
            u = s(n(72)),
            l = o(null);
        },
        function (t, e, n) {
          t.exports = {default: n(75), __esModule: !0};
        },
        function (t, e, n) {
          var r = n(9);
          t.exports = function (t, e) {
            return r.create(t, e);
          };
        },
        function (t, e, n) {
          var r = n(74).default,
            o =
              ((e.__esModule = !0),
              (e.createNewLookupObject = function () {
                for (var t = arguments.length, e = Array(t), n = 0; n < t; n++) e[n] = arguments[n];
                return o.extend.apply(void 0, [r(null)].concat(e));
              }),
              n(5));
        },
        function (t, e) {
          function n(t) {
            this.string = t;
          }
          (e.__esModule = !0),
            (n.prototype.toString = n.prototype.toHTML =
              function () {
                return '' + this.string;
              }),
            (e.default = n),
            (t.exports = e.default);
        },
        function (t, e, n) {
          function a(r, t, o, i, e, s, a) {
            function n(t) {
              var e = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                n = a;
              return (
                !a || t == a[0] || (t === r.nullContext && null === a[0]) || (n = [t].concat(a)),
                o(r, t, r.helpers, r.partials, e.data || i, s && [e.blockParams].concat(s), n)
              );
            }
            return ((n = d(o, n, r, a, i, s)).program = t), (n.depth = a ? a.length : 0), (n.blockParams = e || 0), n;
          }
          function s() {
            return '';
          }
          function d(t, e, n, r, o, i) {
            return t.decorator && ((e = t.decorator(e, (t = {}), n, r && r[0], o, i, r)), h.extend(e, t)), e;
          }
          var r = n(79).default,
            i = n(60).default,
            o = n(3).default,
            u = n(1).default;
          (e.__esModule = !0),
            (e.checkRevision = function (t) {
              var e = (t && t[0]) || 1,
                n = g.COMPILER_REVISION;
              if (!(g.LAST_COMPATIBLE_COMPILER_REVISION <= e && e <= g.COMPILER_REVISION)) {
                if (e < g.LAST_COMPATIBLE_COMPILER_REVISION)
                  throw (
                    ((n = g.REVISION_CHANGES[n]),
                    (e = g.REVISION_CHANGES[e]),
                    new f.default(
                      'Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (' +
                        n +
                        ') or downgrade your runtime to an older version (' +
                        e +
                        ').'
                    ))
                  );
                throw new f.default(
                  'Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (' +
                    t[1] +
                    ').'
                );
              }
            }),
            (e.template = function (u, l) {
              function c(t) {
                function e(t) {
                  return '' + u.main(p, t, p.helpers, p.partials, i, a, s);
                }
                var n,
                  r,
                  o = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                  i = o.data,
                  s =
                    (c._setup(o),
                    !o.partial &&
                      u.useData &&
                      ((n = t), ((r = i) && 'root' in r) || ((r = r ? g.createFrame(r) : {}).root = n), (i = r)),
                    void 0),
                  a = u.useBlockParams ? [] : void 0;
                return (
                  u.useDepths && (s = o.depths ? (t != o.depths[0] ? [t].concat(o.depths) : o.depths) : [t]),
                  (e = d(u.main, e, p, o.depths || [], i, a))(t, o)
                );
              }
              if (!l) throw new f.default('No environment passed to template');
              if (!u || !u.main) throw new f.default('Unknown template object: ' + typeof u);
              (u.main.decorator = u.main_d), l.VM.checkRevision(u.compiler);
              var n = u.compiler && 7 === u.compiler[0],
                p = {
                  strict: function (t, e, n) {
                    if (t && e in t) return p.lookupProperty(t, e);
                    throw new f.default('"' + e + '" not defined in ' + t, {loc: n});
                  },
                  lookupProperty: function (t, e) {
                    var n = t[e];
                    return null == n ||
                      Object.prototype.hasOwnProperty.call(t, e) ||
                      v.resultIsAllowed(n, p.protoAccessControl, e)
                      ? n
                      : void 0;
                  },
                  lookup: function (t, e) {
                    for (var n = t.length, r = 0; r < n; r++)
                      if (null != (t[r] && p.lookupProperty(t[r], e))) return t[r][e];
                  },
                  lambda: function (t, e) {
                    return 'function' == typeof t ? t.call(e) : t;
                  },
                  escapeExpression: h.escapeExpression,
                  invokePartial: function (t, e, n) {
                    n.hash && ((e = h.extend({}, e, n.hash)), n.ids) && (n.ids[0] = !0),
                      (t = l.VM.resolvePartial.call(this, t, e, n));
                    var r = h.extend({}, n, {hooks: this.hooks, protoAccessControl: this.protoAccessControl}),
                      o = l.VM.invokePartial.call(this, t, e, r);
                    if (
                      (null == o &&
                        l.compile &&
                        ((n.partials[n.name] = l.compile(t, u.compilerOptions, l)), (o = n.partials[n.name](e, r))),
                      null == o)
                    )
                      throw new f.default(
                        'The partial ' + n.name + ' could not be compiled when running in runtime-only mode'
                      );
                    if (n.indent) {
                      for (var i = o.split('\n'), s = 0, a = i.length; s < a && (i[s] || s + 1 !== a); s++)
                        i[s] = n.indent + i[s];
                      o = i.join('\n');
                    }
                    return o;
                  },
                  fn: function (t) {
                    var e = u[t];
                    return (e.decorator = u[t + '_d']), e;
                  },
                  programs: [],
                  program: function (t, e, n, r, o) {
                    var i = this.programs[t],
                      s = this.fn(t);
                    return (i = e || o || r || n ? a(this, t, s, e, n, r, o) : i || (this.programs[t] = a(this, t, s)));
                  },
                  data: function (t, e) {
                    for (; t && e--; ) t = t._parent;
                    return t;
                  },
                  mergeIfNeeded: function (t, e) {
                    var n = t || e;
                    return (n = t && e && t !== e ? h.extend({}, e, t) : n);
                  },
                  nullContext: r({}),
                  noop: l.VM.noop,
                  compilerInfo: u.compiler,
                };
              return (
                (c.isTop = !0),
                (c._setup = function (t) {
                  var e, r, o;
                  t.partial
                    ? ((p.protoAccessControl = t.protoAccessControl),
                      (p.helpers = t.helpers),
                      (p.partials = t.partials),
                      (p.decorators = t.decorators),
                      (p.hooks = t.hooks))
                    : ((e = h.extend({}, l.helpers, t.helpers)),
                      (o = p),
                      i((r = e)).forEach(function (t) {
                        var e,
                          n = r[t];
                        r[t] =
                          ((e = o.lookupProperty),
                          y.wrapHelper(n, function (t) {
                            return h.extend({lookupProperty: e}, t);
                          }));
                      }),
                      (p.helpers = e),
                      u.usePartial && (p.partials = p.mergeIfNeeded(t.partials, l.partials)),
                      (u.usePartial || u.useDecorators) && (p.decorators = h.extend({}, l.decorators, t.decorators)),
                      (p.hooks = {}),
                      (p.protoAccessControl = v.createProtoAccessControl(t)),
                      (e = t.allowCallsToHelperMissing || n),
                      m.moveHelperToHooks(p, 'helperMissing', e),
                      m.moveHelperToHooks(p, 'blockHelperMissing', e));
                }),
                (c._child = function (t, e, n, r) {
                  if (u.useBlockParams && !n) throw new f.default('must pass block params');
                  if (u.useDepths && !r) throw new f.default('must pass parent depths');
                  return a(p, t, u[t], e, 0, n, r);
                }),
                c
              );
            }),
            (e.wrapProgram = a),
            (e.resolvePartial = function (t, e, n) {
              return (
                t
                  ? t.call || n.name || ((n.name = t), (t = n.partials[t]))
                  : (t = '@partial-block' === n.name ? n.data['partial-block'] : n.partials[n.name]),
                t
              );
            }),
            (e.invokePartial = function (t, e, n) {
              var r,
                o = n.data && n.data['partial-block'],
                i = ((n.partial = !0), n.ids && (n.data.contextPath = n.ids[0] || n.data.contextPath), void 0);
              if (
                (n.fn &&
                  n.fn !== s &&
                  ((n.data = g.createFrame(n.data)),
                  (r = n.fn),
                  (i = n.data['partial-block'] =
                    function (t) {
                      var e = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
                      return (e.data = g.createFrame(e.data)), (e.data['partial-block'] = o), r(t, e);
                    }),
                  r.partials && (n.partials = h.extend({}, n.partials, r.partials))),
                void 0 === (t = void 0 === t && i ? i : t))
              )
                throw new f.default('The partial ' + n.name + ' could not be found');
              if (t instanceof Function) return t(e, n);
            }),
            (e.noop = s);
          var h = o(n(5)),
            f = u(n(6)),
            g = n(4),
            m = n(10),
            y = n(82),
            v = n(73);
        },
        function (t, e, n) {
          t.exports = {default: n(80), __esModule: !0};
        },
        function (t, e, n) {
          n(81), (t.exports = n(21).Object.seal);
        },
        function (t, e, n) {
          var r = n(40);
          n(64)('seal', function (e) {
            return function (t) {
              return e && r(t) ? e(t) : t;
            };
          });
        },
        function (t, e) {
          (e.__esModule = !0),
            (e.wrapHelper = function (e, n) {
              return 'function' != typeof e
                ? e
                : function () {
                    var t = arguments[arguments.length - 1];
                    return (arguments[arguments.length - 1] = n(t)), e.apply(this, arguments);
                  };
            });
        },
        function (t, e) {
          (e.__esModule = !0),
            (e.default = function (t) {
              'object' != typeof globalThis &&
                (Object.prototype.__defineGetter__('__magic__', function () {
                  return this;
                }),
                (__magic__.globalThis = __magic__),
                delete Object.prototype.__magic__);
              var e = globalThis.Handlebars;
              t.noConflict = function () {
                return globalThis.Handlebars === t && (globalThis.Handlebars = e), t;
              };
            }),
            (t.exports = e.default);
        },
        function (t, e) {
          e.__esModule = !0;
          var n = {
            helpers: {
              helperExpression: function (t) {
                return (
                  'SubExpression' === t.type ||
                  (('MustacheStatement' === t.type || 'BlockStatement' === t.type) &&
                    !!((t.params && t.params.length) || t.hash))
                );
              },
              scopedId: function (t) {
                return /^\.|this\b/.test(t.original);
              },
              simpleId: function (t) {
                return 1 === t.parts.length && !n.helpers.scopedId(t) && !t.depth;
              },
            },
          };
          (e.default = n), (t.exports = e.default);
        },
        function (t, e, n) {
          function r(t, e) {
            return 'Program' === t.type
              ? t
              : (((s.default.yy = u).locInfo = function (t) {
                  return new u.SourceLocation(e && e.srcName, t);
                }),
                s.default.parse(t));
          }
          var o = n(1).default,
            i = n(3).default;
          (e.__esModule = !0),
            (e.parseWithoutProcessing = r),
            (e.parse = function (t, e) {
              return (t = r(t, e)), new a.default(e).accept(t);
            });
          var s = o(n(86)),
            a = o(n(87)),
            o = i(n(89)),
            i = n(5),
            u = ((e.parser = s.default), {});
          i.extend(u, o);
        },
        function (t, e) {
          e.__esModule = !0;
          (n = {
            trace: function () {},
            yy: {},
            symbols_: {
              error: 2,
              root: 3,
              program: 4,
              EOF: 5,
              program_repetition0: 6,
              statement: 7,
              mustache: 8,
              block: 9,
              rawBlock: 10,
              partial: 11,
              partialBlock: 12,
              content: 13,
              COMMENT: 14,
              CONTENT: 15,
              openRawBlock: 16,
              rawBlock_repetition0: 17,
              END_RAW_BLOCK: 18,
              OPEN_RAW_BLOCK: 19,
              helperName: 20,
              openRawBlock_repetition0: 21,
              openRawBlock_option0: 22,
              CLOSE_RAW_BLOCK: 23,
              openBlock: 24,
              block_option0: 25,
              closeBlock: 26,
              openInverse: 27,
              block_option1: 28,
              OPEN_BLOCK: 29,
              openBlock_repetition0: 30,
              openBlock_option0: 31,
              openBlock_option1: 32,
              CLOSE: 33,
              OPEN_INVERSE: 34,
              openInverse_repetition0: 35,
              openInverse_option0: 36,
              openInverse_option1: 37,
              openInverseChain: 38,
              OPEN_INVERSE_CHAIN: 39,
              openInverseChain_repetition0: 40,
              openInverseChain_option0: 41,
              openInverseChain_option1: 42,
              inverseAndProgram: 43,
              INVERSE: 44,
              inverseChain: 45,
              inverseChain_option0: 46,
              OPEN_ENDBLOCK: 47,
              OPEN: 48,
              mustache_repetition0: 49,
              mustache_option0: 50,
              OPEN_UNESCAPED: 51,
              mustache_repetition1: 52,
              mustache_option1: 53,
              CLOSE_UNESCAPED: 54,
              OPEN_PARTIAL: 55,
              partialName: 56,
              partial_repetition0: 57,
              partial_option0: 58,
              openPartialBlock: 59,
              OPEN_PARTIAL_BLOCK: 60,
              openPartialBlock_repetition0: 61,
              openPartialBlock_option0: 62,
              param: 63,
              sexpr: 64,
              OPEN_SEXPR: 65,
              sexpr_repetition0: 66,
              sexpr_option0: 67,
              CLOSE_SEXPR: 68,
              hash: 69,
              hash_repetition_plus0: 70,
              hashSegment: 71,
              ID: 72,
              EQUALS: 73,
              blockParams: 74,
              OPEN_BLOCK_PARAMS: 75,
              blockParams_repetition_plus0: 76,
              CLOSE_BLOCK_PARAMS: 77,
              path: 78,
              dataName: 79,
              STRING: 80,
              NUMBER: 81,
              BOOLEAN: 82,
              UNDEFINED: 83,
              NULL: 84,
              DATA: 85,
              pathSegments: 86,
              SEP: 87,
              $accept: 0,
              $end: 1,
            },
            terminals_: {
              2: 'error',
              5: 'EOF',
              14: 'COMMENT',
              15: 'CONTENT',
              18: 'END_RAW_BLOCK',
              19: 'OPEN_RAW_BLOCK',
              23: 'CLOSE_RAW_BLOCK',
              29: 'OPEN_BLOCK',
              33: 'CLOSE',
              34: 'OPEN_INVERSE',
              39: 'OPEN_INVERSE_CHAIN',
              44: 'INVERSE',
              47: 'OPEN_ENDBLOCK',
              48: 'OPEN',
              51: 'OPEN_UNESCAPED',
              54: 'CLOSE_UNESCAPED',
              55: 'OPEN_PARTIAL',
              60: 'OPEN_PARTIAL_BLOCK',
              65: 'OPEN_SEXPR',
              68: 'CLOSE_SEXPR',
              72: 'ID',
              73: 'EQUALS',
              75: 'OPEN_BLOCK_PARAMS',
              77: 'CLOSE_BLOCK_PARAMS',
              80: 'STRING',
              81: 'NUMBER',
              82: 'BOOLEAN',
              83: 'UNDEFINED',
              84: 'NULL',
              85: 'DATA',
              87: 'SEP',
            },
            productions_: [
              0,
              [3, 2],
              [4, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [13, 1],
              [10, 3],
              [16, 5],
              [9, 4],
              [9, 4],
              [24, 6],
              [27, 6],
              [38, 6],
              [43, 2],
              [45, 3],
              [45, 1],
              [26, 3],
              [8, 5],
              [8, 5],
              [11, 5],
              [12, 3],
              [59, 5],
              [63, 1],
              [63, 1],
              [64, 5],
              [69, 1],
              [71, 3],
              [74, 3],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [56, 1],
              [56, 1],
              [79, 2],
              [78, 1],
              [86, 3],
              [86, 1],
              [6, 0],
              [6, 2],
              [17, 0],
              [17, 2],
              [21, 0],
              [21, 2],
              [22, 0],
              [22, 1],
              [25, 0],
              [25, 1],
              [28, 0],
              [28, 1],
              [30, 0],
              [30, 2],
              [31, 0],
              [31, 1],
              [32, 0],
              [32, 1],
              [35, 0],
              [35, 2],
              [36, 0],
              [36, 1],
              [37, 0],
              [37, 1],
              [40, 0],
              [40, 2],
              [41, 0],
              [41, 1],
              [42, 0],
              [42, 1],
              [46, 0],
              [46, 1],
              [49, 0],
              [49, 2],
              [50, 0],
              [50, 1],
              [52, 0],
              [52, 2],
              [53, 0],
              [53, 1],
              [57, 0],
              [57, 2],
              [58, 0],
              [58, 1],
              [61, 0],
              [61, 2],
              [62, 0],
              [62, 1],
              [66, 0],
              [66, 2],
              [67, 0],
              [67, 1],
              [70, 1],
              [70, 2],
              [76, 1],
              [76, 2],
            ],
            performAction: function (t, e, n, r, o, i, s) {
              var a = i.length - 1;
              switch (o) {
                case 1:
                  return i[a - 1];
                case 2:
                  this.$ = r.prepareProgram(i[a]);
                  break;
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                  this.$ = i[a];
                  break;
                case 9:
                  this.$ = {
                    type: 'CommentStatement',
                    value: r.stripComment(i[a]),
                    strip: r.stripFlags(i[a], i[a]),
                    loc: r.locInfo(this._$),
                  };
                  break;
                case 10:
                  this.$ = {type: 'ContentStatement', original: i[a], value: i[a], loc: r.locInfo(this._$)};
                  break;
                case 11:
                  this.$ = r.prepareRawBlock(i[a - 2], i[a - 1], i[a], this._$);
                  break;
                case 12:
                  this.$ = {path: i[a - 3], params: i[a - 2], hash: i[a - 1]};
                  break;
                case 13:
                  this.$ = r.prepareBlock(i[a - 3], i[a - 2], i[a - 1], i[a], !1, this._$);
                  break;
                case 14:
                  this.$ = r.prepareBlock(i[a - 3], i[a - 2], i[a - 1], i[a], !0, this._$);
                  break;
                case 15:
                  this.$ = {
                    open: i[a - 5],
                    path: i[a - 4],
                    params: i[a - 3],
                    hash: i[a - 2],
                    blockParams: i[a - 1],
                    strip: r.stripFlags(i[a - 5], i[a]),
                  };
                  break;
                case 16:
                case 17:
                  this.$ = {
                    path: i[a - 4],
                    params: i[a - 3],
                    hash: i[a - 2],
                    blockParams: i[a - 1],
                    strip: r.stripFlags(i[a - 5], i[a]),
                  };
                  break;
                case 18:
                  this.$ = {strip: r.stripFlags(i[a - 1], i[a - 1]), program: i[a]};
                  break;
                case 19:
                  var u = r.prepareBlock(i[a - 2], i[a - 1], i[a], i[a], !1, this._$),
                    u = r.prepareProgram([u], i[a - 1].loc);
                  (u.chained = !0), (this.$ = {strip: i[a - 2].strip, program: u, chain: !0});
                  break;
                case 20:
                  this.$ = i[a];
                  break;
                case 21:
                  this.$ = {path: i[a - 1], strip: r.stripFlags(i[a - 2], i[a])};
                  break;
                case 22:
                case 23:
                  this.$ = r.prepareMustache(
                    i[a - 3],
                    i[a - 2],
                    i[a - 1],
                    i[a - 4],
                    r.stripFlags(i[a - 4], i[a]),
                    this._$
                  );
                  break;
                case 24:
                  this.$ = {
                    type: 'PartialStatement',
                    name: i[a - 3],
                    params: i[a - 2],
                    hash: i[a - 1],
                    indent: '',
                    strip: r.stripFlags(i[a - 4], i[a]),
                    loc: r.locInfo(this._$),
                  };
                  break;
                case 25:
                  this.$ = r.preparePartialBlock(i[a - 2], i[a - 1], i[a], this._$);
                  break;
                case 26:
                  this.$ = {path: i[a - 3], params: i[a - 2], hash: i[a - 1], strip: r.stripFlags(i[a - 4], i[a])};
                  break;
                case 27:
                case 28:
                  this.$ = i[a];
                  break;
                case 29:
                  this.$ = {
                    type: 'SubExpression',
                    path: i[a - 3],
                    params: i[a - 2],
                    hash: i[a - 1],
                    loc: r.locInfo(this._$),
                  };
                  break;
                case 30:
                  this.$ = {type: 'Hash', pairs: i[a], loc: r.locInfo(this._$)};
                  break;
                case 31:
                  this.$ = {type: 'HashPair', key: r.id(i[a - 2]), value: i[a], loc: r.locInfo(this._$)};
                  break;
                case 32:
                  this.$ = r.id(i[a - 1]);
                  break;
                case 33:
                case 34:
                  this.$ = i[a];
                  break;
                case 35:
                  this.$ = {type: 'StringLiteral', value: i[a], original: i[a], loc: r.locInfo(this._$)};
                  break;
                case 36:
                  this.$ = {
                    type: 'NumberLiteral',
                    value: Number(i[a]),
                    original: Number(i[a]),
                    loc: r.locInfo(this._$),
                  };
                  break;
                case 37:
                  this.$ = {
                    type: 'BooleanLiteral',
                    value: 'true' === i[a],
                    original: 'true' === i[a],
                    loc: r.locInfo(this._$),
                  };
                  break;
                case 38:
                  this.$ = {type: 'UndefinedLiteral', original: void 0, value: void 0, loc: r.locInfo(this._$)};
                  break;
                case 39:
                  this.$ = {type: 'NullLiteral', original: null, value: null, loc: r.locInfo(this._$)};
                  break;
                case 40:
                case 41:
                  this.$ = i[a];
                  break;
                case 42:
                  this.$ = r.preparePath(!0, i[a], this._$);
                  break;
                case 43:
                  this.$ = r.preparePath(!1, i[a], this._$);
                  break;
                case 44:
                  i[a - 2].push({part: r.id(i[a]), original: i[a], separator: i[a - 1]}), (this.$ = i[a - 2]);
                  break;
                case 45:
                  this.$ = [{part: r.id(i[a]), original: i[a]}];
                  break;
                case 46:
                  this.$ = [];
                  break;
                case 47:
                  i[a - 1].push(i[a]);
                  break;
                case 48:
                  this.$ = [];
                  break;
                case 49:
                  i[a - 1].push(i[a]);
                  break;
                case 50:
                  this.$ = [];
                  break;
                case 51:
                  i[a - 1].push(i[a]);
                  break;
                case 58:
                  this.$ = [];
                  break;
                case 59:
                  i[a - 1].push(i[a]);
                  break;
                case 64:
                  this.$ = [];
                  break;
                case 65:
                  i[a - 1].push(i[a]);
                  break;
                case 70:
                  this.$ = [];
                  break;
                case 71:
                  i[a - 1].push(i[a]);
                  break;
                case 78:
                  this.$ = [];
                  break;
                case 79:
                  i[a - 1].push(i[a]);
                  break;
                case 82:
                  this.$ = [];
                  break;
                case 83:
                  i[a - 1].push(i[a]);
                  break;
                case 86:
                  this.$ = [];
                  break;
                case 87:
                  i[a - 1].push(i[a]);
                  break;
                case 90:
                  this.$ = [];
                  break;
                case 91:
                  i[a - 1].push(i[a]);
                  break;
                case 94:
                  this.$ = [];
                  break;
                case 95:
                  i[a - 1].push(i[a]);
                  break;
                case 98:
                  this.$ = [i[a]];
                  break;
                case 99:
                  i[a - 1].push(i[a]);
                  break;
                case 100:
                  this.$ = [i[a]];
                  break;
                case 101:
                  i[a - 1].push(i[a]);
              }
            },
            table: [
              {
                3: 1,
                4: 2,
                5: [2, 46],
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {1: [3]},
              {5: [1, 4]},
              {
                5: [2, 2],
                7: 5,
                8: 6,
                9: 7,
                10: 8,
                11: 9,
                12: 10,
                13: 11,
                14: [1, 12],
                15: [1, 20],
                16: 17,
                19: [1, 23],
                24: 15,
                27: 16,
                29: [1, 21],
                34: [1, 22],
                39: [2, 2],
                44: [2, 2],
                47: [2, 2],
                48: [1, 13],
                51: [1, 14],
                55: [1, 18],
                59: 19,
                60: [1, 24],
              },
              {1: [2, 1]},
              {
                5: [2, 47],
                14: [2, 47],
                15: [2, 47],
                19: [2, 47],
                29: [2, 47],
                34: [2, 47],
                39: [2, 47],
                44: [2, 47],
                47: [2, 47],
                48: [2, 47],
                51: [2, 47],
                55: [2, 47],
                60: [2, 47],
              },
              {
                5: [2, 3],
                14: [2, 3],
                15: [2, 3],
                19: [2, 3],
                29: [2, 3],
                34: [2, 3],
                39: [2, 3],
                44: [2, 3],
                47: [2, 3],
                48: [2, 3],
                51: [2, 3],
                55: [2, 3],
                60: [2, 3],
              },
              {
                5: [2, 4],
                14: [2, 4],
                15: [2, 4],
                19: [2, 4],
                29: [2, 4],
                34: [2, 4],
                39: [2, 4],
                44: [2, 4],
                47: [2, 4],
                48: [2, 4],
                51: [2, 4],
                55: [2, 4],
                60: [2, 4],
              },
              {
                5: [2, 5],
                14: [2, 5],
                15: [2, 5],
                19: [2, 5],
                29: [2, 5],
                34: [2, 5],
                39: [2, 5],
                44: [2, 5],
                47: [2, 5],
                48: [2, 5],
                51: [2, 5],
                55: [2, 5],
                60: [2, 5],
              },
              {
                5: [2, 6],
                14: [2, 6],
                15: [2, 6],
                19: [2, 6],
                29: [2, 6],
                34: [2, 6],
                39: [2, 6],
                44: [2, 6],
                47: [2, 6],
                48: [2, 6],
                51: [2, 6],
                55: [2, 6],
                60: [2, 6],
              },
              {
                5: [2, 7],
                14: [2, 7],
                15: [2, 7],
                19: [2, 7],
                29: [2, 7],
                34: [2, 7],
                39: [2, 7],
                44: [2, 7],
                47: [2, 7],
                48: [2, 7],
                51: [2, 7],
                55: [2, 7],
                60: [2, 7],
              },
              {
                5: [2, 8],
                14: [2, 8],
                15: [2, 8],
                19: [2, 8],
                29: [2, 8],
                34: [2, 8],
                39: [2, 8],
                44: [2, 8],
                47: [2, 8],
                48: [2, 8],
                51: [2, 8],
                55: [2, 8],
                60: [2, 8],
              },
              {
                5: [2, 9],
                14: [2, 9],
                15: [2, 9],
                19: [2, 9],
                29: [2, 9],
                34: [2, 9],
                39: [2, 9],
                44: [2, 9],
                47: [2, 9],
                48: [2, 9],
                51: [2, 9],
                55: [2, 9],
                60: [2, 9],
              },
              {
                20: 25,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 36,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 37,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {
                4: 38,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {15: [2, 48], 17: 39, 18: [2, 48]},
              {
                20: 41,
                56: 40,
                64: 42,
                65: [1, 43],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 44,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {
                5: [2, 10],
                14: [2, 10],
                15: [2, 10],
                18: [2, 10],
                19: [2, 10],
                29: [2, 10],
                34: [2, 10],
                39: [2, 10],
                44: [2, 10],
                47: [2, 10],
                48: [2, 10],
                51: [2, 10],
                55: [2, 10],
                60: [2, 10],
              },
              {
                20: 45,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 46,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 47,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 41,
                56: 48,
                64: 42,
                65: [1, 43],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                33: [2, 78],
                49: 49,
                65: [2, 78],
                72: [2, 78],
                80: [2, 78],
                81: [2, 78],
                82: [2, 78],
                83: [2, 78],
                84: [2, 78],
                85: [2, 78],
              },
              {
                23: [2, 33],
                33: [2, 33],
                54: [2, 33],
                65: [2, 33],
                68: [2, 33],
                72: [2, 33],
                75: [2, 33],
                80: [2, 33],
                81: [2, 33],
                82: [2, 33],
                83: [2, 33],
                84: [2, 33],
                85: [2, 33],
              },
              {
                23: [2, 34],
                33: [2, 34],
                54: [2, 34],
                65: [2, 34],
                68: [2, 34],
                72: [2, 34],
                75: [2, 34],
                80: [2, 34],
                81: [2, 34],
                82: [2, 34],
                83: [2, 34],
                84: [2, 34],
                85: [2, 34],
              },
              {
                23: [2, 35],
                33: [2, 35],
                54: [2, 35],
                65: [2, 35],
                68: [2, 35],
                72: [2, 35],
                75: [2, 35],
                80: [2, 35],
                81: [2, 35],
                82: [2, 35],
                83: [2, 35],
                84: [2, 35],
                85: [2, 35],
              },
              {
                23: [2, 36],
                33: [2, 36],
                54: [2, 36],
                65: [2, 36],
                68: [2, 36],
                72: [2, 36],
                75: [2, 36],
                80: [2, 36],
                81: [2, 36],
                82: [2, 36],
                83: [2, 36],
                84: [2, 36],
                85: [2, 36],
              },
              {
                23: [2, 37],
                33: [2, 37],
                54: [2, 37],
                65: [2, 37],
                68: [2, 37],
                72: [2, 37],
                75: [2, 37],
                80: [2, 37],
                81: [2, 37],
                82: [2, 37],
                83: [2, 37],
                84: [2, 37],
                85: [2, 37],
              },
              {
                23: [2, 38],
                33: [2, 38],
                54: [2, 38],
                65: [2, 38],
                68: [2, 38],
                72: [2, 38],
                75: [2, 38],
                80: [2, 38],
                81: [2, 38],
                82: [2, 38],
                83: [2, 38],
                84: [2, 38],
                85: [2, 38],
              },
              {
                23: [2, 39],
                33: [2, 39],
                54: [2, 39],
                65: [2, 39],
                68: [2, 39],
                72: [2, 39],
                75: [2, 39],
                80: [2, 39],
                81: [2, 39],
                82: [2, 39],
                83: [2, 39],
                84: [2, 39],
                85: [2, 39],
              },
              {
                23: [2, 43],
                33: [2, 43],
                54: [2, 43],
                65: [2, 43],
                68: [2, 43],
                72: [2, 43],
                75: [2, 43],
                80: [2, 43],
                81: [2, 43],
                82: [2, 43],
                83: [2, 43],
                84: [2, 43],
                85: [2, 43],
                87: [1, 50],
              },
              {72: [1, 35], 86: 51},
              {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45],
              },
              {
                52: 52,
                54: [2, 82],
                65: [2, 82],
                72: [2, 82],
                80: [2, 82],
                81: [2, 82],
                82: [2, 82],
                83: [2, 82],
                84: [2, 82],
                85: [2, 82],
              },
              {25: 53, 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 54, 47: [2, 54]},
              {28: 59, 43: 60, 44: [1, 58], 47: [2, 56]},
              {13: 62, 15: [1, 20], 18: [1, 61]},
              {
                33: [2, 86],
                57: 63,
                65: [2, 86],
                72: [2, 86],
                80: [2, 86],
                81: [2, 86],
                82: [2, 86],
                83: [2, 86],
                84: [2, 86],
                85: [2, 86],
              },
              {
                33: [2, 40],
                65: [2, 40],
                72: [2, 40],
                80: [2, 40],
                81: [2, 40],
                82: [2, 40],
                83: [2, 40],
                84: [2, 40],
                85: [2, 40],
              },
              {
                33: [2, 41],
                65: [2, 41],
                72: [2, 41],
                80: [2, 41],
                81: [2, 41],
                82: [2, 41],
                83: [2, 41],
                84: [2, 41],
                85: [2, 41],
              },
              {
                20: 64,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {26: 65, 47: [1, 66]},
              {
                30: 67,
                33: [2, 58],
                65: [2, 58],
                72: [2, 58],
                75: [2, 58],
                80: [2, 58],
                81: [2, 58],
                82: [2, 58],
                83: [2, 58],
                84: [2, 58],
                85: [2, 58],
              },
              {
                33: [2, 64],
                35: 68,
                65: [2, 64],
                72: [2, 64],
                75: [2, 64],
                80: [2, 64],
                81: [2, 64],
                82: [2, 64],
                83: [2, 64],
                84: [2, 64],
                85: [2, 64],
              },
              {
                21: 69,
                23: [2, 50],
                65: [2, 50],
                72: [2, 50],
                80: [2, 50],
                81: [2, 50],
                82: [2, 50],
                83: [2, 50],
                84: [2, 50],
                85: [2, 50],
              },
              {
                33: [2, 90],
                61: 70,
                65: [2, 90],
                72: [2, 90],
                80: [2, 90],
                81: [2, 90],
                82: [2, 90],
                83: [2, 90],
                84: [2, 90],
                85: [2, 90],
              },
              {
                20: 74,
                33: [2, 80],
                50: 71,
                63: 72,
                64: 75,
                65: [1, 43],
                69: 73,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {72: [1, 79]},
              {
                23: [2, 42],
                33: [2, 42],
                54: [2, 42],
                65: [2, 42],
                68: [2, 42],
                72: [2, 42],
                75: [2, 42],
                80: [2, 42],
                81: [2, 42],
                82: [2, 42],
                83: [2, 42],
                84: [2, 42],
                85: [2, 42],
                87: [1, 50],
              },
              {
                20: 74,
                53: 80,
                54: [2, 84],
                63: 81,
                64: 75,
                65: [1, 43],
                69: 82,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {26: 83, 47: [1, 66]},
              {47: [2, 55]},
              {
                4: 84,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {47: [2, 20]},
              {
                20: 85,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 86,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {26: 87, 47: [1, 66]},
              {47: [2, 57]},
              {
                5: [2, 11],
                14: [2, 11],
                15: [2, 11],
                19: [2, 11],
                29: [2, 11],
                34: [2, 11],
                39: [2, 11],
                44: [2, 11],
                47: [2, 11],
                48: [2, 11],
                51: [2, 11],
                55: [2, 11],
                60: [2, 11],
              },
              {15: [2, 49], 18: [2, 49]},
              {
                20: 74,
                33: [2, 88],
                58: 88,
                63: 89,
                64: 75,
                65: [1, 43],
                69: 90,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                65: [2, 94],
                66: 91,
                68: [2, 94],
                72: [2, 94],
                80: [2, 94],
                81: [2, 94],
                82: [2, 94],
                83: [2, 94],
                84: [2, 94],
                85: [2, 94],
              },
              {
                5: [2, 25],
                14: [2, 25],
                15: [2, 25],
                19: [2, 25],
                29: [2, 25],
                34: [2, 25],
                39: [2, 25],
                44: [2, 25],
                47: [2, 25],
                48: [2, 25],
                51: [2, 25],
                55: [2, 25],
                60: [2, 25],
              },
              {
                20: 92,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 74,
                31: 93,
                33: [2, 60],
                63: 94,
                64: 75,
                65: [1, 43],
                69: 95,
                70: 76,
                71: 77,
                72: [1, 78],
                75: [2, 60],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 74,
                33: [2, 66],
                36: 96,
                63: 97,
                64: 75,
                65: [1, 43],
                69: 98,
                70: 76,
                71: 77,
                72: [1, 78],
                75: [2, 66],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 74,
                22: 99,
                23: [2, 52],
                63: 100,
                64: 75,
                65: [1, 43],
                69: 101,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 74,
                33: [2, 92],
                62: 102,
                63: 103,
                64: 75,
                65: [1, 43],
                69: 104,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {33: [1, 105]},
              {
                33: [2, 79],
                65: [2, 79],
                72: [2, 79],
                80: [2, 79],
                81: [2, 79],
                82: [2, 79],
                83: [2, 79],
                84: [2, 79],
                85: [2, 79],
              },
              {33: [2, 81]},
              {
                23: [2, 27],
                33: [2, 27],
                54: [2, 27],
                65: [2, 27],
                68: [2, 27],
                72: [2, 27],
                75: [2, 27],
                80: [2, 27],
                81: [2, 27],
                82: [2, 27],
                83: [2, 27],
                84: [2, 27],
                85: [2, 27],
              },
              {
                23: [2, 28],
                33: [2, 28],
                54: [2, 28],
                65: [2, 28],
                68: [2, 28],
                72: [2, 28],
                75: [2, 28],
                80: [2, 28],
                81: [2, 28],
                82: [2, 28],
                83: [2, 28],
                84: [2, 28],
                85: [2, 28],
              },
              {23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 106, 72: [1, 107], 75: [2, 30]},
              {23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98]},
              {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                73: [1, 108],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45],
              },
              {
                23: [2, 44],
                33: [2, 44],
                54: [2, 44],
                65: [2, 44],
                68: [2, 44],
                72: [2, 44],
                75: [2, 44],
                80: [2, 44],
                81: [2, 44],
                82: [2, 44],
                83: [2, 44],
                84: [2, 44],
                85: [2, 44],
                87: [2, 44],
              },
              {54: [1, 109]},
              {
                54: [2, 83],
                65: [2, 83],
                72: [2, 83],
                80: [2, 83],
                81: [2, 83],
                82: [2, 83],
                83: [2, 83],
                84: [2, 83],
                85: [2, 83],
              },
              {54: [2, 85]},
              {
                5: [2, 13],
                14: [2, 13],
                15: [2, 13],
                19: [2, 13],
                29: [2, 13],
                34: [2, 13],
                39: [2, 13],
                44: [2, 13],
                47: [2, 13],
                48: [2, 13],
                51: [2, 13],
                55: [2, 13],
                60: [2, 13],
              },
              {38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 111, 46: 110, 47: [2, 76]},
              {
                33: [2, 70],
                40: 112,
                65: [2, 70],
                72: [2, 70],
                75: [2, 70],
                80: [2, 70],
                81: [2, 70],
                82: [2, 70],
                83: [2, 70],
                84: [2, 70],
                85: [2, 70],
              },
              {47: [2, 18]},
              {
                5: [2, 14],
                14: [2, 14],
                15: [2, 14],
                19: [2, 14],
                29: [2, 14],
                34: [2, 14],
                39: [2, 14],
                44: [2, 14],
                47: [2, 14],
                48: [2, 14],
                51: [2, 14],
                55: [2, 14],
                60: [2, 14],
              },
              {33: [1, 113]},
              {
                33: [2, 87],
                65: [2, 87],
                72: [2, 87],
                80: [2, 87],
                81: [2, 87],
                82: [2, 87],
                83: [2, 87],
                84: [2, 87],
                85: [2, 87],
              },
              {33: [2, 89]},
              {
                20: 74,
                63: 115,
                64: 75,
                65: [1, 43],
                67: 114,
                68: [2, 96],
                69: 116,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {33: [1, 117]},
              {32: 118, 33: [2, 62], 74: 119, 75: [1, 120]},
              {
                33: [2, 59],
                65: [2, 59],
                72: [2, 59],
                75: [2, 59],
                80: [2, 59],
                81: [2, 59],
                82: [2, 59],
                83: [2, 59],
                84: [2, 59],
                85: [2, 59],
              },
              {33: [2, 61], 75: [2, 61]},
              {33: [2, 68], 37: 121, 74: 122, 75: [1, 120]},
              {
                33: [2, 65],
                65: [2, 65],
                72: [2, 65],
                75: [2, 65],
                80: [2, 65],
                81: [2, 65],
                82: [2, 65],
                83: [2, 65],
                84: [2, 65],
                85: [2, 65],
              },
              {33: [2, 67], 75: [2, 67]},
              {23: [1, 123]},
              {
                23: [2, 51],
                65: [2, 51],
                72: [2, 51],
                80: [2, 51],
                81: [2, 51],
                82: [2, 51],
                83: [2, 51],
                84: [2, 51],
                85: [2, 51],
              },
              {23: [2, 53]},
              {33: [1, 124]},
              {
                33: [2, 91],
                65: [2, 91],
                72: [2, 91],
                80: [2, 91],
                81: [2, 91],
                82: [2, 91],
                83: [2, 91],
                84: [2, 91],
                85: [2, 91],
              },
              {33: [2, 93]},
              {
                5: [2, 22],
                14: [2, 22],
                15: [2, 22],
                19: [2, 22],
                29: [2, 22],
                34: [2, 22],
                39: [2, 22],
                44: [2, 22],
                47: [2, 22],
                48: [2, 22],
                51: [2, 22],
                55: [2, 22],
                60: [2, 22],
              },
              {23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99]},
              {73: [1, 108]},
              {
                20: 74,
                63: 125,
                64: 75,
                65: [1, 43],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                5: [2, 23],
                14: [2, 23],
                15: [2, 23],
                19: [2, 23],
                29: [2, 23],
                34: [2, 23],
                39: [2, 23],
                44: [2, 23],
                47: [2, 23],
                48: [2, 23],
                51: [2, 23],
                55: [2, 23],
                60: [2, 23],
              },
              {47: [2, 19]},
              {47: [2, 77]},
              {
                20: 74,
                33: [2, 72],
                41: 126,
                63: 127,
                64: 75,
                65: [1, 43],
                69: 128,
                70: 76,
                71: 77,
                72: [1, 78],
                75: [2, 72],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                5: [2, 24],
                14: [2, 24],
                15: [2, 24],
                19: [2, 24],
                29: [2, 24],
                34: [2, 24],
                39: [2, 24],
                44: [2, 24],
                47: [2, 24],
                48: [2, 24],
                51: [2, 24],
                55: [2, 24],
                60: [2, 24],
              },
              {68: [1, 129]},
              {
                65: [2, 95],
                68: [2, 95],
                72: [2, 95],
                80: [2, 95],
                81: [2, 95],
                82: [2, 95],
                83: [2, 95],
                84: [2, 95],
                85: [2, 95],
              },
              {68: [2, 97]},
              {
                5: [2, 21],
                14: [2, 21],
                15: [2, 21],
                19: [2, 21],
                29: [2, 21],
                34: [2, 21],
                39: [2, 21],
                44: [2, 21],
                47: [2, 21],
                48: [2, 21],
                51: [2, 21],
                55: [2, 21],
                60: [2, 21],
              },
              {33: [1, 130]},
              {33: [2, 63]},
              {72: [1, 132], 76: 131},
              {33: [1, 133]},
              {33: [2, 69]},
              {15: [2, 12], 18: [2, 12]},
              {
                14: [2, 26],
                15: [2, 26],
                19: [2, 26],
                29: [2, 26],
                34: [2, 26],
                47: [2, 26],
                48: [2, 26],
                51: [2, 26],
                55: [2, 26],
                60: [2, 26],
              },
              {23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31]},
              {33: [2, 74], 42: 134, 74: 135, 75: [1, 120]},
              {
                33: [2, 71],
                65: [2, 71],
                72: [2, 71],
                75: [2, 71],
                80: [2, 71],
                81: [2, 71],
                82: [2, 71],
                83: [2, 71],
                84: [2, 71],
                85: [2, 71],
              },
              {33: [2, 73], 75: [2, 73]},
              {
                23: [2, 29],
                33: [2, 29],
                54: [2, 29],
                65: [2, 29],
                68: [2, 29],
                72: [2, 29],
                75: [2, 29],
                80: [2, 29],
                81: [2, 29],
                82: [2, 29],
                83: [2, 29],
                84: [2, 29],
                85: [2, 29],
              },
              {
                14: [2, 15],
                15: [2, 15],
                19: [2, 15],
                29: [2, 15],
                34: [2, 15],
                39: [2, 15],
                44: [2, 15],
                47: [2, 15],
                48: [2, 15],
                51: [2, 15],
                55: [2, 15],
                60: [2, 15],
              },
              {72: [1, 137], 77: [1, 136]},
              {72: [2, 100], 77: [2, 100]},
              {
                14: [2, 16],
                15: [2, 16],
                19: [2, 16],
                29: [2, 16],
                34: [2, 16],
                44: [2, 16],
                47: [2, 16],
                48: [2, 16],
                51: [2, 16],
                55: [2, 16],
                60: [2, 16],
              },
              {33: [1, 138]},
              {33: [2, 75]},
              {33: [2, 32]},
              {72: [2, 101], 77: [2, 101]},
              {
                14: [2, 17],
                15: [2, 17],
                19: [2, 17],
                29: [2, 17],
                34: [2, 17],
                39: [2, 17],
                44: [2, 17],
                47: [2, 17],
                48: [2, 17],
                51: [2, 17],
                55: [2, 17],
                60: [2, 17],
              },
            ],
            defaultActions: {
              4: [2, 1],
              54: [2, 55],
              56: [2, 20],
              60: [2, 57],
              73: [2, 81],
              82: [2, 85],
              86: [2, 18],
              90: [2, 89],
              101: [2, 53],
              104: [2, 93],
              110: [2, 19],
              111: [2, 77],
              116: [2, 97],
              119: [2, 63],
              122: [2, 69],
              135: [2, 75],
              136: [2, 32],
            },
            parseError: function (t, e) {
              throw new Error(t);
            },
            parse: function (t) {
              var e = this,
                n = [0],
                r = [null],
                o = [],
                i = this.table,
                s = '',
                a = 0,
                u = 0,
                l = 0,
                c =
                  (this.lexer.setInput(t),
                  (this.lexer.yy = this.yy),
                  (this.yy.lexer = this.lexer),
                  void 0 === (this.yy.parser = this).lexer.yylloc && (this.lexer.yylloc = {}),
                  this.lexer.yylloc),
                p = (o.push(c), this.lexer.options && this.lexer.options.ranges);
              'function' == typeof this.yy.parseError && (this.parseError = this.yy.parseError);
              for (var d, h, f, g, m, y, v, b, x = {}; ; ) {
                if (
                  ((f = n[n.length - 1]),
                  void 0 ===
                    (g =
                      this.defaultActions[f] ||
                      (null == d &&
                        ((S = void 0), (d = S = ('number' != typeof (S = e.lexer.lex() || 1) && e.symbols_[S]) || S)),
                      i[f] && i[f][d])) ||
                    !g.length ||
                    !g[0])
                ) {
                  var S;
                  if (!l) {
                    for (m in ((b = []), i[f])) this.terminals_[m] && 2 < m && b.push("'" + this.terminals_[m] + "'");
                    (S = this.lexer.showPosition
                      ? 'Parse error on line ' +
                        (a + 1) +
                        ':\n' +
                        this.lexer.showPosition() +
                        '\nExpecting ' +
                        b.join(', ') +
                        ", got '" +
                        (this.terminals_[d] || d) +
                        "'"
                      : 'Parse error on line ' +
                        (a + 1) +
                        ': Unexpected ' +
                        (1 == d ? 'end of input' : "'" + (this.terminals_[d] || d) + "'")),
                      this.parseError(S, {
                        text: this.lexer.match,
                        token: this.terminals_[d] || d,
                        line: this.lexer.yylineno,
                        loc: c,
                        expected: b,
                      });
                  }
                }
                if (g[0] instanceof Array && 1 < g.length)
                  throw new Error('Parse Error: multiple actions possible at state: ' + f + ', token: ' + d);
                switch (g[0]) {
                  case 1:
                    n.push(d),
                      r.push(this.lexer.yytext),
                      o.push(this.lexer.yylloc),
                      n.push(g[1]),
                      (d = null),
                      h
                        ? ((d = h), (h = null))
                        : ((u = this.lexer.yyleng),
                          (s = this.lexer.yytext),
                          (a = this.lexer.yylineno),
                          (c = this.lexer.yylloc),
                          0 < l && l--);
                    break;
                  case 2:
                    if (
                      ((y = this.productions_[g[1]][1]),
                      (x.$ = r[r.length - y]),
                      (x._$ = {
                        first_line: o[o.length - (y || 1)].first_line,
                        last_line: o[o.length - 1].last_line,
                        first_column: o[o.length - (y || 1)].first_column,
                        last_column: o[o.length - 1].last_column,
                      }),
                      p && (x._$.range = [o[o.length - (y || 1)].range[0], o[o.length - 1].range[1]]),
                      void 0 !== (v = this.performAction.call(x, s, u, a, this.yy, g[1], r, o)))
                    )
                      return v;
                    y && ((n = n.slice(0, -1 * y * 2)), (r = r.slice(0, -1 * y)), (o = o.slice(0, -1 * y))),
                      n.push(this.productions_[g[1]][0]),
                      r.push(x.$),
                      o.push(x._$),
                      (v = i[n[n.length - 2]][n[n.length - 1]]),
                      n.push(v);
                    break;
                  case 3:
                    return !0;
                }
              }
              return !0;
            },
          }).lexer = {
            EOF: 1,
            parseError: function (t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function (t) {
              return (
                (this._input = t),
                (this._more = this._less = this.done = !1),
                (this.yylineno = this.yyleng = 0),
                (this.yytext = this.matched = this.match = ''),
                (this.conditionStack = ['INITIAL']),
                (this.yylloc = {first_line: 1, first_column: 0, last_line: 1, last_column: 0}),
                this.options.ranges && (this.yylloc.range = [0, 0]),
                (this.offset = 0),
                this
              );
            },
            input: function () {
              var t = this._input[0];
              return (
                (this.yytext += t),
                this.yyleng++,
                this.offset++,
                (this.match += t),
                (this.matched += t),
                t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++,
                this.options.ranges && this.yylloc.range[1]++,
                (this._input = this._input.slice(1)),
                t
              );
            },
            unput: function (t) {
              var e = t.length,
                n = t.split(/(?:\r\n?|\n)/g),
                t =
                  ((this._input = t + this._input),
                  (this.yytext = this.yytext.substr(0, this.yytext.length - e - 1)),
                  (this.offset -= e),
                  this.match.split(/(?:\r\n?|\n)/g)),
                r =
                  ((this.match = this.match.substr(0, this.match.length - 1)),
                  (this.matched = this.matched.substr(0, this.matched.length - 1)),
                  n.length - 1 && (this.yylineno -= n.length - 1),
                  this.yylloc.range);
              return (
                (this.yylloc = {
                  first_line: this.yylloc.first_line,
                  last_line: this.yylineno + 1,
                  first_column: this.yylloc.first_column,
                  last_column: n
                    ? (n.length === t.length ? this.yylloc.first_column : 0) +
                      t[t.length - n.length].length -
                      n[0].length
                    : this.yylloc.first_column - e,
                }),
                this.options.ranges && (this.yylloc.range = [r[0], r[0] + this.yyleng - e]),
                this
              );
            },
            more: function () {
              return (this._more = !0), this;
            },
            less: function (t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function () {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (20 < t.length ? '...' : '') + t.substr(-20).replace(/\n/g, '');
            },
            upcomingInput: function () {
              var t = this.match;
              return (
                t.length < 20 && (t += this._input.substr(0, 20 - t.length)),
                (t.substr(0, 20) + (20 < t.length ? '...' : '')).replace(/\n/g, '')
              );
            },
            showPosition: function () {
              var t = this.pastInput(),
                e = new Array(t.length + 1).join('-');
              return t + this.upcomingInput() + '\n' + e + '^';
            },
            next: function () {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || ((this.yytext = ''), (this.match = ''));
              for (
                var o = this._currentRules(), i = 0;
                i < o.length &&
                (!(e = this._input.match(this.rules[o[i]])) ||
                  (t && !(e[0].length > t[0].length)) ||
                  ((t = e), (n = i), this.options.flex));
                i++
              );
              return t
                ? ((r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length),
                  (this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: r
                      ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length
                      : this.yylloc.last_column + t[0].length,
                  }),
                  (this.yytext += t[0]),
                  (this.match += t[0]),
                  (this.matches = t),
                  (this.yyleng = this.yytext.length),
                  this.options.ranges && (this.yylloc.range = [this.offset, (this.offset += this.yyleng)]),
                  (this._more = !1),
                  (this._input = this._input.slice(t[0].length)),
                  (this.matched += t[0]),
                  (r = this.performAction.call(
                    this,
                    this.yy,
                    this,
                    o[n],
                    this.conditionStack[this.conditionStack.length - 1]
                  )),
                  this.done && this._input && (this.done = !1),
                  r || void 0)
                : '' === this._input
                  ? this.EOF
                  : this.parseError(
                      'Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(),
                      {text: '', token: null, line: this.yylineno}
                    );
            },
            lex: function () {
              var t = this.next();
              return void 0 !== t ? t : this.lex();
            },
            begin: function (t) {
              this.conditionStack.push(t);
            },
            popState: function () {
              return this.conditionStack.pop();
            },
            _currentRules: function () {
              return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
            },
            topState: function () {
              return this.conditionStack[this.conditionStack.length - 2];
            },
            pushState: function (t) {
              this.begin(t);
            },
            options: {},
            performAction: function (t, n, e, r) {
              function o(t, e) {
                return (n.yytext = n.yytext.substring(t, n.yyleng - e + t));
              }
              switch (e) {
                case 0:
                  if (
                    ('\\\\' === n.yytext.slice(-2)
                      ? (o(0, 1), this.begin('mu'))
                      : '\\' === n.yytext.slice(-1)
                        ? (o(0, 1), this.begin('emu'))
                        : this.begin('mu'),
                    n.yytext)
                  )
                    return 15;
                  break;
                case 1:
                  return 15;
                case 2:
                  return this.popState(), 15;
                case 3:
                  return this.begin('raw'), 15;
                case 4:
                  return (
                    this.popState(),
                    'raw' === this.conditionStack[this.conditionStack.length - 1] ? 15 : (o(5, 9), 'END_RAW_BLOCK')
                  );
                case 5:
                  return 15;
                case 6:
                  return this.popState(), 14;
                case 7:
                  return 65;
                case 8:
                  return 68;
                case 9:
                  return 19;
                case 10:
                  return this.popState(), this.begin('raw'), 23;
                case 11:
                  return 55;
                case 12:
                  return 60;
                case 13:
                  return 29;
                case 14:
                  return 47;
                case 15:
                case 16:
                  return this.popState(), 44;
                case 17:
                  return 34;
                case 18:
                  return 39;
                case 19:
                  return 51;
                case 20:
                  return 48;
                case 21:
                  this.unput(n.yytext), this.popState(), this.begin('com');
                  break;
                case 22:
                  return this.popState(), 14;
                case 23:
                  return 48;
                case 24:
                  return 73;
                case 25:
                case 26:
                  return 72;
                case 27:
                  return 87;
                case 28:
                  break;
                case 29:
                  return this.popState(), 54;
                case 30:
                  return this.popState(), 33;
                case 31:
                  return (n.yytext = o(1, 2).replace(/\\"/g, '"')), 80;
                case 32:
                  return (n.yytext = o(1, 2).replace(/\\'/g, "'")), 80;
                case 33:
                  return 85;
                case 34:
                case 35:
                  return 82;
                case 36:
                  return 83;
                case 37:
                  return 84;
                case 38:
                  return 81;
                case 39:
                  return 75;
                case 40:
                  return 77;
                case 41:
                  return 72;
                case 42:
                  return (n.yytext = n.yytext.replace(/\\([\\\]])/g, '$1')), 72;
                case 43:
                  return 'INVALID';
                case 44:
                  return 5;
              }
            },
            rules: [
              /^(?:[^\x00]*?(?=(\{\{)))/,
              /^(?:[^\x00]+)/,
              /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
              /^(?:\{\{\{\{(?=[^/]))/,
              /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
              /^(?:[^\x00]+?(?=(\{\{\{\{)))/,
              /^(?:[\s\S]*?--(~)?\}\})/,
              /^(?:\()/,
              /^(?:\))/,
              /^(?:\{\{\{\{)/,
              /^(?:\}\}\}\})/,
              /^(?:\{\{(~)?>)/,
              /^(?:\{\{(~)?#>)/,
              /^(?:\{\{(~)?#\*?)/,
              /^(?:\{\{(~)?\/)/,
              /^(?:\{\{(~)?\^\s*(~)?\}\})/,
              /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
              /^(?:\{\{(~)?\^)/,
              /^(?:\{\{(~)?\s*else\b)/,
              /^(?:\{\{(~)?\{)/,
              /^(?:\{\{(~)?&)/,
              /^(?:\{\{(~)?!--)/,
              /^(?:\{\{(~)?![\s\S]*?\}\})/,
              /^(?:\{\{(~)?\*?)/,
              /^(?:=)/,
              /^(?:\.\.)/,
              /^(?:\.(?=([=~}\s\/.)|])))/,
              /^(?:[\/.])/,
              /^(?:\s+)/,
              /^(?:\}(~)?\}\})/,
              /^(?:(~)?\}\})/,
              /^(?:"(\\["]|[^"])*")/,
              /^(?:'(\\[']|[^'])*')/,
              /^(?:@)/,
              /^(?:true(?=([~}\s)])))/,
              /^(?:false(?=([~}\s)])))/,
              /^(?:undefined(?=([~}\s)])))/,
              /^(?:null(?=([~}\s)])))/,
              /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
              /^(?:as\s+\|)/,
              /^(?:\|)/,
              /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
              /^(?:\[(\\\]|[^\]])*\])/,
              /^(?:.)/,
              /^(?:$)/,
            ],
            conditions: {
              mu: {
                rules: [
                  7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
                  33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44,
                ],
                inclusive: !1,
              },
              emu: {rules: [2], inclusive: !1},
              com: {rules: [6], inclusive: !1},
              raw: {rules: [3, 4, 5], inclusive: !1},
              INITIAL: {rules: [0, 1, 44], inclusive: !0},
            },
          };
          var n = new ((r.prototype = n).Parser = r)();
          function r() {
            this.yy = {};
          }
          (e.default = n), (t.exports = e.default);
        },
        function (t, e, n) {
          function r() {
            this.options = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
          }
          function d(t, e, n) {
            var r = t[(e = void 0 === e ? t.length : e) - 1];
            return r
              ? 'ContentStatement' === r.type
                ? (t[e - 2] || !n ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(r.original)
                : void 0
              : n;
          }
          function h(t, e, n) {
            var r = t[(e = void 0 === e ? -1 : e) + 1];
            return r
              ? 'ContentStatement' === r.type
                ? (t[e + 2] || !n ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(r.original)
                : void 0
              : n;
          }
          function f(t, e, n) {
            t = t[null == e ? 0 : e + 1];
            !t ||
              'ContentStatement' !== t.type ||
              (!n && t.rightStripped) ||
              ((e = t.value),
              (t.value = t.value.replace(n ? /^\s+/ : /^[ \t]*\r?\n?/, '')),
              (t.rightStripped = t.value !== e));
          }
          function g(t, e, n) {
            t = t[null == e ? t.length - 1 : e - 1];
            if (t && 'ContentStatement' === t.type && (n || !t.leftStripped))
              return (
                (e = t.value),
                (t.value = t.value.replace(n ? /\s+$/ : /[ \t]+$/, '')),
                (t.leftStripped = t.value !== e),
                t.leftStripped
              );
          }
          var o = n(1).default;
          e.__esModule = !0;
          o = o(n(88));
          ((r.prototype = new o.default()).Program = function (t) {
            var e = !this.options.ignoreStandalone,
              n = !this.isRootSeen;
            this.isRootSeen = !0;
            for (var r = t.body, o = 0, i = r.length; o < i; o++) {
              var s,
                a,
                u,
                l,
                c = r[o],
                p = this.accept(c);
              p &&
                ((l = d(r, o, n)),
                (s = h(r, o, n)),
                (a = p.openStandalone && l),
                (u = p.closeStandalone && s),
                (l = p.inlineStandalone && l && s),
                p.close && f(r, o, !0),
                p.open && g(r, o, !0),
                e &&
                  l &&
                  (f(r, o), g(r, o)) &&
                  'PartialStatement' === c.type &&
                  (c.indent = /([ \t]+$)/.exec(r[o - 1].original)[1]),
                e && a && (f((c.program || c.inverse).body), g(r, o)),
                e) &&
                u &&
                (f(r, o), g((c.inverse || c.program).body));
            }
            return t;
          }),
            (r.prototype.BlockStatement =
              r.prototype.DecoratorBlock =
              r.prototype.PartialBlockStatement =
                function (t) {
                  this.accept(t.program), this.accept(t.inverse);
                  var e = t.program || t.inverse,
                    n = t.program && t.inverse,
                    r = n,
                    o = n;
                  if (n && n.chained) for (r = n.body[0].program; o.chained; ) o = o.body[o.body.length - 1].program;
                  var i = {
                    open: t.openStrip.open,
                    close: t.closeStrip.close,
                    openStandalone: h(e.body),
                    closeStandalone: d((r || e).body),
                  };
                  return (
                    t.openStrip.close && f(e.body, null, !0),
                    n
                      ? ((n = t.inverseStrip).open && g(e.body, null, !0),
                        n.close && f(r.body, null, !0),
                        t.closeStrip.open && g(o.body, null, !0),
                        !this.options.ignoreStandalone && d(e.body) && h(r.body) && (g(e.body), f(r.body)))
                      : t.closeStrip.open && g(e.body, null, !0),
                    i
                  );
                }),
            (r.prototype.Decorator = r.prototype.MustacheStatement =
              function (t) {
                return t.strip;
              }),
            (r.prototype.PartialStatement = r.prototype.CommentStatement =
              function (t) {
                t = t.strip || {};
                return {inlineStandalone: !0, open: t.open, close: t.close};
              }),
            (e.default = r),
            (t.exports = e.default);
        },
        function (t, e, n) {
          function r() {
            this.parents = [];
          }
          function o(t) {
            this.acceptRequired(t, 'path'), this.acceptArray(t.params), this.acceptKey(t, 'hash');
          }
          function i(t) {
            o.call(this, t), this.acceptKey(t, 'program'), this.acceptKey(t, 'inverse');
          }
          function s(t) {
            this.acceptRequired(t, 'name'), this.acceptArray(t.params), this.acceptKey(t, 'hash');
          }
          var a = n(1).default;
          e.__esModule = !0;
          var u = a(n(6));
          (r.prototype = {
            constructor: r,
            mutating: !1,
            acceptKey: function (t, e) {
              var n = this.accept(t[e]);
              if (this.mutating) {
                if (n && !r.prototype[n.type])
                  throw new u.default(
                    'Unexpected node type "' + n.type + '" found when accepting ' + e + ' on ' + t.type
                  );
                t[e] = n;
              }
            },
            acceptRequired: function (t, e) {
              if ((this.acceptKey(t, e), !t[e])) throw new u.default(t.type + ' requires ' + e);
            },
            acceptArray: function (t) {
              for (var e = 0, n = t.length; e < n; e++) this.acceptKey(t, e), t[e] || (t.splice(e, 1), e--, n--);
            },
            accept: function (t) {
              if (t) {
                if (!this[t.type]) throw new u.default('Unknown type: ' + t.type, t);
                this.current && this.parents.unshift(this.current), (this.current = t);
                var e = this[t.type](t);
                return (this.current = this.parents.shift()), !this.mutating || e ? e : !1 !== e ? t : void 0;
              }
            },
            Program: function (t) {
              this.acceptArray(t.body);
            },
            MustacheStatement: o,
            Decorator: o,
            BlockStatement: i,
            DecoratorBlock: i,
            PartialStatement: s,
            PartialBlockStatement: function (t) {
              s.call(this, t), this.acceptKey(t, 'program');
            },
            ContentStatement: function () {},
            CommentStatement: function () {},
            SubExpression: o,
            PathExpression: function () {},
            StringLiteral: function () {},
            NumberLiteral: function () {},
            BooleanLiteral: function () {},
            UndefinedLiteral: function () {},
            NullLiteral: function () {},
            Hash: function (t) {
              this.acceptArray(t.pairs);
            },
            HashPair: function (t) {
              this.acceptRequired(t, 'value');
            },
          }),
            (e.default = r),
            (t.exports = e.default);
        },
        function (t, e, n) {
          function l(t, e) {
            var n;
            if (((e = e.path ? e.path.original : e), t.path.original !== e))
              throw ((n = {loc: t.path.loc}), new c.default(t.path.original + " doesn't match " + e, n));
          }
          var r = n(1).default;
          (e.__esModule = !0),
            (e.SourceLocation = function (t, e) {
              (this.source = t),
                (this.start = {line: e.first_line, column: e.first_column}),
                (this.end = {line: e.last_line, column: e.last_column});
            }),
            (e.id = function (t) {
              return /^\[.*\]$/.test(t) ? t.substring(1, t.length - 1) : t;
            }),
            (e.stripFlags = function (t, e) {
              return {open: '~' === t.charAt(2), close: '~' === e.charAt(e.length - 3)};
            }),
            (e.stripComment = function (t) {
              return t.replace(/^\{\{~?!-?-?/, '').replace(/-?-?~?\}\}$/, '');
            }),
            (e.preparePath = function (t, e, n) {
              n = this.locInfo(n);
              for (var r = t ? '@' : '', o = [], i = 0, s = 0, a = e.length; s < a; s++) {
                var u = e[s].part,
                  l = e[s].original !== u;
                if (((r += (e[s].separator || '') + u), l || ('..' !== u && '.' !== u && 'this' !== u))) o.push(u);
                else {
                  if (0 < o.length) throw new c.default('Invalid path: ' + r, {loc: n});
                  '..' === u && i++;
                }
              }
              return {type: 'PathExpression', data: t, depth: i, parts: o, original: r, loc: n};
            }),
            (e.prepareMustache = function (t, e, n, r, o, i) {
              var s = '{' !== (s = r.charAt(3) || r.charAt(2)) && '&' !== s;
              return {
                type: /\*/.test(r) ? 'Decorator' : 'MustacheStatement',
                path: t,
                params: e,
                hash: n,
                escaped: s,
                strip: o,
                loc: this.locInfo(i),
              };
            }),
            (e.prepareRawBlock = function (t, e, n, r) {
              return (
                l(t, n),
                (r = this.locInfo(r)),
                {
                  type: 'BlockStatement',
                  path: t.path,
                  params: t.params,
                  hash: t.hash,
                  program: {type: 'Program', body: e, strip: {}, loc: r},
                  openStrip: {},
                  inverseStrip: {},
                  closeStrip: {},
                  loc: r,
                }
              );
            }),
            (e.prepareBlock = function (t, e, n, r, o, i) {
              r && r.path && l(t, r);
              var s = /\*/.test(t.open),
                a = ((e.blockParams = t.blockParams), void 0),
                u = void 0;
              if (n) {
                if (s) throw new c.default('Unexpected inverse block on decorator', n);
                n.chain && (n.program.body[0].closeStrip = r.strip), (u = n.strip), (a = n.program);
              }
              return (
                o && ((o = a), (a = e), (e = o)),
                {
                  type: s ? 'DecoratorBlock' : 'BlockStatement',
                  path: t.path,
                  params: t.params,
                  hash: t.hash,
                  program: e,
                  inverse: a,
                  openStrip: t.strip,
                  inverseStrip: u,
                  closeStrip: r && r.strip,
                  loc: this.locInfo(i),
                }
              );
            }),
            (e.prepareProgram = function (t, e) {
              var n;
              return {
                type: 'Program',
                body: t,
                strip: {},
                loc: (e =
                  !e && t.length && ((n = t[0].loc), (t = t[t.length - 1].loc), n) && t
                    ? {
                        source: n.source,
                        start: {line: n.start.line, column: n.start.column},
                        end: {line: t.end.line, column: t.end.column},
                      }
                    : e),
              };
            }),
            (e.preparePartialBlock = function (t, e, n, r) {
              return (
                l(t, n),
                {
                  type: 'PartialBlockStatement',
                  name: t.path,
                  params: t.params,
                  hash: t.hash,
                  program: e,
                  openStrip: t.strip,
                  closeStrip: n && n.strip,
                  loc: this.locInfo(r),
                }
              );
            });
          var c = r(n(6));
        },
        function (t, e, n) {
          function r() {}
          function o(t) {
            var e;
            t.path.parts ||
              ((e = t.path),
              (t.path = {
                type: 'PathExpression',
                data: !1,
                depth: 0,
                parts: [e.original + ''],
                original: e.original + '',
                loc: e.loc,
              }));
          }
          var i = n(74).default,
            s = n(1).default;
          (e.__esModule = !0),
            (e.Compiler = r),
            (e.precompile = function (t, e, n) {
              if (null == t || ('string' != typeof t && 'Program' !== t.type))
                throw new a.default(
                  'You must pass a string or Handlebars AST to Handlebars.precompile. You passed ' + t
                );
              return (
                'data' in (e = e || {}) || (e.data = !0),
                e.compat && (e.useDepths = !0),
                (t = n.parse(t, e)),
                (t = new n.Compiler().compile(t, e)),
                new n.JavaScriptCompiler().compile(t, e)
              );
            }),
            (e.compile = function (e, n, r) {
              function o() {
                var t = r.parse(e, n),
                  t = new r.Compiler().compile(t, n),
                  t = new r.JavaScriptCompiler().compile(t, n, void 0, !0);
                return r.template(t);
              }
              function t(t, e) {
                return (i = i || o()).call(this, t, e);
              }
              if ((void 0 === n && (n = {}), null == e || ('string' != typeof e && 'Program' !== e.type)))
                throw new a.default('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + e);
              'data' in (n = u.extend({}, n)) || (n.data = !0), n.compat && (n.useDepths = !0);
              var i = void 0;
              return (
                (t._setup = function (t) {
                  return (i = i || o())._setup(t);
                }),
                (t._child = function (t, e, n, r) {
                  return (i = i || o())._child(t, e, n, r);
                }),
                t
              );
            });
          var a = s(n(6)),
            u = n(5),
            l = s(n(84)),
            c = [].slice;
          r.prototype = {
            compiler: r,
            equals: function (t) {
              var e = this.opcodes.length;
              if (t.opcodes.length !== e) return !1;
              for (var n = 0; n < e; n++) {
                var r = this.opcodes[n],
                  o = t.opcodes[n];
                if (
                  r.opcode !== o.opcode ||
                  !(function t(e, n) {
                    if (e === n) return 1;
                    if (u.isArray(e) && u.isArray(n) && e.length === n.length) {
                      for (var r = 0; r < e.length; r++) if (!t(e[r], n[r])) return;
                      return 1;
                    }
                  })(r.args, o.args)
                )
                  return !1;
              }
              for (e = this.children.length, n = 0; n < e; n++) if (!this.children[n].equals(t.children[n])) return !1;
              return !0;
            },
            guid: 0,
            compile: function (t, e) {
              return (
                (this.sourceNode = []),
                (this.opcodes = []),
                (this.children = []),
                (this.options = e),
                (this.stringParams = e.stringParams),
                (this.trackIds = e.trackIds),
                (e.blockParams = e.blockParams || []),
                (e.knownHelpers = u.extend(
                  i(null),
                  {
                    helperMissing: !0,
                    blockHelperMissing: !0,
                    each: !0,
                    if: !0,
                    unless: !0,
                    with: !0,
                    log: !0,
                    lookup: !0,
                  },
                  e.knownHelpers
                )),
                this.accept(t)
              );
            },
            compileProgram: function (t) {
              var t = new this.compiler().compile(t, this.options),
                e = this.guid++;
              return (
                (this.usePartial = this.usePartial || t.usePartial),
                (this.children[e] = t),
                (this.useDepths = this.useDepths || t.useDepths),
                e
              );
            },
            accept: function (t) {
              if (!this[t.type]) throw new a.default('Unknown type: ' + t.type, t);
              this.sourceNode.unshift(t);
              t = this[t.type](t);
              return this.sourceNode.shift(), t;
            },
            Program: function (t) {
              this.options.blockParams.unshift(t.blockParams);
              for (var e = t.body, n = e.length, r = 0; r < n; r++) this.accept(e[r]);
              return (
                this.options.blockParams.shift(),
                (this.isSimple = 1 === n),
                (this.blockParams = t.blockParams ? t.blockParams.length : 0),
                this
              );
            },
            BlockStatement: function (t) {
              o(t);
              var e = t.program,
                n = t.inverse,
                e = e && this.compileProgram(e),
                n = n && this.compileProgram(n),
                r = this.classifySexpr(t);
              'helper' === r
                ? this.helperSexpr(t, e, n)
                : 'simple' === r
                  ? (this.simpleSexpr(t),
                    this.opcode('pushProgram', e),
                    this.opcode('pushProgram', n),
                    this.opcode('emptyHash'),
                    this.opcode('blockValue', t.path.original))
                  : (this.ambiguousSexpr(t, e, n),
                    this.opcode('pushProgram', e),
                    this.opcode('pushProgram', n),
                    this.opcode('emptyHash'),
                    this.opcode('ambiguousBlockValue')),
                this.opcode('append');
            },
            DecoratorBlock: function (t) {
              var e = t.program && this.compileProgram(t.program),
                e = this.setupFullMustacheParams(t, e, void 0),
                t = t.path;
              (this.useDecorators = !0), this.opcode('registerDecorator', e.length, t.original);
            },
            PartialStatement: function (t) {
              this.usePartial = !0;
              var e = (e = t.program) && this.compileProgram(t.program),
                n = t.params;
              if (1 < n.length) throw new a.default('Unsupported number of partial arguments: ' + n.length, t);
              n.length ||
                (this.options.explicitPartialContext
                  ? this.opcode('pushLiteral', 'undefined')
                  : n.push({type: 'PathExpression', parts: [], depth: 0}));
              var n = t.name.original,
                r = 'SubExpression' === t.name.type,
                e = (r && this.accept(t.name), this.setupFullMustacheParams(t, e, void 0, !0), t.indent || '');
              this.options.preventIndent && e && (this.opcode('appendContent', e), (e = '')),
                this.opcode('invokePartial', r, n, e),
                this.opcode('append');
            },
            PartialBlockStatement: function (t) {
              this.PartialStatement(t);
            },
            MustacheStatement: function (t) {
              this.SubExpression(t),
                t.escaped && !this.options.noEscape ? this.opcode('appendEscaped') : this.opcode('append');
            },
            Decorator: function (t) {
              this.DecoratorBlock(t);
            },
            ContentStatement: function (t) {
              t.value && this.opcode('appendContent', t.value);
            },
            CommentStatement: function () {},
            SubExpression: function (t) {
              o(t);
              var e = this.classifySexpr(t);
              'simple' === e ? this.simpleSexpr(t) : 'helper' === e ? this.helperSexpr(t) : this.ambiguousSexpr(t);
            },
            ambiguousSexpr: function (t, e, n) {
              var t = t.path,
                r = t.parts[0],
                o = null != e || null != n;
              this.opcode('getContext', t.depth),
                this.opcode('pushProgram', e),
                this.opcode('pushProgram', n),
                (t.strict = !0),
                this.accept(t),
                this.opcode('invokeAmbiguous', r, o);
            },
            simpleSexpr: function (t) {
              t = t.path;
              (t.strict = !0), this.accept(t), this.opcode('resolvePossibleLambda');
            },
            helperSexpr: function (t, e, n) {
              var e = this.setupFullMustacheParams(t, e, n),
                n = t.path,
                r = n.parts[0];
              if (this.options.knownHelpers[r]) this.opcode('invokeKnownHelper', e.length, r);
              else {
                if (this.options.knownHelpersOnly)
                  throw new a.default('You specified knownHelpersOnly, but used the unknown helper ' + r, t);
                (n.strict = !0),
                  (n.falsy = !0),
                  this.accept(n),
                  this.opcode('invokeHelper', e.length, n.original, l.default.helpers.simpleId(n));
              }
            },
            PathExpression: function (t) {
              this.addDepth(t.depth), this.opcode('getContext', t.depth);
              var e = t.parts[0],
                n = l.default.helpers.scopedId(t),
                r = !t.depth && !n && this.blockParamIndex(e);
              r
                ? this.opcode('lookupBlockParam', r, t.parts)
                : e
                  ? t.data
                    ? ((this.options.data = !0), this.opcode('lookupData', t.depth, t.parts, t.strict))
                    : this.opcode('lookupOnContext', t.parts, t.falsy, t.strict, n)
                  : this.opcode('pushContext');
            },
            StringLiteral: function (t) {
              this.opcode('pushString', t.value);
            },
            NumberLiteral: function (t) {
              this.opcode('pushLiteral', t.value);
            },
            BooleanLiteral: function (t) {
              this.opcode('pushLiteral', t.value);
            },
            UndefinedLiteral: function () {
              this.opcode('pushLiteral', 'undefined');
            },
            NullLiteral: function () {
              this.opcode('pushLiteral', 'null');
            },
            Hash: function (t) {
              var e = t.pairs,
                n = 0,
                r = e.length;
              for (this.opcode('pushHash'); n < r; n++) this.pushParam(e[n].value);
              for (; n--; ) this.opcode('assignToHash', e[n].key);
              this.opcode('popHash');
            },
            opcode: function (t) {
              this.opcodes.push({opcode: t, args: c.call(arguments, 1), loc: this.sourceNode[0].loc});
            },
            addDepth: function (t) {
              t && (this.useDepths = !0);
            },
            classifySexpr: function (t) {
              var e = l.default.helpers.simpleId(t.path),
                n = e && !!this.blockParamIndex(t.path.parts[0]),
                r = !n && l.default.helpers.helperExpression(t),
                n = !n && (r || e);
              return (
                n &&
                  !r &&
                  ((e = t.path.parts[0]),
                  (t = this.options).knownHelpers[e] ? (r = !0) : t.knownHelpersOnly && (n = !1)),
                r ? 'helper' : n ? 'ambiguous' : 'simple'
              );
            },
            pushParams: function (t) {
              for (var e = 0, n = t.length; e < n; e++) this.pushParam(t[e]);
            },
            pushParam: function (t) {
              var e,
                n,
                r = null != t.value ? t.value : t.original || '';
              this.stringParams
                ? (r.replace && (r = r.replace(/^(\.?\.\/)*/g, '').replace(/\//g, '.')),
                  t.depth && this.addDepth(t.depth),
                  this.opcode('getContext', t.depth || 0),
                  this.opcode('pushStringParam', r, t.type),
                  'SubExpression' === t.type && this.accept(t))
                : (this.trackIds &&
                    ((e = void 0),
                    (e = !t.parts || l.default.helpers.scopedId(t) || t.depth ? e : this.blockParamIndex(t.parts[0]))
                      ? ((n = t.parts.slice(1).join('.')), this.opcode('pushId', 'BlockParam', e, n))
                      : ((r = t.original || r).replace &&
                          (r = r
                            .replace(/^this(?:\.|$)/, '')
                            .replace(/^\.\//, '')
                            .replace(/^\.$/, '')),
                        this.opcode('pushId', t.type, r))),
                  this.accept(t));
            },
            setupFullMustacheParams: function (t, e, n, r) {
              var o = t.params;
              return (
                this.pushParams(o),
                this.opcode('pushProgram', e),
                this.opcode('pushProgram', n),
                t.hash ? this.accept(t.hash) : this.opcode('emptyHash', r),
                o
              );
            },
            blockParamIndex: function (t) {
              for (var e = 0, n = this.options.blockParams.length; e < n; e++) {
                var r = this.options.blockParams[e],
                  o = r && u.indexOf(r, t);
                if (r && 0 <= o) return [e, o];
              }
            },
          };
        },
        function (t, e, n) {
          function a(t) {
            this.value = t;
          }
          function r() {}
          var s = n(60).default,
            o = n(1).default,
            i = ((e.__esModule = !0), n(4)),
            d = o(n(6)),
            u = n(5),
            l = o(n(92));
          r.prototype = {
            nameLookup: function (t, e) {
              return this.internalNameLookup(t, e);
            },
            depthedLookup: function (t) {
              return [this.aliasable('container.lookup'), '(depths, ', JSON.stringify(t), ')'];
            },
            compilerInfo: function () {
              var t = i.COMPILER_REVISION;
              return [t, i.REVISION_CHANGES[t]];
            },
            appendToBuffer: function (t, e, n) {
              return (
                u.isArray(t) || (t = [t]),
                (t = this.source.wrap(t, e)),
                this.environment.isSimple
                  ? ['return ', t, ';']
                  : n
                    ? ['buffer += ', t, ';']
                    : ((t.appendToBuffer = !0), t)
              );
            },
            initializeBuffer: function () {
              return this.quotedString('');
            },
            internalNameLookup: function (t, e) {
              return (this.lookupPropertyFunctionIsUsed = !0), ['lookupProperty(', t, ',', JSON.stringify(e), ')'];
            },
            lookupPropertyFunctionIsUsed: !1,
            compile: function (t, e, n, r) {
              (this.environment = t),
                (this.options = e),
                (this.stringParams = this.options.stringParams),
                (this.trackIds = this.options.trackIds),
                (this.precompile = !r),
                (this.name = this.environment.name),
                (this.isChild = !!n),
                (this.context = n || {decorators: [], programs: [], environments: []}),
                this.preamble(),
                (this.stackSlot = 0),
                (this.stackVars = []),
                (this.aliases = {}),
                (this.registers = {list: []}),
                (this.hashes = []),
                (this.compileStack = []),
                (this.inlineStack = []),
                (this.blockParams = []),
                this.compileChildren(t, e),
                (this.useDepths = this.useDepths || t.useDepths || t.useDecorators || this.options.compat),
                (this.useBlockParams = this.useBlockParams || t.useBlockParams);
              for (var o, i = t.opcodes, s = void 0, a = void 0, u = void 0, a = 0, u = i.length; a < u; a++)
                (o = i[a]), (this.source.currentLocation = o.loc), (s = s || o.loc), this[o.opcode].apply(this, o.args);
              if (
                ((this.source.currentLocation = s),
                this.pushSource(''),
                this.stackSlot || this.inlineStack.length || this.compileStack.length)
              )
                throw new d.default('Compile completed with content left on stack');
              this.decorators.isEmpty()
                ? (this.decorators = void 0)
                : ((this.useDecorators = !0),
                  this.decorators.prepend([
                    'var decorators = container.decorators, ',
                    this.lookupPropertyFunctionVarDeclaration(),
                    ';\n',
                  ]),
                  this.decorators.push('return fn;'),
                  r
                    ? (this.decorators = Function.apply(this, [
                        'fn',
                        'props',
                        'container',
                        'depth0',
                        'data',
                        'blockParams',
                        'depths',
                        this.decorators.merge(),
                      ]))
                    : (this.decorators.prepend('function(fn, props, container, depth0, data, blockParams, depths) {\n'),
                      this.decorators.push('}\n'),
                      (this.decorators = this.decorators.merge())));
              n = this.createFunctionContext(r);
              if (this.isChild) return n;
              var l = {compiler: this.compilerInfo(), main: n},
                t = (this.decorators && ((l.main_d = this.decorators), (l.useDecorators = !0)), this.context),
                c = t.programs,
                p = t.decorators;
              for (a = 0, u = c.length; a < u; a++)
                c[a] && ((l[a] = c[a]), p[a]) && ((l[a + '_d'] = p[a]), (l.useDecorators = !0));
              return (
                this.environment.usePartial && (l.usePartial = !0),
                this.options.data && (l.useData = !0),
                this.useDepths && (l.useDepths = !0),
                this.useBlockParams && (l.useBlockParams = !0),
                this.options.compat && (l.compat = !0),
                r
                  ? (l.compilerOptions = this.options)
                  : ((l.compiler = JSON.stringify(l.compiler)),
                    (this.source.currentLocation = {start: {line: 1, column: 0}}),
                    (l = this.objectLiteral(l)),
                    e.srcName
                      ? ((l = l.toStringWithSourceMap({file: e.destName})).map = l.map && l.map.toString())
                      : (l = l.toString())),
                l
              );
            },
            preamble: function () {
              (this.lastContext = 0),
                (this.source = new l.default(this.options.srcName)),
                (this.decorators = new l.default(this.options.srcName));
            },
            createFunctionContext: function (t) {
              var n = this,
                r = '',
                e = this.stackVars.concat(this.registers.list),
                o = (0 < e.length && (r += ', ' + e.join(', ')), 0),
                e =
                  (s(this.aliases).forEach(function (t) {
                    var e = n.aliases[t];
                    e.children &&
                      1 < e.referenceCount &&
                      ((r += ', alias' + ++o + '=' + t), (e.children[0] = 'alias' + o));
                  }),
                  this.lookupPropertyFunctionIsUsed && (r += ', ' + this.lookupPropertyFunctionVarDeclaration()),
                  ['container', 'depth0', 'helpers', 'partials', 'data']),
                i =
                  ((this.useBlockParams || this.useDepths) && e.push('blockParams'),
                  this.useDepths && e.push('depths'),
                  this.mergeSource(r));
              return t
                ? (e.push(i), Function.apply(this, e))
                : this.source.wrap(['function(', e.join(','), ') {\n  ', i, '}']);
            },
            mergeSource: function (t) {
              var e = this.environment.isSimple,
                n = !this.forceBuffer,
                r = void 0,
                o = void 0,
                i = void 0,
                s = void 0;
              return (
                this.source.each(function (t) {
                  t.appendToBuffer
                    ? (i ? t.prepend('  + ') : (i = t), (s = t))
                    : (i && (o ? i.prepend('buffer += ') : (r = !0), s.add(';'), (i = s = void 0)),
                      (o = !0),
                      e || (n = !1));
                }),
                n
                  ? i
                    ? (i.prepend('return '), s.add(';'))
                    : o || this.source.push('return "";')
                  : ((t += ', buffer = ' + (r ? '' : this.initializeBuffer())),
                    i ? (i.prepend('return buffer + '), s.add(';')) : this.source.push('return buffer;')),
                t && this.source.prepend('var ' + t.substring(2) + (r ? '' : ';\n')),
                this.source.merge()
              );
            },
            lookupPropertyFunctionVarDeclaration: function () {
              return '\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    '.trim();
            },
            blockValue: function (t) {
              var e = this.aliasable('container.hooks.blockHelperMissing'),
                n = [this.contextName(0)],
                t = (this.setupHelperArgs(t, 0, n), this.popStack());
              n.splice(1, 0, t), this.push(this.source.functionCall(e, 'call', n));
            },
            ambiguousBlockValue: function () {
              var t = this.aliasable('container.hooks.blockHelperMissing'),
                e = [this.contextName(0)],
                n = (this.setupHelperArgs('', 0, e, !0), this.flushInline(), this.topStack());
              e.splice(1, 0, n),
                this.pushSource([
                  'if (!',
                  this.lastHelper,
                  ') { ',
                  n,
                  ' = ',
                  this.source.functionCall(t, 'call', e),
                  '}',
                ]);
            },
            appendContent: function (t) {
              this.pendingContent
                ? (t = this.pendingContent + t)
                : (this.pendingLocation = this.source.currentLocation),
                (this.pendingContent = t);
            },
            append: function () {
              var t;
              this.isInline()
                ? (this.replaceStack(function (t) {
                    return [' != null ? ', t, ' : ""'];
                  }),
                  this.pushSource(this.appendToBuffer(this.popStack())))
                : ((t = this.popStack()),
                  this.pushSource(['if (', t, ' != null) { ', this.appendToBuffer(t, void 0, !0), ' }']),
                  this.environment.isSimple &&
                    this.pushSource(['else { ', this.appendToBuffer("''", void 0, !0), ' }']));
            },
            appendEscaped: function () {
              this.pushSource(
                this.appendToBuffer([this.aliasable('container.escapeExpression'), '(', this.popStack(), ')'])
              );
            },
            getContext: function (t) {
              this.lastContext = t;
            },
            pushContext: function () {
              this.pushStackLiteral(this.contextName(this.lastContext));
            },
            lookupOnContext: function (t, e, n, r) {
              var o = 0;
              r || !this.options.compat || this.lastContext
                ? this.pushContext()
                : this.push(this.depthedLookup(t[o++])),
                this.resolvePath('context', t, o, e, n);
            },
            lookupBlockParam: function (t, e) {
              (this.useBlockParams = !0),
                this.push(['blockParams[', t[0], '][', t[1], ']']),
                this.resolvePath('context', e, 1);
            },
            lookupData: function (t, e, n) {
              t ? this.pushStackLiteral('container.data(data, ' + t + ')') : this.pushStackLiteral('data'),
                this.resolvePath('data', e, 0, !0, n);
            },
            resolvePath: function (n, r, o, i, t) {
              var s = this;
              if (this.options.strict || this.options.assumeObjects)
                this.push(
                  ((t, e, n, r, o) => {
                    var i = e.popStack(),
                      s = n.length;
                    for (t && s--; r < s; r++) i = e.nameLookup(i, n[r], o);
                    return t
                      ? [
                          e.aliasable('container.strict'),
                          '(',
                          i,
                          ', ',
                          e.quotedString(n[r]),
                          ', ',
                          JSON.stringify(e.source.currentLocation),
                          ' )',
                        ]
                      : i;
                  })(this.options.strict && t, this, r, o, n)
                );
              else
                for (var e = r.length; o < e; o++)
                  this.replaceStack(function (t) {
                    var e = s.nameLookup(t, r[o], n);
                    return i ? [' && ', e] : [' != null ? ', e, ' : ', t];
                  });
            },
            resolvePossibleLambda: function () {
              this.push([this.aliasable('container.lambda'), '(', this.popStack(), ', ', this.contextName(0), ')']);
            },
            pushStringParam: function (t, e) {
              this.pushContext(),
                this.pushString(e),
                'SubExpression' !== e && ('string' == typeof t ? this.pushString(t) : this.pushStackLiteral(t));
            },
            emptyHash: function (t) {
              this.trackIds && this.push('{}'),
                this.stringParams && (this.push('{}'), this.push('{}')),
                this.pushStackLiteral(t ? 'undefined' : '{}');
            },
            pushHash: function () {
              this.hash && this.hashes.push(this.hash), (this.hash = {values: {}, types: [], contexts: [], ids: []});
            },
            popHash: function () {
              var t = this.hash;
              (this.hash = this.hashes.pop()),
                this.trackIds && this.push(this.objectLiteral(t.ids)),
                this.stringParams &&
                  (this.push(this.objectLiteral(t.contexts)), this.push(this.objectLiteral(t.types))),
                this.push(this.objectLiteral(t.values));
            },
            pushString: function (t) {
              this.pushStackLiteral(this.quotedString(t));
            },
            pushLiteral: function (t) {
              this.pushStackLiteral(t);
            },
            pushProgram: function (t) {
              null != t ? this.pushStackLiteral(this.programExpression(t)) : this.pushStackLiteral(null);
            },
            registerDecorator: function (t, e) {
              var n = this.nameLookup('decorators', e, 'decorator'),
                e = this.setupHelperArgs(e, t);
              this.decorators.push([
                'fn = ',
                this.decorators.functionCall(n, '', ['fn', 'props', 'container', e]),
                ' || fn;',
              ]);
            },
            invokeHelper: function (t, e, n) {
              var r = this.popStack(),
                t = this.setupHelper(t, e),
                e = [],
                n =
                  (n && e.push(t.name),
                  e.push(r),
                  this.options.strict || e.push(this.aliasable('container.hooks.helperMissing')),
                  ['(', this.itemsSeparatedBy(e, '||'), ')']),
                r = this.source.functionCall(n, 'call', t.callParams);
              this.push(r);
            },
            itemsSeparatedBy: function (t, e) {
              var n = [];
              n.push(t[0]);
              for (var r = 1; r < t.length; r++) n.push(e, t[r]);
              return n;
            },
            invokeKnownHelper: function (t, e) {
              t = this.setupHelper(t, e);
              this.push(this.source.functionCall(t.name, 'call', t.callParams));
            },
            invokeAmbiguous: function (t, e) {
              this.useRegister('helper');
              var n = this.popStack(),
                e = (this.emptyHash(), this.setupHelper(0, t, e)),
                t = ['(', '(helper = ', (this.lastHelper = this.nameLookup('helpers', t, 'helper')), ' || ', n, ')'];
              this.options.strict ||
                ((t[0] = '(helper = '),
                t.push(' != null ? helper : ', this.aliasable('container.hooks.helperMissing'))),
                this.push([
                  '(',
                  t,
                  e.paramsInit ? ['),(', e.paramsInit] : [],
                  '),',
                  '(typeof helper === ',
                  this.aliasable('"function"'),
                  ' ? ',
                  this.source.functionCall('helper', 'call', e.callParams),
                  ' : helper))',
                ]);
            },
            invokePartial: function (t, e, n) {
              var r = [],
                o = this.setupParams(e, 1, r);
              t && ((e = this.popStack()), delete o.name),
                n && (o.indent = JSON.stringify(n)),
                (o.helpers = 'helpers'),
                (o.partials = 'partials'),
                (o.decorators = 'container.decorators'),
                t ? r.unshift(e) : r.unshift(this.nameLookup('partials', e, 'partial')),
                this.options.compat && (o.depths = 'depths'),
                (o = this.objectLiteral(o)),
                r.push(o),
                this.push(this.source.functionCall('container.invokePartial', '', r));
            },
            assignToHash: function (t) {
              var e = this.popStack(),
                n = void 0,
                r = void 0,
                o = void 0,
                i =
                  (this.trackIds && (o = this.popStack()),
                  this.stringParams && ((r = this.popStack()), (n = this.popStack())),
                  this.hash);
              n && (i.contexts[t] = n), r && (i.types[t] = r), o && (i.ids[t] = o), (i.values[t] = e);
            },
            pushId: function (t, e, n) {
              'BlockParam' === t
                ? this.pushStackLiteral(
                    'blockParams[' + e[0] + '].path[' + e[1] + ']' + (n ? ' + ' + JSON.stringify('.' + n) : '')
                  )
                : 'PathExpression' === t
                  ? this.pushString(e)
                  : 'SubExpression' === t
                    ? this.pushStackLiteral('true')
                    : this.pushStackLiteral('null');
            },
            compiler: r,
            compileChildren: function (t, e) {
              for (var n = t.children, r = void 0, o = void 0, i = 0, s = n.length; i < s; i++) {
                var a,
                  r = n[i],
                  o = new this.compiler(),
                  u = this.matchExistingProgram(r);
                null == u
                  ? (this.context.programs.push(''),
                    (a = this.context.programs.length),
                    (r.index = a),
                    (r.name = 'program' + a),
                    (this.context.programs[a] = o.compile(r, e, this.context, !this.precompile)),
                    (this.context.decorators[a] = o.decorators),
                    (this.context.environments[a] = r),
                    (this.useDepths = this.useDepths || o.useDepths),
                    (this.useBlockParams = this.useBlockParams || o.useBlockParams),
                    (r.useDepths = this.useDepths),
                    (r.useBlockParams = this.useBlockParams))
                  : ((r.index = u.index),
                    (r.name = 'program' + u.index),
                    (this.useDepths = this.useDepths || u.useDepths),
                    (this.useBlockParams = this.useBlockParams || u.useBlockParams));
              }
            },
            matchExistingProgram: function (t) {
              for (var e = 0, n = this.context.environments.length; e < n; e++) {
                var r = this.context.environments[e];
                if (r && r.equals(t)) return r;
              }
            },
            programExpression: function (t) {
              (t = this.environment.children[t]), (t = [t.index, 'data', t.blockParams]);
              return (
                (this.useBlockParams || this.useDepths) && t.push('blockParams'),
                this.useDepths && t.push('depths'),
                'container.program(' + t.join(', ') + ')'
              );
            },
            useRegister: function (t) {
              this.registers[t] || ((this.registers[t] = !0), this.registers.list.push(t));
            },
            push: function (t) {
              return t instanceof a || (t = this.source.wrap(t)), this.inlineStack.push(t), t;
            },
            pushStackLiteral: function (t) {
              this.push(new a(t));
            },
            pushSource: function (t) {
              this.pendingContent &&
                (this.source.push(
                  this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)
                ),
                (this.pendingContent = void 0)),
                t && this.source.push(t);
            },
            replaceStack: function (t) {
              var e = ['('],
                n = void 0,
                r = void 0,
                o = void 0;
              if (!this.isInline()) throw new d.default('replaceStack on non-inline');
              var i = this.popStack(!0),
                s =
                  (i instanceof a
                    ? ((e = ['(', (n = [i.value])]), (o = !0))
                    : ((r = !0),
                      (s = this.incrStack()),
                      (e = ['((', this.push(s), ' = ', i, ')']),
                      (n = this.topStack())),
                  t.call(this, n));
              o || this.popStack(), r && this.stackSlot--, this.push(e.concat(s, ')'));
            },
            incrStack: function () {
              return (
                this.stackSlot++,
                this.stackSlot > this.stackVars.length && this.stackVars.push('stack' + this.stackSlot),
                this.topStackName()
              );
            },
            topStackName: function () {
              return 'stack' + this.stackSlot;
            },
            flushInline: function () {
              var t = this.inlineStack;
              this.inlineStack = [];
              for (var e = 0, n = t.length; e < n; e++) {
                var r,
                  o = t[e];
                o instanceof a
                  ? this.compileStack.push(o)
                  : ((r = this.incrStack()), this.pushSource([r, ' = ', o, ';']), this.compileStack.push(r));
              }
            },
            isInline: function () {
              return this.inlineStack.length;
            },
            popStack: function (t) {
              var e = this.isInline(),
                n = (e ? this.inlineStack : this.compileStack).pop();
              if (!t && n instanceof a) return n.value;
              if (!e) {
                if (!this.stackSlot) throw new d.default('Invalid stack pop');
                this.stackSlot--;
              }
              return n;
            },
            topStack: function () {
              var t = this.isInline() ? this.inlineStack : this.compileStack,
                t = t[t.length - 1];
              return t instanceof a ? t.value : t;
            },
            contextName: function (t) {
              return this.useDepths && t ? 'depths[' + t + ']' : 'depth' + t;
            },
            quotedString: function (t) {
              return this.source.quotedString(t);
            },
            objectLiteral: function (t) {
              return this.source.objectLiteral(t);
            },
            aliasable: function (t) {
              var e = this.aliases[t];
              return (
                e
                  ? e.referenceCount++
                  : (((e = this.aliases[t] = this.source.wrap(t)).aliasable = !0), (e.referenceCount = 1)),
                e
              );
            },
            setupHelper: function (t, e, n) {
              var r = [];
              return {
                params: r,
                paramsInit: this.setupHelperArgs(e, t, r, n),
                name: this.nameLookup('helpers', e, 'helper'),
                callParams: [
                  this.aliasable(
                    this.contextName(0) + ' != null ? ' + this.contextName(0) + ' : (container.nullContext || {})'
                  ),
                ].concat(r),
              };
            },
            setupParams: function (t, e, n) {
              var r,
                o = {},
                i = [],
                s = [],
                a = [],
                u = !n,
                t =
                  (u && (n = []),
                  (o.name = this.quotedString(t)),
                  (o.hash = this.popStack()),
                  this.trackIds && (o.hashIds = this.popStack()),
                  this.stringParams && ((o.hashTypes = this.popStack()), (o.hashContexts = this.popStack())),
                  this.popStack()),
                l = this.popStack();
              (l || t) && ((o.fn = l || 'container.noop'), (o.inverse = t || 'container.noop'));
              for (var c = e; c--; )
                (r = this.popStack()),
                  (n[c] = r),
                  this.trackIds && (a[c] = this.popStack()),
                  this.stringParams && ((s[c] = this.popStack()), (i[c] = this.popStack()));
              return (
                u && (o.args = this.source.generateArray(n)),
                this.trackIds && (o.ids = this.source.generateArray(a)),
                this.stringParams &&
                  ((o.types = this.source.generateArray(s)), (o.contexts = this.source.generateArray(i))),
                this.options.data && (o.data = 'data'),
                this.useBlockParams && (o.blockParams = 'blockParams'),
                o
              );
            },
            setupHelperArgs: function (t, e, n, r) {
              t = this.setupParams(t, e, n);
              return (
                (t.loc = JSON.stringify(this.source.currentLocation)),
                (t = this.objectLiteral(t)),
                r ? (this.useRegister('options'), n.push('options'), ['options=', t]) : n ? (n.push(t), '') : t
              );
            },
          };
          for (
            var c =
                'break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false'.split(
                  ' '
                ),
              p = (r.RESERVED_WORDS = {}),
              h = 0,
              f = c.length;
            h < f;
            h++
          )
            p[c[h]] = !0;
          (r.isValidJavaScriptVariableName = function (t) {
            return !r.RESERVED_WORDS[t] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(t);
          }),
            (e.default = r),
            (t.exports = e.default);
        },
        function (t, e, n) {
          function i(t, e, n) {
            if (a.isArray(t)) {
              for (var r = [], o = 0, i = t.length; o < i; o++) r.push(e.wrap(t[o], n));
              return r;
            }
            return 'boolean' == typeof t || 'number' == typeof t ? t + '' : t;
          }
          function r(t) {
            (this.srcFile = t), (this.source = []);
          }
          var s = n(60).default,
            a = ((e.__esModule = !0), n(5)),
            o = void 0;
          o ||
            ((o = function (t, e, n, r) {
              (this.src = ''), r && this.add(r);
            }).prototype = {
              add: function (t) {
                a.isArray(t) && (t = t.join('')), (this.src += t);
              },
              prepend: function (t) {
                a.isArray(t) && (t = t.join('')), (this.src = t + this.src);
              },
              toStringWithSourceMap: function () {
                return {code: this.toString()};
              },
              toString: function () {
                return this.src;
              },
            }),
            (r.prototype = {
              isEmpty: function () {
                return !this.source.length;
              },
              prepend: function (t, e) {
                this.source.unshift(this.wrap(t, e));
              },
              push: function (t, e) {
                this.source.push(this.wrap(t, e));
              },
              merge: function () {
                var e = this.empty();
                return (
                  this.each(function (t) {
                    e.add(['  ', t, '\n']);
                  }),
                  e
                );
              },
              each: function (t) {
                for (var e = 0, n = this.source.length; e < n; e++) t(this.source[e]);
              },
              empty: function () {
                var t = this.currentLocation || {start: {}};
                return new o(t.start.line, t.start.column, this.srcFile);
              },
              wrap: function (t) {
                var e =
                  arguments.length <= 1 || void 0 === arguments[1] ? this.currentLocation || {start: {}} : arguments[1];
                return t instanceof o ? t : ((t = i(t, this, e)), new o(e.start.line, e.start.column, this.srcFile, t));
              },
              functionCall: function (t, e, n) {
                return (n = this.generateList(n)), this.wrap([t, e ? '.' + e + '(' : '(', n, ')']);
              },
              quotedString: function (t) {
                return (
                  '"' +
                  (t + '')
                    .replace(/\\/g, '\\\\')
                    .replace(/"/g, '\\"')
                    .replace(/\n/g, '\\n')
                    .replace(/\r/g, '\\r')
                    .replace(/\u2028/g, '\\u2028')
                    .replace(/\u2029/g, '\\u2029') +
                  '"'
                );
              },
              objectLiteral: function (n) {
                var r = this,
                  o = [],
                  t =
                    (s(n).forEach(function (t) {
                      var e = i(n[t], r);
                      'undefined' !== e && o.push([r.quotedString(t), ':', e]);
                    }),
                    this.generateList(o));
                return t.prepend('{'), t.add('}'), t;
              },
              generateList: function (t) {
                for (var e = this.empty(), n = 0, r = t.length; n < r; n++) n && e.add(','), e.add(i(t[n], this));
                return e;
              },
              generateArray: function (t) {
                t = this.generateList(t);
                return t.prepend('['), t.add(']'), t;
              },
            }),
            (e.default = r),
            (t.exports = e.default);
        },
      ]),
      (o = {}),
      (n.m = r),
      (n.c = o),
      (n.p = ''),
      n(0)
    );
    function n(t) {
      var e;
      return (
        o[t] ||
        ((e = o[t] = {exports: {}, id: t, loaded: !1}), r[t].call(e.exports, e, e.exports, n), (e.loaded = !0), e)
      ).exports;
    }
    var r, o;
  }),
  (() => {
    'function' == typeof window.initUnbxdQuickView && window.initUnbxdQuickView();
    var t = document.cookie.match('\\bunbxd.userId=([^;]*)\\b');
    let E = t ? t[1] : '123456',
      r = null,
      n = null;
    function o() {
      var t = (() => {
        let r = [];
        return (
          [
            {prefix: 'pdp_recommendations', pageType: 'PRODUCT'},
            {prefix: 'cart_recommendations', pageType: 'CART'},
            {prefix: 'home_recommendations', pageType: 'HOME'},
            {prefix: 'srp_recommendations', pageType: 'HOME'},
          ].forEach(function (t) {
            let e = 1;
            for (;;) {
              var n = t.prefix + '_' + e;
              if (!document.getElementById(n)) break;
              r.push({elementId: n, pageType: t.pageType}), e++;
            }
            1 === e && document.getElementById(t.prefix) && r.push({elementId: t.prefix, pageType: t.pageType});
          }),
          r
        );
      })();
      if (0 === t.length) return null;
      var e = t[0].pageType;
      let n = null,
        r = null;
      return (
        'PRODUCT' === e &&
          (n = (() => {
            if (void 0 !== window.productJSON && window.productJSON.id) return window.productJSON.id;
            if ('undefined' != typeof ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product)
              return ShopifyAnalytics.meta.product.id;
            var t = document.getElementById('pdp_recommendations');
            if (t && t.dataset.productId) return t.dataset.productId;
            if ((t = document.querySelector('meta[property="og:url"]'))) {
              t = t.content.match(/\/products\/([^\/]+)$/);
              if (t) return t[1];
            }
            return null;
          })()),
        'CART' === e && (r = null),
        {pageType: e, containers: t, productId: n, cartIds: r}
      );
    }
    function e() {
      if (
        ((r = o()),
        (window._unbxd_recs_containers = r ? r.containers : []),
        (window._unbxd_recs_defaultElementId = r ? r.elementId : null),
        r)
      ) {
        var e = [
          'title',
          'uniqueId',
          'productUrl',
          'handle',
          'imageUrl',
          'images',
          'id',
          'availability',
          'available',
          'tags',
          'product_variants',
          'price_AUD',
          'price_NZD',
          'price_USD',
          'compareAtPrice_AUD',
          'compareAtPrice_NZD',
          'compareAtPrice_USD',
          'price',
          'compareAtPrice',
          'salePrice',
          'meta_badges',
          'grouped_products',
          'swatch_image_url',
          'product_hex',
          'meta_promotion_values',
          'meta_promotion_handles',
          'video_urls',
        ].join(',');
        let t =
          'https://recommendations.unbxd.io/v3.0/' +
          getApiKey() +
          '/' +
          getSiteName() +
          '/recommendation?template=false&pageType=' +
          encodeURIComponent(r.pageType) +
          '&uid=' +
          encodeURIComponent(E) +
          '&variants=true&variants.count=100&fields=' +
          encodeURIComponent(e);
        'PRODUCT' === r.pageType && r.productId && (t += '&id=' + encodeURIComponent(r.productId)), (n = t);
      } else n = null;
    }
    let C = 'https://libraries.unbxdapi.com/sdk-assets/defaultImage.svg';
    function T(t, e) {
      if ('' === t || null == t || isNaN(parseFloat(t))) return '';
      var n = parseFloat(t).toFixed(2);
      switch (e) {
        case 'GB':
          return '£' + n + ' GBP';
        case 'AU':
          return '$' + n + ' AUD';
        case 'NZ':
          return '$' + n + ' NZD';
        case 'SG':
          return '$' + n + ' SGD';
        default:
          return '$' + n;
      }
    }
    function A(e) {
      return e
        ? [160, 320, 480, 640, 800, 960]
            .map(function (t) {
              return (-1 !== e.indexOf('?') ? e + '&width=' + t : e + '?width=' + t) + ' ' + t + 'w';
            })
            .join(', ')
        : '';
    }
    function f(t, e, n) {
      var r = t.title || '';
      let o = t.uniqueId || '';
      var i = t.productUrl || '/products/' + o,
        s = t.handle || o;
      let a = Array.isArray(t.imageUrl) ? t.imageUrl[0] : t.imageUrl;
      var u = t.images || [],
        l = Array.isArray(u) && 1 < u.length ? u[u.length - 2] : null,
        c = ((a = a || C), Array.isArray(t.video_urls) ? t.video_urls : []),
        p =
          c.find(function (t) {
            return t.toLowerCase().endsWith('.mp4');
          }) || '',
        d = (void 0 === window._unbxdProductStore && (window._unbxdProductStore = {}), []);
      try {
        var h = t.product_variants;
        h && 'string' == typeof h && '[]' !== h ? (d = JSON.parse(h)) : Array.isArray(h) && (d = h);
      } catch (t) {
        console.error('[Unbxd Recs] Error parsing product_variants:', t);
      }
      var h = d
          .map(function (t) {
            var e = t.v_availableForSale,
              n = !(!1 === e || 'false' === String(e).toLowerCase()),
              r = null != t.v_Size ? t.v_Size : '',
              o = null != t.v_Color ? t.v_Color : '',
              i = [r, o].filter(Boolean).join(' / ') || 'Default Title';
            return {
              id: String(t.variantId || ''),
              v_Size: r,
              v_Color: o,
              title: i,
              v_availableForSale: e,
              available: n,
              availability: n ? 'true' : 'false',
            };
          })
          .filter(function (t) {
            return !!t.id;
          }),
        f =
          (0 === h.length &&
            t.variantId &&
            ((g = !(!1 === (d = t.v_availableForSale) || 'false' === String(d).toLowerCase())),
            (f = [t.v_Size, t.v_Color].filter(Boolean).join(' / ') || 'Default Title'),
            (h = [
              {
                id: String(t.variantId),
                v_Size: t.v_Size || '',
                v_Color: t.v_Color || '',
                title: f,
                v_availableForSale: d,
                available: g,
                availability: t.availability,
              },
            ])),
          h.some(function (t) {
            return !0 === t.available;
          })),
        d = 0 < h.length ? !f : 'false' === String(t.v_availableForSale).toLowerCase(),
        g = (
          Array.isArray(t.tags)
            ? t.tags
            : 'string' == typeof t.tags
              ? t.tags.split(',').map(function (t) {
                  return t.trim();
                })
              : []
        ).some(function (t) {
          return 'in-store only' === t.toLowerCase();
        }),
        m = d ? 'Notify Me' : 'Add to Bag',
        y = d ? r + ' is Sold Out' : r + ' - Add to Bag',
        v =
          h.find(function (t) {
            return !0 === t.available;
          }) || h[0],
        v = v ? v.id : t.variantId || '',
        f =
          ((window._unbxdProductStore[o] = {
            id: t.id || o,
            uniqueId: o,
            title: r,
            handle: s,
            imageUrl: a,
            images: u,
            available: f,
            availability: f ? 'true' : 'false',
            variants: h,
          }),
          'undefined' != typeof window && window.Shopify && window.Shopify.country ? window.Shopify.country : null),
        b =
          {
            GB: {price: t.price_GBP, compareAt: t.compareAtPrice_GBP},
            AU: {price: t.price_AUD, compareAt: t.compareAtPrice_AUD},
            NZ: {price: t.price_NZD, compareAt: t.compareAtPrice_NZD},
            SG: {price: t.price_SGD, compareAt: t.compareAtPrice_SGD},
            US: {price: t.price_USD, compareAt: t.compareAtPrice_USD},
          }[f] || null,
        x = (b && b.price) || t.price || '',
        b = (b && b.compareAt) || t.compareAtPrice || t.salePrice || '',
        S = T(x, f),
        f = T(b, f);
      let w = '';
      p
        ? ((_ = l ? (-1 !== l.indexOf('?') ? l + '&width=600' : l + '?width=600') : ''),
          (w =
            '<div class="product-card__image--secondary"><div class="component-video__wrapper aspect-ratio aspect-ratio--2-3"><video playsinline="playsinline" class="component-video__video" preload="none" autoplay="autoplay" muted="muted" loop="loop" aria-label="' +
            r +
            '" width="1080" height="1920" ' +
            (_ ? 'poster="' + _ + '" ' : '') +
            'disablepictureinpicture="true" disableremoteplayback="true" x-webkit-airplay="deny"><source src="' +
            p +
            '" type="video/mp4"><img alt="' +
            r +
            '" src="' +
            (_ || '') +
            '"></video></div></div>'))
        : l &&
          l !== a &&
          (w =
            '<div class="product-card__image--secondary"><div class="component-image__wrapper aspect-ratio aspect-ratio--2-3"><img srcset="' +
            A(l) +
            '" src="' +
            (-1 !== l.indexOf('?') ? l + '&width=600' : l + '?width=600') +
            '" loading="lazy" sizes="(min-width: 85.5rem) calc(85.5rem / 3), (min-width: 61.875rem) calc(100vw / 3), 100vw" width="1000" height="1500" alt="' +
            r +
            '" class="component-image__image"></div></div>');
      var p = t.meta_badges || [],
        _ = Array.isArray(p) ? p : 'string' == typeof p ? [p] : [],
        l =
          0 < _.length
            ? '<div class="product-badges product-card__badges" data-product-badges="">' +
              _.map(function (t) {
                return (
                  '<div class="badge badge__' +
                  t.toLowerCase().replace(/&/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') +
                  '">' +
                  t +
                  '</div>'
                );
              }).join('') +
              '</div>'
            : '',
        p =
          b && parseFloat(b) > parseFloat(x)
            ? '<span class="visually-hidden">Sale price</span><span>' +
              S +
              '</span><span class="visually-hidden">Regular price</span><span class="product-card__compare-price ns-font-4 ns-text-striked ns-ml-2">' +
              f +
              '</span>'
            : '<span>' + S + '</span>',
        _ = [];
      try {
        var P = t.grouped_products;
        P && 'string' == typeof P && '[]' !== P ? (_ = JSON.parse(P)) : Array.isArray(P) && (_ = P);
      } catch (t) {
        console.error('[Unbxd Recs] Error parsing grouped_products:', t);
      }
      var k,
        b = {
          title: r,
          id: t.id || o,
          uniqueId: o,
          availability: t.availability,
          available: t.available,
          price: t.price || x,
          imageUrl: a,
          productUrl: i,
          meta_badges: t.meta_badges || [],
          meta_promotion_values: t.meta_promotion_values || [],
          meta_promotion_handles: t.meta_promotion_handles || [],
          images: u,
          variants: h,
          handle: s,
          swatch_image_url: t.swatch_image_url || '',
          product_hex: t.product_hex || [],
          video_urls: c,
        },
        f =
          (_.forEach(function (t) {
            Array.isArray(t.video_urls) || (t.video_urls = []);
          }),
          [b].concat(_)),
        S = (void 0 === window._unbxdSwatchData && (window._unbxdSwatchData = {}), ''),
        P =
          (1 < (window._unbxdSwatchData[o] = f).length &&
            ((k = ''),
            f.forEach(function (t, e) {
              var n = t.swatch_image_url || '',
                r = t.product_hex || [],
                r = Array.isArray(r) ? r[0] : r,
                n = n ? 'background-image: url(' + n + ');' : r ? 'background-color: ' + r + ';' : '',
                r = t.title || '',
                t = t.uniqueId || t.id || '';
              k +=
                '<li><button type="button" class="swatch UNX-product-swatch' +
                (0 === e ? ' swatch--active' : '') +
                '" title="' +
                r +
                '" aria-label="Switch to ' +
                r +
                '" data-swatch-action="switchProduct" data-swatch-product-id="' +
                t +
                '" data-swatch-tile-id="' +
                o +
                '" style="' +
                n +
                '"></button></li>';
            }),
            (S =
              '<div class="product-card__swatches swatches"><ul class="swatches__list list-none">' +
              k +
              '</ul></div>')),
          t.meta_promotion_values || []),
        x = Array.isArray(P) ? P : 'string' == typeof P ? [P] : [],
        u = t.meta_promotion_handles || [],
        h = Array.isArray(u) ? u[0] : u,
        c =
          0 < x.length
            ? '<div class="product-card__promotion' +
              (h ? ' product-card__promotion--' + h : '') +
              ' caption">' +
              x.join(', ') +
              '</div>'
            : '',
        b =
          '<product-card data-product-card="" class="product-card" id="' +
          o +
          '">  <div class="product-card__top">    ' +
          l +
          '    <div class="product-card__image">      <a href="' +
          i +
          '">        <div class="component-image__wrapper aspect-ratio aspect-ratio--2-3">          <img srcset="' +
          A(a) +
          '" src="' +
          (-1 !== a.indexOf('?') ? a + '&width=600' : a + '?width=600') +
          '" loading="lazy" sizes="(min-width: 85.5rem) calc(85.5rem / 3), (min-width: 61.875rem) calc(100vw / 3), 100vw" width="1000" height="1500" alt="' +
          r +
          '" class="component-image__image" onerror="this.src=\'' +
          C +
          '\';">        </div>        ' +
          w +
          '      </a>    </div>' +
          (g
            ? ''
            : '    <div class="product-card__actions ns-relative">      <button type="submit" data-product-modal-trigger="' +
              s +
              '" data-product-modal-type="' +
              (d ? 'notify' : 'add') +
              '" data-variant-id="' +
              v +
              '" aria-label="' +
              y +
              '" class="product-card__add body-small">        <span class="hide show--min-lg">' +
              m +
              '</span>        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Add to Bag" class="icon icon--add hide show--max-lg">          <path d="M5 1V3V5M5 5V9M5 5H1M5 5H9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>        </svg>      </button>    </div>') +
          '  </div>  <div class="product-card__meta">    <h4 id="product-title-' +
          o +
          '-unbxd-recs" class="product-card__title body-small">      <a href="' +
          i +
          '">' +
          r +
          '</a>    </h4>    <div class="product-card__price body-small">      <a href="' +
          i +
          '" aria-describedby="product-title-' +
          o +
          '-unbxd-recs">' +
          p +
          '</a>    </div>' +
          (g
            ? ''
            : '    <button aria-label="Add to Wishlist" data-product-modal-trigger="' +
              s +
              '" data-product-modal-type="wishlist" data-wishlist-icon="' +
              o +
              '" class="product-card__wishlist btn--none">      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Heart Icon" class="icon icon--heart">        <path d="M3.4543 11.7241C5.60157 15.6966 9.98827 18.8966 11.9566 20C13.9249 18.8966 18.3984 15.6966 20.5457 11.7241C21.6193 9.73794 21.0825 4 15.7143 4C14.1038 4 13.245 4.96158 11.9566 6.28571C10.6683 4.96158 9.89618 4 8.28566 4C2.91748 4 2.38073 9.73794 3.4543 11.7241Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" vector-effect="non-scaling-stroke" class="icon--fill"></path>      </svg>    </button>') +
          '  </div>' +
          S +
          c +
          '</product-card>';
      return (
        '<div class="_unbxd_recs-slider__item UNX-product-card" id="hz-item-' +
        e +
        '" data-id="' +
        o +
        '" data-product-id="' +
        o +
        '" data-prank="' +
        e +
        '" data-unbxdparam_experience_widget="' +
        (n.widgetNum ? n.widgetNum.toUpperCase() : '') +
        '" data-unbxdparam_experience_pagetype="' +
        (n.pageType || '') +
        '" data-unbxdparam_sku="' +
        o +
        '" data-unbxdparam_requestId="' +
        (E || '') +
        '">' +
        b +
        '</div>'
      );
    }
    (window._unbxd_recsSliderScrollPrev = function (t) {
      var e = t.currentTarget || t.target.closest('button');
      if (!e || !e.disabled)
        try {
          var n = (e || t.target).closest('.unbxd-recs-slider'),
            r = n ? n.querySelector('._unbxd_recs-slider') : null;
          r && r.scrollBy({left: -r.clientWidth, behavior: 'smooth'});
        } catch (t) {
          console.error('[Unbxd Recs] Error scrolling slider prev:', t);
        }
    }),
      (window._unbxd_recsSliderScrollNext = function (t) {
        var e = t.currentTarget || t.target.closest('button');
        if (!e || !e.disabled)
          try {
            var n = (e || t.target).closest('.unbxd-recs-slider'),
              r = n ? n.querySelector('._unbxd_recs-slider') : null;
            r && r.scrollBy({left: r.clientWidth, behavior: 'smooth'});
          } catch (t) {
            console.error('[Unbxd Recs] Error scrolling slider next:', t);
          }
      });
    let g = 0;
    function i(t, e, n) {
      try {
        u = n;
        var r =
          0 === (c = window._unbxd_recs_containers || []).length
            ? null
            : ((l = void 0 !== u ? u : g) < c.length ? ((l = c[l]), void 0 === u && g++, l) : c[c.length - 1])
                .elementId;
        if (r) {
          var o = document.getElementById(r);
          if (o) {
            var i = t.recommendations || [];
            if (0 !== i.length) {
              var s = ((t, n) => {
                var e = (t.widgetTitle || '').replace(/^[^-]+-\s*/, '');
                if (0 === (t = t.recommendations || []).length) return '';
                let r = '';
                return (
                  t.forEach(function (t, e) {
                    r += f(t, e, n);
                  }),
                  (t = 4 < t.length),
                  `
            <div class='unbxd-recs-slider'>
                <div class='_unbxd_recs-slider-header'>
                 <h1 class='fw-400 fs-32 lh-1-1 ff-proxima-nova text-nn-purple mb-0' id='_unbxd_recs-slider-heading' tabIndex='0'>${e}</h1>
                    <div class='_unbxd_recs-slider-controls'>
                        <a href='/collections/best-sellers' class='_unbxd_recs-slider-see-all'>See all</a>
                    </div>
                </div>
                <div class='_unbxd_recs-slider-container' id='_unbxd_recs-slider-container'>
                    ${
                      t
                        ? `
                    <button type='button' aria-label='Previous' class='slider-arrow slider-prev slick-arrow' onclick='_unbxd_recsSliderScrollPrev(event)'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--chevron-left" aria-label="Chevron Left Icon"><path d="m15 18-6-6 6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path></svg>
                    </button>`
                        : ''
                    }
                    <div class='_unbxd_recs-slider' id='_unbxd_recs-slider'>
                        ${r}
                    </div>
                    ${
                      t
                        ? `
                    <button type='button' aria-label='Next' class='slider-arrow slider-next slick-arrow' onclick='_unbxd_recsSliderScrollNext(event)'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--chevron-right" aria-label="Chevron Right Icon"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path></svg>
                    </button>`
                        : ''
                    }
                </div>
            </div>`
                );
              })(t, e);
              o.innerHTML = s;
              let i = o.querySelector('.unbxd-recs-slider');
              if (i) {
                var a = i.querySelector('._unbxd_recs-slider');
                if (a) {
                  let t = function () {
                    var t, e, n, r, o;
                    (t = i) &&
                      ((r = t.querySelector('._unbxd_recs-slider')),
                      (e = t.querySelector('.slider-prev')),
                      (t = t.querySelector('.slider-next')),
                      r) &&
                      e &&
                      t &&
                      ((n = r.scrollLeft),
                      (o = (r = r.scrollWidth - r.clientWidth) <= 0 || r - 2 <= n),
                      (e.disabled = r = r <= 0 || n <= 2),
                      (t.disabled = o),
                      e.setAttribute('aria-disabled', r ? 'true' : 'false'),
                      t.setAttribute('aria-disabled', o ? 'true' : 'false'),
                      e.classList.toggle('slider-arrow--disabled', r),
                      t.classList.toggle('slider-arrow--disabled', o));
                  };
                  a.addEventListener('scroll', t),
                    requestAnimationFrame(function () {
                      t();
                    });
                  var p = a;
                  if (p) {
                    let o = !1,
                      i = 0,
                      s = 0,
                      a = !1,
                      u = 0,
                      l = 0,
                      c = 0,
                      t = null;
                    function d() {
                      t && (cancelAnimationFrame(t), (t = null)), p.classList.remove('is-momentum');
                    }
                    function h() {
                      (u *= 0.92), Math.abs(u) < 0.4 ? d() : ((p.scrollLeft += u), (t = requestAnimationFrame(h)));
                    }
                    p.addEventListener('mousedown', function (t) {
                      0 === t.button &&
                        (d(),
                        (o = !0),
                        (a = !1),
                        (i = t.pageX - p.offsetLeft),
                        (s = p.scrollLeft),
                        (l = t.pageX),
                        (c = performance.now()),
                        (u = 0),
                        p.classList.add('is-dragging'),
                        t.preventDefault());
                    }),
                      document.addEventListener('mouseup', function () {
                        o &&
                          ((o = !1), p.classList.remove('is-dragging'), 0.4 < Math.abs(u)) &&
                          (p.classList.add('is-momentum'), (t = requestAnimationFrame(h)));
                      }),
                      document.addEventListener('mousemove', function (t) {
                        var e, n, r;
                        o &&
                          (t.preventDefault(),
                          (e = t.pageX - p.offsetLeft - i),
                          4 < Math.abs(e) && (a = !0),
                          0 < (r = (n = performance.now()) - c) &&
                            ((r = ((l - t.pageX) / r) * 16), (u = Math.max(-40, Math.min(40, r)))),
                          (l = t.pageX),
                          (c = n),
                          (p.scrollLeft = s - e));
                      }),
                      p.addEventListener(
                        'click',
                        function (t) {
                          a && (t.preventDefault(), t.stopPropagation(), (a = !1));
                        },
                        !0
                      );
                  }
                }
              }
            }
          }
        }
      } catch (t) {
        console.error('[Unbxd Recs] Error rendering widget:', t);
      }
      var u, l, c;
    }
    function s() {
      n &&
        fetch(n)
          .then(function (t) {
            if (t.ok) return t.json();
            throw new Error('Network response was not ok: ' + t.status);
          })
          .then(function (t) {
            if (t && t.response && t.response.widgets) {
              var e = t.response.widgets;
              let n = window.unbxdRequestId || (t.recsMetaData && t.recsMetaData.requestId) || 'req-' + Date.now();
              e.forEach(function (t, e) {
                i(t, {widgetNum: t.widgetId || '', pageType: r && r.pageType ? r.pageType : 'Home', requestId: n}, e);
              });
            }
          })
          .catch(function (t) {
            console.error('[Unbxd Recs] Error fetching recommendations:', t);
          });
    }
    'loading' === document.readyState
      ? document.addEventListener('DOMContentLoaded', function () {
          e(), s();
        })
      : (e(), s());
  })();
let defaultImageUrl = '/assets/placeholder.svg',
  AUTOSUGGEST_IMAGE_SIZES = [320, 480, 640, 800, 960];
function createImageDataSrcSet(t, e) {
  var n,
    r = Array.isArray(t) ? t[0] : String(t || ''),
    o = [];
  for (n of e) {
    var i = r.includes('?') ? r + '&width=' + n : r + '?width=' + n;
    o.push(i + ` ${n}w`);
  }
  return o.join(',');
}
function createImage(t, e, n) {
  t = Array.isArray(t) ? t[0] : String(t || '');
  return `<img class="product-media__image lazyautosizes lazyloaded" data-aspectratio="1.0" data-sizes="auto" src="${t}" alt="${e}"
      srcset="${createImageDataSrcSet(t, n)}" width="" height="" loading="eager" sizes="(min-width: 1740px) 20vw, (min-width: 1392px) 25vw, (min-width: 1044px) 33vw, (min-width: 750px) 50vw, 100vw"
      transitiontoproduct="false" data_max_resolution="${t}" fetchpriority="auto"/>`;
}
function applyRegionToRedirectUrl(e) {
  if (!e) return e;
  var t = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
    t = '/' === t ? '' : t.replace(/\/$/, '');
  let n;
  if (/^https?:\/\//.test(e))
    try {
      var r = new URL(e),
        o = window.location.hostname.replace(/^www\./, '');
      if (r.hostname.replace(/^www\./, '') !== o) return e;
      n = r.pathname + r.search + r.hash;
    } catch (t) {
      return e;
    }
  else n = e.startsWith('/') ? e : '/' + e;
  return t ? ((o = n.startsWith(t + '/') ? n : t + n), window.location.origin + o) : window.location.origin + n;
}
function navigateWithRedirectCheck(t, e, n, r) {
  let o = (t || '').trim();
  t =
    'https://search.unbxd.io/' +
    e +
    '/' +
    n +
    '/search?q=' +
    encodeURIComponent(o) +
    '&rows=0&facet=off&indent=off&analytics=false';
  $.ajax({
    url: t,
    dataType: 'jsonp',
    jsonp: 'json.wrf',
    cache: !0,
    timeout: 3e3,
    success: function (t) {
      t = t && t.redirect;
      r(t && 'url' === t.type && t.value ? applyRegionToRedirectUrl(t.value) : buildSearchUrl(o));
    },
    error: function () {
      r(buildSearchUrl(o));
    },
  });
}
let getActiveCountryCodeAS = () => (window.Shopify && window.Shopify.country) || null,
  buildSearchUrl = (t) => {
    var e = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, ''),
      t = t && '' !== t.trim() ? t.trim() : '';
    return t
      ? window.location.origin + e + '/search?q=' + encodeURIComponent(t)
      : window.location.origin + e + '/search';
  },
  isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    },
  },
  unbxdAsInputSelector = '.modal__body input.search__input',
  PopularproductCount = 4,
  keywordSuggestionsCount = 6,
  topQueriesCount = 5,
  hardcodedTopQueries = ['Essentials', 'Sale', 'Outlet'],
  hardcodedKeywordSuggestions = ['Jeans', 'Dresses', 'Raincoats', 'Pants', 'Denim', 'Blazer', 'Shoes', 'Belt', 'Monet'],
  hardcodedPopularProducts = [],
  _popularProductsFetching = !1,
  fetchMostLovedProducts = () => {
    var t;
    _popularProductsFetching ||
      0 < hardcodedPopularProducts.length ||
      ((_popularProductsFetching = !0),
      (t = (t = getActiveCountryCodeAS()) ? '&filter=available_markets%3A%22' + t + '%22' : ''),
      (t =
        'https://search.unbxd.io/' +
        getApiKey() +
        '/' +
        getSiteName() +
        '/category?p=category_handle_uFilter%3A%22most-loved%22&variants=true&variants.fields=v_availableForSale%2Cv_Size%2Cv_Color%2CvariantId&variants.count=100&variants.groupBy=price&fields=title%2Cid%2CuniqueId%2Cavailable%2Cavailability%2Cprice%2Csku%2CimageUrl%2CproductUrl%2Cimages%2Cvariants%2Cprice_AUD%2Cprice_NZD%2Cprice_USD%2CcompareAtPrice_AUD%2CcompareAtPrice_NZD%2CcompareAtPrice_USD%2Chandle&pagetype=boolean&rows=' +
        PopularproductCount +
        '&start=0&version=V2&viewType=GRID&facet.version=V2' +
        t),
      $.ajax({
        url: t,
        dataType: 'jsonp',
        jsonp: 'json.wrf',
        cache: !0,
        timeout: 5e3,
        success: function (t) {
          t = t && t.response && t.response.products;
          t &&
            t.length &&
            ((hardcodedPopularProducts.length = 0), Array.prototype.push.apply(hardcodedPopularProducts, t)),
            (_popularProductsFetching = !1);
        },
        error: function () {
          _popularProductsFetching = !1;
        },
      }));
  },
  buildPageUrl = (t) => {
    var e = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    return window.location.origin + e + t;
  },
  getHelpBlockHtml = () =>
    `<li class="unbxd-as-help-block-li"><div data-testid="block-component" class="search-flyout__wrapper search-flyout__wrapper--links-list unbxd-as-help-block"><h4 class="search-flyout__title"><span>Explore More</span></h4><ul class="search-flyout__links-list"><li><a rel="" data-label="" href="${buildPageUrl('/pages/store-locator')}">Store Locator</a></li><li><a rel="" data-label="" href="${buildPageUrl('/pages/returns-exchanges')}">Return & Exchange</a></li><li><a rel="" data-label="" href="${buildPageUrl('/pages/faqs')}">FAQs</a></li><li><a rel="" data-label="" href="${buildPageUrl('/pages/ledition')}">Read Our Blog</a></li><li><a rel="" data-label="" href="${buildPageUrl('/pages/about-blue-illusion')}">About Blue Illusion</a></li></ul></div></li>`,
  wrapPopularProductsRow = () => {
    if (!(992 < window.innerWidth)) {
      var t = document.querySelector('.unbxd-as-maincontent');
      if (t) {
        var n = t.querySelector('.unbxd-as-popular-product-header');
        let e = t.querySelector('.unbxd-as-popular-products-row');
        e ||
          (((e = document.createElement('div')).className = 'unbxd-as-popular-products-row'),
          n && n.parentNode === t ? n.insertAdjacentElement('afterend', e) : t.appendChild(e));
        n = Array.from(t.querySelectorAll('.unbxd-as-popular-product')).filter(
          (t) => !t.parentElement || !t.parentElement.classList.contains('unbxd-as-popular-products-row')
        );
        n.length && n.forEach((t) => e.appendChild(t));
      }
    }
  },
  wrapTopQueryPills = () => {
    var t = document.querySelector('.unbxd-as-maincontent');
    if (t) {
      var n = t.querySelector('.unbxd-as-top-queries-header');
      if (n) {
        let e = t.querySelector('.unbxd-top-queries-pills-row');
        e ||
          (((e = document.createElement('li')).className = 'unbxd-top-queries-pills-row'),
          n.insertAdjacentElement('afterend', e)),
          Array.from(t.querySelectorAll('li.unbxd-as-keysuggestion[data-type="TOP_SEARCH_QUERIES"]'))
            .filter((t) => t.parentElement !== e)
            .forEach((t) => e.appendChild(t));
      }
    }
  },
  ensurePopularProductsRow = () => {
    if (!(992 < window.innerWidth)) {
      let t = 0,
        e = () => {
          (t += 1),
            wrapPopularProductsRow(),
            document.querySelector('.unbxd-as-popular-products-row') || 10 <= t || requestAnimationFrame(e);
        };
      requestAnimationFrame(e);
    }
  },
  addSeeMoreButtonToProductsHeader = () => {
    try {
      var t,
        e,
        n = document.querySelector('.unbxd-as-popular-product-header');
      n &&
        (document.querySelector(unbxdAsInputSelector)?.value?.trim(),
        (t = n.querySelector('.unbxd-see-all-btn'))
          ? ((t.style.display = ''), (t.style.visibility = 'visible'), (t.style.opacity = '1'))
          : (((e = document.createElement('p')).className = 'unbxd-see-all-btn'),
            (e.textContent = 'See All'),
            e.addEventListener('click', function (t) {
              t.stopPropagation();
              t = document.querySelector(unbxdAsInputSelector)?.value?.trim();
              t
                ? navigateWithRedirectCheck(t, getApiKey(), getSiteName(), function (t) {
                    window.location.href = t;
                  })
                : (window.location.href = applyRegionToRedirectUrl('https://blueillusion.com/collections/most-loved'));
            }),
            n.appendChild(e)));
    } catch (t) {
      console.error('Error adding see all button:', t);
    }
  },
  addCloseButton = () => {
    var t,
      e = document.querySelector('.unbxd-as-wrapper');
    e &&
      !e.querySelector('.unbxd-as-close-btn') &&
      (((t = document.createElement('div')).className = 'unbxd-as-close-btn'),
      (t.innerHTML = `
      <button type="button" class="unbxd-close-button" aria-label="Close autosuggest" title="Close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `),
      e.insertBefore(t, e.firstChild),
      t.querySelector('.unbxd-close-button').addEventListener('click', function (t) {
        t.preventDefault(), t.stopPropagation(), hideAutosuggest();
      }));
  },
  alignAutosuggestWithSearchBox = () => {
    var t,
      e,
      n,
      r = document.querySelector('.unbxd-as-wrapper');
    r &&
      (t =
        document.querySelector('.modal--search .modal__body .search__form') ||
        document.querySelector('.modal--search .container') ||
        document.querySelector('.modal__body')) &&
      ((t = t.getBoundingClientRect()),
      (n = (n = r.offsetParent) ? n.getBoundingClientRect() : {left: 0, top: 0}),
      (e = t.bottom - n.top),
      r.style.setProperty('top', e + 'px', 'important'),
      r.style.setProperty('margin-top', '0px', 'important'),
      window.innerWidth <= 992
        ? (r.style.removeProperty('left'),
          r.style.removeProperty('width'),
          r.style.removeProperty('min-width'),
          r.style.removeProperty('max-width'))
        : ((e = t.left - n.left),
          (n = t.width),
          r.style.setProperty('left', e + 'px', 'important'),
          r.style.setProperty('width', n + 'px', 'important'),
          r.style.setProperty('min-width', n + 'px', 'important'),
          r.style.setProperty('max-width', n + 'px', 'important')));
  },
  bodyScroll = {
    lock: () => {
      document.body.classList.add('unbxd-scroll-lock');
    },
    unlock: () => {
      document.body.classList.remove('unbxd-scroll-lock');
    },
  },
  _scrollLockObserverSetup = !1,
  setupScrollLockObserver = () => {
    if (!_scrollLockObserverSetup) {
      let t = document.querySelector('.unbxd-as-wrapper');
      t &&
        ((_scrollLockObserverSetup = !0),
        new MutationObserver(() => {
          'none' === t.style.display ? bodyScroll.unlock() : bodyScroll.lock();
        }).observe(t, {attributes: !0, attributeFilter: ['style']}));
    }
  },
  hideAutosuggest = () => {
    var t = document.querySelector('.unbxd-as-wrapper'),
      t = (t && (t.style.display = 'none'), document.querySelector(unbxdAsInputSelector));
    t && t.blur();
  },
  resultclassSelector = 'header.header',
  getUnbxdASConfig = () => {
    var t = getActiveCountryCodeAS(),
      t = t ? 'available_markets:' + t : '';
    return {
      siteName: getSiteName(),
      APIKey: getApiKey(),
      minChars: 0,
      loadingClass: 'unbxd-as-loading',
      resultsContainerSelector: resultclassSelector,
      sideContentOn: 'right',
      zIndex: 1e6,
      position: 'absolute',
      carttype: 'separate',
      isMobile: function () {
        return window.innerWidth <= 992 || isMobile.any();
      },
      sanitizeQueryString: function (t) {
        return t.trim();
      },
      customQueryParse: function (t) {
        t = t ? t.trim() : '';
        return '' === t ? '*' : t;
      },
      onItemSelect: function (t, e) {
        var n = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
          n = '/' === n ? '' : n.replace(/\/$/, '');
        return (
          'POPULAR_PRODUCTS' === t.type || 'POPULAR_PRODUCTS_FILTERED' === t.type
            ? e && e.productUrl && ((e = e.productUrl), (window.location.href = n + (e.startsWith('/') ? e : '/' + e)))
            : navigateWithRedirectCheck(
                (t.value || '').trim(),
                this.options.APIKey,
                this.options.siteName,
                function (t) {
                  window.location = t;
                }
              ),
          !1
        );
      },
      template: '2column',
      mainTpl: ['keywordSuggestions', 'promotedSuggestions', 'topQueries'],
      sideTpl: ['popularProducts'],
      theme: '#666666',
      mobile: {
        template: '1column',
        mainTpl: ['popularProducts', 'keywordSuggestions', 'topQueries'],
        popularProducts: {count: PopularproductCount},
      },
      trendingSearches: {enabled: !1},
      inFields: {count: 0},
      hardcodedTopQueries: hardcodedTopQueries,
      hardcodedKeywordSuggestions: hardcodedKeywordSuggestions,
      hardcodedPopularProducts: hardcodedPopularProducts,
      topQueries: {count: topQueriesCount, header: 'Trending'},
      promotedSuggestions: {count: 0},
      keywordSuggestions: {count: keywordSuggestionsCount, header: 'Top Searches'},
      noResultTpl: function (t) {
        return (
          '<div class="unbxd-as-no-results"><p>No results found for <strong>"' +
          decodeURIComponent(t) +
          '"</strong></p></div>'
        );
      },
      removeDuplicates: !0,
      filtered: !0,
      platform: 'io',
      hideOnResize: !1,
      removeOnBackButton: !1,
      searchEndPoint: 'https://search.unbxd.io',
      onSimpleEnter: function (t) {
        t.preventDefault(), t.stopImmediatePropagation(), t.stopPropagation();
        t = $(this.input).val().trim();
        t
          ? navigateWithRedirectCheck(t, this.options.APIKey, this.options.siteName, function (t) {
              window.location = t;
            })
          : (window.location = buildSearchUrl(t));
      },
      onShowResults: function () {
        setupScrollLockObserver(),
          bodyScroll.lock(),
          wrapPopularProductsRow(),
          wrapTopQueryPills(),
          addCloseButton(),
          alignAutosuggestWithSearchBox(),
          wrapPopularProductsRow(),
          wrapTopQueryPills(),
          addSeeMoreButtonToProductsHeader(),
          addCloseButton(),
          setTimeout(() => {
            wrapPopularProductsRow(),
              wrapTopQueryPills(),
              addSeeMoreButtonToProductsHeader(),
              addCloseButton(),
              alignAutosuggestWithSearchBox();
          }, 150),
          setTimeout(alignAutosuggestWithSearchBox, 400);
      },
      onRender: function () {
        wrapPopularProductsRow(),
          wrapTopQueryPills(),
          addSeeMoreButtonToProductsHeader(),
          addCloseButton(),
          alignAutosuggestWithSearchBox(),
          setTimeout(() => {
            wrapPopularProductsRow(),
              wrapTopQueryPills(),
              addSeeMoreButtonToProductsHeader(),
              addCloseButton(),
              alignAutosuggestWithSearchBox();
          }, 100),
          setTimeout(() => {
            wrapPopularProductsRow(),
              wrapTopQueryPills(),
              addSeeMoreButtonToProductsHeader(),
              addCloseButton(),
              alignAutosuggestWithSearchBox();
          }, 300);
      },
      popularProducts: {
        count: PopularproductCount,
        filter: t,
        price: !0,
        priceFunctionOrKey: 'price',
        image: !0,
        imageUrlOrFunction: 'imageUrl',
        header: 'Best Sellers',
        name: !0,
        nameFunctionOrKey: 'title',
        viewMore: {enabled: !0, tpl: getHelpBlockHtml(), redirect: function () {}},
        fields: [
          'doctype',
          'autosuggest',
          'price',
          'imageUrl',
          'title',
          'productUrl',
          'price_AUD',
          'price_NZD',
          'price_USD',
          'compareAtPrice_AUD',
          'compareAtPrice_NZD',
          'compareAtPrice_USD',
        ],
        tpl: [
          `<div class="unbxd-as-popular-product-info" href="{{regionUrl _original.productUrl}}">
           <a href="{{regionUrl _original.productUrl}}" class="unbxd-as-popular-product-image-container">
             {{{renderProductImage _original}}}
            </a>
            <h4 class="quick-search-results__title body-small">
              <a href="{{regionUrl _original.productUrl}}">{{_original.title}}</a>
            </h4>
            <p class="money body-small">{{{formatPrice _original}}}</p>
         </div>`,
        ],
      },
      hbsHelpers: function () {
        Handlebars.registerHelper('regionUrl', function (t) {
          return applyRegionToRedirectUrl(t || '');
        }),
          Handlebars.registerHelper('renderProductImage', function (t) {
            var e = t.imageUrl,
              e = null != e ? (Array.isArray(e) ? e[0] : String(e)) : defaultImageUrl;
            return new Handlebars.SafeString(createImage(e, t.title || '', AUTOSUGGEST_IMAGE_SIZES));
          }),
          Handlebars.registerHelper('getImageUrl', function (t) {
            return null != t.imageUrl ? t.imageUrl : defaultImageUrl;
          }),
          Handlebars.registerHelper('formatPrice', function (t) {
            var e,
              n = getActiveCountryCodeAS(),
              n =
                {
                  AU: {price: t.price_AUD, compareAt: t.compareAtPrice_AUD, currencyLabel: 'AUD'},
                  NZ: {price: t.price_NZD, compareAt: t.compareAtPrice_NZD, currencyLabel: 'NZD'},
                  US: {price: t.price_USD, compareAt: t.compareAtPrice_USD, currencyLabel: 'USD'},
                }[n] || null,
              t = (n && n.price) || t.price || '',
              r = (n && n.compareAt) || '',
              n = (n && n.currencyLabel) || '';
            return '' === t || null == t
              ? ''
              : ((e = parseFloat(t).toFixed(2)),
                (n = n ? ' ' + n : ''),
                r && parseFloat(r) > parseFloat(t)
                  ? ((t = parseFloat(r).toFixed(2)),
                    new Handlebars.SafeString(
                      '<span class="visually-hidden">Sale price</span><span>$' +
                        e +
                        n +
                        '</span><span class="visually-hidden">Regular price</span><span class="product-card__compare-price ns-font-4 ns-text-striked ns-ml-2">$' +
                        t +
                        n +
                        '</span>'
                    ))
                  : new Handlebars.SafeString('<span>$' + e + n + '</span>'));
          });
      },
    };
  },
  initUnbxdAs = () => {
    unbxdAutoSuggestFunction(jQuery, Handlebars);
    function r() {
      var t = jQuery(unbxdAsInputSelector);
      return !(!t.length || (!t[0].auto && (t.unbxdautocomplete(getUnbxdASConfig()), !t[0] || !t[0].auto)));
    }
    function e() {
      var n, t, e;
      r() &&
        (n = jQuery(unbxdAsInputSelector)).length &&
        ((t = n[0].auto)
          ? ((t.hasFocus = !0),
            (o = !0),
            n.focus(),
            (o = !1),
            (e = t.previous),
            (t.previous = '__FORCE_REFRESH__'),
            t.onChange(),
            (t.previous = e),
            ensurePopularProductsRow(),
            wrapTopQueryPills(),
            setTimeout(() => {
              wrapTopQueryPills(), addSeeMoreButtonToProductsHeader();
            }, 150),
            setTimeout(() => {
              wrapTopQueryPills(), addSeeMoreButtonToProductsHeader();
            }, 300))
          : (n.unbxdautocomplete(getUnbxdASConfig()),
            setTimeout(function () {
              var t,
                e = n[0].auto;
              e &&
                ((e.hasFocus = !0),
                (t = e.previous),
                (e.previous = '__FORCE_REFRESH__'),
                e.onChange(),
                (e.previous = t),
                ensurePopularProductsRow(),
                wrapTopQueryPills(),
                addSeeMoreButtonToProductsHeader());
            }, 150)));
    }
    var o = !1;
    jQuery(document).on('focus', unbxdAsInputSelector, function () {
      var t, e;
      o ||
        (r() &&
          ((e = this.auto)
            ? ((t = e.previous),
              (e.previous = '__FORCE_REFRESH__'),
              e.onChange(),
              (e.previous = t),
              wrapPopularProductsRow(),
              wrapTopQueryPills(),
              addSeeMoreButtonToProductsHeader(),
              setTimeout(() => {
                wrapTopQueryPills(), addSeeMoreButtonToProductsHeader();
              }, 150),
              setTimeout(() => {
                wrapTopQueryPills(), addSeeMoreButtonToProductsHeader();
              }, 300))
            : ((e = jQuery(this)).unbxdautocomplete(getUnbxdASConfig()),
              e[0] && e[0].auto && ((e[0].auto.previous = '__FORCE_REFRESH__'), e[0].auto.onChange()))));
    });
    jQuery(document).on('click', unbxdAsInputSelector, function () {
      console.log('Click event triggered on input'), e();
    }),
      jQuery(document).on('mousedown', 'button.modal__trigger.header__btn.header__btn--search', function () {
        o = !0;
      }),
      jQuery(document).on('click', 'button.modal__trigger.header__btn.header__btn--search', function () {
        console.log('Click event triggered on search button'),
          setTimeout(function () {
            o = !1;
            var t = jQuery(unbxdAsInputSelector);
            t.length && t.is(':visible') && (e(), setTimeout(alignAutosuggestWithSearchBox, 200));
          }, 300);
      }),
      jQuery(document).on('input keyup', unbxdAsInputSelector, function () {
        setTimeout(() => {
          addSeeMoreButtonToProductsHeader();
        }, 50),
          setTimeout(() => {
            addSeeMoreButtonToProductsHeader();
          }, 300),
          setTimeout(adjustMobileAsWrapperHeight, 100),
          setTimeout(adjustMobileAsWrapperHeight, 400);
      }),
      jQuery(document).on(
        'mouseenter',
        '.unbxd-as-keysuggestion, .unbxd-as-topquery, .unbxd-as-promoted-suggestion',
        function () {
          addSeeMoreButtonToProductsHeader(),
            setTimeout(addSeeMoreButtonToProductsHeader, 100),
            setTimeout(addSeeMoreButtonToProductsHeader, 300),
            setTimeout(addSeeMoreButtonToProductsHeader, 600);
        }
      );
  },
  MOBILE_BREAKPOINT = 992,
  WRAPPER_BOTTOM_GAP = 10,
  adjustMobileAsWrapperHeight = () => {
    var t, e;
    window.innerWidth > MOBILE_BREAKPOINT ||
      ((t = document.querySelector('.unbxd-as-wrapper.unbxd-as-overall-autosuggest')) &&
        'none' !== t.style.display &&
        ((e = t.getBoundingClientRect()),
        100 <
          (e =
            (window.visualViewport ? window.visualViewport.height : window.innerHeight) -
            e.top -
            WRAPPER_BOTTOM_GAP)) &&
        t.style.setProperty('max-height', e + 'px', 'important'));
  };
document.addEventListener('DOMContentLoaded', function () {
  fetchMostLovedProducts(), initUnbxdAs();
  let t;
  window.addEventListener('resize', function () {
    clearTimeout(t),
      (t = setTimeout(() => {
        alignAutosuggestWithSearchBox(), adjustMobileAsWrapperHeight();
      }, 100));
  }),
    window.visualViewport && window.visualViewport.addEventListener('resize', adjustMobileAsWrapperHeight);
}),
  jQuery(document).on('click', '.unbxd-see-all-btn', function (t) {
    t.stopPropagation();
    t = document.querySelector(unbxdAsInputSelector)?.value?.trim();
    t
      ? navigateWithRedirectCheck(t, getApiKey(), getSiteName(), function (t) {
          window.location.href = t;
        })
      : (window.location.href = applyRegionToRedirectUrl('https://blueillusion.com/collections/most-loved'));
  });
var unbxdAutoSuggestFunction = function (d, u, n) {
  (window.Unbxd = window.Unbxd || {}),
    (Unbxd.autosuggestVersion = '1.0.1'),
    window.location.origin ||
      (window.location.origin =
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '')),
    Array.prototype.forEach ||
      (Array.prototype.forEach = function (t, e) {
        var n;
        if (null == this) throw new TypeError(' this is null or not defined');
        var r = Object(this),
          o = r.length >>> 0;
        if ('function' != typeof t) throw new TypeError(t + ' is not a function');
        1 < arguments.length && (n = e);
        for (var i, s = 0; s < o; ) s in r && ((i = r[s]), t.call(n, i, s, r)), s++;
      }),
    Array.prototype.indexOf ||
      (Array.prototype.indexOf = function (t, e) {
        var n;
        if (null == this) throw new TypeError('"this" is null or not defined');
        var r = Object(this),
          o = r.length >>> 0;
        if (0 != o) {
          e = +e || 0;
          if (!(o <= (e = Math.abs(e) === 1 / 0 ? 0 : e)))
            for (n = Math.max(0 <= e ? e : o - Math.abs(e), 0); n < o; ) {
              if (n in r && r[n] === t) return n;
              n++;
            }
        }
        return -1;
      });
  function h(t, e) {
    return t.length - e.length == 0 ? t.localeCompare(e) : t.length - e.length;
  }
  var l = '',
    c = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return c.Android() || c.BlackBerry() || c.iOS() || c.Opera() || c.Windows();
      },
    };
  function e(t, e) {
    (this.input = t), this.init(t, e);
  }
  u.registerHelper('unbxdIf', function (t, e, n) {
    return t === e ? n.fn(this) : n.inverse(this);
  }),
    u.registerHelper('safestring', function (t) {
      return new u.SafeString(t);
    }),
    (window.autoSuggestObj = d.extend(e.prototype, {
      default_options: {
        siteName: 'demosite-u1407617955968',
        APIKey: '64a4a2592a648ac8415e13c561e44991',
        integrations: {},
        resultsClass: 'unbxd-as-wrapper',
        minChars: 3,
        delay: 100,
        loadingClass: 'unbxd-as-loading',
        mainWidth: 0,
        sideWidth: 180,
        zIndex: 1e4,
        position: 'absolute',
        sideContentOn: 'right',
        template: '1column',
        theme: '#ff8400',
        hideOnResize: !1,
        mainTpl: ['inFields', 'keywordSuggestions', 'topQueries', 'popularProducts', 'promotedSuggestions'],
        sideTpl: [],
        showCarts: !0,
        cartType: 'inline',
        onCartClick: function (t) {},
        hbsHelpers: null,
        onSimpleEnter: null,
        onItemSelect: null,
        noResultTpl: null,
        mobile: {
          template: '1column',
          mainTpl: ['inFields', 'keywordSuggestions', 'topQueries', 'promotedSuggestions', 'popularProducts'],
          popularProducts: {count: 2},
        },
        trendingSearches: {enabled: !0, tpl: '{{{safestring highlighted}}}', maxCount: 6, preferInputWidthTrending: !0},
        inFields: {
          count: 2,
          fields: {brand: 3, category: 3, color: 3},
          header: '',
          tpl: '{{{safestring highlighted}}}',
        },
        topQueries: {count: 2, hidden: !1, header: '', tpl: '{{{safestring highlighted}}}'},
        keywordSuggestions: {count: 2, header: '', tpl: '{{{safestring highlighted}}}'},
        promotedSuggestions: {count: 3, tpl: '{{{safestring highlighted}}}'},
        suggestionsHeader: '',
        popularProducts: {
          count: 2,
          price: !0,
          priceFunctionOrKey: 'price',
          name: !0,
          nameFunctionOrKey: 'title',
          salePrice: !1,
          salePriceKey: '',
          image: !0,
          imageUrlOrFunction: 'imageUrl',
          currency: 'Rs.',
          header: '',
          view: 'list',
          tpl: [
            '{{#if ../showCarts}}',
            '{{#unbxdIf ../../cartType "inline"}}',
            '<div class="unbxd-as-popular-product-inlinecart">',
            '<div class="unbxd-as-popular-product-image-container">',
            '{{#if image}}',
            '<img src="{{image}}" alt="{{autosuggest}}"/>',
            '{{/if}}',
            '</div>',
            '<div  class="unbxd-as-popular-product-name popular-title">',
            '<div style="table-layout:fixed;width:100%;display:table;">',
            '<div style="display:table-row">',
            '<div style="display:table-cell;text-overflow:ellipsis;overflow: hidden;white-space: nowrap;">',
            '{{{safestring highlighted}}}',
            '</div>',
            '</div>',
            '</div>',
            '</div>',
            '{{#if price}}',
            '<div class="unbxd-as-popular-product-price">',
            '{{#if salePrice}}',
            '<span class="regular-price">',
            '{{currency}}{{price}}',
            '</span>',
            '<span class="unbxd-as-discount">',
            '{{currency}}{{salePrice}}',
            '</span>',
            '{{else}}',
            '{{currency}}{{price}}',
            '{{/if}}',
            '</div>',
            '{{/if}}',
            '<div class="unbxd-as-popular-product-quantity">',
            '<div class="unbxd-as-popular-product-quantity-container">',
            '<span>Qty</span>',
            '<input class="unbxd-popular-product-qty-input" value="1"/>',
            '</div>',
            '</div>',
            '<div class="unbxd-as-popular-product-cart-action">',
            '<button class="unbxd-as-popular-product-cart-button">Add to cart</button>',
            '</div>',
            '</div>',
            '{{else}}',
            '<div class="unbxd-as-popular-product-info">',
            '<div class="unbxd-as-popular-product-image-container">',
            '{{#if image}}',
            '<img src="{{image}}" alt="{{autosuggest}}"/>',
            '{{/if}}',
            '</div>',
            '<div>',
            '<div  class="unbxd-as-popular-product-name popular-title">',
            '{{{safestring highlighted}}}',
            '</div>',
            '<div class="unbxd-as-popular-product-cart">',
            '<div class="unbxd-as-popular-product-cart-action">',
            '<button class="unbxd-as-popular-product-cart-button">Add to cart</button>',
            '</div>',
            '<div class="unbxd-as-popular-product-quantity">',
            '<div class="unbxd-as-popular-product-quantity-container">',
            '<span>Qty</span>',
            '<input class="unbxd-popular-product-qty-input" value="1"/>',
            '</div>',
            '</div>',
            '{{#if price}}',
            '<div class="unbxd-as-popular-product-price">',
            '{{#if salePrice}}',
            '<span class="regular-price">',
            '{{currency}}{{price}}',
            '</span>',
            '<span class="unbxd-as-discount">',
            '{{currency}}{{salePrice}}',
            '</span>',
            '{{else}}',
            '{{currency}}{{price}}',
            '{{/if}}',
            '</div>',
            '{{/if}}',
            '</div>',
            '</div>',
            '</div>',
            '{{/unbxdIf}}',
            '{{else}}',
            '<div class="unbxd-as-popular-product-info">',
            '<div class="unbxd-as-popular-product-image-container">',
            '{{#if image}}',
            '<img src="{{image}}" alt="{{autosuggest}}"/>',
            '{{/if}}',
            '</div>',
            '<div  class="unbxd-as-popular-product-name popular-title">',
            '{{{safestring highlighted}}}',
            '</div>',
            '{{#if price}}',
            '<div class="unbxd-as-popular-product-price">',
            '{{#if salePrice}}',
            '<span class="regular-price">',
            '{{currency}}{{price}}',
            '</span>',
            '<span class="unbxd-as-discount">',
            '{{currency}}{{salePrice}}',
            '</span>',
            '{{else}}',
            '{{currency}}{{price}}',
            '{{/if}}',
            '</div>',
            '{{/if}}',
            '</div>',
            '{{/if}}',
          ].join(''),
          viewMore: {enabled: !1, tpl: '', redirect: function () {}},
        },
        removeDuplicates: !1,
        filtered: !1,
        preferInputWidthTotalContent: !1,
        platform: 'com',
        sortedSuggestions: {tpl: '{{{safestring highlighted}}}'},
        removeOnBackButton: !1,
        resultsContainerSelector: null,
        processResultsStyles: null,
        inputContainerSelector: '',
        getProductsInfo: function (t) {
          return t.productInfo;
        },
        searchEndPoint: '//search.unbxd.io',
      },
      productInfo: {},
      $input: null,
      $results: null,
      timeout: null,
      previous: '',
      activeRow: -1,
      activeColumn: 0,
      keyb: !1,
      compiledPopularProductHeader: '',
      hasFocus: !1,
      lastKeyPressCode: null,
      ajaxCall: null,
      currentResults: [],
      currentTopResults: [],
      cache: {},
      params: {query: '*', filters: {}},
      preferOneColumnFullWidth: !1,
      selectedClass: 'unbxd-ac-selected',
      scrollbarWidth: null,
      getPopularProductsHeader: function (t) {
        var e = t.options.popularProducts.header,
          n = '';
        return 'string' == typeof e ? (n = e) : 'function' == typeof e && (n = e(t)), n;
      },
      init: function (t, e) {
        var o;
        (this.options = d.extend({}, this.default_options, e)),
          this.setDefaultPopularProductsOptions(),
          this.setDefaultOptions(),
          this.getPopularProductFields(),
          (this.$input = d(t).attr('autocomplete', 'off')),
          (this.$results = d('<div/>', {class: this.options.resultsClass + ' unbxd-as-overall-autosuggest'})
            .css('position', 'relative' === this.options.position ? 'absolute' : this.options.position)
            .hide()),
          0 < this.options.zIndex && this.$results.css('zIndex', this.options.zIndex),
          ('string' == typeof this.options.resultsContainerSelector && this.options.resultsContainerSelector.length
            ? d(this.options.resultsContainerSelector)
            : d('body')
          ).append(this.$results),
          'function' == typeof this.options.hbsHelpers && this.options.hbsHelpers.call(this),
          this.options.trendingSearches.enabled &&
            ((this.trendingQueries = []),
            (e =
              (this.options.searchEndPoint ? this.options.searchEndPoint + '/' : 'https://search.unbxd.io/') +
              this.options.APIKey +
              '/' +
              this.options.siteName +
              '/autosuggest?trending-queries=true&q=*'),
            (o = this),
            d
              .ajax({url: e, method: 'GET'})
              .done(function (t) {
                if (t && t.response.products && 0 < t.response.products.length) {
                  var e = t.response.products.splice(0, o.options.trendingSearches.maxCount);
                  o.clickResults || (o.clickResults = {}), (o.clickResults.TRENDING_QUERIES = e);
                  for (var n = 0; n < e.length; n++) {
                    var r = e[n];
                    o.processTrendingQueries(r);
                  }
                  o.$results.html('');
                  t = u.compile(o.prepareTrendingQueriesHTML());
                  o.$results.html(t({data1: o.trendingQueries}));
                }
              })
              .fail(function (t) {
                console.log('error', t);
              })),
          this.wire();
      },
      wire: function () {
        var i = this;
        this.$input.bind('keydown.auto', this.keyevents()),
          this.$input.bind('select.auto', function () {
            i.log('select : setting focus'), (i.hasFocus = !0);
          }),
          d('.unbxd-as-wrapper').on('mouseover', 'ul.unbxd-as-maincontent', function (t) {
            var e, n, r, o;
            d.contains(i.$results[0], t.target) &&
              i.options.filtered &&
              (d('.' + i.selectedClass).removeClass(i.selectedClass),
              d(t.target).addClass(i.selectedClass),
              (n = e = d(t.target)),
              (i.hasFocus = !1),
              'LI' !== t.target.tagName && (n = e.parents('li')),
              (e = d(n).attr('data-value') ? d(n).attr('data-value') : ''),
              (r = d(n).attr('data-filtername') ? d(n).attr('data-filtername') : ''),
              (o = d(n).attr('data-filtervalue') ? d(n).attr('data-filtervalue') : ''),
              !n ||
                n.hasClass('unbxd-as-header') ||
                n.hasClass('unbxd-as-popular-product') ||
                n.hasClass('topproducts') ||
                'INPUT' === t.target.tagName ||
                (e &&
                  ((n = e + ('' != r ? ':' + r + ':' + o : '')),
                  i.options.filtered &&
                    ((t = i.getPopularProductsHeader(i)),
                    (r = u.compile(t)),
                    (i.compiledPopularProductHeader = r({hoverSuggestion: e}))),
                  (o = ''),
                  (o =
                    i.options.popularProducts.viewMore && i.options.popularProducts.viewMore.enabled
                      ? (('1column' === i.options.template
                          ? d('.unbxd-as-maincontent')
                          : d('.unbxd-as-sidecontent')
                        ).addClass('unbxd-as-view-more'),
                        u.compile(i.preparefilteredPopularProducts() + i.options.popularProducts.viewMore.tpl))
                      : u.compile(i.preparefilteredPopularProducts())),
                  i.currentTopResults[n] && 0 < i.currentTopResults[n].length
                    ? d('.unbxd-as-sidecontent').html(
                        o({data: i.currentTopResults[n], showCarts: i.options.showCarts, cartType: i.options.cartType})
                      )
                    : d('.unbxd-as-sidecontent').html(
                        o({
                          data: i.currentResults.POPULAR_PRODUCTS,
                          showCarts: i.options.showCarts,
                          cartType: i.options.cartType,
                        })
                      ),
                  (i.hoveredQuery = e)),
                'grid' === i.options.popularProducts.view &&
                  i.options.popularProducts.rowCount &&
                  d('.unbxd-as-sidecontent')
                    .find('li.unbxd-as-popular-product-grid')
                    .css('width', 100 / i.options.popularProducts.rowCount + '%')));
          }),
          d(window).bind('resize', function () {
            i.options.hideOnResize && i.hideResults();
          }),
          window.addEventListener('popstate', function (t) {
            i.options.removeOnBackButton && d('.unbxd-as-wrapper').hide();
          }),
          d(document).bind('click.auto', function (t) {
            var e, n, r, o;
            t.target == i.input
              ? (i.log('clicked on input : focused'),
                (i.hasFocus = !0),
                i.previous === i.$input.val() &&
                  (i.$results.find('.unbxd-as-trending').length ||
                    ((i.$results.find('.unbxd-as-maincontent').length ||
                      i.$results.find('.unbxd-as-sidecontent').length) &&
                      i.$results.html(i.prepareHTML())),
                  i.showResults()))
              : t.target == i.$results[0]
                ? (i.log('clicked on results block : selecting'), (i.hasFocus = !1))
                : d(t.target).hasClass('unbxd-as-view-more')
                  ? i.options.popularProducts.viewMore.redirect(i.hoveredQuery || i.$input.val())
                  : d.contains(i.$results[0], t.target)
                    ? (i.log('clicked on element for selection', t.target.tagName),
                      (e = n = d(t.target)),
                      (i.hasFocus = !1),
                      (e = 'LI' !== t.target.tagName ? n.parents('li') : e) &&
                        !e.hasClass('.unbxd-as-header') &&
                        'INPUT' != t.target.tagName &&
                        ('BUTTON' == t.target.tagName &&
                        n.hasClass('unbxd-as-popular-product-cart-button') &&
                        'function' == typeof i.options.onCartClick
                          ? (i.log('BUTTON click'),
                            ((n = e.data()).quantity = parseFloat(
                              e.find('input.unbxd-popular-product-qty-input').val()
                            )),
                            (r = {}),
                            (o = {}),
                            n.pid && ((r.pid = n.pid), (o.pid = n.pid)),
                            Object.keys(r).length && i.addToAnalytics('click', r),
                            i.options.onCartClick.call(
                              i,
                              n,
                              i.currentResults.POPULAR_PRODUCTS[parseInt(n.index)]._original
                            ) && i.hideResults(),
                            n.quantity && (o.qty = n.quantity),
                            Object.keys(o).length && i.addToAnalytics('addToCart', o))
                          : i.selectItem(e.data(), t)))
                    : ((i.hasFocus = !1), i.hideResults());
          }),
          i.options.trendingSearches.enabled &&
            i.clickResults &&
            i.clickResults.TRENDING_QUERIES.length &&
            d(document).bind('keyup.auto', function (t) {
              '' === t.target.value &&
                (i.$results.html(''),
                (t = u.compile(i.prepareTrendingQueriesHTML())),
                i.$results.html(t({data1: i.trendingQueries})),
                i.showResults());
            });
      },
      keyevents: function () {
        var e = this;
        if (!n || !n.selfServe)
          return function (t) {
            switch (((e.lastKeyPressCode = t.keyCode), (e.lastKeyEvent = t).keyCode)) {
              case 38:
                t.preventDefault(), e.moveSelect(-1);
                break;
              case 40:
                t.preventDefault(), e.moveSelect(1);
                break;
              case 39:
                -1 < e.activeRow && (t.preventDefault(), e.moveSide(1));
                break;
              case 37:
                -1 < e.activeRow && (t.preventDefault(), e.moveSide(-1));
                break;
              case 9:
              case 13:
                e.selectCurrent(t) ? t.preventDefault() : e.hideResultsNow();
                break;
              default:
                (e.activeRow = -1),
                  d('.' + e.selectedClass).removeClass(e.selectedClass),
                  (e.hasFocus = !0),
                  e.timeout && clearTimeout(e.timeout),
                  (e.timeout = setTimeout(
                    ((r = function () {
                      e.onChange();
                    }),
                    (o = 250),
                    function () {
                      var t = this,
                        e = arguments,
                        n = i && !s;
                      clearTimeout(s),
                        (s = setTimeout(function () {
                          (s = null), i || r.apply(t, e);
                        }, o)),
                        n && r.apply(t, e);
                    }),
                    e.options.delay
                  ));
            }
            var r, o, i, s;
          };
        e.onChange();
      },
      moveSide: function (t) {
        var e = this.activeColumn;
        '2column' == this.options.template &&
          ('left' == this.options.sideContentOn
            ? (0 == this.activeColumn && -1 == t && (e = 1), 1 == this.activeColumn && 1 == t && (e = 0))
            : (0 == this.activeColumn && 1 == t && (e = 1), 1 == this.activeColumn && -1 == t && (e = 0)),
          e != this.activeColumn) &&
          ((this.activeColumn = e), (this.activeRow = -1), this.moveSelect(1));
      },
      moveSelect: function (t) {
        var e,
          n,
          r = this.$results
            .find('ul.' + (this.activeColumn ? 'unbxd-as-sidecontent' : 'unbxd-as-maincontent'))
            .find('li:not(.unbxd-as-header)');
        r &&
          ((this.activeRow += t),
          this.activeRow < -1
            ? (this.activeRow = ('function' == typeof r.size ? r.size() : r.length) - 1)
            : -1 == this.activeRow
              ? this.$input.focus()
              : this.activeRow >= ('function' == typeof r.size ? r.size() : r.length) &&
                ((this.activeRow = -1), this.$input.focus()),
          d('.' + this.selectedClass).removeClass(this.selectedClass),
          d(r[this.activeRow]).addClass(this.selectedClass),
          0 <= this.activeRow && this.activeRow < ('function' == typeof r.size ? r.size() : r.length)
            ? (this.$input.val(d(r[this.activeRow]).data('value')),
              this.options.filtered &&
                0 === this.activeColumn &&
                ((t = d(r[this.activeRow]).attr('data-value') ? d(r[this.activeRow]).attr('data-value') : ''),
                (e = d(r[this.activeRow]).attr('data-filtername') ? d(r[this.activeRow]).attr('data-filtername') : ''),
                (r = d(r[this.activeRow]).attr('data-filtervalue')
                  ? d(r[this.activeRow]).attr('data-filtervalue')
                  : ''),
                (e = t + ('' != e ? ':' + e + ':' + r : '')),
                this.options.filtered &&
                  ((r = this.getPopularProductsHeader(this)),
                  (r = u.compile(r)),
                  (this.compiledPopularProductHeader = r({hoverSuggestion: t}))),
                (n = ''),
                (n =
                  this.options.popularProducts.viewMore && this.options.popularProducts.viewMore.enabled
                    ? (d('.unbxd-as-sidecontent').addClass('unbxd-as-view-more'),
                      u.compile(this.preparefilteredPopularProducts() + this.options.popularProducts.viewMore.tpl))
                    : u.compile(this.preparefilteredPopularProducts())),
                this.currentTopResults[e] && 0 < this.currentTopResults[e].length
                  ? d('.unbxd-as-sidecontent').html(
                      n({
                        data: this.currentTopResults[e],
                        showCarts: this.options.showCarts,
                        cartType: this.options.cartType,
                      })
                    )
                  : d('.unbxd-as-sidecontent').html(
                      n({
                        data: this.currentResults.POPULAR_PRODUCTS,
                        showCarts: this.options.showCarts,
                        cartType: this.options.cartType,
                      })
                    ),
                'grid' === this.options.popularProducts.view) &&
                this.options.popularProducts.rowCount &&
                this.$results
                  .find('ul li.unbxd-as-popular-product-grid')
                  .css('width', 100 / this.options.popularProducts.rowCount + '%'))
            : -1 == this.activeRow &&
              (this.$input.val(this.previous), this.options.filtered) &&
              ((n = ''),
              (n =
                this.options.popularProducts.viewMore && this.options.popularProducts.viewMore.enabled
                  ? (d('.unbxd-as-sidecontent').addClass('unbxd-as-view-more'),
                    u.compile(this.preparefilteredPopularProducts() + this.options.popularProducts.viewMore.tpl))
                  : u.compile(this.preparefilteredPopularProducts())),
              this.currentTopResults[this.previous] && 0 < this.currentTopResults[this.previous].length
                ? d('.unbxd-as-sidecontent').html(
                    n({
                      data: this.currentTopResults[this.previous],
                      showCarts: this.options.showCarts,
                      cartType: this.options.cartType,
                    })
                  )
                : d('.unbxd-as-sidecontent').html(
                    n({
                      data: this.currentResults.POPULAR_PRODUCTS,
                      showCarts: this.options.showCarts,
                      cartType: this.options.cartType,
                    })
                  ),
              'grid' === this.options.popularProducts.view) &&
              this.options.popularProducts.rowCount &&
              this.$results
                .find('ul li.unbxd-as-popular-product-grid')
                .css('width', 100 / this.options.popularProducts.rowCount + '%'));
      },
      selectCurrent: function (t) {
        var e = this.$results.find('li.' + this.selectedClass);
        return e.length
          ? (this.selectItem(e.data(), t), !0)
          : ('function' != typeof this.options.onSimpleEnter ||
              (10 != this.lastKeyPressCode && 13 != this.lastKeyPressCode) ||
              (this.lastKeyEvent.preventDefault(), this.options.onSimpleEnter.call(this, t)),
            !1);
      },
      selectItem: function (t, e) {
        var n, r;
        'value' in t &&
          (this.log('selected Item : ', t),
          (r = d.trim(t.value)),
          (n = this.previous),
          (this.previous = r),
          (this.input.lastSelected = t),
          this.$results.html(''),
          this.$input.val(r),
          this.hideResultsNow(this),
          (r = {unbxdprank: parseInt(t.index, 10) + 1 || 0, internal_query: n || '*'}),
          t.type &&
            ('TRENDING_QUERIES' === t.type
              ? (r.autosuggest_type = 'TOP_SEARCH_QUERIES')
              : (r.autosuggest_type = t.type)),
          t.value &&
            'POPULAR_PRODUCTS' !== t.type &&
            'POPULAR_PRODUCTS_FILTERED' !== t.type &&
            (r.autosuggest_suggestion = t.value),
          t.filtervalue && (r.field_value = t.filtervalue),
          t.filtername && (r.field_name = t.filtername),
          t.source && (r.src_field = t.source),
          t.pid && (r.pid = t.pid),
          t.src && (r.src_query = t.src),
          (n = {query: t.value, autosuggestParams: r}),
          'TRENDING_QUERIES' === t.type &&
            (n.misc ? (n.misc.unxAsType = 'TRENDING_QUERIES') : (n.misc = {unxAsType: 'TRENDING_QUERIES'})),
          this.addToAnalytics('search', n),
          ('POPULAR_PRODUCTS' !== t.type && 'POPULAR_PRODUCTS_FILTERED' !== t.type) ||
            ((r = {}), t.pid && (r.pid = t.pid), Object.keys(r).length && this.addToAnalytics('click', {pid: t.pid})),
          'function' == typeof this.options.onItemSelect && 'TRENDING_QUERIES' === t.type
            ? this.options.onItemSelect.call(this, t, this.clickResults.TRENDING_QUERIES[parseInt(t.index)])
            : 'function' == typeof this.options.onItemSelect && 'POPULAR_PRODUCTS_FILTERED' !== t.type
              ? t.sorted
                ? this.options.onItemSelect.call(
                    this,
                    t,
                    this.currentResults.SORTED_SUGGESTIONS[parseInt(t.index)]._original,
                    e
                  )
                : this.options.onItemSelect.call(this, t, this.currentResults[t.type][parseInt(t.index)]._original, e)
              : 'POPULAR_PRODUCTS_FILTERED' === t.type &&
                this.options.onItemSelect.call(this, t, this.currentTopResults[t.src][parseInt(t.index)]._original, e));
      },
      addToAnalytics: function (t, e) {
        'Unbxd' in window &&
          'track' in window.Unbxd &&
          'function' == typeof window.Unbxd.track &&
          (this.log('Pushing data to analytics', t, e), Unbxd.track(t, e)),
          'search' === t &&
            ('classical' in this.options.integrations && this.trackclassical(t, e),
            'universal' in this.options.integrations) &&
            this.trackuniversal(t, e);
      },
      getEventAction: function (t) {
        return {
          IN_FIELD: 'Scope_Click',
          POPULAR_PRODUCTS: 'Pop_Click',
          KEYWORD_SUGGESTION: 'TQ_Click',
          TOP_SEARCH_QUERIES: 'TQ_Click',
          POPULAR_PRODUCTS_FILTERED: 'Filtered_Pop_Click',
          PROMOTED_SUGGESTION: 'TQ_Click',
        }[t];
      },
      getEventLabel: function (t) {
        var t = t.autosuggestParams,
          e = t.autosuggest_suggestion,
          n = t.unbxdprank,
          r = t.field_name && t.field_value ? t.field_name + ':' + t.field_value : void 0;
        return {
          IN_FIELD: e + (r ? '&filter=' + r : '') + '-' + n,
          POPULAR_PRODUCTS: e + '-' + n,
          KEYWORD_SUGGESTION: e + '-' + n,
          TOP_SEARCH_QUERIES: e + '-' + n,
          POPULAR_PRODUCTS_FILTERED: e + '-' + n,
          PROMOTED_SUGGESTION: e + '-' + n,
        }[t.autosuggest_type];
      },
      trackclassical: function (t, e) {
        var n = this.options.integrations.classical,
          r = this.getEventAction(e.autosuggestParams.autosuggest_type),
          e = this.getEventLabel(e);
        n && (!0 === n && (n = '_gaq'), window[n]) && window[n].push(['_trackEvent', 'U_Autocomplete', r, e, 1, !0]);
      },
      trackuniversal: function (t, e) {
        var n = this.options.integrations.universal,
          r = this.getEventAction(e.autosuggestParams.autosuggest_type),
          e = this.getEventLabel(e);
        n &&
          (!0 === n && (n = 'ga'), window[n]) &&
          window[n]('send', 'event', 'U_Autocomplete', r, e, 1, {nonInteraction: 1});
      },
      showResults: function () {
        this.options.width && (this.options.mainWidth = this.options.width);
        var t = this.options.inputContainerSelector ? d(this.options.inputContainerSelector) : this.$input,
          e = t.offset(),
          n = '',
          r = '',
          o =
            ('io' == this.options.platform &&
              (788 <
                (n =
                  (n = this.options.preferInputWidthTotalContent
                    ? t.outerWidth()
                    : this.options.sideContentOn && 'left' === this.options.sideContentOn
                      ? e.left + t.outerWidth()
                      : document.body.clientWidth - e.left) > document.body.clientWidth
                    ? document.body.clientWidth
                    : n) && n < 2e3
                ? (n = this.options.totalWidthPercent ? (this.options.totalWidthPercent * n) / 100 : (70 * n) / 100)
                : 2e3 < n && (n = (45 * n) / 100),
              (this.options.isMobile && this.options.isMobile()) || c.any()
                ? ((this.options.template = this.options.mobile.template),
                  (this.options.mainTpl = this.options.mobile.mainTpl),
                  (this.options.popularProducts.count = this.options.mobile.popularProducts.count))
                : ((this.options.template = this.options.desktop.template.column),
                  (this.options.mainTpl = this.options.desktop.mainTpl),
                  (this.options.popularProducts.count = this.options.desktop.popularProducts.count)),
              (r =
                '1column' == this.options.template
                  ? ((o = this.options.preferInputWidthMainContent),
                    function () {
                      return !('function' == typeof this.options.isMobile ? this.options.isMobile() : c.any());
                    }.call(this) &&
                      ((o =
                        this.options.desktop.template[this.options.desktop.template.column]
                          .preferInputWidthMainContent),
                      d('.unbxd-as-popular-product-info').addClass('unbxd-1column-popular-product-desktop')),
                    o ? t.outerWidth() : (60 * n) / 100)
                  : this.options.mainWidthPercent
                    ? (this.options.mainWidthPercent * n) / 100
                    : (30 * n) / 100)),
            0 < this.options.mainWidth ? this.options.mainWidth : n ? r : t.innerWidth()),
          r = parseInt(t.css('border-top-width'), 10),
          i = parseInt(t.css('border-bottom-width'), 10),
          s = parseInt(t.css('border-left-width'), 10),
          a = parseInt(t.css('border-right-width'), 10),
          o = (parseInt(t.css('padding-bottom'), 10), parseInt(o) - 2 + s + a),
          s = {top: e.top + (isNaN(r) ? 0 : r + i) + t.innerHeight() + 'px', left: e.left + 'px'},
          a = this.options.trendingSearches.preferInputWidthTrending ? t.outerWidth() : o;
        this.$results.find('ul.unbxd-as-maincontent').css('width', o + 'px'),
          this.$results.find('ul.unbxd-as-maincontent').css('box-sizing', 'border-box'),
          this.$results.find('ul.unbxd-as-maincontent.unbxd-as-trending').css('width', a + 'px'),
          null == this.scrollbarWidth && this.setScrollWidth(),
          '2column' == this.options.template &&
            ((r = this.options.sideWidth === this.default_options.sideWidth && n ? n - o : this.options.sideWidth),
            this.$results.find('ul.unbxd-as-sidecontent').css('width', r + 'px'),
            this.$results.find('ul.unbxd-as-sidecontent').css('box-sizing', 'border-box'),
            this.$results.removeClass('unbxd-as-extra-left unbxd-as-extra-right'),
            this.$results.addClass('unbxd-as-extra-' + this.options.sideContentOn),
            0 < this.$results.find('ul.unbxd-as-sidecontent').length &&
              'left' == this.options.sideContentOn &&
              ((i =
                e.left + t.outerWidth() > document.body.clientWidth
                  ? document.body.clientWidth
                  : e.left + t.outerWidth()),
              (s.left = i - o - r),
              s.left < 0 && (s.left = 0),
              0 == this.$results.find('ul.unbxd-as-maincontent').length && (s.left = s.left + o),
              (s.left = s.left + 'px')),
            'grid' === this.options.popularProducts.view) &&
            this.options.popularProducts.rowCount &&
            this.$results
              .find('ul li.unbxd-as-popular-product-grid')
              .css('width', 100 / this.options.popularProducts.rowCount + '%'),
          this.options.showCarts &&
            this.$results.find('.unbxd-as-popular-product-cart-button').css('background-color', this.options.theme),
          'function' == typeof this.options.processResultsStyles &&
            (s = this.options.processResultsStyles.call(this, s)),
          this.$results.css(s).show(),
          this.options.onShowResults && this.options.onShowResults();
      },
      setScrollWidth: function () {
        var t = document.createElement('div');
        t.setAttribute('style', 'width: 100px;height: 100px;overflow: scroll;position: absolute;top: -9999px;'),
          document.body.appendChild(t),
          (this.scrollbarWidth = t.offsetWidth - t.clientWidth),
          document.body.removeChild(t);
      },
      hideResults: function () {
        this.options.onHideResults && this.options.onHideResults(), this.timeout && clearTimeout(this.timeout);
        var t = this;
        this.timeout = setTimeout(function () {
          t.hideResultsNow();
        }, 200);
      },
      hideResultsNow: function () {
        this.log('hideResultsNow'),
          this.timeout && clearTimeout(this.timeout),
          this.$input.removeClass(this.options.loadingClass),
          this.$results.is(':visible') && this.$results.hide(),
          this.ajaxCall && this.ajaxCall.abort();
      },
      addFilter: function (t, e) {
        return t in this.params.filters || (this.params.filters[t] = {}), (this.params.filters[t][e] = t), this;
      },
      removeFilter: function (t, e) {
        return (
          e in this.params.filters[t] && delete this.params.filters[t][e],
          0 == Object.keys(this.params.filters[t]).length && delete this.params.filters[t],
          this
        );
      },
      clearFilters: function () {
        return (this.params.filters = {}), this;
      },
      onChange: function () {
        if (46 == this.lastKeyPressCode || (8 < this.lastKeyPressCode && this.lastKeyPressCode < 32))
          return (
            27 == this.lastKeyPressCode &&
              'object' == typeof this.input.lastSelected &&
              this.$input.val(this.input.lastSelected.value),
            this.$results.hide()
          );
        var t,
          e = '';
        (e = n && n.selfServe ? '*' : this.$input.val()) != this.previous &&
          ((this.params.q = e),
          (this.previous = e),
          (this.currentResults = {
            KEYWORD_SUGGESTION: [],
            TOP_SEARCH_QUERIES: [],
            POPULAR_PRODUCTS: [],
            IN_FIELD: [],
            SORTED_SUGGESTIONS: [],
            PROMOTED_SUGGESTION: [],
          }),
          this.inCache(e)
            ? (this.log('picked from cache : ' + e),
              (this.currentResults = this.getFromCache(e)),
              (this.productInfo.popularProductsCount = this.currentResults.POPULAR_PRODUCTS.length),
              this.options.filtered &&
                ((t = this.getPopularProductsHeader(this)),
                (t = u.compile(t)),
                (this.compiledPopularProductHeader = t({hoverSuggestion: e}))),
              this.$results.html(this.prepareHTML()),
              this.showResults())
            : (this.ajaxCall && this.ajaxCall.abort(),
              e.length >= this.options.minChars
                ? (this.$input.addClass(this.options.loadingClass), this.requestData(e))
                : (this.$input.removeClass(this.options.loadingClass),
                  (this.options.trendingSearches.enabled &&
                    this.clickResults &&
                    0 < this.clickResults.TRENDING_QUERIES.length &&
                    '' === e) ||
                    this.$results.hide())));
      },
      getClass: function (t) {
        return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1];
      },
      requestData: function (t) {
        var e = this,
          n = e.autosuggestUrl(),
          r = (this.log('requestData', n), this.getAjaxParams());
        (r.url = n),
          (r.cache = !0),
          (this.ajaxCall = d
            .ajax(r)
            .done(function (t) {
              e.receiveData(t);
            })
            .fail(function (t) {
              e.$input.removeClass(e.options.loadingClass), 'abort' !== t.statusText && e.$results.hide();
            }));
      },
      getHostDomainName: function () {
        return 'com' === this.options.platform ? '//search.unbxdapi.com/' : this.options.searchEndPoint + '/';
      },
      getAjaxParams: function () {
        return 'io' === this.options.platform
          ? {dataType: 'json', method: 'get'}
          : {dataType: 'jsonp', jsonp: 'json.wrf'};
      },
      autosuggestUrl: function () {
        var t,
          e = this.getHostNPath(),
          n = this.params.q,
          r =
            (this.options.customQueryParse &&
              'function' == typeof this.options.customQueryParse &&
              (n = this.options.customQueryParse(this.params.q)),
            'q=' + encodeURIComponent(n));
        for (t in (this.options.maxSuggestions
          ? (r +=
              '&inFields.count=' +
              this.options.maxSuggestions +
              '&topQueries.count=' +
              this.options.maxSuggestions +
              '&keywordSuggestions.count=' +
              this.options.maxSuggestions +
              '&popularProducts.count=' +
              this.options.popularProducts.count +
              '&promotedSuggestion.count=' +
              this.options.maxSuggestions +
              '&indent=off')
          : (r +=
              '&inFields.count=' +
              this.options.inFields.count +
              '&topQueries.count=' +
              this.options.topQueries.count +
              '&keywordSuggestions.count=' +
              this.options.keywordSuggestions.count +
              '&popularProducts.count=' +
              this.options.popularProducts.count +
              '&promotedSuggestion.count=' +
              this.options.promotedSuggestions.count +
              '&indent=off'),
        0 < this.options.popularProducts.fields.length &&
          ((n = this.options.popularProducts.fields.join(',')), (r = r + '&popularProducts.fields=' + n)),
        this.options.popularProducts &&
          this.options.popularProducts.filter &&
          (r = r + '&popularProducts.filter=' + this.options.popularProducts.filter),
        this.options.removeDuplicates && (r += '&variants=true'),
        this.params.filters))
          if (this.params.filters.hasOwnProperty(t)) {
            var o,
              i = [];
            for (o in this.params.filters[t])
              this.params.filters[t].hasOwnProperty(o) &&
                i.push((t + ':"' + encodeURIComponent(o.replace(/(^")|("$)/g, '')) + '"').replace(/\"{2,}/g, '"'));
            r += '&filter=' + i.join(' OR ');
          }
        var s = this.options.extraParams || {},
          n = Object.keys(s);
        return (
          n.length &&
            n.forEach((t) => {
              r = r + '&' + t + '=' + s[t];
            }),
          e + '?' + r
        );
      },
      getHostNPath: function () {
        return this.getHostDomainName() + this.options.APIKey + '/' + this.options.siteName + '/autosuggest';
      },
      receiveData: function (t) {
        if (t) {
          if (
            (this.$input.removeClass(this.options.loadingClass),
            this.$results.html(''),
            ((!this.hasFocus && (!n || !n.selfServe)) || 0 == t.response.numberOfProducts || 'error' in t) &&
              !this.options.noResultTpl)
          )
            return this.hideResultsNow(this);
          this.processData(t),
            this.addToCache(this.params.q, this.currentResults),
            this.$results.html(this.prepareHTML()),
            this.showResults();
        } else this.hideResultsNow(this);
      },
      max_suggest: function (t) {
        for (
          var e = 0,
            n = 0,
            r = 0,
            o = 0,
            i = Math.floor(0.2 * this.options.maxSuggestions),
            s = Math.floor(0.3 * this.options.maxSuggestions),
            a = Math.ceil(0.3 * this.options.maxSuggestions),
            u = Math.floor(0.2 * this.options.maxSuggestions),
            l = 0,
            c = 0,
            p = 0,
            d = 0;
          d < t.response.products.length;
          d++
        )
          'IN_FIELD' == t.response.products[d].doctype
            ? e++
            : 'KEYWORD_SUGGESTION' == t.response.products[d].doctype
              ? r++
              : 'TOP_SEARCH_QUERIES' == t.response.products[d].doctype
                ? n++
                : 'PROMOTED_SUGGESTION' == t.response.products[d].doctype && o++;
        if (e < i) {
          for (var h = i - e; 0 < h; )
            s < r
              ? h <= r - s
                ? ((s += h), (h = 0))
                : ((h = h - r + s), (s = r))
              : a < n
                ? h <= n - a
                  ? ((a += h), (h = 0))
                  : ((h = h - n + a), (a = n))
                : u < o
                  ? h <= o - u
                    ? ((u += h), (h = 0))
                    : ((h = h - o + u), (u = o))
                  : (h = 0);
          i = e;
        }
        if (n < a) {
          for (c = a - n; 0 < c && s < r; )
            s < r
              ? c <= r - s
                ? ((s += c), (c = 0))
                : ((c = c - r + s), (s = r))
              : u < o && (c <= o - u ? ((u += c), (c = 0)) : ((c = c - o + u), (u = o)));
          a = n;
        }
        if (r < s) {
          for (l = s - r; 0 < l && a < n; )
            a < n
              ? l <= n - a
                ? ((a += l), (l = 0))
                : ((l = l - n + a), (a = n))
              : u < o && (l <= o - u ? ((u += l), (l = 0)) : ((l = l - o + u), (u = o)));
          s = r;
        }
        if (o < u) {
          for (p = u - o; 0 < p; )
            a < n
              ? p <= n - a
                ? ((a += p), (p = 0))
                : ((p = p - n + a), (a = n))
              : s < r
                ? p <= r - s
                  ? ((s += p), (p = 0))
                  : ((p = p - r + s), (s = r))
                : (p = 0);
          u = o;
        }
        var f = {};
        return (
          (f.infields = i),
          (f.topquery = a),
          (f.promoted = u),
          (f.keyword = s),
          (f.key_rem = l),
          (f.top_rem = c),
          (f.promo_rem = p),
          f
        );
      },
      isUnique: function (t, e) {
        try {
          t = t.toLowerCase();
          for (var n = !0, r = 0; r < e.length; r++) {
            var o = e[r];
            if (Math.abs(o.length - t.length) < 3 && (-1 != o.indexOf(t) || -1 != t.indexOf(o))) {
              n = !1;
              break;
            }
          }
          return n && e.push(t), n;
        } catch (t) {
          return !0;
        }
      },
      isTempUnique: function (t, e) {
        return (t = t.toLowerCase()), -1 === e.indexOf(t) && e.push(t);
      },
      getfilteredPopularProducts: function () {
        var i,
          t = this.params.q,
          s =
            (this.options.customQueryParse &&
              'function' == typeof this.options.customQueryParse &&
              (t = this.options.customQueryParse(this.params.q)),
            this),
          a = this.getHostDomainName() + this.options.APIKey + '/' + this.options.siteName + '/search',
          u = 'indent=off&facet=off&analytics=false&redirect=false',
          e = a + '?q=' + encodeURIComponent(t) + '&rows=' + this.options.popularProducts.count + '&' + u,
          n =
            (0 < s.options.popularProducts.fields.length &&
              ((i = '&fields=' + s.options.popularProducts.fields.join(',')), (e += i)),
            s.options.removeDuplicates && (e += '&variants=true'),
            s.options.extraParams || {}),
          t = Object.keys(n);
        t.length &&
          t.forEach((t) => {
            e = e + '&' + t + '=' + n[t];
          }),
          s.options.popularProducts &&
            s.options.popularProducts.filter &&
            (e = e + '&filter=' + s.options.popularProducts.filter);
        let l = '';
        var r,
          o = (s.options.popularProducts && s.options.popularProducts.filteredExtraParams) || {},
          t = Object.keys(o),
          t =
            (t.length &&
              t.forEach((t) => {
                l = l + '&' + t + '=' + o[t];
              }),
            s.options.popularProducts &&
              s.options.popularProducts.filter &&
              (l = l + '&filter=' + s.options.popularProducts.filter),
            this.getAjaxParams());
        for (r in ((t.url = e),
        (t.cache = !0),
        d.ajax(t).done(function (t) {
          var e = s.params.q;
          s.processfilteredPopularProducts(e, t);
        }),
        this.currentResults))
          if ('POPULAR_PRODUCTS' != r && this.currentResults.hasOwnProperty(r))
            for (var c in this.currentResults[r])
              this.currentResults[r].hasOwnProperty(c) &&
                ((e, n, r) => {
                  var t = n
                      ? a +
                        '?q=' +
                        encodeURIComponent(e) +
                        '&filter=' +
                        n +
                        ':"' +
                        encodeURIComponent(r) +
                        '"&rows=' +
                        s.options.popularProducts.count +
                        i +
                        '&' +
                        u +
                        l
                      : a +
                        '?q=' +
                        encodeURIComponent(e) +
                        '&rows=' +
                        s.options.popularProducts.count +
                        i +
                        '&' +
                        u +
                        l,
                    o = s.getAjaxParams();
                  (o.url = t),
                    (o.cache = !0),
                    d.ajax(o).done(function (t) {
                      s.processfilteredPopularProducts(n ? e + ':' + n + ':' + r : e, t);
                    });
                })(
                  s.currentResults[r][c].autosuggest,
                  s.currentResults[r][c].filtername || '',
                  s.currentResults[r][c].filtervalue || ''
                );
      },
      processfilteredPopularProducts: function (t, e) {
        if (
          ((this.currentTopResults[t] = []),
          e.hasOwnProperty('response') && e.response.hasOwnProperty('products') && e.response.products.length)
        )
          for (var n = 0; n < e.response.products.length; n++) {
            var r = e.response.products[n],
              o = {_original: r, type: 'POPULAR_PRODUCTS_FILTERED', src: t, pid: r.uniqueId || ''};
            this.options.popularProducts.name && this.options.popularProducts.nameFunctionOrKey
              ? (o.autosuggest = r[this.options.popularProducts.nameFunctionOrKey])
              : this.options.popularProducts.autosuggestName && r[this.options.popularProducts.autosuggestName]
                ? (o.autosuggest = r[this.options.popularProducts.autosuggestName])
                : this.options.popularProducts.title && r[this.options.popularProducts.title]
                  ? (o.autosuggest = r[this.options.popularProducts.title])
                  : r.title
                    ? (o.autosuggest = r.title)
                    : (o.autosuggest = ''),
              (o.highlighted = this.highlightStr(o.autosuggest)),
              this.options.popularProducts.price &&
                ('function' == typeof this.options.popularProducts.priceFunctionOrKey
                  ? (o.price = this.options.popularProducts.priceFunctionOrKey(r))
                  : 'string' == typeof this.options.popularProducts.priceFunctionOrKey &&
                      this.options.popularProducts.priceFunctionOrKey
                    ? (o.price =
                        this.options.popularProducts.priceFunctionOrKey in r
                          ? r[this.options.popularProducts.priceFunctionOrKey]
                          : null)
                    : (o.price = 'price' in r ? r.price : null),
                this.options.popularProducts.currency) &&
                (o.currency = this.options.popularProducts.currency),
              this.options.popularProducts.salePrice &&
                this.options.popularProducts.salePriceKey &&
                (o.salePrice =
                  this.options.popularProducts.salePriceKey in r ? r[this.options.popularProducts.salePriceKey] : null),
              this.options.popularProducts.image &&
                ('function' == typeof this.options.popularProducts.imageUrlOrFunction
                  ? (o.image = this.options.popularProducts.imageUrlOrFunction(r))
                  : 'string' == typeof this.options.popularProducts.imageUrlOrFunction &&
                    this.options.popularProducts.imageUrlOrFunction &&
                    (o.image =
                      this.options.popularProducts.imageUrlOrFunction in r
                        ? r[this.options.popularProducts.imageUrlOrFunction]
                        : null)),
              this.currentTopResults[t].push(o);
          }
      },
      processTopSearchQuery: function (t) {
        t = {
          autosuggest: t.autosuggest,
          highlighted: this.highlightStr(t.autosuggest),
          type: 'TOP_SEARCH_QUERIES',
          _original: t.doctype,
        };
        this.currentResults.TOP_SEARCH_QUERIES.push(t);
      },
      processTrendingQueries: function (t) {
        t = {
          autosuggest: t.autosuggest,
          highlighted: this.highlightStr(t.autosuggest),
          type: 'TRENDING_QUERIES',
          _original: t,
          source: t.unbxdAutosuggestSrc || '',
        };
        this.trendingQueries.push(t);
      },
      processKeywordSuggestion: function (t) {
        t = {
          autosuggest: t.autosuggest,
          highlighted: this.highlightStr(t.autosuggest),
          type: 'KEYWORD_SUGGESTION',
          _original: t,
          source: t.unbxdAutosuggestSrc || '',
        };
        this.currentResults.KEYWORD_SUGGESTION.push(t);
      },
      processPromotedSuggestion: function (t) {
        t = {
          autosuggest: t.autosuggest,
          highlighted: this.highlightStr(t.autosuggest),
          type: 'PROMOTED_SUGGESTION',
          _original: t,
          source: t.unbxdAutosuggestSrc || '',
        };
        this.currentResults.PROMOTED_SUGGESTION.push(t);
      },
      setDefaultPopularProductsOptions: function () {
        this.options.popularProducts.autosuggestName || (this.options.popularProducts.autosuggestName = 'title'),
          this.options.popularProducts.title || (this.options.popularProducts.title = 'autosuggest'),
          this.options.popularProducts.fields || (this.options.popularProducts.fields = []),
          this.options.popularProducts.rowCount ||
            'io' !== this.options.platform ||
            (this.options.popularProducts.rowCount = this.options.popularProducts.count / 2);
      },
      setDefaultOptions: function () {
        this.options.inFields.type || (this.options.inFields.type = 'separate'),
          this.options.inFields.noOfInfields || (this.options.inFields.noOfInfields = 3),
          this.options.inFields.showDefault || (this.options.inFields.showDefault = !1),
          this.options.desktop ||
            (this.options.desktop = {
              template: {
                column: this.options.template,
                '1column': {preferInputWidthMainContent: this.options.preferOneColumnFullWidth},
                '2column': {preferInputWidthMainContent: this.options.preferInputWidthMainContent},
              },
              mainTpl: this.options.mainTpl,
              popularProducts: {count: this.options.popularProducts.count},
            });
      },
      getPopularProductFields: function () {
        var t = ['doctype'],
          t =
            (this.options.popularProducts.fields.push(this.options.popularProducts.title),
            this.options.popularProducts.price &&
              'string' == typeof this.options.popularProducts.priceFunctionOrKey &&
              this.options.popularProducts.priceFunctionOrKey &&
              t.push(this.options.popularProducts.priceFunctionOrKey),
            this.options.popularProducts.image &&
              'string' == typeof this.options.popularProducts.imageUrlOrFunction &&
              this.options.popularProducts.imageUrlOrFunction &&
              t.push(this.options.popularProducts.imageUrlOrFunction),
            0 < this.options.popularProducts.fields.length
              ? (this.options.popularProducts.fields = t.concat(this.options.popularProducts.fields))
              : (this.options.popularProducts.fields = t),
            this.getPopularProductsHeader(this));
        this.compiledPopularProductHeader = t;
      },
      processPopularProducts: function (t) {
        var e = {type: t.doctype, pid: t.uniqueId.replace('popularProduct_', ''), _original: t};
        this.options.popularProducts.name
          ? (e.autosuggest =
              t[this.options.popularProducts.nameFunctionOrKey] || t[this.options.popularProducts.title] || '')
          : (e.autosuggest = ''),
          (e.highlighted = this.highlightStr(e.autosuggest)),
          this.options.popularProducts.price &&
            ('function' == typeof this.options.popularProducts.priceFunctionOrKey
              ? (e.price = this.options.popularProducts.priceFunctionOrKey(t))
              : 'string' == typeof this.options.popularProducts.priceFunctionOrKey &&
                  this.options.popularProducts.priceFunctionOrKey
                ? (e.price =
                    this.options.popularProducts.priceFunctionOrKey in t
                      ? t[this.options.popularProducts.priceFunctionOrKey]
                      : null)
                : (e.price = 'price' in t ? t.price : null)),
          this.options.popularProducts.salePrice &&
            this.options.popularProducts.salePriceKey &&
            (e.salePrice =
              this.options.popularProducts.salePriceKey in t ? t[this.options.popularProducts.salePriceKey] : null),
          this.options.popularProducts.currency && (e.currency = this.options.popularProducts.currency),
          this.options.popularProducts.image &&
            ('function' == typeof this.options.popularProducts.imageUrlOrFunction
              ? (e.image = this.options.popularProducts.imageUrlOrFunction(t))
              : 'string' == typeof this.options.popularProducts.imageUrlOrFunction &&
                this.options.popularProducts.imageUrlOrFunction &&
                (e.image =
                  this.options.popularProducts.imageUrlOrFunction in t
                    ? t[this.options.popularProducts.imageUrlOrFunction]
                    : null)),
          this.currentResults.POPULAR_PRODUCTS.push(e),
          (this.productInfo.popularProductsCount = this.currentResults.POPULAR_PRODUCTS.length),
          this.options.filtered &&
            ((t = this.getPopularProductsHeader(this)),
            (e = u.compile(t)),
            (this.compiledPopularProductHeader = e({hoverSuggestion: this.params.q})));
      },
      processInFields: function (e) {
        var t,
          n = {},
          r = ' ' + e.unbxdAutosuggestSrc + ' ',
          o = this.highlightStr(e.autosuggest);
        if (this.options.inFields.showDefault) {
          var i = this;
          Object.keys(e).forEach(function (t) {
            3 <= t.length &&
              '_in' === t.substring(t.length - 3) &&
              ((t = t.split('_in')[0]), (n[t] = e[t + '_in'].slice(0, parseInt(i.options.inFields.noOfInfields))));
          });
        } else
          for (var s in this.options.inFields.fields)
            s + '_in' in e &&
              e[s + '_in'].length &&
              -1 == r.indexOf(' ' + s + ' ') &&
              ((n[s] = e[s + '_in'].slice(0, parseInt(this.options.inFields.fields[s]))),
              this.options.inFields.removeDuplicateKeyword) &&
              0 <= (t = n[s].indexOf(e.autosuggest.trim())) &&
              n[s].splice(t, 1);
        var a = [];
        if (this.options.sortByLength) {
          var u = 0;
          for (c in n) for (var l = 0; l < n[c].length; l++) (a[u] = {filterName: c, filterValue: n[c][l]}), u++;
          a.sort(function (t, e) {
            return h(t.filterValue, e.filterValue);
          });
        }
        if (d.isEmptyObject(n))
          this.currentResults.KEYWORD_SUGGESTION.push({
            autosuggest: e.autosuggest,
            highlighted: o,
            type: 'KEYWORD_SUGGESTION',
            source: e.unbxdAutosuggestSrc,
          });
        else {
          this.currentResults.IN_FIELD.push({
            autosuggest: e.autosuggest,
            highlighted: o,
            type: 'keyword',
            source: e.unbxdAutosuggestSrc,
          });
          i = this;
          if (this.options.sortByLength)
            for (var c = 0; c < a.length; c++)
              '' !== a[c].filterValue &&
                this.currentResults.IN_FIELD.push({
                  autosuggest: e.autosuggest,
                  highlighted:
                    'separate' === this.options.inFields.type
                      ? i.prepareinFieldsKeyword(a[c].filterValue)
                      : i.highlightStr(e.autosuggest) + ' in ' + i.prepareinFieldsKeyword(a[c].filterValue),
                  type: e.doctype,
                  filtername: a[c].filterName,
                  filtervalue: a[c].filterValue,
                  _original: e,
                  source: e.unbxdAutosuggestSrc,
                });
          else
            for (var s in n)
              for (var p = 0; p < n[s].length; p++)
                '' !== n[s][p] &&
                  this.currentResults.IN_FIELD.push({
                    autosuggest: e.autosuggest,
                    highlighted:
                      'separate' === this.options.inFields.type
                        ? i.prepareinFieldsKeyword(n[s][p])
                        : i.highlightStr(e.autosuggest) + ' in ' + i.prepareinFieldsKeyword(n[s][p]),
                    type: e.doctype,
                    filtername: s,
                    filtervalue: n[s][p],
                    _original: e,
                    source: e.unbxdAutosuggestSrc,
                  });
        }
      },
      sortSuggestionsBylength: function () {
        (this.currentResults.SORTED_SUGGESTIONS = this.currentResults.KEYWORD_SUGGESTION.concat(
          this.currentResults.TOP_SEARCH_QUERIES,
          this.currentResults.PROMOTED_SUGGESTION
        )),
          this.currentResults.SORTED_SUGGESTIONS.sort(function (t, e) {
            return h(t.autosuggest, e.autosuggest);
          }),
          this.currentResults.IN_FIELD.sort(function (t, e) {
            return h(t.autosuggest, e.autosuggest);
          });
      },
      processData: function (t) {
        this.options.maxSuggestions && (e = this.max_suggest(t)),
          (this.currentResults = {
            KEYWORD_SUGGESTION: [],
            TOP_SEARCH_QUERIES: [],
            POPULAR_PRODUCTS: [],
            IN_FIELD: [],
            SORTED_SUGGESTIONS: [],
            PROMOTED_SUGGESTION: [],
          }),
          (this.clickResults = {TRENDING_QUERIES: []});
        var e,
          n = 0,
          r = [],
          o = [],
          i = 0;
        if (this.options.hardcodedTopQueries && 0 < this.options.hardcodedTopQueries.length)
          for (var s = 0; s < this.options.hardcodedTopQueries.length; s++) {
            var a = this.options.hardcodedTopQueries[s];
            this.isUnique(a, o) &&
              this.currentResults.TOP_SEARCH_QUERIES.push({
                autosuggest: a,
                highlighted: a,
                type: 'TOP_SEARCH_QUERIES',
                _original: 'TOP_SEARCH_QUERIES',
              });
          }
        if (
          '' === this.params.q &&
          this.options.hardcodedKeywordSuggestions &&
          0 < this.options.hardcodedKeywordSuggestions.length
        )
          for (
            var u = (this.options.keywordSuggestions && this.options.keywordSuggestions.count) || 6, l = 0;
            l < this.options.hardcodedKeywordSuggestions.length && this.currentResults.KEYWORD_SUGGESTION.length < u;
            l++
          ) {
            var c = this.options.hardcodedKeywordSuggestions[l];
            this.isUnique(c, o) &&
              this.currentResults.KEYWORD_SUGGESTION.push({
                autosuggest: c,
                highlighted: c,
                type: 'KEYWORD_SUGGESTION',
                source: 'hardcoded',
              });
          }
        if (
          '' === this.params.q &&
          this.options.hardcodedPopularProducts &&
          0 < this.options.hardcodedPopularProducts.length
        )
          for (
            var p = (this.options.popularProducts && this.options.popularProducts.count) || 4, d = 0;
            d < this.options.hardcodedPopularProducts.length && this.currentResults.POPULAR_PRODUCTS.length < p;
            d++
          ) {
            var h = this.options.hardcodedPopularProducts[d];
            h.doctype || (h = Object.assign({}, h, {doctype: 'POPULAR_PRODUCTS'})), this.processPopularProducts(h);
          }
        for (var f = 0; f < t.response.products.length; f++) {
          var g = t.response.products[f];
          this.options.maxSuggestions
            ? 'TOP_SEARCH_QUERIES' == g.doctype && e.topquery > i && this.isUnique(g.autosuggest, o)
              ? (this.processTopSearchQuery(g), i++)
              : 'IN_FIELD' == g.doctype &&
                  e.infields + e.key_rem + e.top_rem > n &&
                  this.isUnique(g.autosuggest, r) &&
                  this.isUnique(g.autosuggest, o)
                ? e.infields > n
                  ? (n++, this.processInFields(g))
                  : e.key_rem + e.top_rem > this.currentResults.KEYWORD_SUGGESTION.length &&
                    this.isUnique(g.autosuggest, o) &&
                    this.processKeywordSuggestion(g)
                : 'KEYWORD_SUGGESTION' == g.doctype &&
                    e.keyword > this.currentResults.KEYWORD_SUGGESTION.length &&
                    this.isUnique(g.autosuggest, r)
                  ? this.processKeywordSuggestion(g)
                  : 'POPULAR_PRODUCTS' == g.doctype &&
                      this.options.popularProducts.count > this.currentResults.POPULAR_PRODUCTS.length
                    ? this.processPopularProducts(g)
                    : 'PROMOTED_SUGGESTION' == g.doctype &&
                      e.promoted > this.currentResults.PROMOTED_SUGGESTION.length &&
                      this.isUnique(g.autosuggest, o) &&
                      this.processPromotedSuggestion(g)
            : 'TOP_SEARCH_QUERIES' == g.doctype && this.options.topQueries.count > i && this.isUnique(g.autosuggest, o)
              ? (this.processTopSearchQuery(g), i++)
              : 'IN_FIELD' == g.doctype &&
                  this.options.inFields.count > n &&
                  this.isTempUnique(g.autosuggest, r) &&
                  this.isUnique(g.autosuggest, o)
                ? this.processInFields(g)
                : 'KEYWORD_SUGGESTION' == g.doctype &&
                    this.options.keywordSuggestions.count > this.currentResults.KEYWORD_SUGGESTION.length &&
                    this.isUnique(g.autosuggest, o)
                  ? this.processKeywordSuggestion(g)
                  : 'POPULAR_PRODUCTS' == g.doctype &&
                      this.options.popularProducts.count > this.currentResults.POPULAR_PRODUCTS.length
                    ? this.processPopularProducts(g)
                    : 'PROMOTED_SUGGESTION' == g.doctype &&
                      this.options.promotedSuggestions.count > this.currentResults.PROMOTED_SUGGESTION.length &&
                      this.isUnique(g.autosuggest, o) &&
                      this.processPromotedSuggestion(g);
        }
        this.options.filtered && this.getfilteredPopularProducts(),
          this.options.sortByLength && this.sortSuggestionsBylength();
        this.currentResults.POPULAR_PRODUCTS.length, this.currentResults.IN_FIELD.length;
        if (this.options.sortSuggestionsOnLength)
          for (var m in this.currentResults)
            'in_field' != m.toLowerCase() &&
              this.currentResults[m].sort(function (t, e) {
                return t.autosuggest.length > e.autosuggest.length ? 1 : -1;
              });
      },
      escapeStr: function (t) {
        return t.replace(/([\\{}()|.?*+\-\^$\[\]])/g, '\\$1');
      },
      highlightStr: function (t) {
        return t;
      },
      prepareinFieldsKeyword: function (t) {
        return (
          '<span class="unbxd-as-suggestions-infields">' +
          (t =
            this.options.customInfieldsFilter && 'function' == typeof this.options.customInfieldsFilter
              ? this.options.customInfieldsFilter(t)
              : t) +
          '</span>'
        );
      },
      prepareinFieldsHTML: function () {
        return 'inline' === this.options.inFields.type
          ? '{{#if data.IN_FIELD}}' +
              (this.options.inFields.header
                ? '<li class="unbxd-as-header">' + this.options.inFields.header + '</li>'
                : '') +
              '{{#each data.IN_FIELD}}{{#unbxdIf type "keyword"}}{{else}}<li data-index="{{@index}}" data-type="{{type}}" data-value="{{autosuggest}}" data-filtername="{{filtername}}" data-filtervalue="{{filtervalue}}"  data-source="{{source}}">' +
              (this.options.inFields.tpl || this.default_options.inFields.tpl) +
              '</li>{{/unbxdIf}}{{/each}}{{/if}}'
          : '{{#if data.IN_FIELD}}' +
              (this.options.inFields.header
                ? '<li class="unbxd-as-header">' + this.options.inFields.header + '</li>'
                : '') +
              '{{#each data.IN_FIELD}}{{#unbxdIf type "keyword"}}<li class="unbxd-as-keysuggestion" data-index="{{@index}}" data-value="{{autosuggest}}" data-type="IN_FIELD" data-source="{{source}}">' +
              (this.options.inFields.tpl || this.default_options.inFields.tpl) +
              '</li>{{else}}<li class="unbxd-as-insuggestion" style="color:' +
              this.options.theme +
              ';" data-index="{{@index}}" data-type="{{type}}" data-value="{{autosuggest}}" data-filtername="{{filtername}}" data-filtervalue="{{filtervalue}}"  data-source="{{source}}">in ' +
              (this.options.inFields.tpl || this.default_options.inFields.tpl) +
              '</li>{{/unbxdIf}}{{/each}}{{/if}}';
      },
      preparekeywordSuggestionsHTML: function () {
        return (
          '{{#if data.KEYWORD_SUGGESTION}}' +
          (this.options.keywordSuggestions.header
            ? '<li class="unbxd-as-header">' + this.options.keywordSuggestions.header + '</li>'
            : '') +
          '{{#each data.KEYWORD_SUGGESTION}}<li class="unbxd-as-keysuggestion" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}"  data-source="{{source}}">' +
          (this.options.keywordSuggestions.tpl || this.default_options.keywordSuggestions.tpl) +
          '</li>{{/each}}{{/if}}'
        );
      },
      prepareTrendingQueriesHTML: function () {
        return (
          '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall unbxd-as-trending">' +
          (this.options.trendingSearches.header
            ? '<li class="unbxd-as-header">' + this.options.trendingSearches.header + '</li>'
            : '') +
          '{{#each data1}}<li class="unbxd-as-keysuggestion" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}"  data-source="{{source}}">' +
          (this.options.trendingSearches.tpl || this.default_options.trendingSearches.tpl) +
          '</li>{{/each}}</ul>'
        );
      },
      preparepromotedSuggestionsHTML: function () {
        return (
          '{{#if data.PROMOTED_SUGGESTION}}' +
          (this.options.promotedSuggestions.header
            ? '<li class="unbxd-as-header">' + this.options.promotedSuggestions.header + '</li>'
            : '') +
          '{{#each data.PROMOTED_SUGGESTION}}<li class="unbxd-as-keysuggestion" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}"  data-source="{{source}}">' +
          (this.options.promotedSuggestions.tpl || this.default_options.promotedSuggestions.tpl) +
          '</li>{{/each}}{{/if}}'
        );
      },
      preparetopQueriesHTML: function () {
        return (
          '{{#if data.TOP_SEARCH_QUERIES}}' +
          (this.options.topQueries.header
            ? '<li class="unbxd-as-header unbxd-as-top-queries-header">' + this.options.topQueries.header + '</li>'
            : '') +
          '{{#each data.TOP_SEARCH_QUERIES}}<li class="unbxd-as-keysuggestion" data-type="{{type}}" data-index="{{@index}}" data-value="{{autosuggest}}">' +
          (this.options.topQueries.tpl || this.default_options.topQueries.tpl) +
          '</li>{{/each}}{{/if}}'
        );
      },
      preparefilteredPopularProducts: function () {
        return (
          (this.compiledPopularProductHeader
            ? '<li class="unbxd-as-header unbxd-as-popular-product-header">' +
              this.compiledPopularProductHeader +
              '</li>'
            : '') +
          '{{#data}}<li class="unbxd-as-popular-product ' +
          ('grid' === this.options.popularProducts.view ? 'unbxd-as-popular-product-grid' : '') +
          '" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}" data-pid="{{pid}}" data-src="{{src}}">' +
          (this.options.popularProducts.tpl || this.default_options.popularProducts.tpl) +
          '</li>{{/data}}'
        );
      },
      preparepopularProductsHTML: function () {
        return (
          '{{#if data.POPULAR_PRODUCTS}}' +
          (this.compiledPopularProductHeader
            ? '<li class="unbxd-as-header unbxd-as-popular-product-header">' +
              this.compiledPopularProductHeader +
              '</li>'
            : '') +
          '{{#data.POPULAR_PRODUCTS}}<li class="unbxd-as-popular-product ' +
          ('grid' === this.options.popularProducts.view ? 'unbxd-as-popular-product-grid' : '') +
          '" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}" data-pid="{{pid}}" >' +
          (this.options.popularProducts.tpl || this.default_options.popularProducts.tpl) +
          '</li>{{/data.POPULAR_PRODUCTS}}{{/if}}'
        );
      },
      standardizeKeys: function (t) {
        return (t =
          'inFields' === t
            ? 'IN_FIELD'
            : 'popularProducts' === t
              ? 'POPULAR_PRODUCTS'
              : 'topQueries' === t
                ? 'TOP_SEARCH_QUERIES'
                : 'promotedSuggestions' === t
                  ? 'PROMOTED_SUGGESTION'
                  : 'KEYWORD_SUGGESTION');
      },
      prepareSortedSuggestionsHTML: function () {
        return (
          '{{#if data.SORTED_SUGGESTIONS}}{{#each data.SORTED_SUGGESTIONS}}<li class="unbxd-as-sorted-suggestion" data-type="{{type}}" data-index="{{@index}}" data-value="{{autosuggest}}" data-sorted="true">' +
          (this.options.sortedSuggestions.tpl || this.default_options.sortedSuggestions.tpl) +
          '</li>{{/each}}{{/if}}'
        );
      },
      preprocessHTML: function () {
        ((this.options.isMobile && this.options.isMobile()) || c.any()) &&
          ((this.options.template = this.options.mobile.template),
          (this.options.mainTpl = this.options.mobile.mainTpl),
          (this.options.popularProducts.count = this.options.mobile.popularProducts.count));
      },
      prepareHTML: function () {
        this.preprocessHTML();
        var e = '',
          t =
            ('1column' === this.options.template &&
            this.options.popularProducts.viewMore &&
            this.options.popularProducts.viewMore.enabled
              ? (e += '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall unbxd-as-view-more">')
              : (e += '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall">'),
            '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall unbxd-as-mobile-view">'),
          n = '',
          r = '',
          o = !1,
          i = this,
          s = 0,
          a = 0,
          o =
            ('1column' === this.options.template &&
              this.options.suggestionsHeader &&
              (i.currentResults.IN_FIELD.length ||
                i.currentResults.KEYWORD_SUGGESTION.length ||
                i.currentResults.TOP_SEARCH_QUERIES.length) &&
              (r =
                r +
                '<li class="unbxd-as-header unbxd-as-suggestions-header">' +
                this.options.suggestionsHeader +
                '</li>'),
            i.currentResults.IN_FIELD.length ||
              i.currentResults.KEYWORD_SUGGESTION.length ||
              i.currentResults.POPULAR_PRODUCTS.length ||
              i.currentResults.TOP_SEARCH_QUERIES.length ||
              i.currentResults.PROMOTED_SUGGESTION.length ||
              !this.options.noResultTpl ||
              ((o = !0),
              'function' == typeof this.options.noResultTpl
                ? (e = e + '<li>' + this.options.noResultTpl.call(i, encodeURIComponent(i.params.q)) + '</li></ul>')
                : 'string' == typeof this.options.noResultTpl &&
                  (e = e + '<li>' + this.options.noResultTpl + '</li></ul>')),
            this.options.mainTpl.forEach(function (t) {
              (t = i.standardizeKeys(t)), (s += i.currentResults[t].length);
            }),
            this.options.sideTpl.forEach(function (t) {
              a +=
                i.currentResults[
                  (t =
                    'inFields' === t
                      ? 'IN_FIELD'
                      : 'popularProducts' === t
                        ? 'POPULAR_PRODUCTS'
                        : 'topQueries' === t
                          ? 'TOP_SEARCH_QUERIES'
                          : 'promotedSuggestions' === t
                            ? 'PROMOTED_SUGGESTION'
                            : 'KEYWORD_SUGGESTION')
                ].length;
            }),
            '2column' !== this.options.template ||
              this.options.sideTpl.length ||
              this.options.mainTpl ||
              ((this.options.sideTpl = ['keywordSuggestions', 'topQueries']),
              (this.options.mainTpl = ['inFields', 'popularProducts'])),
            '2column' === this.options.template &&
              (0 == s && 0 != a
                ? ((e = '<ul class="unbxd-as-sidecontent">'),
                  this.options.sideTpl.forEach(function (t) {
                    (i.options.sortByLength &&
                      ('topQueries' == t || 'keywordSuggestions' == t || 'promotedSuggestions' == t)) ||
                      (e += i[(t = 'prepare' + t + 'HTML')]());
                  }),
                  this.options.popularProducts.viewMore &&
                    this.options.popularProducts.viewMore.enabled &&
                    (e += this.options.popularProducts.viewMore.tpl),
                  (e += '</ul>'))
                : 0 < s &&
                  0 != a &&
                  ((n =
                    this.options.popularProducts.viewMore && this.options.popularProducts.viewMore.enabled
                      ? '<ul class="unbxd-as-sidecontent unbxd-as-view-more">'
                      : '<ul class="unbxd-as-sidecontent">'),
                  this.options.sideTpl.forEach(function (t) {
                    (i.options.sortByLength &&
                      ('topQueries' == t || 'keywordSuggestions' == t || 'promotedSuggestions' == t)) ||
                      (n += i[(t = 'prepare' + t + 'HTML')]());
                  }),
                  this.options.popularProducts.viewMore &&
                    this.options.popularProducts.viewMore.enabled &&
                    (n += this.options.popularProducts.viewMore.tpl),
                  (n += '</ul>'),
                  (r += '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall">'),
                  this.options.suggestionsHeader) &&
                  (r =
                    r +
                    '<li class="unbxd-as-header unbxd-as-suggestions-header">' +
                    this.options.suggestionsHeader +
                    '</li>')),
            !o &&
              0 < s &&
              (this.options.sortByLength
                ? 0 === a
                  ? (r = r + '<ul class="unbxd-as-maincontent">' + i.prepareSortedSuggestionsHTML())
                  : (r += i.prepareSortedSuggestionsHTML())
                : 0 === a && (r += '<ul class="unbxd-as-maincontent">'),
              this.options.mainTpl.forEach(function (t) {
                i.currentResults[i.standardizeKeys(t)].length &&
                  '' === l &&
                  (l = i.currentResults[i.standardizeKeys(t)][0].autosuggest),
                  (i.options.sortByLength &&
                    ('topQueries' == t || 'keywordSuggestions' == t || 'promotedSuggestions' == t)) ||
                    (r += i[(t = 'prepare' + t + 'HTML')]());
              }),
              this.options.popularProducts.viewMore &&
                this.options.popularProducts.viewMore.enabled &&
                (r += this.options.popularProducts.viewMore.tpl),
              (r += '</ul>'),
              (e =
                (this.options.isMobile && this.options.isMobile()) || c.any()
                  ? t + r
                  : '1column' === this.options.template
                    ? e + r + '</ul>'
                    : 'right' === this.options.sideContentOn
                      ? 0 < s && 0 === a
                        ? e + r + '</ul>'
                        : r + n
                      : n + r)),
            u.compile(e));
        return (
          this.log(
            'prepraing html :-> template : ' +
              this.options.template +
              ' ,carts : ' +
              this.options.showCarts +
              ' ,cartType : ' +
              this.options.cartType
          ),
          this.log('html data : ', this.currentResults),
          o({data: this.currentResults, showCarts: this.options.showCarts, cartType: this.options.cartType})
        );
      },
      addToCache: function (t, e) {
        t in this.cache || (this.cache[t] = d.extend({}, e));
      },
      inCache: function (t) {
        return t in this.cache && this.cache.hasOwnProperty(t);
      },
      getFromCache: function (t) {
        return this.cache[t];
      },
      destroy: function (t) {
        t.$input.unbind('.auto'),
          (t.input.lastSelected = null),
          t.$input.removeAttr('autocomplete', 'off'),
          t.$results.remove(),
          t.$input.removeData('autocomplete');
      },
      setOption: function (t, e) {
        var n = t.split('.');
        if (1 < n.length) {
          for (var r = this.options, o = 0; o < n.length - 1; o++) n[o] in r || (r[n[o]] = {}), (r = r[n[o]]);
          r[n[n.length - 1]] = e;
        } else this.options[t] = e;
        (this.previous = ''), this.$results.html(''), (this.cache = {}), (this.cache.length = 0);
      },
      log: function () {},
    })),
    (d.fn.unbxdautocomplete = function (t) {
      return this.each(function () {
        try {
          this.auto = new e(this, t);
        } catch (t) {}
      });
    });
};
(() => {
  function t() {
    if (!window.__unbxdQuickViewInitialized) {
      window.__unbxdQuickViewInitialized = !0;
      let o = JSON.stringify({
          addToCart: 'Add to Bag',
          addToWishlist: 'Add to Wishlist',
          addedToWishlist: 'Added to Wishlist',
          optionSelector: 'Select an option',
          optionSelectPrompt: 'Select an option',
          outOfStock: 'Out of stock',
          notifyMe: 'Notify Me',
          notifyMeButtonLabel: 'Notify when available',
          notifyMeButtonPrompt: 'Enter details',
        }),
        h =
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--chevron-down" aria-label="Chevron Down Icon"><path d="m18 9-6 6-6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path></svg>';
      document.addEventListener('click', function (t) {
        var e,
          n,
          r = t.target.closest('[data-product-modal-trigger]');
        r &&
          (r.closest('.results-grid') || r.closest('[data-id]')) &&
          (t.preventDefault(), t.stopPropagation(), (t = r.getAttribute('data-product-modal-trigger'))) &&
          ((n = r.getAttribute('data-product-modal-type') || 'add'),
          (t = i(
            (e = (e = r.closest('.results-grid__tile') || r.closest('._unbxd_recs-slider__item'))
              ? e.getAttribute('data-id')
              : '')
              ? window._unbxdProductStore[e]
              : null,
            t
          ))
            ? (a(t, n),
              (t = r.getAttribute('data-variant-id')) &&
                (n = document.getElementById('modal-product')) &&
                n.setAttribute('data-recs-variant-id', t))
            : console.error('Quick View: product not found in _unbxdProductStore for id:', e));
      }),
        document.addEventListener('click', function (t) {
          var e;
          t.target.closest('[data-modal-close="modal-product"]')
            ? (t.preventDefault(), u())
            : (e = document.getElementById('modal-product')) && t.target === e && u();
        }),
        document.addEventListener('keydown', function (t) {
          'Escape' === t.key && u();
        }),
        document.addEventListener('submit', function (o) {
          var i = o.target.closest('#modal-product .shopify-product-form');
          if (i) {
            var s = document.getElementById('modal-product');
            if (s && s.contains(i)) {
              o.preventDefault();
              var o = i.querySelector('input[type="radio"][name="id"]:checked'),
                a = i.querySelector('input[type="hidden"][name="id"]');
              let t = o ? o.value : a ? a.value : '';
              if ((t = t || s.getAttribute('data-recs-variant-id') || '')) {
                let n = i.querySelector('[data-submit-button]'),
                  r = n ? n.textContent : '';
                o = i.getAttribute('data-product-handle') && n && -1 !== r.toLowerCase().indexOf('wishlist');
                if ((n && ((n.disabled = !0), (n.textContent = 'Adding...')), o)) {
                  (a = i.getAttribute('data-product-handle') || ''), (s = i.querySelector('input[name="product-id"]'));
                  let e = s ? s.value : '';
                  o = {epi: parseInt(t), empi: parseInt(e), du: window.location.origin + '/products/' + a};
                  window._swat && 'function' == typeof window._swat.addToWishList
                    ? window._swat.addToWishList(
                        o,
                        function () {
                          n && (n.textContent = 'Added to Wishlist');
                          var t = document.querySelector('[data-wishlist-icon="' + e + '"]');
                          t && t.classList.add('is-wishlisted'),
                            setTimeout(function () {
                              u(), n && ((n.disabled = !1), (n.textContent = r));
                            }, 1e3);
                        },
                        function (t) {
                          console.error('Swym wishlist error:', t),
                            n &&
                              ((n.textContent = 'Error - try again'),
                              setTimeout(function () {
                                (n.disabled = !1), (n.textContent = r);
                              }, 2e3));
                        }
                      )
                    : (console.warn('Swym (_swat) not available, falling back to page navigation'),
                      (window.location.href = '/products/' + a));
                } else if (window.sideCart && 'function' == typeof window.sideCart.handleAddToCartEvent)
                  try {
                    window.sideCart.handleAddToCartEvent({id: parseInt(t), quantity: 1, properties: {}}, !0),
                      n && (n.textContent = 'Added!'),
                      setTimeout(function () {
                        u(), n && ((n.disabled = !1), (n.textContent = r));
                      }, 1e3);
                  } catch (t) {
                    console.error('sideCart add to cart error:', t),
                      n &&
                        ((n.textContent = 'Error - try again'),
                        setTimeout(function () {
                          (n.disabled = !1), (n.textContent = r);
                        }, 2e3));
                  }
                else
                  n &&
                    (console.error('sideCart not available for add to cart'),
                    (n.textContent = 'Error - try again'),
                    setTimeout(function () {
                      (n.disabled = !1), (n.textContent = r);
                    }, 2e3));
              } else alert('Please select an option');
            }
          }
        }),
        document.addEventListener('submit', function (t) {
          let o = t.target.closest('#modal-product [data-notify-form]');
          if (o) {
            let r = document.getElementById('modal-product');
            if (r && r.contains(o)) {
              t.preventDefault();
              var t = o.querySelector('input[name="email"]'),
                i = o.querySelector('input[name="variant"]'),
                t = t ? t.value.trim() : '',
                i = i ? i.value : '';
              if (t) {
                let e = o.querySelector('[data-notify-form-submit]'),
                  n = e ? e.textContent : '';
                e && ((e.disabled = !0), (e.textContent = 'Submitting...')),
                  fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=RVwmQH', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json', revision: '2024-10-15'},
                    body: JSON.stringify({
                      data: {
                        type: 'back-in-stock-subscription',
                        attributes: {channels: ['EMAIL'], profile: {data: {type: 'profile', attributes: {email: t}}}},
                        relationships: {variant: {data: {type: 'catalog-variant', id: '$shopify:::$default:::' + i}}},
                      },
                    }),
                  })
                    .then(function (t) {
                      if (!t.ok && 202 !== t.status)
                        return t.json().then(function (t) {
                          throw new Error((t.errors && t.errors[0] && t.errors[0].detail) || 'Subscription failed');
                        });
                      t = r.querySelector('[data-notify-form-success]');
                      t && t.setAttribute('aria-hidden', 'false'), (o.style.display = 'none');
                    })
                    .catch(function (t) {
                      console.error('Klaviyo BIS error:', t),
                        e &&
                          ((e.textContent = 'Error - try again'),
                          setTimeout(function () {
                            (e.disabled = !1), (e.textContent = n);
                          }, 2e3));
                    });
              } else alert('Please enter your email address');
            }
          }
        });
      function f(t, e) {
        var n, r;
        return t
          ? ((n = t.v_Size || t.size || t.option1 || ''),
            (r = t.v_Color || t.color || t.option2 || ''),
            n && r ? n + ' / ' + r : n || r || t.title || t.public_title || t.name || e || '')
          : e || '';
      }
      function i(t, e) {
        if (!t) return null;
        var n = t.imageUrl || t.unxImageUrl || (Array.isArray(t.images) && t.images.length ? t.images[0] : '');
        let o = t.title || t.unxTitle || '';
        var r = Array.isArray(t.variants)
          ? t.variants
              .map(function (e) {
                {
                  var n = o,
                    r = e && (e.id || e.variantId || e.v_variantId || e.uniqueId || ''),
                    n = f(e, n);
                  let t = e ? e.available : void 0;
                  return {
                    id: r,
                    title: n,
                    name: n,
                    available: (t =
                      'boolean' != typeof t
                        ? !(!1 === e.availability || 'false' === String(e.availability).toLowerCase())
                        : t),
                    v_availableForSale: e.v_availableForSale,
                    featured_image: null,
                  };
                }
              })
              .filter(function (t) {
                return !!t.id;
              })
          : [];
        let i = t.available;
        return (
          'boolean' != typeof i && (i = !(!1 === t.availability || 'false' === String(t.availability).toLowerCase())),
          'boolean' != typeof t.available &&
            r.length &&
            (i = r.some(function (t) {
              return t.available;
            })),
          {
            id: t.id || t.uniqueId || '',
            title: o,
            handle: t.handle || e || t.uniqueId || '',
            available: i,
            featured_image: n,
            images: Array.isArray(t.images) ? t.images : n ? [n] : [],
            variants: r,
          }
        );
      }
      function g(e) {
        return e
          ? [320, 480, 640, 800, 960]
              .map(function (t) {
                return e + (e.includes('?') ? '&' : '?') + 'width=' + t + ' ' + t + 'w';
              })
              .join(', ')
          : '';
      }
      function s(t, e) {
        var e = 'wishlist' === e,
          n = t.featured_image || (t.images && t.images[0]) || '',
          r = t.variants && t.variants[0],
          o = r ? r.id : '',
          i = r ? f(r, t.title || '') : '',
          s =
            (t.variants && t.variants.length,
            t.variants && 1 === t.variants.length && t.variants[0].title,
            !1 !== t.available),
          a = ((s, a) => {
            if (!s.variants || 0 === s.variants.length) return '';
            if (1 === s.variants.length) return '';
            s.variants[0];
            let u = '';
            return (
              s.variants.forEach(function (t, e) {
                var n,
                  r,
                  o,
                  i = t.id || t.variantId || t.v_variantId || '';
                i &&
                  ((n = f(t, s.title || '')),
                  (t = !(!1 === t.v_availableForSale || 'false' === String(t.v_availableForSale).toLowerCase())),
                  (r = !a && !t ? ' disabled=""' : ''),
                  (o = a ? 'wishlist' : t ? 'add' : 'notify'),
                  (t = a ? 'Add to Wishlist' : t ? 'Add to Bag' : 'Notify Me'),
                  (u +=
                    '<li><input type="radio" value="' +
                    i +
                    '" name="id" id="option-' +
                    i +
                    '" class="visually-hidden"' +
                    r +
                    '><label for="option-' +
                    i +
                    '" class="product-modal__option" data-product-option="' +
                    o +
                    '" data-label="' +
                    n +
                    '"><span>' +
                    n +
                    '</span><span class="helper-text" data-helper-text="">' +
                    t +
                    '</span></label></li>'));
              }),
              '<div class="product-modal__options-wrapper"><div class="product-modal__options" data-product-options-wrapper="" aria-expanded="false"><button class="btn-none product-modal__options-toggle" data-options-toggle=""><span data-options-toggle-label="">Select your size</span>' +
                h +
                '</button><ul class="list-none product-modal__options-list">' +
                u +
                '</ul></div></div>'
            );
          })(t, e),
          u = '' === a ? '<input type="hidden" value="' + o + '" name="id">' : '',
          n =
            '<div class="product-modal__image" data-product-image=""><div class="component-image__wrapper aspect-ratio aspect-ratio--2-3"><img class="component-image__image" srcset="' +
            g(n) +
            '" src="' +
            n +
            '" loading="eager" fetchpriority="auto" decoding="async" sizes="" width="1000" height="1500" alt="' +
            (t.title || '') +
            '"></div></div>',
          l = t.variants && t.variants.length <= 1;
        let c, p, d;
        d = l
          ? ((l = r ? !1 !== r.available : s),
            e
              ? ((c = 'Add to Wishlist'), (p = 'btn'), '')
              : l
                ? ((c = 'Add to Bag'), (p = 'btn'), '')
                : ((c = 'Out of stock'), (p = 'btn btn--tertiary'), ' disabled=""'))
          : ((c = 'Select a size'), (p = 'btn btn--tertiary'), ' disabled=""');
        return (
          n +
          ('<form method="post" action="' +
            (e ? '' : '/cart/add') +
            '" id="product_form_' +
            t.id +
            '" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" data-product-form="" data-product-handle="' +
            (t.handle || '') +
            '"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">' +
            u +
            a +
            '<div class="product-modal__footer"><button class="' +
            p +
            '" type="submit" data-submit-button=""' +
            d +
            '>' +
            c +
            '</button></div><input type="hidden" name="product-id" value="' +
            t.id +
            '"></form>') +
          ('<form method="post" action="" class="product-modal__bis" data-notify-form=""><h3>Notify when available</h3><p class="body-small bis__text">Enter your details and we\'ll notify you when this item is back in stock.</p><p class="body-small bis__details">' +
            (t.title || '') +
            '</p><input type="hidden" name="a" value="RVwmQH"><input type="hidden" name="variant" value="' +
            o +
            '"><input type="hidden" name="platform" value="shopify"><button class="btn-none product-modal__options-toggle" data-notify-form-toggle=""><span data-notify-form-toggle-label="">' +
            i +
            '</span>' +
            h +
            '</button><div class="form__group"><input type="email" name="email" id="notify-email-' +
            t.id +
            '" placeholder="Email Address" aria-label="Email Address" required=""></div><div class="bis__disclaimer"><div class="form__inline-input"><label for="bisDisclaimer" class="visually-hidden">Sign up for our newsletter and receive updates about our new arrivals, events and special offers. By clicking submit you agree to our <a href="" target="_blank">privacy policy</a>.</label><input type="checkbox" id="bisDisclaimer" required="" value="accepts_marketing"><label aria-hidden="true">Sign up for our newsletter and receive updates about our new arrivals, events and special offers. By clicking submit you agree to our <a href="" target="_blank">privacy policy</a>.</label></div></div><button type="submit" class="btn btn--block btn--tertiary" data-notify-form-submit="">Enter details</button></form>') +
          '<div class="bis__success-message" data-notify-form-success="" aria-hidden="true"><p class="hero-3">Merci beaucoup!</p><p>Your details have been received.<br> We\'ll notify you once this item is available.</p></div>'
        );
      }
      function a(n, e) {
        let r = document.getElementById('modal-product');
        r ||
          (((r = document.createElement('div')).className = 'modal modal--product-modal modal--sm'),
          (r.id = 'modal-product'),
          r.setAttribute('data-modal-product', ''),
          r.setAttribute('data-test-quick-view-modal', ''),
          r.setAttribute('role', 'dialog'),
          r.setAttribute('aria-label', 'Product Quick View'),
          r.setAttribute('aria-modal', 'true'),
          (r.innerHTML =
            '<div class="modal__dialog"><button type="button" class="btn-none modal__close-button" data-modal-close="modal-product" data-test-modal-close=""><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--cross" aria-label="Cross Icon"><path d="m18 18-6.06-6m0 0L6 6.12M11.94 12 18 6m-6.06 6L6 17.88" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path></svg></button><div class="product-modal" data-product-modal=""></div></div>'),
          document.body.appendChild(r));
        var a = r.querySelector('[data-product-modal]');
        if (a) {
          a.classList.remove('product-modal--placeholder');
          var u = n.variants && n.variants.length <= 1;
          let t = 'add';
          'wishlist' === e
            ? (t = 'wishlist')
            : ('notify' !== e && !1 !== n.available) || (t = u ? 'notify' : 'unavailable'),
            customElements.get('product-modal')
              ? ((u = document.createElement('product-modal')).setAttribute('strings', o),
                u.setAttribute('state', t),
                u.setAttribute('product', JSON.stringify(n)),
                (u.innerHTML = s(n, e)),
                (a.innerHTML = ''),
                a.appendChild(u))
              : (a.innerHTML = s(n, e)),
            r.classList.add('modal--visible'),
            r.setAttribute('aria-hidden', 'false'),
            (document.body.style.overflow = 'hidden');
          {
            var l = r;
            var c = n;
            let t = l.querySelector('[data-options-toggle]'),
              e = l.querySelector('[data-notify-form-toggle]'),
              o = l.querySelector('[data-product-options-wrapper]'),
              i = l.querySelector('product-modal'),
              s = i && 'wishlist' === i.getAttribute('state');
            t &&
              o &&
              t.addEventListener('click', function (t) {
                t.preventDefault();
                t = 'true' === o.getAttribute('aria-expanded');
                o.setAttribute('aria-expanded', t ? 'false' : 'true');
              }),
              e &&
                i &&
                e.addEventListener('click', function (t) {
                  t.preventDefault(), i.setAttribute('state', 'unavailable');
                });
            (u = l.querySelectorAll('input[type="radio"][name="id"]')),
              (a = l.querySelector('.product-modal__options-list'));
            function p(t, e) {
              var n, r;
              t &&
                ((r = !1 !== t.available),
                (e = !s && (e || !r)),
                (r = t.title || t.name || ''),
                (n = l.querySelector('[data-options-toggle-label]')) && (n.textContent = r),
                (n = l.querySelector('[data-notify-form-toggle-label]')) && (n.textContent = r),
                (n = l.querySelector('[data-notify-form] input[name="variant"]')) && (n.value = t.id),
                t.featured_image &&
                  (r = l.querySelector('.product-modal__image img')) &&
                  ((r.src = t.featured_image.src), (r.srcset = g(t.featured_image.src))),
                (n = l.querySelector('[data-submit-button]')),
                (r = l.querySelector('[data-notify-form]')),
                n &&
                  (s
                    ? ((n.disabled = !1),
                      (n.textContent = 'Add to Wishlist'),
                      (n.className = 'btn'),
                      i && i.setAttribute('state', 'wishlist'),
                      r && (r.style.display = ''))
                    : e
                      ? ((n.disabled = !0),
                        (n.textContent = 'Out of stock'),
                        (n.className = 'btn btn--tertiary'),
                        i && i.setAttribute('state', 'notify'))
                      : ((n.disabled = !1),
                        (n.textContent = 'Add to Bag'),
                        (n.className = 'btn'),
                        i && i.setAttribute('state', 'add'),
                        r && (r.style.display = ''))),
                o) &&
                o.setAttribute('aria-expanded', 'false');
            }
            u.forEach(function (t) {
              t.addEventListener('change', function () {
                let e = this.value;
                p(
                  c.variants.find(function (t) {
                    return String(t.id) === String(e);
                  })
                );
              });
            }),
              a &&
                a.addEventListener('click', function (t) {
                  var e = t.target.closest('.product-modal__option[data-product-option="notify"]');
                  if (e) {
                    t.preventDefault();
                    t = e.getAttribute('for');
                    if (t) {
                      let e = l.querySelector('#' + t);
                      e &&
                        p(
                          c.variants.find(function (t) {
                            return String(t.id) === String(e.value);
                          }),
                          !0
                        );
                    }
                  }
                });
          }
        }
      }
      function u() {
        var t = document.getElementById('modal-product');
        t &&
          (t.classList.remove('modal--visible'),
          t.setAttribute('aria-hidden', 'true'),
          (document.body.style.overflow = ''),
          t.removeAttribute('data-recs-variant-id'));
      }
      function b(t, e) {
        if ('' === t || null == t || isNaN(parseFloat(t))) return '';
        var n = parseFloat(t).toFixed(2);
        switch (e) {
          case 'GB':
            return '£' + n + ' GBP';
          case 'AU':
            return '$' + n + ' AUD';
          case 'NZ':
            return '$' + n + ' NZD';
          case 'SG':
            return '$' + n + ' SGD';
          default:
            return '$' + n;
        }
      }
      function l(t, e) {
        var n =
            'undefined' != typeof window && window.Shopify && window.Shopify.country ? window.Shopify.country : null,
          r =
            {
              GB: {price: e.price_GBP, compareAt: e.compareAtPrice_GBP},
              AU: {price: e.price_AUD, compareAt: e.compareAtPrice_AUD},
              NZ: {price: e.price_NZD, compareAt: e.compareAtPrice_NZD},
              SG: {price: e.price_SGD, compareAt: e.compareAtPrice_SGD},
              US: {price: e.price_USD, compareAt: e.compareAtPrice_USD},
            }[n] || null,
          o = (null != (r && r.price) ? r : e).price,
          r = null != (r && r.compareAt) ? r.compareAt : null,
          i = b(o, n),
          n = b(r, n),
          s = Array.isArray(e.imageUrl) ? e.imageUrl[0] : e.imageUrl,
          a = e.images || [],
          u = 0 < a.length ? a[0] : null;
        let l = e.productUrl || '/products/' + (e.handle || e.uniqueId || e.id);
        var c = e.handle || e.uniqueId || e.id,
          p = e.title || '',
          d = !1 === e.availability || 'false' === String(e.availability).toLowerCase() || !1 === e.available,
          h =
            (Array.isArray(e.video_urls) ? e.video_urls : []).find(function (t) {
              return t.toLowerCase().endsWith('.mp4');
            }) || '';
        let f = '/assets/placeholder.svg';
        function g(e) {
          return e
            ? [160, 320, 480, 640, 800, 960]
                .map(function (t) {
                  return e + (-1 !== e.indexOf('?') ? '&' : '?') + 'width=' + t + ' ' + t + 'w';
                })
                .join(', ')
            : '';
        }
        var m = t.querySelector('.product-card__image .component-image__image'),
          m =
            (m &&
              ((m.src = s ? (-1 !== s.indexOf('?') ? s + '&width=600' : s + '?width=600') : f),
              (m.srcset = g(s)),
              (m.alt = p),
              (m.onerror = function () {
                this.src = f;
              })),
            t.querySelector('.product-card__image--secondary')),
          y = t.querySelector('.product-card__image a');
        if (m) {
          var v = m.querySelector('video');
          if (v)
            try {
              v.pause(), (v.src = '');
            } catch (t) {}
          m.remove();
        }
        h
          ? ((v = u ? (-1 !== u.indexOf('?') ? u + '&width=600' : u + '?width=600') : ''),
            y &&
              y.insertAdjacentHTML(
                'beforeend',
                '<div class="product-card__image--secondary"><div class="component-video__wrapper aspect-ratio aspect-ratio--2-3"><video playsinline="playsinline" class="component-video__video" preload="none" autoplay="autoplay" muted="muted" loop="loop" aria-label="' +
                  p +
                  '" width="1080" height="1920" ' +
                  (v ? 'poster="' + v + '" ' : '') +
                  'disablepictureinpicture="true" disableremoteplayback="true" x-webkit-airplay="deny"><source src="' +
                  h +
                  '" type="video/mp4"><img alt="' +
                  p +
                  '" src="' +
                  (v || '') +
                  '"></video></div></div>'
              ),
            (m = t.querySelector('.product-card__image--secondary video')) &&
              (m.load(), m.play().catch(function () {})))
          : u &&
            u !== s &&
            ((h =
              '<div class="product-card__image--secondary"><div class="component-image__wrapper aspect-ratio aspect-ratio--2-3"><img srcset="' +
              g(u) +
              '" src="' +
              (-1 !== u.indexOf('?') ? u + '&width=600' : u + '?width=600') +
              '" loading="lazy" sizes="(min-width: 85.5rem) calc(85.5rem / 3), (min-width: 61.875rem) calc(100vw / 3), 100vw" width="1000" height="1500" alt="' +
              p +
              '" class="component-image__image"></div></div>'),
            y) &&
            y.insertAdjacentHTML('beforeend', h),
          t
            .querySelectorAll('.product-card__image > a, .product-card__title a, .product-card__price a')
            .forEach(function (t) {
              t.href = l;
            });
        var v = t.querySelector('.product-card__title a'),
          m =
            (v && (v.textContent = p),
            null != r && '' !== r && parseFloat(r) > parseFloat(o)
              ? '<span class="visually-hidden">Sale price</span><span>' +
                i +
                '</span><span class="visually-hidden">Regular price</span><span class="product-card__compare-price ns-font-4 ns-text-striked ns-ml-2">' +
                n +
                '</span>'
              : '<span>' + i + '</span>'),
          u = t.querySelector('.product-card__price a'),
          y = (u && (u.innerHTML = m), t.querySelector('.product-badges')),
          h = e.meta_badges || [],
          v = Array.isArray(h) ? h : 'string' == typeof h ? [h] : [],
          n =
            (0 < v.length
              ? ((r = v
                  .map(function (t) {
                    return (
                      '<div class="badge badge__' +
                      t.toLowerCase().replace(/&/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') +
                      '">' +
                      t +
                      '</div>'
                    );
                  })
                  .join('')),
                y
                  ? (y.innerHTML = r)
                  : (o = t.querySelector('.product-card__top')) &&
                    o.insertAdjacentHTML(
                      'afterbegin',
                      '<div class="product-badges product-card__badges" data-product-badges="">' + r + '</div>'
                    ))
              : y && y.remove(),
            t.querySelector('.product-card__promotion')),
          i = e.meta_promotion_values || [],
          m = Array.isArray(i) ? i : 'string' == typeof i ? [i] : [],
          h = e.meta_promotion_handles || [],
          v = Array.isArray(h) ? h[0] : h,
          o = v ? ' product-card__promotion--' + v : '',
          y =
            (0 < m.length
              ? ((r = m.join(', ')),
                n
                  ? ((n.className = 'product-card__promotion' + o + ' caption'), (n.textContent = r))
                  : (t.querySelector('product-card') || t).insertAdjacentHTML(
                      'beforeend',
                      '<div class="product-card__promotion' + o + ' caption">' + r + '</div>'
                    ))
              : n && n.remove(),
            t.querySelector('.product-card__add')),
          v =
            (y &&
              ((i = d ? 'Notify Me' : 'Add to Bag'),
              y.setAttribute('data-product-modal-trigger', c),
              y.setAttribute('data-product-modal-type', d ? 'notify' : 'add'),
              y.setAttribute('aria-label', d ? p + ' is Sold Out' : p + ' - Add to Bag'),
              (h = y.querySelector('.hide.show--min-lg'))) &&
              (h.textContent = i),
            t.querySelector('.product-card__wishlist')),
          m =
            (v &&
              (v.setAttribute('data-product-modal-trigger', c),
              v.setAttribute('data-wishlist-icon', e.uniqueId || e.id)),
            e.uniqueId || e.id),
          o =
            ((window._unbxdProductStore[m] = {
              id: e.id || m,
              uniqueId: m,
              title: p,
              handle: c,
              imageUrl: s,
              images: a,
              available: e.available,
              availability: e.availability,
              variants: (e.variants || []).map(function (t) {
                return {
                  id: t.id || t.variantId || t.v_variantId || '',
                  v_Size: t.v_Size || '',
                  v_Color: t.v_Color || '',
                  title: t.title || '',
                  v_availableForSale: t.v_availableForSale,
                  available: t.available,
                  availability: t.availability,
                };
              }),
            }),
            t.setAttribute('data-id', m),
            t.querySelector('product-card')),
          r = (o && (o.id = m), t.querySelector('.product-card__title'));
        r && (r.id = 'product-title-' + m + '-unbxd'),
          u && u.setAttribute('aria-describedby', 'product-title-' + m + '-unbxd');
      }
      document.addEventListener('click', function (t) {
        var n = t.target.closest('[data-swatch-action="switchProduct"]');
        if (n && (t.preventDefault(), t.stopPropagation(), !n.classList.contains('swatch--active'))) {
          let e = n.dataset.swatchProductId;
          var t = n.dataset.swatchTileId,
            r = n.closest('.results-grid__tile') || n.closest('._unbxd_recs-slider__item');
          r &&
            (t = window._unbxdSwatchData && window._unbxdSwatchData[t]) &&
            (t = t.find(function (t) {
              return String(t.uniqueId || t.id) === String(e);
            })) &&
            (r.querySelectorAll('.UNX-product-swatch').forEach(function (t) {
              t.classList.remove('swatch--active');
            }),
            n.classList.add('swatch--active'),
            l(r, t));
        }
      });
    }
  }
  (window.initUnbxdQuickView = t),
    'loading' === document.readyState ? document.addEventListener('DOMContentLoaded', t) : t();
})();
